import { Jsonifiable, JsonValue, PartialDeep } from "type-fest"
import { Ref } from "@graphql-tools/mock";
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ResolverFn<TResult, TParent, TContext, TArgs> = (parent: TParent, args: TArgs, context: TContext, info: GraphQLResolveInfo) => Promise<PartialDeep<TResult, { recurseIntoArrays: true }>> | PartialDeep<TResult, { recurseIntoArrays: true }> | Ref;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: string; output: string; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: string; output: string; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: number; output: number; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Jsonifiable; output: JsonValue; }
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: string; output: string; }
};

export type ApplicationUser = {
  __typename: 'ApplicationUser';
  /** Reads and enables pagination through a set of `ApplicationUserMembership`. */
  applicationUserMembershipsByUserId: ApplicationUserMembershipsConnection;
  /** Reads and enables pagination through a set of `ApplicationUserMetadatum`. */
  applicationUserMetadataByUserId: ApplicationUserMetadataConnection;
  /** Reads and enables pagination through a set of `ApplicationUserSession`. */
  applicationUserSessionsByUserId: ApplicationUserSessionsConnection;
  /** Reads a single `Avatar` that is related to this `ApplicationUser`. */
  avatarByUserId: Maybe<Avatar>;
  /**
   * Reads and enables pagination through a set of `Avatar`.
   * @deprecated Please use avatarByUserId instead
   */
  avatarsByUserId: AvatarsConnection;
  /** Reads and enables pagination through a set of `CodeFile`. */
  codeFilesByUserId: CodeFilesConnection;
  cognitoTenantKey: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `DataTable`. */
  dataTablesByUserId: DataTablesConnection;
  dateCreated: Scalars['Datetime']['output'];
  email: Scalars['String']['output'];
  emailMarketingConsent: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `EulaVersionUserAcceptance`. */
  eulaVersionUserAcceptancesByUserId: EulaVersionUserAcceptancesConnection;
  /** Reads and enables pagination through a set of `FileActivity`. */
  fileActivitiesByUserId: FileActivitiesConnection;
  /** Reads and enables pagination through a set of `FileOutputGroup`. */
  fileOutputGroupsByUserId: FileOutputGroupsConnection;
  /** Reads and enables pagination through a set of `FileProcessingNotification`. */
  fileProcessingNotificationsByUserId: FileProcessingNotificationsConnection;
  /** Reads and enables pagination through a set of `File`. */
  filesByUserId: FilesConnection;
  firstName: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  gdtAnalysisTableRowsByUserId: GdtAnalysisTableRowsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. */
  gdtAnalysisTablesByUserId: GdtAnalysisTablesConnection;
  globalUserId: Maybe<Scalars['UUID']['output']>;
  homeRegion: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  internal: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `MetadataValue`. */
  metadataValuesByUserId: MetadataValuesConnection;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsByUserId: NotificationsConnection;
  personalRegion: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ProjectClonedNotification`. */
  projectClonedNotificationsByUserId: ProjectClonedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectFolder`. */
  projectFoldersByUserId: ProjectFoldersConnection;
  /** Reads and enables pagination through a set of `ProjectSharedNotification`. */
  projectSharedNotificationsBySharerId: ProjectSharedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectSharedNotification`. */
  projectSharedNotificationsByUserId: ProjectSharedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectTag`. */
  projectTagsByUserId: ProjectTagsConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projectsByUserId: ProjectsConnection;
  /** Reads and enables pagination through a set of `RoleChangeNotification`. */
  roleChangeNotificationsByUserId: RoleChangeNotificationsConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasksByUserId: TasksConnection;
  /** Reads and enables pagination through a set of `TenantUserMembershipNotification`. */
  tenantUserMembershipNotificationsByInviterId: TenantUserMembershipNotificationsConnection;
  /** Reads and enables pagination through a set of `TenantUserMembershipNotification`. */
  tenantUserMembershipNotificationsByUserId: TenantUserMembershipNotificationsConnection;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  toolVersionsByUserId: ToolVersionsConnection;
  /** Reads and enables pagination through a set of `Tool`. */
  toolsByUserId: ToolsConnection;
  userOrigin: Scalars['String']['output'];
  username: Scalars['String']['output'];
};


export type ApplicationUserApplicationUserMembershipsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApplicationUserMembershipCondition>;
  filter?: InputMaybe<ApplicationUserMembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApplicationUserMembershipsOrderBy>>;
};


export type ApplicationUserApplicationUserMetadataByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApplicationUserMetadatumCondition>;
  filter?: InputMaybe<ApplicationUserMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApplicationUserMetadataOrderBy>>;
};


export type ApplicationUserApplicationUserSessionsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApplicationUserSessionCondition>;
  filter?: InputMaybe<ApplicationUserSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};


export type ApplicationUserAvatarsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AvatarCondition>;
  filter?: InputMaybe<AvatarFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AvatarsOrderBy>>;
};


export type ApplicationUserCodeFilesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CodeFileCondition>;
  filter?: InputMaybe<CodeFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};


export type ApplicationUserDataTablesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DataTableCondition>;
  filter?: InputMaybe<DataTableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTablesOrderBy>>;
};


export type ApplicationUserEulaVersionUserAcceptancesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EulaVersionUserAcceptanceCondition>;
  filter?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
};


export type ApplicationUserFileActivitiesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};


export type ApplicationUserFileOutputGroupsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};


export type ApplicationUserFileProcessingNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileProcessingNotificationCondition>;
  filter?: InputMaybe<FileProcessingNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileProcessingNotificationsOrderBy>>;
};


export type ApplicationUserFilesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type ApplicationUserGdtAnalysisTableRowsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};


export type ApplicationUserGdtAnalysisTablesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};


export type ApplicationUserMetadataValuesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MetadataValueCondition>;
  filter?: InputMaybe<MetadataValueFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};


export type ApplicationUserNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type ApplicationUserProjectClonedNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};


export type ApplicationUserProjectFoldersByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectFolderCondition>;
  filter?: InputMaybe<ProjectFolderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectFoldersOrderBy>>;
};


export type ApplicationUserProjectSharedNotificationsBySharerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};


export type ApplicationUserProjectSharedNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};


export type ApplicationUserProjectTagsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};


export type ApplicationUserProjectsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type ApplicationUserRoleChangeNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoleChangeNotificationCondition>;
  filter?: InputMaybe<RoleChangeNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoleChangeNotificationsOrderBy>>;
};


export type ApplicationUserTasksByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


export type ApplicationUserTenantUserMembershipNotificationsByInviterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};


export type ApplicationUserTenantUserMembershipNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};


export type ApplicationUserToolVersionsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolVersionCondition>;
  filter?: InputMaybe<ToolVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};


export type ApplicationUserToolsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolCondition>;
  filter?: InputMaybe<ToolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

/** The fields on `applicationUser` to look up the row to connect. */
export type ApplicationUserApplicationUserEmailKeyConnect = {
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to connect. */
export type ApplicationUserApplicationUserGlobalUserIdKeyConnect = {
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to connect. */
export type ApplicationUserApplicationUserPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to connect. */
export type ApplicationUserApplicationUserUsernameKeyConnect = {
  username: Scalars['String']['input'];
};

/** A filter to be used against `ApplicationUser` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApplicationUserFilter>>;
  /** Filter by the object’s `applicationUserMembershipsByUserId` relation. */
  applicationUserMembershipsByUserId?: InputMaybe<ApplicationUserToManyApplicationUserMembershipFilter>;
  /** Some related `applicationUserMembershipsByUserId` exist. */
  applicationUserMembershipsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `applicationUserMetadataByUserId` relation. */
  applicationUserMetadataByUserId?: InputMaybe<ApplicationUserToManyApplicationUserMetadatumFilter>;
  /** Some related `applicationUserMetadataByUserId` exist. */
  applicationUserMetadataByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `applicationUserSessionsByUserId` relation. */
  applicationUserSessionsByUserId?: InputMaybe<ApplicationUserToManyApplicationUserSessionFilter>;
  /** Some related `applicationUserSessionsByUserId` exist. */
  applicationUserSessionsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `avatarByUserId` relation. */
  avatarByUserId?: InputMaybe<AvatarFilter>;
  /** A related `avatarByUserId` exists. */
  avatarByUserIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `codeFilesByUserId` relation. */
  codeFilesByUserId?: InputMaybe<ApplicationUserToManyCodeFileFilter>;
  /** Some related `codeFilesByUserId` exist. */
  codeFilesByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `cognitoTenantKey` field. */
  cognitoTenantKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dataTablesByUserId` relation. */
  dataTablesByUserId?: InputMaybe<ApplicationUserToManyDataTableFilter>;
  /** Some related `dataTablesByUserId` exist. */
  dataTablesByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailMarketingConsent` field. */
  emailMarketingConsent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `eulaVersionUserAcceptancesByUserId` relation. */
  eulaVersionUserAcceptancesByUserId?: InputMaybe<ApplicationUserToManyEulaVersionUserAcceptanceFilter>;
  /** Some related `eulaVersionUserAcceptancesByUserId` exist. */
  eulaVersionUserAcceptancesByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileActivitiesByUserId` relation. */
  fileActivitiesByUserId?: InputMaybe<ApplicationUserToManyFileActivityFilter>;
  /** Some related `fileActivitiesByUserId` exist. */
  fileActivitiesByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileOutputGroupsByUserId` relation. */
  fileOutputGroupsByUserId?: InputMaybe<ApplicationUserToManyFileOutputGroupFilter>;
  /** Some related `fileOutputGroupsByUserId` exist. */
  fileOutputGroupsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileProcessingNotificationsByUserId` relation. */
  fileProcessingNotificationsByUserId?: InputMaybe<ApplicationUserToManyFileProcessingNotificationFilter>;
  /** Some related `fileProcessingNotificationsByUserId` exist. */
  fileProcessingNotificationsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `filesByUserId` relation. */
  filesByUserId?: InputMaybe<ApplicationUserToManyFileFilter>;
  /** Some related `filesByUserId` exist. */
  filesByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gdtAnalysisTableRowsByUserId` relation. */
  gdtAnalysisTableRowsByUserId?: InputMaybe<ApplicationUserToManyGdtAnalysisTableRowFilter>;
  /** Some related `gdtAnalysisTableRowsByUserId` exist. */
  gdtAnalysisTableRowsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `gdtAnalysisTablesByUserId` relation. */
  gdtAnalysisTablesByUserId?: InputMaybe<ApplicationUserToManyGdtAnalysisTableFilter>;
  /** Some related `gdtAnalysisTablesByUserId` exist. */
  gdtAnalysisTablesByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `globalUserId` field. */
  globalUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `homeRegion` field. */
  homeRegion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `internal` field. */
  internal?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isStaff` field. */
  isStaff?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isSuperuser` field. */
  isSuperuser?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadataValuesByUserId` relation. */
  metadataValuesByUserId?: InputMaybe<ApplicationUserToManyMetadataValueFilter>;
  /** Some related `metadataValuesByUserId` exist. */
  metadataValuesByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `notificationsByUserId` relation. */
  notificationsByUserId?: InputMaybe<ApplicationUserToManyNotificationFilter>;
  /** Some related `notificationsByUserId` exist. */
  notificationsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApplicationUserFilter>>;
  /** Filter by the object’s `personalRegion` field. */
  personalRegion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `projectClonedNotificationsByUserId` relation. */
  projectClonedNotificationsByUserId?: InputMaybe<ApplicationUserToManyProjectClonedNotificationFilter>;
  /** Some related `projectClonedNotificationsByUserId` exist. */
  projectClonedNotificationsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectFoldersByUserId` relation. */
  projectFoldersByUserId?: InputMaybe<ApplicationUserToManyProjectFolderFilter>;
  /** Some related `projectFoldersByUserId` exist. */
  projectFoldersByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectSharedNotificationsBySharerId` relation. */
  projectSharedNotificationsBySharerId?: InputMaybe<ApplicationUserToManyProjectSharedNotificationFilter>;
  /** Some related `projectSharedNotificationsBySharerId` exist. */
  projectSharedNotificationsBySharerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectSharedNotificationsByUserId` relation. */
  projectSharedNotificationsByUserId?: InputMaybe<ApplicationUserToManyProjectSharedNotificationFilter>;
  /** Some related `projectSharedNotificationsByUserId` exist. */
  projectSharedNotificationsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectTagsByUserId` relation. */
  projectTagsByUserId?: InputMaybe<ApplicationUserToManyProjectTagFilter>;
  /** Some related `projectTagsByUserId` exist. */
  projectTagsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectsByUserId` relation. */
  projectsByUserId?: InputMaybe<ApplicationUserToManyProjectFilter>;
  /** Some related `projectsByUserId` exist. */
  projectsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `roleChangeNotificationsByUserId` relation. */
  roleChangeNotificationsByUserId?: InputMaybe<ApplicationUserToManyRoleChangeNotificationFilter>;
  /** Some related `roleChangeNotificationsByUserId` exist. */
  roleChangeNotificationsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tasksByUserId` relation. */
  tasksByUserId?: InputMaybe<ApplicationUserToManyTaskFilter>;
  /** Some related `tasksByUserId` exist. */
  tasksByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantUserMembershipNotificationsByInviterId` relation. */
  tenantUserMembershipNotificationsByInviterId?: InputMaybe<ApplicationUserToManyTenantUserMembershipNotificationFilter>;
  /** Some related `tenantUserMembershipNotificationsByInviterId` exist. */
  tenantUserMembershipNotificationsByInviterIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantUserMembershipNotificationsByUserId` relation. */
  tenantUserMembershipNotificationsByUserId?: InputMaybe<ApplicationUserToManyTenantUserMembershipNotificationFilter>;
  /** Some related `tenantUserMembershipNotificationsByUserId` exist. */
  tenantUserMembershipNotificationsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolVersionsByUserId` relation. */
  toolVersionsByUserId?: InputMaybe<ApplicationUserToManyToolVersionFilter>;
  /** Some related `toolVersionsByUserId` exist. */
  toolVersionsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolsByUserId` relation. */
  toolsByUserId?: InputMaybe<ApplicationUserToManyToolFilter>;
  /** Some related `toolsByUserId` exist. */
  toolsByUserIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userOrigin` field. */
  userOrigin?: InputMaybe<StringFilter>;
  /** Filter by the object’s `username` field. */
  username?: InputMaybe<StringFilter>;
};

/** Input for the nested mutation of `applicationUser` in the `ApplicationUserMembershipInput` mutation. */
export type ApplicationUserMemUserId631Fddc5FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserMembership` in the `ApplicationUserInput` mutation. */
export type ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput = {
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ApplicationUserMembershipApplicationUserMembershipPkeyConnect>>;
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  connectByUserIdAndTenantId?: InputMaybe<Array<ApplicationUserMembershipUserTenantUniqueConnect>>;
  /** The primary key(s) and patch data for `applicationUserMembership` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate>>;
  /** The primary key(s) and patch data for `applicationUserMembership` for the far side of the relationship. */
  updateByUserIdAndTenantId?: InputMaybe<Array<ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate>>;
};

export type ApplicationUserMembership = {
  __typename: 'ApplicationUserMembership';
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMembership`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars['Int']['output'];
  role: Scalars['Int']['output'];
  sfLeadCreated: Scalars['Boolean']['output'];
  /** Reads a single `Tenant` that is related to this `ApplicationUserMembership`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
  userId: Scalars['UUID']['output'];
};

/** The fields on `applicationUserMembership` to look up the row to connect. */
export type ApplicationUserMembershipApplicationUserMembershipPkeyConnect = {
  id: Scalars['Int']['input'];
};

/**
 * A condition to be used against `ApplicationUserMembership` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ApplicationUserMembershipCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sfLeadCreated` field. */
  sfLeadCreated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `ApplicationUserMembership` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserMembershipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApplicationUserMembershipFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApplicationUserMembershipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApplicationUserMembershipFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sfLeadCreated` field. */
  sfLeadCreated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `applicationUserMembership` to look up the row to update. */
export type ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
  applicationUserMembershipPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  id: Scalars['Int']['input'];
};

/** The fields on `applicationUserMembership` to look up the row to update. */
export type ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate = {
  /** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
  applicationUserMembershipPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  tenantId: Scalars['Int']['input'];
  userId: Scalars['UUID']['input'];
};

/** The fields on `applicationUserMembership` to look up the row to update. */
export type ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
  applicationUserMembershipPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  id: Scalars['Int']['input'];
};

/** The fields on `applicationUserMembership` to look up the row to update. */
export type ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate = {
  /** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
  applicationUserMembershipPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  tenantId: Scalars['Int']['input'];
  userId: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `tenant` in the `ApplicationUserMembershipInput` mutation. */
export type ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserMembership` in the `TenantInput` mutation. */
export type ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput = {
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ApplicationUserMembershipApplicationUserMembershipPkeyConnect>>;
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  connectByUserIdAndTenantId?: InputMaybe<Array<ApplicationUserMembershipUserTenantUniqueConnect>>;
  /** The primary key(s) and patch data for `applicationUserMembership` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate>>;
  /** The primary key(s) and patch data for `applicationUserMembership` for the far side of the relationship. */
  updateByUserIdAndTenantId?: InputMaybe<Array<ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate>>;
};

/** The fields on `applicationUserMembership` to look up the row to connect. */
export type ApplicationUserMembershipUserTenantUniqueConnect = {
  tenantId: Scalars['Int']['input'];
  userId: Scalars['UUID']['input'];
};

/** A connection to a list of `ApplicationUserMembership` values. */
export type ApplicationUserMembershipsConnection = {
  __typename: 'ApplicationUserMembershipsConnection';
  /** A list of edges which contains the `ApplicationUserMembership` and cursor to aid in pagination. */
  edges: Array<ApplicationUserMembershipsEdge>;
  /** A list of `ApplicationUserMembership` objects. */
  nodes: Array<ApplicationUserMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApplicationUserMembership` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ApplicationUserMembership` edge in the connection. */
export type ApplicationUserMembershipsEdge = {
  __typename: 'ApplicationUserMembershipsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ApplicationUserMembership` at the end of the edge. */
  node: ApplicationUserMembership;
};

/** Methods to use when ordering `ApplicationUserMembership`. */
export enum ApplicationUserMembershipsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  SfLeadCreatedAsc = 'SF_LEAD_CREATED_ASC',
  SfLeadCreatedDesc = 'SF_LEAD_CREATED_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** The `applicationUserMetadatum` to be created by this mutation. */
export type ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput = {
  applicationUserToUserId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Input for the nested mutation of `applicationUser` in the `ApplicationUserMetadatumInput` mutation. */
export type ApplicationUserMetUserId897Fbde1FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserMetadatum` in the `ApplicationUserInput` mutation. */
export type ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput = {
  /** The primary key(s) for `applicationUserMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ApplicationUserMetadatumApplicationUserMetadataPkeyConnect>>;
  /** The primary key(s) for `applicationUserMetadatum` for the far side of the relationship. */
  connectByUserIdAndKey?: InputMaybe<Array<ApplicationUserMetadatumUserKeyConnect>>;
  /** A `ApplicationUserMetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput>>;
  /** The primary key(s) and patch data for `applicationUserMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate>>;
  /** The primary key(s) and patch data for `applicationUserMetadatum` for the far side of the relationship. */
  updateByUserIdAndKey?: InputMaybe<Array<ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate>>;
};

/** A connection to a list of `ApplicationUserMetadatum` values. */
export type ApplicationUserMetadataConnection = {
  __typename: 'ApplicationUserMetadataConnection';
  /** A list of edges which contains the `ApplicationUserMetadatum` and cursor to aid in pagination. */
  edges: Array<ApplicationUserMetadataEdge>;
  /** A list of `ApplicationUserMetadatum` objects. */
  nodes: Array<ApplicationUserMetadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApplicationUserMetadatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ApplicationUserMetadatum` edge in the connection. */
export type ApplicationUserMetadataEdge = {
  __typename: 'ApplicationUserMetadataEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ApplicationUserMetadatum` at the end of the edge. */
  node: ApplicationUserMetadatum;
};

/** Methods to use when ordering `ApplicationUserMetadatum`. */
export enum ApplicationUserMetadataOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type ApplicationUserMetadatum = {
  __typename: 'ApplicationUserMetadatum';
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMetadatum`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  userId: Scalars['UUID']['output'];
  value: Scalars['String']['output'];
};

/** The fields on `applicationUserMetadatum` to look up the row to connect. */
export type ApplicationUserMetadatumApplicationUserMetadataPkeyConnect = {
  id: Scalars['Int']['input'];
};

/**
 * A condition to be used against `ApplicationUserMetadatum` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ApplicationUserMetadatumCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ApplicationUserMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApplicationUserMetadatumFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApplicationUserMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApplicationUserMetadatumFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ApplicationUserMetadatum` */
export type ApplicationUserMetadatumInput = {
  applicationUserToUserId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
  value: Scalars['String']['input'];
};

/** The fields on `applicationUserMetadatum` to look up the row to update. */
export type ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUserMetadatum` being updated. */
  applicationUserMetadatumPatch: UpdateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  id: Scalars['Int']['input'];
};

/** The fields on `applicationUserMetadatum` to look up the row to update. */
export type ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUserMetadatum` being updated. */
  applicationUserMetadatumPatch: UpdateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  key: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `ApplicationUserMetadatum`. Fields that are set will be updated. */
export type ApplicationUserMetadatumPatch = {
  applicationUserToUserId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The fields on `applicationUserMetadatum` to look up the row to connect. */
export type ApplicationUserMetadatumUserKeyConnect = {
  key: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  email: Scalars['String']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  globalUserId: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUser` being updated. */
  applicationUserPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  username: Scalars['String']['input'];
};

/** Represents an update to a `ApplicationUser`. Fields that are set will be updated. */
export type ApplicationUserPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** The `applicationUserSession` to be created by this mutation. */
export type ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput = {
  active: Scalars['Boolean']['input'];
  applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
  datetimeLastActive?: InputMaybe<Scalars['Datetime']['input']>;
  id: Scalars['UUID']['input'];
  lastPath?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
};

/** Input for the nested mutation of `applicationUser` in the `ApplicationUserSessionInput` mutation. */
export type ApplicationUserSesUserId2Fb30D0CFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserSession` in the `ApplicationUserInput` mutation. */
export type ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput = {
  /** The primary key(s) for `applicationUserSession` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ApplicationUserSessionApplicationUserSessionPkeyConnect>>;
  /** A `ApplicationUserSessionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput>>;
  /** The primary key(s) and patch data for `applicationUserSession` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate>>;
};

export type ApplicationUserSession = {
  __typename: 'ApplicationUserSession';
  active: Scalars['Boolean']['output'];
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserSession`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  datetimeLastActive: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  lastPath: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserSession`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Maybe<Scalars['Int']['output']>;
  userId: Scalars['UUID']['output'];
};

/** The fields on `applicationUserSession` to look up the row to connect. */
export type ApplicationUserSessionApplicationUserSessionPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/**
 * A condition to be used against `ApplicationUserSession` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ApplicationUserSessionCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `datetimeLastActive` field. */
  datetimeLastActive?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `lastPath` field. */
  lastPath?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `ApplicationUserSession` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserSessionFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApplicationUserSessionFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `datetimeLastActive` field. */
  datetimeLastActive?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lastPath` field. */
  lastPath?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApplicationUserSessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApplicationUserSessionFilter>>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** A related `tenantByTenantId` exists. */
  tenantByTenantIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ApplicationUserSession` */
export type ApplicationUserSessionInput = {
  active: Scalars['Boolean']['input'];
  applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
  datetimeLastActive?: InputMaybe<Scalars['Datetime']['input']>;
  id: Scalars['UUID']['input'];
  lastPath?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `applicationUserSession` to look up the row to update. */
export type ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUserSession` being updated. */
  applicationUserSessionPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `applicationUserSession` to look up the row to update. */
export type ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate = {
  /** An object where the defined keys will be set on the `applicationUserSession` being updated. */
  applicationUserSessionPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  id: Scalars['UUID']['input'];
};

/** The `applicationUserSession` to be created by this mutation. */
export type ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput = {
  active: Scalars['Boolean']['input'];
  applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
  datetimeLastActive?: InputMaybe<Scalars['Datetime']['input']>;
  id: Scalars['UUID']['input'];
  lastPath?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['JSON']['input']>;
  tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for the nested mutation of `tenant` in the `ApplicationUserSessionInput` mutation. */
export type ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserSession` in the `TenantInput` mutation. */
export type ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput = {
  /** The primary key(s) for `applicationUserSession` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ApplicationUserSessionApplicationUserSessionPkeyConnect>>;
  /** A `ApplicationUserSessionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput>>;
  /** The primary key(s) and patch data for `applicationUserSession` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate>>;
};

/** A connection to a list of `ApplicationUserSession` values. */
export type ApplicationUserSessionsConnection = {
  __typename: 'ApplicationUserSessionsConnection';
  /** A list of edges which contains the `ApplicationUserSession` and cursor to aid in pagination. */
  edges: Array<ApplicationUserSessionsEdge>;
  /** A list of `ApplicationUserSession` objects. */
  nodes: Array<ApplicationUserSession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApplicationUserSession` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ApplicationUserSession` edge in the connection. */
export type ApplicationUserSessionsEdge = {
  __typename: 'ApplicationUserSessionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ApplicationUserSession` at the end of the edge. */
  node: ApplicationUserSession;
};

/** Methods to use when ordering `ApplicationUserSession`. */
export enum ApplicationUserSessionsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  DatetimeLastActiveAsc = 'DATETIME_LAST_ACTIVE_ASC',
  DatetimeLastActiveDesc = 'DATETIME_LAST_ACTIVE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastPathAsc = 'LAST_PATH_ASC',
  LastPathDesc = 'LAST_PATH_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A filter to be used against many `ApplicationUserMembership` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyApplicationUserMembershipFilter = {
  /** Every related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserMembershipFilter>;
  /** No related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserMembershipFilter>;
  /** Some related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserMembershipFilter>;
};

/** A filter to be used against many `ApplicationUserMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyApplicationUserMetadatumFilter = {
  /** Every related `ApplicationUserMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserMetadatumFilter>;
  /** No related `ApplicationUserMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserMetadatumFilter>;
  /** Some related `ApplicationUserMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserMetadatumFilter>;
};

/** A filter to be used against many `ApplicationUserSession` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyApplicationUserSessionFilter = {
  /** Every related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserSessionFilter>;
  /** No related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserSessionFilter>;
  /** Some related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserSessionFilter>;
};

/** A filter to be used against many `CodeFile` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyCodeFileFilter = {
  /** Every related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CodeFileFilter>;
  /** No related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CodeFileFilter>;
  /** Some related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CodeFileFilter>;
};

/** A filter to be used against many `DataTable` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyDataTableFilter = {
  /** Every related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableFilter>;
  /** No related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableFilter>;
  /** Some related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableFilter>;
};

/** A filter to be used against many `EulaVersionUserAcceptance` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyEulaVersionUserAcceptanceFilter = {
  /** Every related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  /** No related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  /** Some related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EulaVersionUserAcceptanceFilter>;
};

/** A filter to be used against many `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyFileActivityFilter = {
  /** Every related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileActivityFilter>;
  /** No related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileActivityFilter>;
  /** Some related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileActivityFilter>;
};

/** A filter to be used against many `File` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyFileFilter = {
  /** Every related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileFilter>;
  /** No related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileFilter>;
  /** Some related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileFilter>;
};

/** A filter to be used against many `FileOutputGroup` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyFileOutputGroupFilter = {
  /** Every related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupFilter>;
  /** No related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupFilter>;
  /** Some related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupFilter>;
};

/** A filter to be used against many `FileProcessingNotification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyFileProcessingNotificationFilter = {
  /** Every related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileProcessingNotificationFilter>;
  /** No related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileProcessingNotificationFilter>;
  /** Some related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileProcessingNotificationFilter>;
};

/** A filter to be used against many `GdtAnalysisTable` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyGdtAnalysisTableFilter = {
  /** Every related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableFilter>;
  /** No related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableFilter>;
  /** Some related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableFilter>;
};

/** A filter to be used against many `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyGdtAnalysisTableRowFilter = {
  /** Every related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** No related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Some related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableRowFilter>;
};

/** A filter to be used against many `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyMetadataValueFilter = {
  /** Every related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadataValueFilter>;
  /** No related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadataValueFilter>;
  /** Some related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadataValueFilter>;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A filter to be used against many `ProjectClonedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyProjectClonedNotificationFilter = {
  /** Every related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectClonedNotificationFilter>;
  /** No related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectClonedNotificationFilter>;
  /** Some related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectClonedNotificationFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `ProjectFolder` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyProjectFolderFilter = {
  /** Every related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFolderFilter>;
  /** No related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFolderFilter>;
  /** Some related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFolderFilter>;
};

/** A filter to be used against many `ProjectSharedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyProjectSharedNotificationFilter = {
  /** Every related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectSharedNotificationFilter>;
  /** No related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectSharedNotificationFilter>;
  /** Some related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectSharedNotificationFilter>;
};

/** A filter to be used against many `ProjectTag` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyProjectTagFilter = {
  /** Every related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectTagFilter>;
  /** No related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectTagFilter>;
  /** Some related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectTagFilter>;
};

/** A filter to be used against many `RoleChangeNotification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyRoleChangeNotificationFilter = {
  /** Every related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoleChangeNotificationFilter>;
  /** No related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoleChangeNotificationFilter>;
  /** Some related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoleChangeNotificationFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `TenantUserMembershipNotification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyTenantUserMembershipNotificationFilter = {
  /** Every related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** No related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** Some related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantUserMembershipNotificationFilter>;
};

/** A filter to be used against many `Tool` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyToolFilter = {
  /** Every related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolFilter>;
  /** No related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolFilter>;
  /** Some related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolFilter>;
};

/** A filter to be used against many `ToolVersion` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyToolVersionFilter = {
  /** Every related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolVersionFilter>;
  /** No related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolVersionFilter>;
  /** Some related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolVersionFilter>;
};

/** A `ApplicationUser` edge in the connection. */
export type ApplicationUsersEdge = {
  __typename: 'ApplicationUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ApplicationUser` at the end of the edge. */
  node: ApplicationUser;
};

/** Methods to use when ordering `ApplicationUser`. */
export enum ApplicationUsersOrderBy {
  CognitoTenantKeyAsc = 'COGNITO_TENANT_KEY_ASC',
  CognitoTenantKeyDesc = 'COGNITO_TENANT_KEY_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EmailMarketingConsentAsc = 'EMAIL_MARKETING_CONSENT_ASC',
  EmailMarketingConsentDesc = 'EMAIL_MARKETING_CONSENT_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  GlobalUserIdAsc = 'GLOBAL_USER_ID_ASC',
  GlobalUserIdDesc = 'GLOBAL_USER_ID_DESC',
  HomeRegionAsc = 'HOME_REGION_ASC',
  HomeRegionDesc = 'HOME_REGION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InternalAsc = 'INTERNAL_ASC',
  InternalDesc = 'INTERNAL_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  IsStaffAsc = 'IS_STAFF_ASC',
  IsStaffDesc = 'IS_STAFF_DESC',
  IsSuperuserAsc = 'IS_SUPERUSER_ASC',
  IsSuperuserDesc = 'IS_SUPERUSER_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PersonalRegionAsc = 'PERSONAL_REGION_ASC',
  PersonalRegionDesc = 'PERSONAL_REGION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  UserOriginAsc = 'USER_ORIGIN_ASC',
  UserOriginDesc = 'USER_ORIGIN_DESC'
}

export type Avatar = {
  __typename: 'Avatar';
  /** Reads a single `ApplicationUser` that is related to this `Avatar`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  color: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  imageBase64: Maybe<Scalars['String']['output']>;
  initials: Scalars['String']['output'];
  useImage: Scalars['Boolean']['output'];
  userId: Scalars['UUID']['output'];
};

/** The fields on `avatar` to look up the row to connect. */
export type AvatarAvatarPkeyConnect = {
  id: Scalars['BigInt']['input'];
};

/** The fields on `avatar` to look up the row to connect. */
export type AvatarAvatarUserIdKeyConnect = {
  userId: Scalars['UUID']['input'];
};

/** A condition to be used against `Avatar` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AvatarCondition = {
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `imageBase64` field. */
  imageBase64?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `initials` field. */
  initials?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `useImage` field. */
  useImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `Avatar` object types. All fields are combined with a logical ‘and.’ */
export type AvatarFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AvatarFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `imageBase64` field. */
  imageBase64?: InputMaybe<StringFilter>;
  /** Filter by the object’s `initials` field. */
  initials?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AvatarFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AvatarFilter>>;
  /** Filter by the object’s `useImage` field. */
  useImage?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `avatar` to look up the row to update. */
export type AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate = {
  /** An object where the defined keys will be set on the `avatar` being updated. */
  avatarPatch: UpdateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  id: Scalars['BigInt']['input'];
};

/** The fields on `avatar` to look up the row to update. */
export type AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `avatar` being updated. */
  avatarPatch: UpdateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `Avatar`. Fields that are set will be updated. */
export type AvatarPatch = {
  applicationUserToUserId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  imageBase64?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  useImage?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for the nested mutation of `applicationUser` in the `AvatarInput` mutation. */
export type AvatarUserId771332F2FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `avatar` in the `ApplicationUserInput` mutation. */
export type AvatarUserId771332F2FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `avatar` for the far side of the relationship. */
  connectById?: InputMaybe<AvatarAvatarPkeyConnect>;
  /** The primary key(s) for `avatar` for the far side of the relationship. */
  connectByUserId?: InputMaybe<AvatarAvatarUserIdKeyConnect>;
  /** The primary key(s) and patch data for `avatar` for the far side of the relationship. */
  updateById?: InputMaybe<AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate>;
  /** The primary key(s) and patch data for `avatar` for the far side of the relationship. */
  updateByUserId?: InputMaybe<AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate>;
};

/** A connection to a list of `Avatar` values. */
export type AvatarsConnection = {
  __typename: 'AvatarsConnection';
  /** A list of edges which contains the `Avatar` and cursor to aid in pagination. */
  edges: Array<AvatarsEdge>;
  /** A list of `Avatar` objects. */
  nodes: Array<Avatar>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Avatar` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Avatar` edge in the connection. */
export type AvatarsEdge = {
  __typename: 'AvatarsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Avatar` at the end of the edge. */
  node: Avatar;
};

/** Methods to use when ordering `Avatar`. */
export enum AvatarsOrderBy {
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ImageBase_64Asc = 'IMAGE_BASE_64_ASC',
  ImageBase_64Desc = 'IMAGE_BASE_64_DESC',
  InitialsAsc = 'INITIALS_ASC',
  InitialsDesc = 'INITIALS_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  UseImageAsc = 'USE_IMAGE_ASC',
  UseImageDesc = 'USE_IMAGE_DESC'
}

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** All input for the `changeUserSession` mutation. */
export type ChangeUserSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  userid: Scalars['UUID']['input'];
};

/** The output of our `changeUserSession` mutation. */
export type ChangeUserSessionPayload = {
  __typename: 'ChangeUserSessionPayload';
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserSession`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  applicationUserSession: Maybe<ApplicationUserSession>;
  /** An edge for our `ApplicationUserSession`. May be used by Relay 1. */
  applicationUserSessionEdge: Maybe<ApplicationUserSessionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserSession`. */
  tenantByTenantId: Maybe<Tenant>;
};


/** The output of our `changeUserSession` mutation. */
export type ChangeUserSessionPayloadApplicationUserSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};

export type CodeFile = {
  __typename: 'CodeFile';
  /** Reads a single `ApplicationUser` that is related to this `CodeFile`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  checksum: Scalars['String']['output'];
  /** Reads a single `CodeFile` that is related to this `CodeFile`. */
  codeFileBySeriesParentId: Maybe<CodeFile>;
  /** Reads and enables pagination through a set of `CodeFile`. */
  codeFilesBySeriesParentId: CodeFilesConnection;
  compressed: Scalars['Boolean']['output'];
  dateArchived: Maybe<Scalars['Datetime']['output']>;
  dateCreated: Scalars['Datetime']['output'];
  dateDataDeleted: Maybe<Scalars['Datetime']['output']>;
  dateDeleted: Maybe<Scalars['Datetime']['output']>;
  executorId: Maybe<Scalars['UUID']['output']>;
  fileFormat: Maybe<Scalars['Int']['output']>;
  fileStructure: Maybe<Scalars['Int']['output']>;
  fileType: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  isSeries: Scalars['Boolean']['output'];
  key: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  multipartUploadId: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  partSize: Maybe<Scalars['Int']['output']>;
  seriesParentId: Maybe<Scalars['UUID']['output']>;
  signal: Maybe<Scalars['Int']['output']>;
  size: Maybe<Scalars['BigInt']['output']>;
  status: Scalars['Int']['output'];
  tags: Array<Maybe<Scalars['String']['output']>>;
  /** Reads a single `Tenant` that is related to this `CodeFile`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
  uploadStatus: Maybe<Scalars['Int']['output']>;
  userId: Scalars['UUID']['output'];
};


export type CodeFileCodeFilesBySeriesParentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CodeFileCondition>;
  filter?: InputMaybe<CodeFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};

/** The fields on `codeFile` to look up the row to connect. */
export type CodeFileCodeFilePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/**
 * A condition to be used against `CodeFile` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CodeFileCondition = {
  /** Checks for equality with the object’s `checksum` field. */
  checksum?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `compressed` field. */
  compressed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `executorId` field. */
  executorId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `fileFormat` field. */
  fileFormat?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fileStructure` field. */
  fileStructure?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fileType` field. */
  fileType?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `isSeries` field. */
  isSeries?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `location` field. */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `multipartUploadId` field. */
  multipartUploadId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `originalName` field. */
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `partSize` field. */
  partSize?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `seriesParentId` field. */
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `signal` field. */
  signal?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `size` field. */
  size?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `uploadStatus` field. */
  uploadStatus?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `CodeFile` object types. All fields are combined with a logical ‘and.’ */
export type CodeFileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CodeFileFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `checksum` field. */
  checksum?: InputMaybe<StringFilter>;
  /** Filter by the object’s `codeFileBySeriesParentId` relation. */
  codeFileBySeriesParentId?: InputMaybe<CodeFileFilter>;
  /** A related `codeFileBySeriesParentId` exists. */
  codeFileBySeriesParentIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `codeFilesBySeriesParentId` relation. */
  codeFilesBySeriesParentId?: InputMaybe<CodeFileToManyCodeFileFilter>;
  /** Some related `codeFilesBySeriesParentId` exist. */
  codeFilesBySeriesParentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `compressed` field. */
  compressed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `executorId` field. */
  executorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fileFormat` field. */
  fileFormat?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fileStructure` field. */
  fileStructure?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fileType` field. */
  fileType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isSeries` field. */
  isSeries?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `location` field. */
  location?: InputMaybe<StringFilter>;
  /** Filter by the object’s `multipartUploadId` field. */
  multipartUploadId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CodeFileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CodeFileFilter>>;
  /** Filter by the object’s `originalName` field. */
  originalName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `partSize` field. */
  partSize?: InputMaybe<IntFilter>;
  /** Filter by the object’s `seriesParentId` field. */
  seriesParentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `signal` field. */
  signal?: InputMaybe<IntFilter>;
  /** Filter by the object’s `size` field. */
  size?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `uploadStatus` field. */
  uploadStatus?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `codeFile` to look up the row to update. */
export type CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `codeFile` being updated. */
  codeFilePatch: UpdateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `codeFile` to look up the row to update. */
export type CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `codeFile` being updated. */
  codeFilePatch: UpdateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `codeFile` to look up the row to update. */
export type CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `codeFile` being updated. */
  codeFilePatch: UpdateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `codeFile` in the `CodeFileInput` mutation. */
export type CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput = {
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  connectById?: InputMaybe<CodeFileCodeFilePkeyConnect>;
  /** The primary key(s) and patch data for `codeFile` for the far side of the relationship. */
  updateById?: InputMaybe<CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate>;
};

/** Input for the nested mutation of `tenant` in the `CodeFileInput` mutation. */
export type CodeFileTenantIdC35D8B4EFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `codeFile` in the `TenantInput` mutation. */
export type CodeFileTenantIdC35D8B4EFkTenantIdInverseInput = {
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CodeFileCodeFilePkeyConnect>>;
  /** The primary key(s) and patch data for `codeFile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate>>;
};

/** A filter to be used against many `CodeFile` object types. All fields are combined with a logical ‘and.’ */
export type CodeFileToManyCodeFileFilter = {
  /** Every related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CodeFileFilter>;
  /** No related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CodeFileFilter>;
  /** Some related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CodeFileFilter>;
};

/** Input for the nested mutation of `applicationUser` in the `CodeFileInput` mutation. */
export type CodeFileUserIdAb9E5143FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `codeFile` in the `ApplicationUserInput` mutation. */
export type CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CodeFileCodeFilePkeyConnect>>;
  /** The primary key(s) and patch data for `codeFile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate>>;
};

/** A connection to a list of `CodeFile` values. */
export type CodeFilesConnection = {
  __typename: 'CodeFilesConnection';
  /** A list of edges which contains the `CodeFile` and cursor to aid in pagination. */
  edges: Array<CodeFilesEdge>;
  /** A list of `CodeFile` objects. */
  nodes: Array<CodeFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CodeFile` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CodeFile` edge in the connection. */
export type CodeFilesEdge = {
  __typename: 'CodeFilesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `CodeFile` at the end of the edge. */
  node: CodeFile;
};

/** Methods to use when ordering `CodeFile`. */
export enum CodeFilesOrderBy {
  ChecksumAsc = 'CHECKSUM_ASC',
  ChecksumDesc = 'CHECKSUM_DESC',
  CompressedAsc = 'COMPRESSED_ASC',
  CompressedDesc = 'COMPRESSED_DESC',
  DateArchivedAsc = 'DATE_ARCHIVED_ASC',
  DateArchivedDesc = 'DATE_ARCHIVED_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DateDataDeletedAsc = 'DATE_DATA_DELETED_ASC',
  DateDataDeletedDesc = 'DATE_DATA_DELETED_DESC',
  DateDeletedAsc = 'DATE_DELETED_ASC',
  DateDeletedDesc = 'DATE_DELETED_DESC',
  ExecutorIdAsc = 'EXECUTOR_ID_ASC',
  ExecutorIdDesc = 'EXECUTOR_ID_DESC',
  FileFormatAsc = 'FILE_FORMAT_ASC',
  FileFormatDesc = 'FILE_FORMAT_DESC',
  FileStructureAsc = 'FILE_STRUCTURE_ASC',
  FileStructureDesc = 'FILE_STRUCTURE_DESC',
  FileTypeAsc = 'FILE_TYPE_ASC',
  FileTypeDesc = 'FILE_TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsSeriesAsc = 'IS_SERIES_ASC',
  IsSeriesDesc = 'IS_SERIES_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  LocationAsc = 'LOCATION_ASC',
  LocationDesc = 'LOCATION_DESC',
  MultipartUploadIdAsc = 'MULTIPART_UPLOAD_ID_ASC',
  MultipartUploadIdDesc = 'MULTIPART_UPLOAD_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OriginalNameAsc = 'ORIGINAL_NAME_ASC',
  OriginalNameDesc = 'ORIGINAL_NAME_DESC',
  PartSizeAsc = 'PART_SIZE_ASC',
  PartSizeDesc = 'PART_SIZE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SeriesParentIdAsc = 'SERIES_PARENT_ID_ASC',
  SeriesParentIdDesc = 'SERIES_PARENT_ID_DESC',
  SignalAsc = 'SIGNAL_ASC',
  SignalDesc = 'SIGNAL_DESC',
  SizeAsc = 'SIZE_ASC',
  SizeDesc = 'SIZE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UploadStatusAsc = 'UPLOAD_STATUS_ASC',
  UploadStatusDesc = 'UPLOAD_STATUS_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** All input for the create `ApplicationUserMetadatum` mutation. */
export type CreateApplicationUserMetadatumInput = {
  /** The `ApplicationUserMetadatum` to be created by this mutation. */
  applicationUserMetadatum: ApplicationUserMetadatumInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ApplicationUserMetadatum` mutation. */
export type CreateApplicationUserMetadatumPayload = {
  __typename: 'CreateApplicationUserMetadatumPayload';
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMetadatum`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserMetadatum` that was created by this mutation. */
  applicationUserMetadatum: Maybe<ApplicationUserMetadatum>;
  /** An edge for our `ApplicationUserMetadatum`. May be used by Relay 1. */
  applicationUserMetadatumEdge: Maybe<ApplicationUserMetadataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `ApplicationUserMetadatum` mutation. */
export type CreateApplicationUserMetadatumPayloadApplicationUserMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUserMetadataOrderBy>>;
};

/** All input for the create `ApplicationUserSession` mutation. */
export type CreateApplicationUserSessionInput = {
  /** The `ApplicationUserSession` to be created by this mutation. */
  applicationUserSession: ApplicationUserSessionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ApplicationUserSession` mutation. */
export type CreateApplicationUserSessionPayload = {
  __typename: 'CreateApplicationUserSessionPayload';
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserSession`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserSession` that was created by this mutation. */
  applicationUserSession: Maybe<ApplicationUserSession>;
  /** An edge for our `ApplicationUserSession`. May be used by Relay 1. */
  applicationUserSessionEdge: Maybe<ApplicationUserSessionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserSession`. */
  tenantByTenantId: Maybe<Tenant>;
};


/** The output of our create `ApplicationUserSession` mutation. */
export type CreateApplicationUserSessionPayloadApplicationUserSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};

/** All input for the create `EulaVersionUserAcceptance` mutation. */
export type CreateEulaVersionUserAcceptanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EulaVersionUserAcceptance` to be created by this mutation. */
  eulaVersionUserAcceptance: EulaVersionUserAcceptanceInput;
};

/** The output of our create `EulaVersionUserAcceptance` mutation. */
export type CreateEulaVersionUserAcceptancePayload = {
  __typename: 'CreateEulaVersionUserAcceptancePayload';
  /** Reads a single `ApplicationUser` that is related to this `EulaVersionUserAcceptance`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Reads a single `EulaVersion` that is related to this `EulaVersionUserAcceptance`. */
  eulaVersionByEulaVersionId: Maybe<EulaVersion>;
  /** The `EulaVersionUserAcceptance` that was created by this mutation. */
  eulaVersionUserAcceptance: Maybe<EulaVersionUserAcceptance>;
  /** An edge for our `EulaVersionUserAcceptance`. May be used by Relay 1. */
  eulaVersionUserAcceptanceEdge: Maybe<EulaVersionUserAcceptancesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `EulaVersionUserAcceptance` mutation. */
export type CreateEulaVersionUserAcceptancePayloadEulaVersionUserAcceptanceEdgeArgs = {
  orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
};

/** All input for the create `MetadataValue` mutation. */
export type CreateMetadataValueInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MetadataValue` to be created by this mutation. */
  metadataValue: MetadataValueInput;
};

/** The output of our create `MetadataValue` mutation. */
export type CreateMetadataValuePayload = {
  __typename: 'CreateMetadataValuePayload';
  /** Reads a single `ApplicationUser` that is related to this `MetadataValue`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `MetadataValue` that was created by this mutation. */
  metadataValue: Maybe<MetadataValue>;
  /** An edge for our `MetadataValue`. May be used by Relay 1. */
  metadataValueEdge: Maybe<MetadataValuesEdge>;
  /** Reads a single `Metadatum` that is related to this `MetadataValue`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `MetadataValue`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `MetadataValue`. */
  taskByTaskId: Maybe<Task>;
  /** Reads a single `Tenant` that is related to this `MetadataValue`. */
  tenantByTenantId: Maybe<Tenant>;
};


/** The output of our create `MetadataValue` mutation. */
export type CreateMetadataValuePayloadMetadataValueEdgeArgs = {
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};

/** All input for the create `Metadatum` mutation. */
export type CreateMetadatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Metadatum` to be created by this mutation. */
  metadatum: MetadatumInput;
};

/** The output of our create `Metadatum` mutation. */
export type CreateMetadatumPayload = {
  __typename: 'CreateMetadatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Metadatum` that was created by this mutation. */
  metadatum: Maybe<Metadatum>;
  /** An edge for our `Metadatum`. May be used by Relay 1. */
  metadatumEdge: Maybe<MetadataEdge>;
  /** Reads a single `Project` that is related to this `Metadatum`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Metadatum`. */
  tenantByTenantId: Maybe<Tenant>;
};


/** The output of our create `Metadatum` mutation. */
export type CreateMetadatumPayloadMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<MetadataOrderBy>>;
};

/** All input for the `createRole` mutation. */
export type CreateRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inpt?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `createRole` mutation. */
export type CreateRolePayload = {
  __typename: 'CreateRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** All input for the `createSession` mutation. */
export type CreateSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  tenant?: InputMaybe<Scalars['Int']['input']>;
  userid?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `createSession` mutation. */
export type CreateSessionPayload = {
  __typename: 'CreateSessionPayload';
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserSession`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  applicationUserSession: Maybe<ApplicationUserSession>;
  /** An edge for our `ApplicationUserSession`. May be used by Relay 1. */
  applicationUserSessionEdge: Maybe<ApplicationUserSessionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserSession`. */
  tenantByTenantId: Maybe<Tenant>;
};


/** The output of our `createSession` mutation. */
export type CreateSessionPayloadApplicationUserSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};

export type CurrentApplicationUser = {
  __typename: 'CurrentApplicationUser';
  email: Maybe<Scalars['String']['output']>;
  globalUserId: Maybe<Scalars['UUID']['output']>;
  id: Maybe<Scalars['UUID']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `CurrentApplicationUser` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CurrentApplicationUserCondition = {
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `globalUserId` field. */
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `username` field. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CurrentApplicationUser` object types. All fields are combined with a logical ‘and.’ */
export type CurrentApplicationUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CurrentApplicationUserFilter>>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `globalUserId` field. */
  globalUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CurrentApplicationUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CurrentApplicationUserFilter>>;
  /** Filter by the object’s `username` field. */
  username?: InputMaybe<StringFilter>;
};

/** A connection to a list of `CurrentApplicationUser` values. */
export type CurrentApplicationUsersConnection = {
  __typename: 'CurrentApplicationUsersConnection';
  /** A list of edges which contains the `CurrentApplicationUser` and cursor to aid in pagination. */
  edges: Array<CurrentApplicationUsersEdge>;
  /** A list of `CurrentApplicationUser` objects. */
  nodes: Array<CurrentApplicationUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CurrentApplicationUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CurrentApplicationUser` edge in the connection. */
export type CurrentApplicationUsersEdge = {
  __typename: 'CurrentApplicationUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `CurrentApplicationUser` at the end of the edge. */
  node: CurrentApplicationUser;
};

/** Methods to use when ordering `CurrentApplicationUser`. */
export enum CurrentApplicationUsersOrderBy {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  GlobalUserIdAsc = 'GLOBAL_USER_ID_ASC',
  GlobalUserIdDesc = 'GLOBAL_USER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  Natural = 'NATURAL',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC'
}

export type CurrentUserMembership = {
  __typename: 'CurrentUserMembership';
  role: Maybe<Scalars['Int']['output']>;
  tenantId: Maybe<Scalars['Int']['output']>;
  userId: Maybe<Scalars['UUID']['output']>;
};

/**
 * A condition to be used against `CurrentUserMembership` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CurrentUserMembershipCondition = {
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `CurrentUserMembership` object types. All fields are combined with a logical ‘and.’ */
export type CurrentUserMembershipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CurrentUserMembershipFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<CurrentUserMembershipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CurrentUserMembershipFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `CurrentUserMembership` values. */
export type CurrentUserMembershipsConnection = {
  __typename: 'CurrentUserMembershipsConnection';
  /** A list of edges which contains the `CurrentUserMembership` and cursor to aid in pagination. */
  edges: Array<CurrentUserMembershipsEdge>;
  /** A list of `CurrentUserMembership` objects. */
  nodes: Array<CurrentUserMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CurrentUserMembership` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CurrentUserMembership` edge in the connection. */
export type CurrentUserMembershipsEdge = {
  __typename: 'CurrentUserMembershipsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `CurrentUserMembership` at the end of the edge. */
  node: CurrentUserMembership;
};

/** Methods to use when ordering `CurrentUserMembership`. */
export enum CurrentUserMembershipsOrderBy {
  Natural = 'NATURAL',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type DataTable = {
  __typename: 'DataTable';
  /** Reads a single `ApplicationUser` that is related to this `DataTable`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars['Datetime']['output'];
  dateDeleted: Maybe<Scalars['Datetime']['output']>;
  description: Scalars['String']['output'];
  folderId: Maybe<Scalars['UUID']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Reads a single `Project` that is related to this `DataTable`. */
  projectByProjectId: Maybe<Project>;
  /** Reads a single `ProjectFolder` that is related to this `DataTable`. */
  projectFolderByFolderId: Maybe<ProjectFolder>;
  projectId: Scalars['UUID']['output'];
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `DataTable` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DataTableCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `folderId` field. */
  folderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `hidden` field. */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `dataTable` to look up the row to connect. */
export type DataTableDataTablePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A filter to be used against `DataTable` object types. All fields are combined with a logical ‘and.’ */
export type DataTableFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `folderId` field. */
  folderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `hidden` field. */
  hidden?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectFolderByFolderId` relation. */
  projectFolderByFolderId?: InputMaybe<ProjectFolderFilter>;
  /** A related `projectFolderByFolderId` exists. */
  projectFolderByFolderIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `projectFolder` in the `DataTableInput` mutation. */
export type DataTableFolderId4Fe6C7FeFkProjectFolderIdInput = {
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectFolderProjectFolderPkeyConnect>;
  /** The primary key(s) and patch data for `projectFolder` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate>;
};

/** Input for the nested mutation of `dataTable` in the `ProjectFolderInput` mutation. */
export type DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput = {
  /** The primary key(s) for `dataTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableDataTablePkeyConnect>>;
  /** The primary key(s) and patch data for `dataTable` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate>>;
};

/** The fields on `dataTable` to look up the row to update. */
export type DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate = {
  /** An object where the defined keys will be set on the `dataTable` being updated. */
  dataTablePatch: UpdateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `dataTable` to look up the row to update. */
export type DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate = {
  /** An object where the defined keys will be set on the `dataTable` being updated. */
  dataTablePatch: UpdateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `dataTable` to look up the row to update. */
export type DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate = {
  /** An object where the defined keys will be set on the `dataTable` being updated. */
  dataTablePatch: UpdateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `project` in the `DataTableInput` mutation. */
export type DataTableProjectId59F60EaeFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTable` in the `ProjectInput` mutation. */
export type DataTableProjectId59F60EaeFkProjectIdInverseInput = {
  /** The primary key(s) for `dataTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableDataTablePkeyConnect>>;
  /** The primary key(s) and patch data for `dataTable` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate>>;
};

/** Input for the nested mutation of `applicationUser` in the `DataTableInput` mutation. */
export type DataTableUserIdAb79B056FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `dataTable` in the `ApplicationUserInput` mutation. */
export type DataTableUserIdAb79B056FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `dataTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableDataTablePkeyConnect>>;
  /** The primary key(s) and patch data for `dataTable` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate>>;
};

/** A connection to a list of `DataTable` values. */
export type DataTablesConnection = {
  __typename: 'DataTablesConnection';
  /** A list of edges which contains the `DataTable` and cursor to aid in pagination. */
  edges: Array<DataTablesEdge>;
  /** A list of `DataTable` objects. */
  nodes: Array<DataTable>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTable` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DataTable` edge in the connection. */
export type DataTablesEdge = {
  __typename: 'DataTablesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `DataTable` at the end of the edge. */
  node: DataTable;
};

/** Methods to use when ordering `DataTable`. */
export enum DataTablesOrderBy {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DateDeletedAsc = 'DATE_DELETED_ASC',
  DateDeletedDesc = 'DATE_DELETED_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  FolderIdAsc = 'FOLDER_ID_ASC',
  FolderIdDesc = 'FOLDER_ID_DESC',
  HiddenAsc = 'HIDDEN_ASC',
  HiddenDesc = 'HIDDEN_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** All input for the `deleteSession` mutation. */
export type DeleteSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `deleteSession` mutation. */
export type DeleteSessionPayload = {
  __typename: 'DeleteSessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

export type EulaVersion = {
  __typename: 'EulaVersion';
  content: Scalars['String']['output'];
  dateCreated: Scalars['Datetime']['output'];
  dateVersion: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `EulaVersionUserAcceptance`. */
  eulaVersionUserAcceptancesByEulaVersionId: EulaVersionUserAcceptancesConnection;
  id: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};


export type EulaVersionEulaVersionUserAcceptancesByEulaVersionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EulaVersionUserAcceptanceCondition>;
  filter?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
};

/**
 * A condition to be used against `EulaVersion` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EulaVersionCondition = {
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateVersion` field. */
  dateVersion?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** The fields on `eulaVersion` to look up the row to connect. */
export type EulaVersionEulaVersionPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** The fields on `eulaVersion` to look up the row to connect. */
export type EulaVersionEulaVersionVersionKeyConnect = {
  version: Scalars['String']['input'];
};

/** A filter to be used against `EulaVersion` object types. All fields are combined with a logical ‘and.’ */
export type EulaVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EulaVersionFilter>>;
  /** Filter by the object’s `content` field. */
  content?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateVersion` field. */
  dateVersion?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eulaVersionUserAcceptancesByEulaVersionId` relation. */
  eulaVersionUserAcceptancesByEulaVersionId?: InputMaybe<EulaVersionToManyEulaVersionUserAcceptanceFilter>;
  /** Some related `eulaVersionUserAcceptancesByEulaVersionId` exist. */
  eulaVersionUserAcceptancesByEulaVersionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EulaVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EulaVersionFilter>>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<StringFilter>;
};

/** The fields on `eulaVersion` to look up the row to update. */
export type EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate = {
  /** An object where the defined keys will be set on the `eulaVersion` being updated. */
  eulaVersionPatch: UpdateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  id: Scalars['Int']['input'];
};

/** The fields on `eulaVersion` to look up the row to update. */
export type EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate = {
  /** An object where the defined keys will be set on the `eulaVersion` being updated. */
  eulaVersionPatch: UpdateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  version: Scalars['String']['input'];
};

/** A filter to be used against many `EulaVersionUserAcceptance` object types. All fields are combined with a logical ‘and.’ */
export type EulaVersionToManyEulaVersionUserAcceptanceFilter = {
  /** Every related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  /** No related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  /** Some related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EulaVersionUserAcceptanceFilter>;
};

/** The `eulaVersionUserAcceptance` to be created by this mutation. */
export type EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput = {
  accepted: Scalars['Boolean']['input'];
  applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
  dateReviewed?: InputMaybe<Scalars['Datetime']['input']>;
  eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
  id: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for the nested mutation of `eulaVersion` in the `EulaVersionUserAcceptanceInput` mutation. */
export type EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput = {
  /** The primary key(s) for `eulaVersion` for the far side of the relationship. */
  connectById?: InputMaybe<EulaVersionEulaVersionPkeyConnect>;
  /** The primary key(s) for `eulaVersion` for the far side of the relationship. */
  connectByVersion?: InputMaybe<EulaVersionEulaVersionVersionKeyConnect>;
  /** The primary key(s) and patch data for `eulaVersion` for the far side of the relationship. */
  updateById?: InputMaybe<EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate>;
  /** The primary key(s) and patch data for `eulaVersion` for the far side of the relationship. */
  updateByVersion?: InputMaybe<EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate>;
};

/** Input for the nested mutation of `eulaVersionUserAcceptance` in the `EulaVersionInput` mutation. */
export type EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput = {
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect>>;
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  connectByUserIdAndEulaVersionId?: InputMaybe<Array<EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect>>;
  /** A `EulaVersionUserAcceptanceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput>>;
  /** The primary key(s) and patch data for `eulaVersionUserAcceptance` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate>>;
  /** The primary key(s) and patch data for `eulaVersionUserAcceptance` for the far side of the relationship. */
  updateByUserIdAndEulaVersionId?: InputMaybe<Array<EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate>>;
};

/** The `eulaVersionUserAcceptance` to be created by this mutation. */
export type EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput = {
  accepted: Scalars['Boolean']['input'];
  applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
  dateReviewed?: InputMaybe<Scalars['Datetime']['input']>;
  eulaVersionId?: InputMaybe<Scalars['Int']['input']>;
  eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `applicationUser` in the `EulaVersionUserAcceptanceInput` mutation. */
export type EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `eulaVersionUserAcceptance` in the `ApplicationUserInput` mutation. */
export type EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput = {
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect>>;
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  connectByUserIdAndEulaVersionId?: InputMaybe<Array<EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect>>;
  /** A `EulaVersionUserAcceptanceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput>>;
  /** The primary key(s) and patch data for `eulaVersionUserAcceptance` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate>>;
  /** The primary key(s) and patch data for `eulaVersionUserAcceptance` for the far side of the relationship. */
  updateByUserIdAndEulaVersionId?: InputMaybe<Array<EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate>>;
};

export type EulaVersionUserAcceptance = {
  __typename: 'EulaVersionUserAcceptance';
  accepted: Scalars['Boolean']['output'];
  /** Reads a single `ApplicationUser` that is related to this `EulaVersionUserAcceptance`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateReviewed: Scalars['Datetime']['output'];
  /** Reads a single `EulaVersion` that is related to this `EulaVersionUserAcceptance`. */
  eulaVersionByEulaVersionId: Maybe<EulaVersion>;
  eulaVersionId: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `EulaVersionUserAcceptance` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EulaVersionUserAcceptanceCondition = {
  /** Checks for equality with the object’s `accepted` field. */
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dateReviewed` field. */
  dateReviewed?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `eulaVersionId` field. */
  eulaVersionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to connect. */
export type EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to connect. */
export type EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect = {
  eulaVersionId: Scalars['Int']['input'];
  userId: Scalars['UUID']['input'];
};

/** A filter to be used against `EulaVersionUserAcceptance` object types. All fields are combined with a logical ‘and.’ */
export type EulaVersionUserAcceptanceFilter = {
  /** Filter by the object’s `accepted` field. */
  accepted?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EulaVersionUserAcceptanceFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateReviewed` field. */
  dateReviewed?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eulaVersionByEulaVersionId` relation. */
  eulaVersionByEulaVersionId?: InputMaybe<EulaVersionFilter>;
  /** Filter by the object’s `eulaVersionId` field. */
  eulaVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EulaVersionUserAcceptanceFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `EulaVersionUserAcceptance` */
export type EulaVersionUserAcceptanceInput = {
  accepted: Scalars['Boolean']['input'];
  applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
  dateReviewed?: InputMaybe<Scalars['Datetime']['input']>;
  eulaVersionId?: InputMaybe<Scalars['Int']['input']>;
  eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
  id: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to update. */
export type EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate = {
  /** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
  eulaVersionUserAcceptancePatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to update. */
export type EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate = {
  eulaVersionId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
  eulaVersionUserAcceptancePatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  userId: Scalars['UUID']['input'];
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to update. */
export type EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate = {
  /** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
  eulaVersionUserAcceptancePatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to update. */
export type EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate = {
  eulaVersionId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
  eulaVersionUserAcceptancePatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  userId: Scalars['UUID']['input'];
};

/** A connection to a list of `EulaVersionUserAcceptance` values. */
export type EulaVersionUserAcceptancesConnection = {
  __typename: 'EulaVersionUserAcceptancesConnection';
  /** A list of edges which contains the `EulaVersionUserAcceptance` and cursor to aid in pagination. */
  edges: Array<EulaVersionUserAcceptancesEdge>;
  /** A list of `EulaVersionUserAcceptance` objects. */
  nodes: Array<EulaVersionUserAcceptance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EulaVersionUserAcceptance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EulaVersionUserAcceptance` edge in the connection. */
export type EulaVersionUserAcceptancesEdge = {
  __typename: 'EulaVersionUserAcceptancesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `EulaVersionUserAcceptance` at the end of the edge. */
  node: EulaVersionUserAcceptance;
};

/** Methods to use when ordering `EulaVersionUserAcceptance`. */
export enum EulaVersionUserAcceptancesOrderBy {
  AcceptedAsc = 'ACCEPTED_ASC',
  AcceptedDesc = 'ACCEPTED_DESC',
  DateReviewedAsc = 'DATE_REVIEWED_ASC',
  DateReviewedDesc = 'DATE_REVIEWED_DESC',
  EulaVersionIdAsc = 'EULA_VERSION_ID_ASC',
  EulaVersionIdDesc = 'EULA_VERSION_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A connection to a list of `EulaVersion` values. */
export type EulaVersionsConnection = {
  __typename: 'EulaVersionsConnection';
  /** A list of edges which contains the `EulaVersion` and cursor to aid in pagination. */
  edges: Array<EulaVersionsEdge>;
  /** A list of `EulaVersion` objects. */
  nodes: Array<EulaVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EulaVersion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EulaVersion` edge in the connection. */
export type EulaVersionsEdge = {
  __typename: 'EulaVersionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `EulaVersion` at the end of the edge. */
  node: EulaVersion;
};

/** Methods to use when ordering `EulaVersion`. */
export enum EulaVersionsOrderBy {
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DateVersionAsc = 'DATE_VERSION_ASC',
  DateVersionDesc = 'DATE_VERSION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC'
}

export type File = {
  __typename: 'File';
  /** Reads a single `ApplicationUser` that is related to this `File`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateArchived: Maybe<Scalars['Datetime']['output']>;
  dateCreated: Scalars['Datetime']['output'];
  dateDataDeleted: Maybe<Scalars['Datetime']['output']>;
  dateDeleted: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `FileActivity`. */
  fileActivitiesByFileId: FileActivitiesConnection;
  /** Reads a single `File` that is related to this `File`. */
  fileBySeriesParentId: Maybe<File>;
  fileFormat: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `FileMetadatum`. */
  fileMetadataByFileId: FileMetadataConnection;
  /** Reads and enables pagination through a set of `FileProcessingNotification`. */
  fileProcessingNotificationsByFileId: FileProcessingNotificationsConnection;
  fileStructure: Maybe<Scalars['Int']['output']>;
  fileType: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `File`. */
  filesBySeriesParentId: FilesConnection;
  id: Scalars['UUID']['output'];
  isSeries: Scalars['Boolean']['output'];
  key: Maybe<Scalars['String']['output']>;
  location: Maybe<Scalars['String']['output']>;
  multipartUploadId: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `OutputGroupFile`. */
  outputGroupFilesByFileId: OutputGroupFilesConnection;
  parentIds: Maybe<Scalars['JSON']['output']>;
  partSize: Maybe<Scalars['Int']['output']>;
  preview: Maybe<Scalars['JSON']['output']>;
  processingStatus: Scalars['Int']['output'];
  /** Reads a single `Project` that is related to this `File`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
  referenceId: Scalars['UUID']['output'];
  seriesOrder: Maybe<Scalars['Int']['output']>;
  seriesParentId: Maybe<Scalars['UUID']['output']>;
  signal: Maybe<Scalars['Int']['output']>;
  size: Maybe<Scalars['BigInt']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tags: Array<Maybe<Scalars['String']['output']>>;
  /** Reads a single `Task` that is related to this `File`. */
  taskByTaskId: Maybe<Task>;
  taskId: Maybe<Scalars['UUID']['output']>;
  /** Reads and enables pagination through a set of `TaskSource`. */
  taskSourcesByFileId: TaskSourcesConnection;
  /** Reads a single `Tenant` that is related to this `File`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
  uploadStatus: Maybe<Scalars['Int']['output']>;
  userId: Scalars['UUID']['output'];
};


export type FileFileActivitiesByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};


export type FileFileMetadataByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};


export type FileFileProcessingNotificationsByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileProcessingNotificationCondition>;
  filter?: InputMaybe<FileProcessingNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileProcessingNotificationsOrderBy>>;
};


export type FileFilesBySeriesParentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type FileOutputGroupFilesByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OutputGroupFileCondition>;
  filter?: InputMaybe<OutputGroupFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};


export type FileTaskSourcesByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskSourceCondition>;
  filter?: InputMaybe<TaskSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

/** A connection to a list of `FileActivity` values. */
export type FileActivitiesConnection = {
  __typename: 'FileActivitiesConnection';
  /** A list of edges which contains the `FileActivity` and cursor to aid in pagination. */
  edges: Array<FileActivitiesEdge>;
  /** A list of `FileActivity` objects. */
  nodes: Array<FileActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileActivity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FileActivity` edge in the connection. */
export type FileActivitiesEdge = {
  __typename: 'FileActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FileActivity` at the end of the edge. */
  node: FileActivity;
};

/** Methods to use when ordering `FileActivity`. */
export enum FileActivitiesOrderBy {
  ActivityTypeAsc = 'ACTIVITY_TYPE_ASC',
  ActivityTypeDesc = 'ACTIVITY_TYPE_DESC',
  BytesAsc = 'BYTES_ASC',
  BytesDesc = 'BYTES_DESC',
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  ContentTypeIdAsc = 'CONTENT_TYPE_ID_ASC',
  ContentTypeIdDesc = 'CONTENT_TYPE_ID_DESC',
  CostIdAsc = 'COST_ID_ASC',
  CostIdDesc = 'COST_ID_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  FileIdAsc = 'FILE_ID_ASC',
  FileIdDesc = 'FILE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type FileActivity = {
  __typename: 'FileActivity';
  activityType: Scalars['Int']['output'];
  /** Reads a single `ApplicationUser` that is related to this `FileActivity`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  bytes: Maybe<Scalars['BigInt']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  contentTypeId: Maybe<Scalars['Int']['output']>;
  costId: Maybe<Scalars['BigInt']['output']>;
  dateCreated: Scalars['Datetime']['output'];
  /** Reads a single `File` that is related to this `FileActivity`. */
  fileByFileId: Maybe<File>;
  fileId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['Int']['output'];
  objectId: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `Project` that is related to this `FileActivity`. */
  projectByProjectId: Maybe<Project>;
  projectId: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `Tenant` that is related to this `FileActivity`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Maybe<Scalars['Int']['output']>;
  userId: Maybe<Scalars['UUID']['output']>;
};

/**
 * A condition to be used against `FileActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FileActivityCondition = {
  /** Checks for equality with the object’s `activityType` field. */
  activityType?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `bytes` field. */
  bytes?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `comment` field. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `contentTypeId` field. */
  contentTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `costId` field. */
  costId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `fileActivity` to look up the row to connect. */
export type FileActivityFileActivityPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** Input for the nested mutation of `file` in the `FileActivityInput` mutation. */
export type FileActivityFileId015763A9FkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `fileActivity` in the `FileInput` mutation. */
export type FileActivityFileId015763A9FkFileIdInverseInput = {
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileActivityFileActivityPkeyConnect>>;
  /** The primary key(s) and patch data for `fileActivity` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate>>;
};

/** A filter to be used against `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type FileActivityFilter = {
  /** Filter by the object’s `activityType` field. */
  activityType?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileActivityFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `bytes` field. */
  bytes?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `comment` field. */
  comment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contentTypeId` field. */
  contentTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `costId` field. */
  costId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileByFileId` relation. */
  fileByFileId?: InputMaybe<FileFilter>;
  /** A related `fileByFileId` exists. */
  fileByFileIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileActivityFilter>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileActivityFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** A related `projectByProjectId` exists. */
  projectByProjectIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** A related `tenantByTenantId` exists. */
  tenantByTenantIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `fileActivity` to look up the row to update. */
export type FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileActivity` being updated. */
  fileActivityPatch: UpdateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  id: Scalars['Int']['input'];
};

/** The fields on `fileActivity` to look up the row to update. */
export type FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileActivity` being updated. */
  fileActivityPatch: UpdateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  id: Scalars['Int']['input'];
};

/** The fields on `fileActivity` to look up the row to update. */
export type FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileActivity` being updated. */
  fileActivityPatch: UpdateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  id: Scalars['Int']['input'];
};

/** The fields on `fileActivity` to look up the row to update. */
export type FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileActivity` being updated. */
  fileActivityPatch: UpdateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  id: Scalars['Int']['input'];
};

/** Input for the nested mutation of `project` in the `FileActivityInput` mutation. */
export type FileActivityProjectId6F35B8CcFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `fileActivity` in the `ProjectInput` mutation. */
export type FileActivityProjectId6F35B8CcFkProjectIdInverseInput = {
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileActivityFileActivityPkeyConnect>>;
  /** The primary key(s) and patch data for `fileActivity` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate>>;
};

/** Input for the nested mutation of `tenant` in the `FileActivityInput` mutation. */
export type FileActivityTenantIdC46A4F01FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `fileActivity` in the `TenantInput` mutation. */
export type FileActivityTenantIdC46A4F01FkTenantIdInverseInput = {
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileActivityFileActivityPkeyConnect>>;
  /** The primary key(s) and patch data for `fileActivity` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate>>;
};

/** Input for the nested mutation of `applicationUser` in the `FileActivityInput` mutation. */
export type FileActivityUserId868Ad8A9FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `fileActivity` in the `ApplicationUserInput` mutation. */
export type FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileActivityFileActivityPkeyConnect>>;
  /** The primary key(s) and patch data for `fileActivity` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate>>;
};

/** A condition to be used against `File` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FileCondition = {
  /** Checks for equality with the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fileFormat` field. */
  fileFormat?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fileStructure` field. */
  fileStructure?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fileType` field. */
  fileType?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `isSeries` field. */
  isSeries?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `location` field. */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `multipartUploadId` field. */
  multipartUploadId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `originalName` field. */
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `parentIds` field. */
  parentIds?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `partSize` field. */
  partSize?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `preview` field. */
  preview?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `processingStatus` field. */
  processingStatus?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `referenceId` field. */
  referenceId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `seriesOrder` field. */
  seriesOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `seriesParentId` field. */
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `signal` field. */
  signal?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `size` field. */
  size?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `source` field. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `uploadStatus` field. */
  uploadStatus?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `file` to look up the row to connect. */
export type FileFilePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A filter to be used against `File` object types. All fields are combined with a logical ‘and.’ */
export type FileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileActivitiesByFileId` relation. */
  fileActivitiesByFileId?: InputMaybe<FileToManyFileActivityFilter>;
  /** Some related `fileActivitiesByFileId` exist. */
  fileActivitiesByFileIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileBySeriesParentId` relation. */
  fileBySeriesParentId?: InputMaybe<FileFilter>;
  /** A related `fileBySeriesParentId` exists. */
  fileBySeriesParentIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileFormat` field. */
  fileFormat?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fileMetadataByFileId` relation. */
  fileMetadataByFileId?: InputMaybe<FileToManyFileMetadatumFilter>;
  /** Some related `fileMetadataByFileId` exist. */
  fileMetadataByFileIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileProcessingNotificationsByFileId` relation. */
  fileProcessingNotificationsByFileId?: InputMaybe<FileToManyFileProcessingNotificationFilter>;
  /** Some related `fileProcessingNotificationsByFileId` exist. */
  fileProcessingNotificationsByFileIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileStructure` field. */
  fileStructure?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fileType` field. */
  fileType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `filesBySeriesParentId` relation. */
  filesBySeriesParentId?: InputMaybe<FileToManyFileFilter>;
  /** Some related `filesBySeriesParentId` exist. */
  filesBySeriesParentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isSeries` field. */
  isSeries?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `location` field. */
  location?: InputMaybe<StringFilter>;
  /** Filter by the object’s `multipartUploadId` field. */
  multipartUploadId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileFilter>>;
  /** Filter by the object’s `originalName` field. */
  originalName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `outputGroupFilesByFileId` relation. */
  outputGroupFilesByFileId?: InputMaybe<FileToManyOutputGroupFileFilter>;
  /** Some related `outputGroupFilesByFileId` exist. */
  outputGroupFilesByFileIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `parentIds` field. */
  parentIds?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `partSize` field. */
  partSize?: InputMaybe<IntFilter>;
  /** Filter by the object’s `preview` field. */
  preview?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `processingStatus` field. */
  processingStatus?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `referenceId` field. */
  referenceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `seriesOrder` field. */
  seriesOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `seriesParentId` field. */
  seriesParentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `signal` field. */
  signal?: InputMaybe<IntFilter>;
  /** Filter by the object’s `size` field. */
  size?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `source` field. */
  source?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** A related `taskByTaskId` exists. */
  taskByTaskIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `taskSourcesByFileId` relation. */
  taskSourcesByFileId?: InputMaybe<FileToManyTaskSourceFilter>;
  /** Some related `taskSourcesByFileId` exist. */
  taskSourcesByFileIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `uploadStatus` field. */
  uploadStatus?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `FileMetadatum` values. */
export type FileMetadataConnection = {
  __typename: 'FileMetadataConnection';
  /** A list of edges which contains the `FileMetadatum` and cursor to aid in pagination. */
  edges: Array<FileMetadataEdge>;
  /** A list of `FileMetadatum` objects. */
  nodes: Array<FileMetadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileMetadatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FileMetadatum` edge in the connection. */
export type FileMetadataEdge = {
  __typename: 'FileMetadataEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FileMetadatum` at the end of the edge. */
  node: FileMetadatum;
};

/** Input for the nested mutation of `file` in the `FileMetadatumInput` mutation. */
export type FileMetadataFileId78256936FkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `fileMetadatum` in the `FileInput` mutation. */
export type FileMetadataFileId78256936FkFileIdInverseInput = {
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyConnect>>;
  /** The primary key(s) and patch data for `fileMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate>>;
};

/** Input for the nested mutation of `metadatum` in the `FileMetadatumInput` mutation. */
export type FileMetadataMetadataIdFefc0061FkMetadataIdInput = {
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  connectById?: InputMaybe<MetadatumMetadataPkeyConnect>;
  /** The primary key(s) and patch data for `metadatum` for the far side of the relationship. */
  updateById?: InputMaybe<MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate>;
};

/** Input for the nested mutation of `fileMetadatum` in the `MetadatumInput` mutation. */
export type FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput = {
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyConnect>>;
  /** The primary key(s) and patch data for `fileMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate>>;
};

/** Methods to use when ordering `FileMetadatum`. */
export enum FileMetadataOrderBy {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  FileIdAsc = 'FILE_ID_ASC',
  FileIdDesc = 'FILE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MetadataIdAsc = 'METADATA_ID_ASC',
  MetadataIdDesc = 'METADATA_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

/** Input for the nested mutation of `project` in the `FileMetadatumInput` mutation. */
export type FileMetadataProjectId3474994EFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `fileMetadatum` in the `ProjectInput` mutation. */
export type FileMetadataProjectId3474994EFkProjectIdInverseInput = {
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyConnect>>;
  /** The primary key(s) and patch data for `fileMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate>>;
};

/** Input for the nested mutation of `tenant` in the `FileMetadatumInput` mutation. */
export type FileMetadataTenantId79Fe438BFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `fileMetadatum` in the `TenantInput` mutation. */
export type FileMetadataTenantId79Fe438BFkTenantIdInverseInput = {
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyConnect>>;
  /** The primary key(s) and patch data for `fileMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate>>;
};

export type FileMetadatum = {
  __typename: 'FileMetadatum';
  dateCreated: Scalars['Datetime']['output'];
  /** Reads a single `File` that is related to this `FileMetadatum`. */
  fileByFileId: Maybe<File>;
  fileId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  metadataId: Scalars['UUID']['output'];
  /** Reads a single `Metadatum` that is related to this `FileMetadatum`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `FileMetadatum`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
  /** Reads a single `Tenant` that is related to this `FileMetadatum`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `FileMetadatum` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FileMetadatumCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `metadataId` field. */
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
};

/** The fields on `fileMetadatum` to look up the row to connect. */
export type FileMetadatumFileMetadataPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A filter to be used against `FileMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type FileMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileMetadatumFilter>>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileByFileId` relation. */
  fileByFileId?: InputMaybe<FileFilter>;
  /** A related `fileByFileId` exists. */
  fileByFileIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadataId` field. */
  metadataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadatumByMetadataId` relation. */
  metadatumByMetadataId?: InputMaybe<MetadatumFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileMetadatumFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
};

/** The fields on `fileMetadatum` to look up the row to update. */
export type FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileMetadatum` being updated. */
  fileMetadatumPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileMetadatum` to look up the row to update. */
export type FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileMetadatum` being updated. */
  fileMetadatumPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileMetadatum` to look up the row to update. */
export type FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileMetadatum` being updated. */
  fileMetadatumPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileMetadatum` to look up the row to update. */
export type FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileMetadatum` being updated. */
  fileMetadatumPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch;
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileTenantId61625016FkTenantIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileTenantId61625016FkTenantIdPatch;
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `file` to look up the row to update. */
export type FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

export type FileOutputGroup = {
  __typename: 'FileOutputGroup';
  /** Reads a single `ApplicationUser` that is related to this `FileOutputGroup`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. */
  fileOutputGroupMetadataByFileOutputGroupId: FileOutputGroupMetadataConnection;
  groupType: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  key: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `OutputGroupFile`. */
  outputGroupFilesByFileOutputGroupId: OutputGroupFilesConnection;
  /** Reads a single `Project` that is related to this `FileOutputGroup`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
  /** Reads a single `Task` that is related to this `FileOutputGroup`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars['UUID']['output'];
  /** Reads a single `Tenant` that is related to this `FileOutputGroup`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
  userId: Scalars['UUID']['output'];
};


export type FileOutputGroupFileOutputGroupMetadataByFileOutputGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};


export type FileOutputGroupOutputGroupFilesByFileOutputGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OutputGroupFileCondition>;
  filter?: InputMaybe<OutputGroupFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};

/**
 * A condition to be used against `FileOutputGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FileOutputGroupCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `groupType` field. */
  groupType?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `fileOutputGroup` to look up the row to connect. */
export type FileOutputGroupFileOutputGroupPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to connect. */
export type FileOutputGroupFileOutputGroupTaskIdKeyConnect = {
  taskId: Scalars['UUID']['input'];
};

/** A filter to be used against `FileOutputGroup` object types. All fields are combined with a logical ‘and.’ */
export type FileOutputGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileOutputGroupFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileOutputGroupMetadataByFileOutputGroupId` relation. */
  fileOutputGroupMetadataByFileOutputGroupId?: InputMaybe<FileOutputGroupToManyFileOutputGroupMetadatumFilter>;
  /** Some related `fileOutputGroupMetadataByFileOutputGroupId` exist. */
  fileOutputGroupMetadataByFileOutputGroupIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `groupType` field. */
  groupType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileOutputGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileOutputGroupFilter>>;
  /** Filter by the object’s `outputGroupFilesByFileOutputGroupId` relation. */
  outputGroupFilesByFileOutputGroupId?: InputMaybe<FileOutputGroupToManyOutputGroupFileFilter>;
  /** Some related `outputGroupFilesByFileOutputGroupId` exist. */
  outputGroupFilesByFileOutputGroupIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `fileOutputGroup` in the `FileOutputGroupMetadatumInput` mutation. */
export type FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FileOutputGroupFileOutputGroupPkeyConnect>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<FileOutputGroupFileOutputGroupTaskIdKeyConnect>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroupMetadatum` in the `FileOutputGroupInput` mutation. */
export type FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput = {
  /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect>>;
  /** The primary key(s) and patch data for `fileOutputGroupMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate>>;
};

/** A connection to a list of `FileOutputGroupMetadatum` values. */
export type FileOutputGroupMetadataConnection = {
  __typename: 'FileOutputGroupMetadataConnection';
  /** A list of edges which contains the `FileOutputGroupMetadatum` and cursor to aid in pagination. */
  edges: Array<FileOutputGroupMetadataEdge>;
  /** A list of `FileOutputGroupMetadatum` objects. */
  nodes: Array<FileOutputGroupMetadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileOutputGroupMetadatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FileOutputGroupMetadatum` edge in the connection. */
export type FileOutputGroupMetadataEdge = {
  __typename: 'FileOutputGroupMetadataEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FileOutputGroupMetadatum` at the end of the edge. */
  node: FileOutputGroupMetadatum;
};

/** Input for the nested mutation of `metadatum` in the `FileOutputGroupMetadatumInput` mutation. */
export type FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput = {
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  connectById?: InputMaybe<MetadatumMetadataPkeyConnect>;
  /** The primary key(s) and patch data for `metadatum` for the far side of the relationship. */
  updateById?: InputMaybe<MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroupMetadatum` in the `MetadatumInput` mutation. */
export type FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput = {
  /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect>>;
  /** The primary key(s) and patch data for `fileOutputGroupMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate>>;
};

/** Methods to use when ordering `FileOutputGroupMetadatum`. */
export enum FileOutputGroupMetadataOrderBy {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  FileOutputGroupIdAsc = 'FILE_OUTPUT_GROUP_ID_ASC',
  FileOutputGroupIdDesc = 'FILE_OUTPUT_GROUP_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MetadataIdAsc = 'METADATA_ID_ASC',
  MetadataIdDesc = 'METADATA_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

/** Input for the nested mutation of `project` in the `FileOutputGroupMetadatumInput` mutation. */
export type FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `fileOutputGroupMetadatum` in the `ProjectInput` mutation. */
export type FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput = {
  /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect>>;
  /** The primary key(s) and patch data for `fileOutputGroupMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate>>;
};

/** Input for the nested mutation of `tenant` in the `FileOutputGroupMetadatumInput` mutation. */
export type FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroupMetadatum` in the `TenantInput` mutation. */
export type FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput = {
  /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect>>;
  /** The primary key(s) and patch data for `fileOutputGroupMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate>>;
};

export type FileOutputGroupMetadatum = {
  __typename: 'FileOutputGroupMetadatum';
  dateCreated: Scalars['Datetime']['output'];
  /** Reads a single `FileOutputGroup` that is related to this `FileOutputGroupMetadatum`. */
  fileOutputGroupByFileOutputGroupId: Maybe<FileOutputGroup>;
  fileOutputGroupId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  metadataId: Scalars['UUID']['output'];
  /** Reads a single `Metadatum` that is related to this `FileOutputGroupMetadatum`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `FileOutputGroupMetadatum`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
  /** Reads a single `Tenant` that is related to this `FileOutputGroupMetadatum`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `FileOutputGroupMetadatum` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type FileOutputGroupMetadatumCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fileOutputGroupId` field. */
  fileOutputGroupId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `metadataId` field. */
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
};

/** The fields on `fileOutputGroupMetadatum` to look up the row to connect. */
export type FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A filter to be used against `FileOutputGroupMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type FileOutputGroupMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileOutputGroupMetadatumFilter>>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileOutputGroupByFileOutputGroupId` relation. */
  fileOutputGroupByFileOutputGroupId?: InputMaybe<FileOutputGroupFilter>;
  /** A related `fileOutputGroupByFileOutputGroupId` exists. */
  fileOutputGroupByFileOutputGroupIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileOutputGroupId` field. */
  fileOutputGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadataId` field. */
  metadataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadatumByMetadataId` relation. */
  metadatumByMetadataId?: InputMaybe<MetadatumFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileOutputGroupMetadatumFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
};

/** The fields on `fileOutputGroupMetadatum` to look up the row to update. */
export type FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
  fileOutputGroupMetadatumPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroupMetadatum` to look up the row to update. */
export type FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
  fileOutputGroupMetadatumPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroupMetadatum` to look up the row to update. */
export type FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
  fileOutputGroupMetadatumPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroupMetadatum` to look up the row to update. */
export type FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
  fileOutputGroupMetadatumPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  taskId: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  taskId: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  taskId: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  taskId: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  taskId: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate = {
  /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
  fileOutputGroupPatch: UpdateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  taskId: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `project` in the `FileOutputGroupInput` mutation. */
export type FileOutputGroupProjectId908Fb9FfFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `fileOutputGroup` in the `ProjectInput` mutation. */
export type FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileOutputGroupFileOutputGroupPkeyConnect>>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<Array<FileOutputGroupFileOutputGroupTaskIdKeyConnect>>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate>>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate>>;
};

/** Input for the nested mutation of `task` in the `FileOutputGroupInput` mutation. */
export type FileOutputGroupTaskId2B1Df6A1FkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroup` in the `TaskInput` mutation. */
export type FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FileOutputGroupFileOutputGroupPkeyConnect>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<FileOutputGroupFileOutputGroupTaskIdKeyConnect>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate>;
};

/** Input for the nested mutation of `tenant` in the `FileOutputGroupInput` mutation. */
export type FileOutputGroupTenantId3Fa46D44FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroup` in the `TenantInput` mutation. */
export type FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileOutputGroupFileOutputGroupPkeyConnect>>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<Array<FileOutputGroupFileOutputGroupTaskIdKeyConnect>>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate>>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate>>;
};

/** A filter to be used against many `FileOutputGroupMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type FileOutputGroupToManyFileOutputGroupMetadatumFilter = {
  /** Every related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** No related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** Some related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupMetadatumFilter>;
};

/** A filter to be used against many `OutputGroupFile` object types. All fields are combined with a logical ‘and.’ */
export type FileOutputGroupToManyOutputGroupFileFilter = {
  /** Every related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OutputGroupFileFilter>;
  /** No related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OutputGroupFileFilter>;
  /** Some related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OutputGroupFileFilter>;
};

/** Input for the nested mutation of `applicationUser` in the `FileOutputGroupInput` mutation. */
export type FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroup` in the `ApplicationUserInput` mutation. */
export type FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileOutputGroupFileOutputGroupPkeyConnect>>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<Array<FileOutputGroupFileOutputGroupTaskIdKeyConnect>>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate>>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate>>;
};

/** A connection to a list of `FileOutputGroup` values. */
export type FileOutputGroupsConnection = {
  __typename: 'FileOutputGroupsConnection';
  /** A list of edges which contains the `FileOutputGroup` and cursor to aid in pagination. */
  edges: Array<FileOutputGroupsEdge>;
  /** A list of `FileOutputGroup` objects. */
  nodes: Array<FileOutputGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileOutputGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FileOutputGroup` edge in the connection. */
export type FileOutputGroupsEdge = {
  __typename: 'FileOutputGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FileOutputGroup` at the end of the edge. */
  node: FileOutputGroup;
};

/** Methods to use when ordering `FileOutputGroup`. */
export enum FileOutputGroupsOrderBy {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  GroupTypeAsc = 'GROUP_TYPE_ASC',
  GroupTypeDesc = 'GROUP_TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `applicationUser` in the `FileProcessingNotificationInput` mutation. */
export type FileProcessingNotiUserId08265156FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `fileProcessingNotification` in the `ApplicationUserInput` mutation. */
export type FileProcessingNotiUserId08265156FkApplicatiInverseInput = {
  /** The primary key(s) for `fileProcessingNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileProcessingNotificationFileProcessingNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `fileProcessingNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate>>;
};

export type FileProcessingNotification = {
  __typename: 'FileProcessingNotification';
  /** Reads a single `ApplicationUser` that is related to this `FileProcessingNotification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads a single `File` that is related to this `FileProcessingNotification`. */
  fileByFileId: Maybe<File>;
  fileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `Notification` that is related to this `FileProcessingNotification`. */
  notificationById: Maybe<Notification>;
  status: Scalars['Int']['output'];
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `FileProcessingNotification` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type FileProcessingNotificationCondition = {
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for the nested mutation of `file` in the `FileProcessingNotificationInput` mutation. */
export type FileProcessingNotificationFileId717B514EFkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `fileProcessingNotification` in the `FileInput` mutation. */
export type FileProcessingNotificationFileId717B514EFkFileIdInverseInput = {
  /** The primary key(s) for `fileProcessingNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileProcessingNotificationFileProcessingNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `fileProcessingNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate>>;
};

/** The fields on `fileProcessingNotification` to look up the row to connect. */
export type FileProcessingNotificationFileProcessingNotificationPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A filter to be used against `FileProcessingNotification` object types. All fields are combined with a logical ‘and.’ */
export type FileProcessingNotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileProcessingNotificationFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `fileByFileId` relation. */
  fileByFileId?: InputMaybe<FileFilter>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileProcessingNotificationFilter>;
  /** Filter by the object’s `notificationById` relation. */
  notificationById?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileProcessingNotificationFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `notification` in the `FileProcessingNotificationInput` mutation. */
export type FileProcessingNotificationId630E6495FkNotificationIdInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `fileProcessingNotification` in the `NotificationInput` mutation. */
export type FileProcessingNotificationId630E6495FkNotificationIdInverseInput = {
  /** The primary key(s) for `fileProcessingNotification` for the far side of the relationship. */
  connectById?: InputMaybe<FileProcessingNotificationFileProcessingNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `fileProcessingNotification` for the far side of the relationship. */
  updateById?: InputMaybe<FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate>;
};

/** The fields on `fileProcessingNotification` to look up the row to update. */
export type FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
  fileProcessingNotificationPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileProcessingNotification` to look up the row to update. */
export type FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
  fileProcessingNotificationPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `fileProcessingNotification` to look up the row to update. */
export type FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate = {
  /** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
  fileProcessingNotificationPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
  id: Scalars['UUID']['input'];
};

/** A connection to a list of `FileProcessingNotification` values. */
export type FileProcessingNotificationsConnection = {
  __typename: 'FileProcessingNotificationsConnection';
  /** A list of edges which contains the `FileProcessingNotification` and cursor to aid in pagination. */
  edges: Array<FileProcessingNotificationsEdge>;
  /** A list of `FileProcessingNotification` objects. */
  nodes: Array<FileProcessingNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileProcessingNotification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FileProcessingNotification` edge in the connection. */
export type FileProcessingNotificationsEdge = {
  __typename: 'FileProcessingNotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FileProcessingNotification` at the end of the edge. */
  node: FileProcessingNotification;
};

/** Methods to use when ordering `FileProcessingNotification`. */
export enum FileProcessingNotificationsOrderBy {
  FileIdAsc = 'FILE_ID_ASC',
  FileIdDesc = 'FILE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `project` in the `FileInput` mutation. */
export type FileProjectId3Ecca975FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `file` in the `ProjectInput` mutation. */
export type FileProjectId3Ecca975FkProjectIdInverseInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileFilePkeyConnect>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<Array<FileProjectReferenceIdUniqueConnect>>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate>>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<Array<FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate>>;
};

/** The fields on `file` to look up the row to connect. */
export type FileProjectReferenceIdUniqueConnect = {
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `file` in the `FileInput` mutation. */
export type FileSeriesParentIdF7A07E20FkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `task` in the `FileInput` mutation. */
export type FileTaskIdE4Da87AeFkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `file` in the `TaskInput` mutation. */
export type FileTaskIdE4Da87AeFkTaskIdInverseInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileFilePkeyConnect>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<Array<FileProjectReferenceIdUniqueConnect>>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate>>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<Array<FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate>>;
};

/** Input for the nested mutation of `tenant` in the `FileInput` mutation. */
export type FileTenantId61625016FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `file` in the `TenantInput` mutation. */
export type FileTenantId61625016FkTenantIdInverseInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileFilePkeyConnect>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<Array<FileProjectReferenceIdUniqueConnect>>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate>>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<Array<FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate>>;
};

/** A filter to be used against many `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyFileActivityFilter = {
  /** Every related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileActivityFilter>;
  /** No related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileActivityFilter>;
  /** Some related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileActivityFilter>;
};

/** A filter to be used against many `File` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyFileFilter = {
  /** Every related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileFilter>;
  /** No related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileFilter>;
  /** Some related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileFilter>;
};

/** A filter to be used against many `FileMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyFileMetadatumFilter = {
  /** Every related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileMetadatumFilter>;
  /** No related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileMetadatumFilter>;
  /** Some related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileMetadatumFilter>;
};

/** A filter to be used against many `FileProcessingNotification` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyFileProcessingNotificationFilter = {
  /** Every related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileProcessingNotificationFilter>;
  /** No related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileProcessingNotificationFilter>;
  /** Some related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileProcessingNotificationFilter>;
};

/** A filter to be used against many `OutputGroupFile` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyOutputGroupFileFilter = {
  /** Every related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OutputGroupFileFilter>;
  /** No related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OutputGroupFileFilter>;
  /** Some related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OutputGroupFileFilter>;
};

/** A filter to be used against many `TaskSource` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyTaskSourceFilter = {
  /** Every related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskSourceFilter>;
  /** No related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskSourceFilter>;
  /** Some related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskSourceFilter>;
};

/** Input for the nested mutation of `applicationUser` in the `FileInput` mutation. */
export type FileUserId01D90B53FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `file` in the `ApplicationUserInput` mutation. */
export type FileUserId01D90B53FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileFilePkeyConnect>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<Array<FileProjectReferenceIdUniqueConnect>>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate>>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<Array<FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate>>;
};

/** A connection to a list of `File` values. */
export type FilesConnection = {
  __typename: 'FilesConnection';
  /** A list of edges which contains the `File` and cursor to aid in pagination. */
  edges: Array<FilesEdge>;
  /** A list of `File` objects. */
  nodes: Array<File>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `File` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `File` edge in the connection. */
export type FilesEdge = {
  __typename: 'FilesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `File` at the end of the edge. */
  node: File;
};

/** Methods to use when ordering `File`. */
export enum FilesOrderBy {
  DateArchivedAsc = 'DATE_ARCHIVED_ASC',
  DateArchivedDesc = 'DATE_ARCHIVED_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DateDataDeletedAsc = 'DATE_DATA_DELETED_ASC',
  DateDataDeletedDesc = 'DATE_DATA_DELETED_DESC',
  DateDeletedAsc = 'DATE_DELETED_ASC',
  DateDeletedDesc = 'DATE_DELETED_DESC',
  FileFormatAsc = 'FILE_FORMAT_ASC',
  FileFormatDesc = 'FILE_FORMAT_DESC',
  FileStructureAsc = 'FILE_STRUCTURE_ASC',
  FileStructureDesc = 'FILE_STRUCTURE_DESC',
  FileTypeAsc = 'FILE_TYPE_ASC',
  FileTypeDesc = 'FILE_TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsSeriesAsc = 'IS_SERIES_ASC',
  IsSeriesDesc = 'IS_SERIES_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  LocationAsc = 'LOCATION_ASC',
  LocationDesc = 'LOCATION_DESC',
  MultipartUploadIdAsc = 'MULTIPART_UPLOAD_ID_ASC',
  MultipartUploadIdDesc = 'MULTIPART_UPLOAD_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OriginalNameAsc = 'ORIGINAL_NAME_ASC',
  OriginalNameDesc = 'ORIGINAL_NAME_DESC',
  ParentIdsAsc = 'PARENT_IDS_ASC',
  ParentIdsDesc = 'PARENT_IDS_DESC',
  PartSizeAsc = 'PART_SIZE_ASC',
  PartSizeDesc = 'PART_SIZE_DESC',
  PreviewAsc = 'PREVIEW_ASC',
  PreviewDesc = 'PREVIEW_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcessingStatusAsc = 'PROCESSING_STATUS_ASC',
  ProcessingStatusDesc = 'PROCESSING_STATUS_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  ReferenceIdAsc = 'REFERENCE_ID_ASC',
  ReferenceIdDesc = 'REFERENCE_ID_DESC',
  SeriesOrderAsc = 'SERIES_ORDER_ASC',
  SeriesOrderDesc = 'SERIES_ORDER_DESC',
  SeriesParentIdAsc = 'SERIES_PARENT_ID_ASC',
  SeriesParentIdDesc = 'SERIES_PARENT_ID_DESC',
  SignalAsc = 'SIGNAL_ASC',
  SignalDesc = 'SIGNAL_DESC',
  SizeAsc = 'SIZE_ASC',
  SizeDesc = 'SIZE_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UploadStatusAsc = 'UPLOAD_STATUS_ASC',
  UploadStatusDesc = 'UPLOAD_STATUS_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GdtAnalysisTable = {
  __typename: 'GdtAnalysisTable';
  /** Reads a single `ApplicationUser` that is related to this `GdtAnalysisTable`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars['Datetime']['output'];
  dateDeleted: Maybe<Scalars['Datetime']['output']>;
  description: Scalars['String']['output'];
  folderId: Maybe<Scalars['UUID']['output']>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  gdtAnalysisTableRowsByTableId: GdtAnalysisTableRowsConnection;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Reads a single `Project` that is related to this `GdtAnalysisTable`. */
  projectByProjectId: Maybe<Project>;
  /** Reads a single `ProjectFolder` that is related to this `GdtAnalysisTable`. */
  projectFolderByFolderId: Maybe<ProjectFolder>;
  projectId: Scalars['UUID']['output'];
  /** Reads a single `ToolVersion` that is related to this `GdtAnalysisTable`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars['Int']['output'];
  userId: Scalars['UUID']['output'];
  workflowTableId: Maybe<Scalars['UUID']['output']>;
};


export type GdtAnalysisTableGdtAnalysisTableRowsByTableIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};

/**
 * A condition to be used against `GdtAnalysisTable` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GdtAnalysisTableCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `folderId` field. */
  folderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `hidden` field. */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `workflowTableId` field. */
  workflowTableId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `GdtAnalysisTable` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GdtAnalysisTableFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `folderId` field. */
  folderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `gdtAnalysisTableRowsByTableId` relation. */
  gdtAnalysisTableRowsByTableId?: InputMaybe<GdtAnalysisTableToManyGdtAnalysisTableRowFilter>;
  /** Some related `gdtAnalysisTableRowsByTableId` exist. */
  gdtAnalysisTableRowsByTableIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `hidden` field. */
  hidden?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GdtAnalysisTableFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GdtAnalysisTableFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectFolderByFolderId` relation. */
  projectFolderByFolderId?: InputMaybe<ProjectFolderFilter>;
  /** A related `projectFolderByFolderId` exists. */
  projectFolderByFolderIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `workflowTableId` field. */
  workflowTableId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `projectFolder` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput = {
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectFolderProjectFolderPkeyConnect>;
  /** The primary key(s) and patch data for `projectFolder` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `ProjectFolderInput` mutation. */
export type GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableGdtAnalysisTablePkeyConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate>>;
};

/** The fields on `gdtAnalysisTable` to look up the row to connect. */
export type GdtAnalysisTableGdtAnalysisTablePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
  gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
  gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
  gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
  gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
  gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `project` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableProjectId544B76D9FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `ProjectInput` mutation. */
export type GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableGdtAnalysisTablePkeyConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate>>;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<GdtAnalysisTableGdtAnalysisTablePkeyConnect>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowOrderUniqueConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowOrderUniqueUpdate>>;
};

/** Input for the nested mutation of `toolVersion` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `ToolVersionInput` mutation. */
export type GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowOrderUniqueConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowOrderUniqueUpdate>>;
};

export type GdtAnalysisTableRow = {
  __typename: 'GdtAnalysisTableRow';
  /** Reads a single `ApplicationUser` that is related to this `GdtAnalysisTableRow`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  cached: Scalars['Boolean']['output'];
  dateCreated: Scalars['Datetime']['output'];
  dateDeleted: Maybe<Scalars['Datetime']['output']>;
  editable: Scalars['Boolean']['output'];
  /** Reads a single `GdtAnalysisTable` that is related to this `GdtAnalysisTableRow`. */
  gdtAnalysisTableByTableId: Maybe<GdtAnalysisTable>;
  id: Scalars['UUID']['output'];
  index: Scalars['Int']['output'];
  joinable: Scalars['Boolean']['output'];
  order: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Project` that is related to this `GdtAnalysisTableRow`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
  resourceTier: Maybe<Scalars['Int']['output']>;
  tableId: Scalars['UUID']['output'];
  /** Reads a single `Task` that is related to this `GdtAnalysisTableRow`. */
  taskByTaskId: Maybe<Task>;
  taskId: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `ToolVersion` that is related to this `GdtAnalysisTableRow`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Maybe<Scalars['Int']['output']>;
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `GdtAnalysisTableRow` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GdtAnalysisTableRowCondition = {
  /** Checks for equality with the object’s `cached` field. */
  cached?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `editable` field. */
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `joinable` field. */
  joinable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `resourceTier` field. */
  resourceTier?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableRowFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GdtAnalysisTableRowFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `cached` field. */
  cached?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `editable` field. */
  editable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `gdtAnalysisTableByTableId` relation. */
  gdtAnalysisTableByTableId?: InputMaybe<GdtAnalysisTableFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `joinable` field. */
  joinable?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GdtAnalysisTableRowFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `resourceTier` field. */
  resourceTier?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** A related `taskByTaskId` exists. */
  taskByTaskIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** A related `toolVersionByToolVersionId` exists. */
  toolVersionByToolVersionIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `gdtAnalysisTableRow` to look up the row to connect. */
export type GdtAnalysisTableRowGdtAnalysisTableRowOrderUniqueConnect = {
  order: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to connect. */
export type GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to connect. */
export type GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect = {
  index: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowOrderUniqueUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  order: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  index: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowOrderUniqueUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  order: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  index: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowOrderUniqueUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  order: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  index: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowOrderUniqueUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  order: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  index: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowOrderUniqueUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  order: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  id: Scalars['UUID']['input'];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate = {
  /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
  gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  index: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `project` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `ProjectInput` mutation. */
export type GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowOrderUniqueConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowOrderUniqueUpdate>>;
};

/** Input for the nested mutation of `task` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `TaskInput` mutation. */
export type GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowOrderUniqueConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowOrderUniqueUpdate>>;
};

/** Input for the nested mutation of `applicationUser` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `ApplicationUserInput` mutation. */
export type GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<Array<GdtAnalysisTableRowGdtAnalysisTableRowOrderUniqueConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate>>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowOrderUniqueUpdate>>;
};

/** A connection to a list of `GdtAnalysisTableRow` values. */
export type GdtAnalysisTableRowsConnection = {
  __typename: 'GdtAnalysisTableRowsConnection';
  /** A list of edges which contains the `GdtAnalysisTableRow` and cursor to aid in pagination. */
  edges: Array<GdtAnalysisTableRowsEdge>;
  /** A list of `GdtAnalysisTableRow` objects. */
  nodes: Array<GdtAnalysisTableRow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GdtAnalysisTableRow` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GdtAnalysisTableRow` edge in the connection. */
export type GdtAnalysisTableRowsEdge = {
  __typename: 'GdtAnalysisTableRowsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `GdtAnalysisTableRow` at the end of the edge. */
  node: GdtAnalysisTableRow;
};

/** Methods to use when ordering `GdtAnalysisTableRow`. */
export enum GdtAnalysisTableRowsOrderBy {
  CachedAsc = 'CACHED_ASC',
  CachedDesc = 'CACHED_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DateDeletedAsc = 'DATE_DELETED_ASC',
  DateDeletedDesc = 'DATE_DELETED_DESC',
  EditableAsc = 'EDITABLE_ASC',
  EditableDesc = 'EDITABLE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  JoinableAsc = 'JOINABLE_ASC',
  JoinableDesc = 'JOINABLE_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  ResourceTierAsc = 'RESOURCE_TIER_ASC',
  ResourceTierDesc = 'RESOURCE_TIER_DESC',
  TableIdAsc = 'TABLE_ID_ASC',
  TableIdDesc = 'TABLE_ID_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC',
  ToolVersionIdAsc = 'TOOL_VERSION_ID_ASC',
  ToolVersionIdDesc = 'TOOL_VERSION_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A filter to be used against many `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableToManyGdtAnalysisTableRowFilter = {
  /** Every related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** No related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Some related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableRowFilter>;
};

/** Input for the nested mutation of `toolVersion` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `ToolVersionInput` mutation. */
export type GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableGdtAnalysisTablePkeyConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate>>;
};

/** Input for the nested mutation of `applicationUser` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `ApplicationUserInput` mutation. */
export type GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableGdtAnalysisTablePkeyConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate>>;
};

/** A connection to a list of `GdtAnalysisTable` values. */
export type GdtAnalysisTablesConnection = {
  __typename: 'GdtAnalysisTablesConnection';
  /** A list of edges which contains the `GdtAnalysisTable` and cursor to aid in pagination. */
  edges: Array<GdtAnalysisTablesEdge>;
  /** A list of `GdtAnalysisTable` objects. */
  nodes: Array<GdtAnalysisTable>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GdtAnalysisTable` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GdtAnalysisTable` edge in the connection. */
export type GdtAnalysisTablesEdge = {
  __typename: 'GdtAnalysisTablesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `GdtAnalysisTable` at the end of the edge. */
  node: GdtAnalysisTable;
};

/** Methods to use when ordering `GdtAnalysisTable`. */
export enum GdtAnalysisTablesOrderBy {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DateDeletedAsc = 'DATE_DELETED_ASC',
  DateDeletedDesc = 'DATE_DELETED_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  FolderIdAsc = 'FOLDER_ID_ASC',
  FolderIdDesc = 'FOLDER_ID_DESC',
  HiddenAsc = 'HIDDEN_ASC',
  HiddenDesc = 'HIDDEN_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  ToolVersionIdAsc = 'TOOL_VERSION_ID_ASC',
  ToolVersionIdDesc = 'TOOL_VERSION_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  WorkflowTableIdAsc = 'WORKFLOW_TABLE_ID_ASC',
  WorkflowTableIdDesc = 'WORKFLOW_TABLE_ID_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename: 'Interval';
  /** A quantity of days. */
  days: Maybe<Scalars['Int']['output']>;
  /** A quantity of hours. */
  hours: Maybe<Scalars['Int']['output']>;
  /** A quantity of minutes. */
  minutes: Maybe<Scalars['Int']['output']>;
  /** A quantity of months. */
  months: Maybe<Scalars['Int']['output']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds: Maybe<Scalars['Float']['output']>;
  /** A quantity of years. */
  years: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']['input']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

/** A connection to a list of `Metadatum` values. */
export type MetadataConnection = {
  __typename: 'MetadataConnection';
  /** A list of edges which contains the `Metadatum` and cursor to aid in pagination. */
  edges: Array<MetadataEdge>;
  /** A list of `Metadatum` objects. */
  nodes: Array<Metadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Metadatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Metadatum` edge in the connection. */
export type MetadataEdge = {
  __typename: 'MetadataEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Metadatum` at the end of the edge. */
  node: Metadatum;
};

/** Methods to use when ordering `Metadatum`. */
export enum MetadataOrderBy {
  DisplayNameAsc = 'DISPLAY_NAME_ASC',
  DisplayNameDesc = 'DISPLAY_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

/** Input for the nested mutation of `project` in the `MetadatumInput` mutation. */
export type MetadataProjectId3333C2AdFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `metadatum` in the `ProjectInput` mutation. */
export type MetadataProjectId3333C2AdFkProjectIdInverseInput = {
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadatumMetadataPkeyConnect>>;
  /** A `MetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput>>;
  /** The primary key(s) and patch data for `metadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate>>;
};

/** The `metadatum` to be created by this mutation. */
export type MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput = {
  displayName: Scalars['String']['input'];
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  id: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** Input for the nested mutation of `tenant` in the `MetadatumInput` mutation. */
export type MetadataTenantIdC1D8772DFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `metadatum` in the `TenantInput` mutation. */
export type MetadataTenantIdC1D8772DFkTenantIdInverseInput = {
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadatumMetadataPkeyConnect>>;
  /** A `MetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput>>;
  /** The primary key(s) and patch data for `metadatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate>>;
};

/** The `metadatum` to be created by this mutation. */
export type MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput = {
  displayName: Scalars['String']['input'];
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  id: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

export type MetadataValue = {
  __typename: 'MetadataValue';
  /** Reads a single `ApplicationUser` that is related to this `MetadataValue`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  metadataId: Scalars['UUID']['output'];
  /** Reads a single `Metadatum` that is related to this `MetadataValue`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `MetadataValue`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
  /** Reads a single `Task` that is related to this `MetadataValue`. */
  taskByTaskId: Maybe<Task>;
  taskId: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `Tenant` that is related to this `MetadataValue`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
  userId: Maybe<Scalars['UUID']['output']>;
  value: Maybe<Scalars['JSON']['output']>;
};

/**
 * A condition to be used against `MetadataValue` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MetadataValueCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `metadataId` field. */
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type MetadataValueFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MetadataValueFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadataId` field. */
  metadataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadatumByMetadataId` relation. */
  metadatumByMetadataId?: InputMaybe<MetadatumFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MetadataValueFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MetadataValueFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** A related `taskByTaskId` exists. */
  taskByTaskIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** An input for mutations affecting `MetadataValue` */
export type MetadataValueInput = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  id: Scalars['UUID']['input'];
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Input for the nested mutation of `metadatum` in the `MetadataValueInput` mutation. */
export type MetadataValueMetadataId063A53B6FkMetadataIdInput = {
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  connectById?: InputMaybe<MetadatumMetadataPkeyConnect>;
  /** A `MetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput>;
  /** The primary key(s) and patch data for `metadatum` for the far side of the relationship. */
  updateById?: InputMaybe<MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate>;
};

/** Input for the nested mutation of `metadataValue` in the `MetadatumInput` mutation. */
export type MetadataValueMetadataId063A53B6FkMetadataIdInverseInput = {
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadataValueMetadataValuePkeyConnect>>;
  /** A `MetadataValueInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput>>;
  /** The primary key(s) and patch data for `metadataValue` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate>>;
};

/** The `metadatum` to be created by this mutation. */
export type MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput = {
  displayName: Scalars['String']['input'];
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  id: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** The `metadataValue` to be created by this mutation. */
export type MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  id: Scalars['UUID']['input'];
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** The fields on `metadataValue` to look up the row to connect. */
export type MetadataValueMetadataValuePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `metadataValue` to look up the row to update. */
export type MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metadataValue` being updated. */
  metadataValuePatch: UpdateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
};

/** The fields on `metadataValue` to look up the row to update. */
export type MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metadataValue` being updated. */
  metadataValuePatch: UpdateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
};

/** The fields on `metadataValue` to look up the row to update. */
export type MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metadataValue` being updated. */
  metadataValuePatch: UpdateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
};

/** The fields on `metadataValue` to look up the row to update. */
export type MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metadataValue` being updated. */
  metadataValuePatch: UpdateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
};

/** The fields on `metadataValue` to look up the row to update. */
export type MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metadataValue` being updated. */
  metadataValuePatch: UpdateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
};

/** Input for the nested mutation of `project` in the `MetadataValueInput` mutation. */
export type MetadataValueProjectId87227D96FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `metadataValue` in the `ProjectInput` mutation. */
export type MetadataValueProjectId87227D96FkProjectIdInverseInput = {
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadataValueMetadataValuePkeyConnect>>;
  /** A `MetadataValueInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput>>;
  /** The primary key(s) and patch data for `metadataValue` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate>>;
};

/** The `metadataValue` to be created by this mutation. */
export type MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  id: Scalars['UUID']['input'];
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Input for the nested mutation of `task` in the `MetadataValueInput` mutation. */
export type MetadataValueTaskId3D37D135FkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `metadataValue` in the `TaskInput` mutation. */
export type MetadataValueTaskId3D37D135FkTaskIdInverseInput = {
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadataValueMetadataValuePkeyConnect>>;
  /** A `MetadataValueInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput>>;
  /** The primary key(s) and patch data for `metadataValue` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate>>;
};

/** The `metadataValue` to be created by this mutation. */
export type MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  id: Scalars['UUID']['input'];
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Input for the nested mutation of `tenant` in the `MetadataValueInput` mutation. */
export type MetadataValueTenantIdB4C2D5D6FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `metadataValue` in the `TenantInput` mutation. */
export type MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput = {
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadataValueMetadataValuePkeyConnect>>;
  /** A `MetadataValueInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput>>;
  /** The primary key(s) and patch data for `metadataValue` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate>>;
};

/** The `metadataValue` to be created by this mutation. */
export type MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  id: Scalars['UUID']['input'];
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Input for the nested mutation of `applicationUser` in the `MetadataValueInput` mutation. */
export type MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `metadataValue` in the `ApplicationUserInput` mutation. */
export type MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput = {
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadataValueMetadataValuePkeyConnect>>;
  /** A `MetadataValueInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput>>;
  /** The primary key(s) and patch data for `metadataValue` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate>>;
};

/** The `metadataValue` to be created by this mutation. */
export type MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  id: Scalars['UUID']['input'];
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `MetadataValue` values. */
export type MetadataValuesConnection = {
  __typename: 'MetadataValuesConnection';
  /** A list of edges which contains the `MetadataValue` and cursor to aid in pagination. */
  edges: Array<MetadataValuesEdge>;
  /** A list of `MetadataValue` objects. */
  nodes: Array<MetadataValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MetadataValue` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MetadataValue` edge in the connection. */
export type MetadataValuesEdge = {
  __typename: 'MetadataValuesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `MetadataValue` at the end of the edge. */
  node: MetadataValue;
};

/** Methods to use when ordering `MetadataValue`. */
export enum MetadataValuesOrderBy {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MetadataIdAsc = 'METADATA_ID_ASC',
  MetadataIdDesc = 'METADATA_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type Metadatum = {
  __typename: 'Metadatum';
  activeValue: Maybe<Scalars['JSON']['output']>;
  displayName: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `FileMetadatum`. */
  fileMetadataByMetadataId: FileMetadataConnection;
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. */
  fileOutputGroupMetadataByMetadataId: FileOutputGroupMetadataConnection;
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `MetadataValue`. */
  metadataValuesByMetadataId: MetadataValuesConnection;
  /** Reads a single `Project` that is related to this `Metadatum`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
  /** Reads a single `Tenant` that is related to this `Metadatum`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
};


export type MetadatumActiveValueArgs = {
  at?: InputMaybe<Scalars['Datetime']['input']>;
};


export type MetadatumFileMetadataByMetadataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};


export type MetadatumFileOutputGroupMetadataByMetadataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};


export type MetadatumMetadataValuesByMetadataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MetadataValueCondition>;
  filter?: InputMaybe<MetadataValueFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};

/**
 * A condition to be used against `Metadatum` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MetadatumCondition = {
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Metadatum` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MetadatumFilter>>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileMetadataByMetadataId` relation. */
  fileMetadataByMetadataId?: InputMaybe<MetadatumToManyFileMetadatumFilter>;
  /** Some related `fileMetadataByMetadataId` exist. */
  fileMetadataByMetadataIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileOutputGroupMetadataByMetadataId` relation. */
  fileOutputGroupMetadataByMetadataId?: InputMaybe<MetadatumToManyFileOutputGroupMetadatumFilter>;
  /** Some related `fileOutputGroupMetadataByMetadataId` exist. */
  fileOutputGroupMetadataByMetadataIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadataValuesByMetadataId` relation. */
  metadataValuesByMetadataId?: InputMaybe<MetadatumToManyMetadataValueFilter>;
  /** Some related `metadataValuesByMetadataId` exist. */
  metadataValuesByMetadataIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<MetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MetadatumFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Metadatum` */
export type MetadatumInput = {
  displayName: Scalars['String']['input'];
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  id: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** The fields on `metadatum` to look up the row to connect. */
export type MetadatumMetadataPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `metadatum` to look up the row to update. */
export type MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metadatum` being updated. */
  metadatumPatch: UpdateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
};

/** The fields on `metadatum` to look up the row to update. */
export type MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metadatum` being updated. */
  metadatumPatch: UpdateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
};

/** The fields on `metadatum` to look up the row to update. */
export type MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metadatum` being updated. */
  metadatumPatch: UpdateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
};

/** The fields on `metadatum` to look up the row to update. */
export type MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metadatum` being updated. */
  metadatumPatch: UpdateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
};

/** The fields on `metadatum` to look up the row to update. */
export type MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metadatum` being updated. */
  metadatumPatch: UpdateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
};

/** A filter to be used against many `FileMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumToManyFileMetadatumFilter = {
  /** Every related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileMetadatumFilter>;
  /** No related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileMetadatumFilter>;
  /** Some related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileMetadatumFilter>;
};

/** A filter to be used against many `FileOutputGroupMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumToManyFileOutputGroupMetadatumFilter = {
  /** Every related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** No related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** Some related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupMetadatumFilter>;
};

/** A filter to be used against many `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumToManyMetadataValueFilter = {
  /** Every related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadataValueFilter>;
  /** No related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadataValueFilter>;
  /** Some related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadataValueFilter>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename: 'Mutation';
  changeUserSession: Maybe<ChangeUserSessionPayload>;
  /** Creates a single `ApplicationUserMetadatum`. */
  createApplicationUserMetadatum: Maybe<CreateApplicationUserMetadatumPayload>;
  /** Creates a single `ApplicationUserSession`. */
  createApplicationUserSession: Maybe<CreateApplicationUserSessionPayload>;
  /** Creates a single `EulaVersionUserAcceptance`. */
  createEulaVersionUserAcceptance: Maybe<CreateEulaVersionUserAcceptancePayload>;
  /** Creates a single `MetadataValue`. */
  createMetadataValue: Maybe<CreateMetadataValuePayload>;
  /** Creates a single `Metadatum`. */
  createMetadatum: Maybe<CreateMetadatumPayload>;
  createRole: Maybe<CreateRolePayload>;
  createSession: Maybe<CreateSessionPayload>;
  deleteSession: Maybe<DeleteSessionPayload>;
  /** Updates a single `ApplicationUser` using a unique key and a patch. */
  updateApplicationUserByEmail: Maybe<UpdateApplicationUserPayload>;
  /** Updates a single `ApplicationUser` using a unique key and a patch. */
  updateApplicationUserByGlobalUserId: Maybe<UpdateApplicationUserPayload>;
  /** Updates a single `ApplicationUser` using a unique key and a patch. */
  updateApplicationUserById: Maybe<UpdateApplicationUserPayload>;
  /** Updates a single `ApplicationUser` using a unique key and a patch. */
  updateApplicationUserByUsername: Maybe<UpdateApplicationUserPayload>;
  /** Updates a single `ApplicationUserMetadatum` using a unique key and a patch. */
  updateApplicationUserMetadatumById: Maybe<UpdateApplicationUserMetadatumPayload>;
  /** Updates a single `ApplicationUserMetadatum` using a unique key and a patch. */
  updateApplicationUserMetadatumByUserIdAndKey: Maybe<UpdateApplicationUserMetadatumPayload>;
  /** Updates a single `Avatar` using a unique key and a patch. */
  updateAvatarById: Maybe<UpdateAvatarPayload>;
  /** Updates a single `Avatar` using a unique key and a patch. */
  updateAvatarByUserId: Maybe<UpdateAvatarPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeUserSessionArgs = {
  input: ChangeUserSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApplicationUserMetadatumArgs = {
  input: CreateApplicationUserMetadatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApplicationUserSessionArgs = {
  input: CreateApplicationUserSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEulaVersionUserAcceptanceArgs = {
  input: CreateEulaVersionUserAcceptanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMetadataValueArgs = {
  input: CreateMetadataValueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMetadatumArgs = {
  input: CreateMetadatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSessionArgs = {
  input: DeleteSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserByEmailArgs = {
  input: UpdateApplicationUserByEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserByGlobalUserIdArgs = {
  input: UpdateApplicationUserByGlobalUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserByIdArgs = {
  input: UpdateApplicationUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserByUsernameArgs = {
  input: UpdateApplicationUserByUsernameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserMetadatumByIdArgs = {
  input: UpdateApplicationUserMetadatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserMetadatumByUserIdAndKeyArgs = {
  input: UpdateApplicationUserMetadatumByUserIdAndKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAvatarByIdArgs = {
  input: UpdateAvatarByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAvatarByUserIdArgs = {
  input: UpdateAvatarByUserIdInput;
};

export type Notification = {
  __typename: 'Notification';
  /** Reads a single `ApplicationUser` that is related to this `Notification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars['Datetime']['output'];
  /** Reads a single `FileProcessingNotification` that is related to this `Notification`. */
  fileProcessingNotificationById: Maybe<FileProcessingNotification>;
  /**
   * Reads and enables pagination through a set of `FileProcessingNotification`.
   * @deprecated Please use fileProcessingNotificationById instead
   */
  fileProcessingNotificationsById: FileProcessingNotificationsConnection;
  hasSeen: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `ProjectClonedNotification` that is related to this `Notification`. */
  projectClonedNotificationById: Maybe<ProjectClonedNotification>;
  /**
   * Reads and enables pagination through a set of `ProjectClonedNotification`.
   * @deprecated Please use projectClonedNotificationById instead
   */
  projectClonedNotificationsById: ProjectClonedNotificationsConnection;
  /** Reads a single `ProjectSharedNotification` that is related to this `Notification`. */
  projectSharedNotificationById: Maybe<ProjectSharedNotification>;
  /**
   * Reads and enables pagination through a set of `ProjectSharedNotification`.
   * @deprecated Please use projectSharedNotificationById instead
   */
  projectSharedNotificationsById: ProjectSharedNotificationsConnection;
  /** Reads a single `RoleChangeNotification` that is related to this `Notification`. */
  roleChangeNotificationById: Maybe<RoleChangeNotification>;
  /**
   * Reads and enables pagination through a set of `RoleChangeNotification`.
   * @deprecated Please use roleChangeNotificationById instead
   */
  roleChangeNotificationsById: RoleChangeNotificationsConnection;
  /** Reads a single `TenantUserMembershipNotification` that is related to this `Notification`. */
  tenantUserMembershipNotificationById: Maybe<TenantUserMembershipNotification>;
  /**
   * Reads and enables pagination through a set of `TenantUserMembershipNotification`.
   * @deprecated Please use tenantUserMembershipNotificationById instead
   */
  tenantUserMembershipNotificationsById: TenantUserMembershipNotificationsConnection;
  userId: Scalars['UUID']['output'];
};


export type NotificationFileProcessingNotificationsByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileProcessingNotificationCondition>;
  filter?: InputMaybe<FileProcessingNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileProcessingNotificationsOrderBy>>;
};


export type NotificationProjectClonedNotificationsByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};


export type NotificationProjectSharedNotificationsByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};


export type NotificationRoleChangeNotificationsByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoleChangeNotificationCondition>;
  filter?: InputMaybe<RoleChangeNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoleChangeNotificationsOrderBy>>;
};


export type NotificationTenantUserMembershipNotificationsByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};

/**
 * A condition to be used against `Notification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NotificationCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `hasSeen` field. */
  hasSeen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `Notification` object types. All fields are combined with a logical ‘and.’ */
export type NotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileProcessingNotificationById` relation. */
  fileProcessingNotificationById?: InputMaybe<FileProcessingNotificationFilter>;
  /** A related `fileProcessingNotificationById` exists. */
  fileProcessingNotificationByIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `hasSeen` field. */
  hasSeen?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `projectClonedNotificationById` relation. */
  projectClonedNotificationById?: InputMaybe<ProjectClonedNotificationFilter>;
  /** A related `projectClonedNotificationById` exists. */
  projectClonedNotificationByIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectSharedNotificationById` relation. */
  projectSharedNotificationById?: InputMaybe<ProjectSharedNotificationFilter>;
  /** A related `projectSharedNotificationById` exists. */
  projectSharedNotificationByIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `roleChangeNotificationById` relation. */
  roleChangeNotificationById?: InputMaybe<RoleChangeNotificationFilter>;
  /** A related `roleChangeNotificationById` exists. */
  roleChangeNotificationByIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantUserMembershipNotificationById` relation. */
  tenantUserMembershipNotificationById?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** A related `tenantUserMembershipNotificationById` exists. */
  tenantUserMembershipNotificationByIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `notification` to look up the row to connect. */
export type NotificationNotificationPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  notificationPatch: UpdateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  notificationPatch: UpdateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  notificationPatch: UpdateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  notificationPatch: UpdateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  notificationPatch: UpdateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  notificationPatch: UpdateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
};

/** Input for the nested mutation of `applicationUser` in the `NotificationInput` mutation. */
export type NotificationUserId1002Fc38FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `notification` in the `ApplicationUserInput` mutation. */
export type NotificationUserId1002Fc38FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate>>;
};

/** A connection to a list of `Notification` values. */
export type NotificationsConnection = {
  __typename: 'NotificationsConnection';
  /** A list of edges which contains the `Notification` and cursor to aid in pagination. */
  edges: Array<NotificationsEdge>;
  /** A list of `Notification` objects. */
  nodes: Array<Notification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Notification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Notification` edge in the connection. */
export type NotificationsEdge = {
  __typename: 'NotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Notification` at the end of the edge. */
  node: Notification;
};

/** Methods to use when ordering `Notification`. */
export enum NotificationsOrderBy {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  HasSeenAsc = 'HAS_SEEN_ASC',
  HasSeenDesc = 'HAS_SEEN_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type OutputGroupFile = {
  __typename: 'OutputGroupFile';
  dateCreated: Scalars['Datetime']['output'];
  /** Reads a single `File` that is related to this `OutputGroupFile`. */
  fileByFileId: Maybe<File>;
  fileId: Scalars['UUID']['output'];
  /** Reads a single `FileOutputGroup` that is related to this `OutputGroupFile`. */
  fileOutputGroupByFileOutputGroupId: Maybe<FileOutputGroup>;
  fileOutputGroupId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `Project` that is related to this `OutputGroupFile`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `OutputGroupFile` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OutputGroupFileCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `fileOutputGroupId` field. */
  fileOutputGroupId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `OutputGroupFile` object types. All fields are combined with a logical ‘and.’ */
export type OutputGroupFileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OutputGroupFileFilter>>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileByFileId` relation. */
  fileByFileId?: InputMaybe<FileFilter>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fileOutputGroupByFileOutputGroupId` relation. */
  fileOutputGroupByFileOutputGroupId?: InputMaybe<FileOutputGroupFilter>;
  /** Filter by the object’s `fileOutputGroupId` field. */
  fileOutputGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OutputGroupFileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OutputGroupFileFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** The fields on `outputGroupFile` to look up the row to update. */
export type OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `outputGroupFile` being updated. */
  outputGroupFilePatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
};

/** The fields on `outputGroupFile` to look up the row to update. */
export type OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `outputGroupFile` being updated. */
  outputGroupFilePatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
};

/** The fields on `outputGroupFile` to look up the row to update. */
export type OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `outputGroupFile` being updated. */
  outputGroupFilePatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
};

/** The fields on `outputGroupFile` to look up the row to connect. */
export type OutputGroupFileOutputGroupFilesPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A connection to a list of `OutputGroupFile` values. */
export type OutputGroupFilesConnection = {
  __typename: 'OutputGroupFilesConnection';
  /** A list of edges which contains the `OutputGroupFile` and cursor to aid in pagination. */
  edges: Array<OutputGroupFilesEdge>;
  /** A list of `OutputGroupFile` objects. */
  nodes: Array<OutputGroupFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OutputGroupFile` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OutputGroupFile` edge in the connection. */
export type OutputGroupFilesEdge = {
  __typename: 'OutputGroupFilesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `OutputGroupFile` at the end of the edge. */
  node: OutputGroupFile;
};

/** Input for the nested mutation of `file` in the `OutputGroupFileInput` mutation. */
export type OutputGroupFilesFileIdEdeabb23FkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `outputGroupFile` in the `FileInput` mutation. */
export type OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput = {
  /** The primary key(s) for `outputGroupFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OutputGroupFileOutputGroupFilesPkeyConnect>>;
  /** The primary key(s) and patch data for `outputGroupFile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate>>;
};

/** Input for the nested mutation of `fileOutputGroup` in the `OutputGroupFileInput` mutation. */
export type OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FileOutputGroupFileOutputGroupPkeyConnect>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<FileOutputGroupFileOutputGroupTaskIdKeyConnect>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate>;
};

/** Input for the nested mutation of `outputGroupFile` in the `FileOutputGroupInput` mutation. */
export type OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput = {
  /** The primary key(s) for `outputGroupFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OutputGroupFileOutputGroupFilesPkeyConnect>>;
  /** The primary key(s) and patch data for `outputGroupFile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate>>;
};

/** Methods to use when ordering `OutputGroupFile`. */
export enum OutputGroupFilesOrderBy {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  FileIdAsc = 'FILE_ID_ASC',
  FileIdDesc = 'FILE_ID_DESC',
  FileOutputGroupIdAsc = 'FILE_OUTPUT_GROUP_ID_ASC',
  FileOutputGroupIdDesc = 'FILE_OUTPUT_GROUP_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC'
}

/** Input for the nested mutation of `project` in the `OutputGroupFileInput` mutation. */
export type OutputGroupFilesProjectId8709B561FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `outputGroupFile` in the `ProjectInput` mutation. */
export type OutputGroupFilesProjectId8709B561FkProjectIdInverseInput = {
  /** The primary key(s) for `outputGroupFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OutputGroupFileOutputGroupFilesPkeyConnect>>;
  /** The primary key(s) and patch data for `outputGroupFile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['Cursor']['output']>;
};

export type Project = {
  __typename: 'Project';
  /** Reads and enables pagination through a set of `File`. */
  activeFiles: FilesConnection;
  activeStorageSize: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `ApplicationUser` that is related to this `Project`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  archivedStorageSize: Maybe<Scalars['BigInt']['output']>;
  cloneSourceId: Maybe<Scalars['UUID']['output']>;
  /** Reads and enables pagination through a set of `DataTable`. */
  dataTablesByProjectId: DataTablesConnection;
  dateArchived: Maybe<Scalars['Datetime']['output']>;
  dateCreated: Scalars['Datetime']['output'];
  dateDataDeleted: Maybe<Scalars['Datetime']['output']>;
  dateDeleted: Maybe<Scalars['Datetime']['output']>;
  dateLastActive: Maybe<Scalars['Datetime']['output']>;
  defaultUserAccessLevel: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `FileActivity`. */
  fileActivitiesByProjectId: FileActivitiesConnection;
  /** Reads and enables pagination through a set of `FileMetadatum`. */
  fileMetadataByProjectId: FileMetadataConnection;
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. */
  fileOutputGroupMetadataByProjectId: FileOutputGroupMetadataConnection;
  /** Reads and enables pagination through a set of `FileOutputGroup`. */
  fileOutputGroupsByProjectId: FileOutputGroupsConnection;
  /** Reads and enables pagination through a set of `File`. */
  filesByProjectId: FilesConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  gdtAnalysisTableRowsByProjectId: GdtAnalysisTableRowsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. */
  gdtAnalysisTablesByProjectId: GdtAnalysisTablesConnection;
  icon: Maybe<Scalars['String']['output']>;
  iconColor: Scalars['String']['output'];
  iconText: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isDemo: Scalars['Boolean']['output'];
  isToolProject: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Metadatum`. */
  metadataByProjectId: MetadataConnection;
  /** Reads and enables pagination through a set of `MetadataValue`. */
  metadataValuesByProjectId: MetadataValuesConnection;
  name: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `OutputGroupFile`. */
  outputGroupFilesByProjectId: OutputGroupFilesConnection;
  pinned: Maybe<Scalars['Boolean']['output']>;
  prefix: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `Project`. */
  projectByCloneSourceId: Maybe<Project>;
  /** Reads and enables pagination through a set of `ProjectClonedNotification`. */
  projectClonedNotificationsByProjectId: ProjectClonedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectClonedNotification`. */
  projectClonedNotificationsBySrcProjectId: ProjectClonedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectFolder`. */
  projectFoldersByProjectId: ProjectFoldersConnection;
  /** Reads and enables pagination through a set of `ProjectSharedNotification`. */
  projectSharedNotificationsByProjectId: ProjectSharedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectTag`. */
  projectTagsByProjectId: ProjectTagsConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projectsByCloneSourceId: ProjectsConnection;
  shortDescription: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `Task`. */
  tasksByProjectId: TasksConnection;
  /** Reads a single `Tenant` that is related to this `Project`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
  /** Reads a single `Tool` that is related to this `Project`. */
  toolByProjectId: Maybe<Tool>;
  /**
   * Reads and enables pagination through a set of `Tool`.
   * @deprecated Please use toolByProjectId instead
   */
  toolsByProjectId: ToolsConnection;
  tourType: Maybe<Scalars['Int']['output']>;
  usedCredits: Maybe<Scalars['Float']['output']>;
  userId: Scalars['UUID']['output'];
};


export type ProjectActiveFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  at?: InputMaybe<Scalars['Datetime']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectDataTablesByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DataTableCondition>;
  filter?: InputMaybe<DataTableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTablesOrderBy>>;
};


export type ProjectFileActivitiesByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};


export type ProjectFileMetadataByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};


export type ProjectFileOutputGroupMetadataByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};


export type ProjectFileOutputGroupsByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};


export type ProjectFilesByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type ProjectGdtAnalysisTableRowsByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};


export type ProjectGdtAnalysisTablesByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};


export type ProjectMetadataByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MetadatumCondition>;
  filter?: InputMaybe<MetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetadataOrderBy>>;
};


export type ProjectMetadataValuesByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MetadataValueCondition>;
  filter?: InputMaybe<MetadataValueFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};


export type ProjectOutputGroupFilesByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OutputGroupFileCondition>;
  filter?: InputMaybe<OutputGroupFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};


export type ProjectProjectClonedNotificationsByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};


export type ProjectProjectClonedNotificationsBySrcProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};


export type ProjectProjectFoldersByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectFolderCondition>;
  filter?: InputMaybe<ProjectFolderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectFoldersOrderBy>>;
};


export type ProjectProjectSharedNotificationsByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};


export type ProjectProjectTagsByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};


export type ProjectProjectsByCloneSourceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type ProjectTasksByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


export type ProjectToolsByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolCondition>;
  filter?: InputMaybe<ToolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

/** Input for the nested mutation of `project` in the `ProjectInput` mutation. */
export type ProjectCloneSourceId92Ccacf5FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `project` in the `ProjectClonedNotificationInput` mutation. */
export type ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `projectClonedNotification` in the `ProjectInput` mutation. */
export type ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput = {
  /** The primary key(s) for `projectClonedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectClonedNotificationProjectClonedNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `projectClonedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate>>;
};

/** Input for the nested mutation of `applicationUser` in the `ProjectClonedNotificationInput` mutation. */
export type ProjectClonedNotifUserId4Fd693D7FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `projectClonedNotification` in the `ApplicationUserInput` mutation. */
export type ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput = {
  /** The primary key(s) for `projectClonedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectClonedNotificationProjectClonedNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `projectClonedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate>>;
};

export type ProjectClonedNotification = {
  __typename: 'ProjectClonedNotification';
  /** Reads a single `ApplicationUser` that is related to this `ProjectClonedNotification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars['UUID']['output'];
  /** Reads a single `Notification` that is related to this `ProjectClonedNotification`. */
  notificationById: Maybe<Notification>;
  /** Reads a single `Project` that is related to this `ProjectClonedNotification`. */
  projectByProjectId: Maybe<Project>;
  /** Reads a single `Project` that is related to this `ProjectClonedNotification`. */
  projectBySrcProjectId: Maybe<Project>;
  projectId: Maybe<Scalars['UUID']['output']>;
  projectName: Maybe<Scalars['String']['output']>;
  srcProjectId: Maybe<Scalars['UUID']['output']>;
  succeeded: Scalars['Boolean']['output'];
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `ProjectClonedNotification` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectClonedNotificationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `projectName` field. */
  projectName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `srcProjectId` field. */
  srcProjectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `succeeded` field. */
  succeeded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `ProjectClonedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ProjectClonedNotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectClonedNotificationFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectClonedNotificationFilter>;
  /** Filter by the object’s `notificationById` relation. */
  notificationById?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectClonedNotificationFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** A related `projectByProjectId` exists. */
  projectByProjectIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectBySrcProjectId` relation. */
  projectBySrcProjectId?: InputMaybe<ProjectFilter>;
  /** A related `projectBySrcProjectId` exists. */
  projectBySrcProjectIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectName` field. */
  projectName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `srcProjectId` field. */
  srcProjectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `succeeded` field. */
  succeeded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `notification` in the `ProjectClonedNotificationInput` mutation. */
export type ProjectClonedNotificationIdD235A018FkNotificationIdInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `projectClonedNotification` in the `NotificationInput` mutation. */
export type ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput = {
  /** The primary key(s) for `projectClonedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectClonedNotificationProjectClonedNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `projectClonedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate>;
};

/** The fields on `projectClonedNotification` to look up the row to update. */
export type ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
  projectClonedNotificationPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
};

/** The fields on `projectClonedNotification` to look up the row to update. */
export type ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
  projectClonedNotificationPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
};

/** The fields on `projectClonedNotification` to look up the row to update. */
export type ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
  projectClonedNotificationPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
};

/** The fields on `projectClonedNotification` to look up the row to update. */
export type ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
  projectClonedNotificationPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
};

/** The fields on `projectClonedNotification` to look up the row to connect. */
export type ProjectClonedNotificationProjectClonedNotificationPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `project` in the `ProjectClonedNotificationInput` mutation. */
export type ProjectClonedNotificationProjectIdF6267374FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `projectClonedNotification` in the `ProjectInput` mutation. */
export type ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput = {
  /** The primary key(s) for `projectClonedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectClonedNotificationProjectClonedNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `projectClonedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate>>;
};

/** A connection to a list of `ProjectClonedNotification` values. */
export type ProjectClonedNotificationsConnection = {
  __typename: 'ProjectClonedNotificationsConnection';
  /** A list of edges which contains the `ProjectClonedNotification` and cursor to aid in pagination. */
  edges: Array<ProjectClonedNotificationsEdge>;
  /** A list of `ProjectClonedNotification` objects. */
  nodes: Array<ProjectClonedNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectClonedNotification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectClonedNotification` edge in the connection. */
export type ProjectClonedNotificationsEdge = {
  __typename: 'ProjectClonedNotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectClonedNotification` at the end of the edge. */
  node: ProjectClonedNotification;
};

/** Methods to use when ordering `ProjectClonedNotification`. */
export enum ProjectClonedNotificationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  ProjectNameAsc = 'PROJECT_NAME_ASC',
  ProjectNameDesc = 'PROJECT_NAME_DESC',
  SrcProjectIdAsc = 'SRC_PROJECT_ID_ASC',
  SrcProjectIdDesc = 'SRC_PROJECT_ID_DESC',
  SucceededAsc = 'SUCCEEDED_ASC',
  SucceededDesc = 'SUCCEEDED_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A condition to be used against `Project` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProjectCondition = {
  /** Checks for equality with the object’s `cloneSourceId` field. */
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `defaultUserAccessLevel` field. */
  defaultUserAccessLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `icon` field. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `iconColor` field. */
  iconColor?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `iconText` field. */
  iconText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `isDemo` field. */
  isDemo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isToolProject` field. */
  isToolProject?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `prefix` field. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `shortDescription` field. */
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tourType` field. */
  tourType?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `cloneSourceId` field. */
  cloneSourceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `dataTablesByProjectId` relation. */
  dataTablesByProjectId?: InputMaybe<ProjectToManyDataTableFilter>;
  /** Some related `dataTablesByProjectId` exist. */
  dataTablesByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultUserAccessLevel` field. */
  defaultUserAccessLevel?: InputMaybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileActivitiesByProjectId` relation. */
  fileActivitiesByProjectId?: InputMaybe<ProjectToManyFileActivityFilter>;
  /** Some related `fileActivitiesByProjectId` exist. */
  fileActivitiesByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileMetadataByProjectId` relation. */
  fileMetadataByProjectId?: InputMaybe<ProjectToManyFileMetadatumFilter>;
  /** Some related `fileMetadataByProjectId` exist. */
  fileMetadataByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileOutputGroupMetadataByProjectId` relation. */
  fileOutputGroupMetadataByProjectId?: InputMaybe<ProjectToManyFileOutputGroupMetadatumFilter>;
  /** Some related `fileOutputGroupMetadataByProjectId` exist. */
  fileOutputGroupMetadataByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileOutputGroupsByProjectId` relation. */
  fileOutputGroupsByProjectId?: InputMaybe<ProjectToManyFileOutputGroupFilter>;
  /** Some related `fileOutputGroupsByProjectId` exist. */
  fileOutputGroupsByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `filesByProjectId` relation. */
  filesByProjectId?: InputMaybe<ProjectToManyFileFilter>;
  /** Some related `filesByProjectId` exist. */
  filesByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `gdtAnalysisTableRowsByProjectId` relation. */
  gdtAnalysisTableRowsByProjectId?: InputMaybe<ProjectToManyGdtAnalysisTableRowFilter>;
  /** Some related `gdtAnalysisTableRowsByProjectId` exist. */
  gdtAnalysisTableRowsByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `gdtAnalysisTablesByProjectId` relation. */
  gdtAnalysisTablesByProjectId?: InputMaybe<ProjectToManyGdtAnalysisTableFilter>;
  /** Some related `gdtAnalysisTablesByProjectId` exist. */
  gdtAnalysisTablesByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `icon` field. */
  icon?: InputMaybe<StringFilter>;
  /** Filter by the object’s `iconColor` field. */
  iconColor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `iconText` field. */
  iconText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isDemo` field. */
  isDemo?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isToolProject` field. */
  isToolProject?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadataByProjectId` relation. */
  metadataByProjectId?: InputMaybe<ProjectToManyMetadatumFilter>;
  /** Some related `metadataByProjectId` exist. */
  metadataByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `metadataValuesByProjectId` relation. */
  metadataValuesByProjectId?: InputMaybe<ProjectToManyMetadataValueFilter>;
  /** Some related `metadataValuesByProjectId` exist. */
  metadataValuesByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `outputGroupFilesByProjectId` relation. */
  outputGroupFilesByProjectId?: InputMaybe<ProjectToManyOutputGroupFileFilter>;
  /** Some related `outputGroupFilesByProjectId` exist. */
  outputGroupFilesByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `prefix` field. */
  prefix?: InputMaybe<StringFilter>;
  /** Filter by the object’s `projectByCloneSourceId` relation. */
  projectByCloneSourceId?: InputMaybe<ProjectFilter>;
  /** A related `projectByCloneSourceId` exists. */
  projectByCloneSourceIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectClonedNotificationsByProjectId` relation. */
  projectClonedNotificationsByProjectId?: InputMaybe<ProjectToManyProjectClonedNotificationFilter>;
  /** Some related `projectClonedNotificationsByProjectId` exist. */
  projectClonedNotificationsByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectClonedNotificationsBySrcProjectId` relation. */
  projectClonedNotificationsBySrcProjectId?: InputMaybe<ProjectToManyProjectClonedNotificationFilter>;
  /** Some related `projectClonedNotificationsBySrcProjectId` exist. */
  projectClonedNotificationsBySrcProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectFoldersByProjectId` relation. */
  projectFoldersByProjectId?: InputMaybe<ProjectToManyProjectFolderFilter>;
  /** Some related `projectFoldersByProjectId` exist. */
  projectFoldersByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectSharedNotificationsByProjectId` relation. */
  projectSharedNotificationsByProjectId?: InputMaybe<ProjectToManyProjectSharedNotificationFilter>;
  /** Some related `projectSharedNotificationsByProjectId` exist. */
  projectSharedNotificationsByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectTagsByProjectId` relation. */
  projectTagsByProjectId?: InputMaybe<ProjectToManyProjectTagFilter>;
  /** Some related `projectTagsByProjectId` exist. */
  projectTagsByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectsByCloneSourceId` relation. */
  projectsByCloneSourceId?: InputMaybe<ProjectToManyProjectFilter>;
  /** Some related `projectsByCloneSourceId` exist. */
  projectsByCloneSourceIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `shortDescription` field. */
  shortDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tasksByProjectId` relation. */
  tasksByProjectId?: InputMaybe<ProjectToManyTaskFilter>;
  /** Some related `tasksByProjectId` exist. */
  tasksByProjectIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolByProjectId` relation. */
  toolByProjectId?: InputMaybe<ToolFilter>;
  /** A related `toolByProjectId` exists. */
  toolByProjectIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tourType` field. */
  tourType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

export type ProjectFolder = {
  __typename: 'ProjectFolder';
  /** Reads a single `ApplicationUser` that is related to this `ProjectFolder`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  color: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `DataTable`. */
  dataTablesByFolderId: DataTablesConnection;
  dateCreated: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. */
  gdtAnalysisTablesByFolderId: GdtAnalysisTablesConnection;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /** Reads a single `Project` that is related to this `ProjectFolder`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
  userId: Maybe<Scalars['UUID']['output']>;
};


export type ProjectFolderDataTablesByFolderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DataTableCondition>;
  filter?: InputMaybe<DataTableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTablesOrderBy>>;
};


export type ProjectFolderGdtAnalysisTablesByFolderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};

/**
 * A condition to be used against `ProjectFolder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectFolderCondition = {
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `ProjectFolder` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFolderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectFolderFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dataTablesByFolderId` relation. */
  dataTablesByFolderId?: InputMaybe<ProjectFolderToManyDataTableFilter>;
  /** Some related `dataTablesByFolderId` exist. */
  dataTablesByFolderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `gdtAnalysisTablesByFolderId` relation. */
  gdtAnalysisTablesByFolderId?: InputMaybe<ProjectFolderToManyGdtAnalysisTableFilter>;
  /** Some related `gdtAnalysisTablesByFolderId` exist. */
  gdtAnalysisTablesByFolderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectFolderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectFolderFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `projectFolder` to look up the row to update. */
export type ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectFolder` being updated. */
  projectFolderPatch: UpdateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
};

/** The fields on `projectFolder` to look up the row to update. */
export type ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectFolder` being updated. */
  projectFolderPatch: UpdateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
};

/** The fields on `projectFolder` to look up the row to update. */
export type ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectFolder` being updated. */
  projectFolderPatch: UpdateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
};

/** The fields on `projectFolder` to look up the row to update. */
export type ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectFolder` being updated. */
  projectFolderPatch: UpdateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
};

/** The fields on `projectFolder` to look up the row to connect. */
export type ProjectFolderProjectFolderPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `project` in the `ProjectFolderInput` mutation. */
export type ProjectFolderProjectIdEf44DadfFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `projectFolder` in the `ProjectInput` mutation. */
export type ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput = {
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectFolderProjectFolderPkeyConnect>>;
  /** The primary key(s) and patch data for `projectFolder` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate>>;
};

/** A filter to be used against many `DataTable` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFolderToManyDataTableFilter = {
  /** Every related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableFilter>;
  /** No related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableFilter>;
  /** Some related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableFilter>;
};

/** A filter to be used against many `GdtAnalysisTable` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFolderToManyGdtAnalysisTableFilter = {
  /** Every related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableFilter>;
  /** No related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableFilter>;
  /** Some related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableFilter>;
};

/** Input for the nested mutation of `applicationUser` in the `ProjectFolderInput` mutation. */
export type ProjectFolderUserIdF2E16179FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `projectFolder` in the `ApplicationUserInput` mutation. */
export type ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectFolderProjectFolderPkeyConnect>>;
  /** The primary key(s) and patch data for `projectFolder` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate>>;
};

/** A connection to a list of `ProjectFolder` values. */
export type ProjectFoldersConnection = {
  __typename: 'ProjectFoldersConnection';
  /** A list of edges which contains the `ProjectFolder` and cursor to aid in pagination. */
  edges: Array<ProjectFoldersEdge>;
  /** A list of `ProjectFolder` objects. */
  nodes: Array<ProjectFolder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectFolder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectFolder` edge in the connection. */
export type ProjectFoldersEdge = {
  __typename: 'ProjectFoldersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectFolder` at the end of the edge. */
  node: ProjectFolder;
};

/** Methods to use when ordering `ProjectFolder`. */
export enum ProjectFoldersOrderBy {
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnToolForToolProjectId20A84210FkProjectIdPatch;
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `project` being updated. */
  projectPatch: UpdateProjectOnToolForToolProjectId20A84210FkProjectIdPatch;
};

/** The fields on `project` to look up the row to connect. */
export type ProjectProjectKeyTenantUniqueConnect = {
  key: Scalars['String']['input'];
  tenantId: Scalars['Int']['input'];
};

/** The fields on `project` to look up the row to connect. */
export type ProjectProjectPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `applicationUser` in the `ProjectSharedNotificationInput` mutation. */
export type ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `projectSharedNotification` in the `ApplicationUserInput` mutation. */
export type ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput = {
  /** The primary key(s) for `projectSharedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectSharedNotificationProjectSharedNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `projectSharedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate>>;
};

/** Input for the nested mutation of `applicationUser` in the `ProjectSharedNotificationInput` mutation. */
export type ProjectSharedNotifUserId9A19122FFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `projectSharedNotification` in the `ApplicationUserInput` mutation. */
export type ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput = {
  /** The primary key(s) for `projectSharedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectSharedNotificationProjectSharedNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `projectSharedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate>>;
};

export type ProjectSharedNotification = {
  __typename: 'ProjectSharedNotification';
  accessLevel: Scalars['Int']['output'];
  /** Reads a single `ApplicationUser` that is related to this `ProjectSharedNotification`. */
  applicationUserBySharerId: Maybe<ApplicationUser>;
  /** Reads a single `ApplicationUser` that is related to this `ProjectSharedNotification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars['UUID']['output'];
  /** Reads a single `Notification` that is related to this `ProjectSharedNotification`. */
  notificationById: Maybe<Notification>;
  /** Reads a single `Project` that is related to this `ProjectSharedNotification`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
  sharerId: Scalars['UUID']['output'];
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `ProjectSharedNotification` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectSharedNotificationCondition = {
  /** Checks for equality with the object’s `accessLevel` field. */
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `sharerId` field. */
  sharerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `ProjectSharedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ProjectSharedNotificationFilter = {
  /** Filter by the object’s `accessLevel` field. */
  accessLevel?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectSharedNotificationFilter>>;
  /** Filter by the object’s `applicationUserBySharerId` relation. */
  applicationUserBySharerId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectSharedNotificationFilter>;
  /** Filter by the object’s `notificationById` relation. */
  notificationById?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectSharedNotificationFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sharerId` field. */
  sharerId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `notification` in the `ProjectSharedNotificationInput` mutation. */
export type ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `projectSharedNotification` in the `NotificationInput` mutation. */
export type ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput = {
  /** The primary key(s) for `projectSharedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectSharedNotificationProjectSharedNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `projectSharedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate>;
};

/** The fields on `projectSharedNotification` to look up the row to update. */
export type ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
  projectSharedNotificationPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
};

/** The fields on `projectSharedNotification` to look up the row to update. */
export type ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
  projectSharedNotificationPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
};

/** The fields on `projectSharedNotification` to look up the row to update. */
export type ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
  projectSharedNotificationPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
};

/** The fields on `projectSharedNotification` to look up the row to update. */
export type ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
  projectSharedNotificationPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
};

/** Input for the nested mutation of `project` in the `ProjectSharedNotificationInput` mutation. */
export type ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `projectSharedNotification` in the `ProjectInput` mutation. */
export type ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput = {
  /** The primary key(s) for `projectSharedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectSharedNotificationProjectSharedNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `projectSharedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate>>;
};

/** The fields on `projectSharedNotification` to look up the row to connect. */
export type ProjectSharedNotificationProjectSharedNotificationPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A connection to a list of `ProjectSharedNotification` values. */
export type ProjectSharedNotificationsConnection = {
  __typename: 'ProjectSharedNotificationsConnection';
  /** A list of edges which contains the `ProjectSharedNotification` and cursor to aid in pagination. */
  edges: Array<ProjectSharedNotificationsEdge>;
  /** A list of `ProjectSharedNotification` objects. */
  nodes: Array<ProjectSharedNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectSharedNotification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectSharedNotification` edge in the connection. */
export type ProjectSharedNotificationsEdge = {
  __typename: 'ProjectSharedNotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectSharedNotification` at the end of the edge. */
  node: ProjectSharedNotification;
};

/** Methods to use when ordering `ProjectSharedNotification`. */
export enum ProjectSharedNotificationsOrderBy {
  AccessLevelAsc = 'ACCESS_LEVEL_ASC',
  AccessLevelDesc = 'ACCESS_LEVEL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  SharerIdAsc = 'SHARER_ID_ASC',
  SharerIdDesc = 'SHARER_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type ProjectTag = {
  __typename: 'ProjectTag';
  /** Reads a single `ApplicationUser` that is related to this `ProjectTag`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  label: Scalars['String']['output'];
  /** Reads a single `Project` that is related to this `ProjectTag`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars['UUID']['output'];
  userId: Maybe<Scalars['UUID']['output']>;
};

/**
 * A condition to be used against `ProjectTag` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProjectTagCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `ProjectTag` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectTagFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectTagFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectTagFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `projectTag` to look up the row to update. */
export type ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectTag` being updated. */
  projectTagPatch: UpdateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
};

/** The fields on `projectTag` to look up the row to update. */
export type ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `projectTag` being updated. */
  projectTagPatch: UpdateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
};

/** Input for the nested mutation of `project` in the `ProjectTagInput` mutation. */
export type ProjectTagProjectId5Ab280C9FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `projectTag` in the `ProjectInput` mutation. */
export type ProjectTagProjectId5Ab280C9FkProjectIdInverseInput = {
  /** The primary key(s) for `projectTag` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTagProjectTagPkeyConnect>>;
  /** The primary key(s) and patch data for `projectTag` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate>>;
};

/** The fields on `projectTag` to look up the row to connect. */
export type ProjectTagProjectTagPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `applicationUser` in the `ProjectTagInput` mutation. */
export type ProjectTagUserId780C8348FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `projectTag` in the `ApplicationUserInput` mutation. */
export type ProjectTagUserId780C8348FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `projectTag` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTagProjectTagPkeyConnect>>;
  /** The primary key(s) and patch data for `projectTag` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate>>;
};

/** A connection to a list of `ProjectTag` values. */
export type ProjectTagsConnection = {
  __typename: 'ProjectTagsConnection';
  /** A list of edges which contains the `ProjectTag` and cursor to aid in pagination. */
  edges: Array<ProjectTagsEdge>;
  /** A list of `ProjectTag` objects. */
  nodes: Array<ProjectTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectTag` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProjectTag` edge in the connection. */
export type ProjectTagsEdge = {
  __typename: 'ProjectTagsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ProjectTag` at the end of the edge. */
  node: ProjectTag;
};

/** Methods to use when ordering `ProjectTag`. */
export enum ProjectTagsOrderBy {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `tenant` in the `ProjectInput` mutation. */
export type ProjectTenantId03F0Ca53FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `project` in the `TenantInput` mutation. */
export type ProjectTenantId03F0Ca53FkTenantIdInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<Array<ProjectProjectKeyTenantUniqueConnect>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<Array<ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate>>;
};

/** A filter to be used against many `DataTable` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableFilter = {
  /** Every related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableFilter>;
  /** No related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableFilter>;
  /** Some related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableFilter>;
};

/** A filter to be used against many `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFileActivityFilter = {
  /** Every related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileActivityFilter>;
  /** No related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileActivityFilter>;
  /** Some related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileActivityFilter>;
};

/** A filter to be used against many `File` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFileFilter = {
  /** Every related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileFilter>;
  /** No related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileFilter>;
  /** Some related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileFilter>;
};

/** A filter to be used against many `FileMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFileMetadatumFilter = {
  /** Every related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileMetadatumFilter>;
  /** No related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileMetadatumFilter>;
  /** Some related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileMetadatumFilter>;
};

/** A filter to be used against many `FileOutputGroup` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFileOutputGroupFilter = {
  /** Every related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupFilter>;
  /** No related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupFilter>;
  /** Some related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupFilter>;
};

/** A filter to be used against many `FileOutputGroupMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFileOutputGroupMetadatumFilter = {
  /** Every related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** No related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** Some related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupMetadatumFilter>;
};

/** A filter to be used against many `GdtAnalysisTable` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyGdtAnalysisTableFilter = {
  /** Every related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableFilter>;
  /** No related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableFilter>;
  /** Some related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableFilter>;
};

/** A filter to be used against many `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyGdtAnalysisTableRowFilter = {
  /** Every related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** No related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Some related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableRowFilter>;
};

/** A filter to be used against many `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyMetadataValueFilter = {
  /** Every related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadataValueFilter>;
  /** No related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadataValueFilter>;
  /** Some related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadataValueFilter>;
};

/** A filter to be used against many `Metadatum` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyMetadatumFilter = {
  /** Every related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadatumFilter>;
  /** No related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadatumFilter>;
  /** Some related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadatumFilter>;
};

/** A filter to be used against many `OutputGroupFile` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyOutputGroupFileFilter = {
  /** Every related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OutputGroupFileFilter>;
  /** No related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OutputGroupFileFilter>;
  /** Some related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OutputGroupFileFilter>;
};

/** A filter to be used against many `ProjectClonedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectClonedNotificationFilter = {
  /** Every related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectClonedNotificationFilter>;
  /** No related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectClonedNotificationFilter>;
  /** Some related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectClonedNotificationFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `ProjectFolder` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectFolderFilter = {
  /** Every related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFolderFilter>;
  /** No related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFolderFilter>;
  /** Some related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFolderFilter>;
};

/** A filter to be used against many `ProjectSharedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectSharedNotificationFilter = {
  /** Every related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectSharedNotificationFilter>;
  /** No related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectSharedNotificationFilter>;
  /** Some related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectSharedNotificationFilter>;
};

/** A filter to be used against many `ProjectTag` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectTagFilter = {
  /** Every related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectTagFilter>;
  /** No related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectTagFilter>;
  /** Some related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectTagFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** Input for the nested mutation of `applicationUser` in the `ProjectInput` mutation. */
export type ProjectUserIdB5Fbb914FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `project` in the `ApplicationUserInput` mutation. */
export type ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<Array<ProjectProjectKeyTenantUniqueConnect>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<Array<ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate>>;
};

/** A connection to a list of `Project` values. */
export type ProjectsConnection = {
  __typename: 'ProjectsConnection';
  /** A list of edges which contains the `Project` and cursor to aid in pagination. */
  edges: Array<ProjectsEdge>;
  /** A list of `Project` objects. */
  nodes: Array<Project>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Project` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Project` edge in the connection. */
export type ProjectsEdge = {
  __typename: 'ProjectsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Project` at the end of the edge. */
  node: Project;
};

/** Methods to use when ordering `Project`. */
export enum ProjectsOrderBy {
  CloneSourceIdAsc = 'CLONE_SOURCE_ID_ASC',
  CloneSourceIdDesc = 'CLONE_SOURCE_ID_DESC',
  DateArchivedAsc = 'DATE_ARCHIVED_ASC',
  DateArchivedDesc = 'DATE_ARCHIVED_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DateDataDeletedAsc = 'DATE_DATA_DELETED_ASC',
  DateDataDeletedDesc = 'DATE_DATA_DELETED_DESC',
  DateDeletedAsc = 'DATE_DELETED_ASC',
  DateDeletedDesc = 'DATE_DELETED_DESC',
  DefaultUserAccessLevelAsc = 'DEFAULT_USER_ACCESS_LEVEL_ASC',
  DefaultUserAccessLevelDesc = 'DEFAULT_USER_ACCESS_LEVEL_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IconAsc = 'ICON_ASC',
  IconColorAsc = 'ICON_COLOR_ASC',
  IconColorDesc = 'ICON_COLOR_DESC',
  IconDesc = 'ICON_DESC',
  IconTextAsc = 'ICON_TEXT_ASC',
  IconTextDesc = 'ICON_TEXT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDemoAsc = 'IS_DEMO_ASC',
  IsDemoDesc = 'IS_DEMO_DESC',
  IsToolProjectAsc = 'IS_TOOL_PROJECT_ASC',
  IsToolProjectDesc = 'IS_TOOL_PROJECT_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrefixAsc = 'PREFIX_ASC',
  PrefixDesc = 'PREFIX_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShortDescriptionAsc = 'SHORT_DESCRIPTION_ASC',
  ShortDescriptionDesc = 'SHORT_DESCRIPTION_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TourTypeAsc = 'TOUR_TYPE_ASC',
  TourTypeDesc = 'TOUR_TYPE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename: 'Query';
  /** Reads and enables pagination through a set of `ApplicationUserMembership`. */
  allApplicationUserMemberships: Maybe<ApplicationUserMembershipsConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserMetadatum`. */
  allApplicationUserMetadata: Maybe<ApplicationUserMetadataConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserSession`. */
  allApplicationUserSessions: Maybe<ApplicationUserSessionsConnection>;
  /** Reads and enables pagination through a set of `Avatar`. */
  allAvatars: Maybe<AvatarsConnection>;
  /** Reads and enables pagination through a set of `CodeFile`. */
  allCodeFiles: Maybe<CodeFilesConnection>;
  /** Reads and enables pagination through a set of `CurrentApplicationUser`. */
  allCurrentApplicationUsers: Maybe<CurrentApplicationUsersConnection>;
  /** Reads and enables pagination through a set of `CurrentUserMembership`. */
  allCurrentUserMemberships: Maybe<CurrentUserMembershipsConnection>;
  /** Reads and enables pagination through a set of `DataTable`. */
  allDataTables: Maybe<DataTablesConnection>;
  /** Reads and enables pagination through a set of `EulaVersionUserAcceptance`. */
  allEulaVersionUserAcceptances: Maybe<EulaVersionUserAcceptancesConnection>;
  /** Reads and enables pagination through a set of `EulaVersion`. */
  allEulaVersions: Maybe<EulaVersionsConnection>;
  /** Reads and enables pagination through a set of `FileActivity`. */
  allFileActivities: Maybe<FileActivitiesConnection>;
  /** Reads and enables pagination through a set of `FileMetadatum`. */
  allFileMetadata: Maybe<FileMetadataConnection>;
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. */
  allFileOutputGroupMetadata: Maybe<FileOutputGroupMetadataConnection>;
  /** Reads and enables pagination through a set of `FileOutputGroup`. */
  allFileOutputGroups: Maybe<FileOutputGroupsConnection>;
  /** Reads and enables pagination through a set of `FileProcessingNotification`. */
  allFileProcessingNotifications: Maybe<FileProcessingNotificationsConnection>;
  /** Reads and enables pagination through a set of `File`. */
  allFiles: Maybe<FilesConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  allGdtAnalysisTableRows: Maybe<GdtAnalysisTableRowsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. */
  allGdtAnalysisTables: Maybe<GdtAnalysisTablesConnection>;
  /** Reads and enables pagination through a set of `Notification`. */
  allNotifications: Maybe<NotificationsConnection>;
  /** Reads and enables pagination through a set of `OutputGroupFile`. */
  allOutputGroupFiles: Maybe<OutputGroupFilesConnection>;
  /** Reads and enables pagination through a set of `ProjectClonedNotification`. */
  allProjectClonedNotifications: Maybe<ProjectClonedNotificationsConnection>;
  /** Reads and enables pagination through a set of `ProjectFolder`. */
  allProjectFolders: Maybe<ProjectFoldersConnection>;
  /** Reads and enables pagination through a set of `ProjectSharedNotification`. */
  allProjectSharedNotifications: Maybe<ProjectSharedNotificationsConnection>;
  /** Reads and enables pagination through a set of `ProjectTag`. */
  allProjectTags: Maybe<ProjectTagsConnection>;
  /** Reads and enables pagination through a set of `Project`. */
  allProjects: Maybe<ProjectsConnection>;
  /** Reads and enables pagination through a set of `RoleChangeNotification`. */
  allRoleChangeNotifications: Maybe<RoleChangeNotificationsConnection>;
  /** Reads and enables pagination through a set of `TaskActivity`. */
  allTaskActivities: Maybe<TaskActivitiesConnection>;
  /** Reads and enables pagination through a set of `TaskResourceUsage`. */
  allTaskResourceUsages: Maybe<TaskResourceUsagesConnection>;
  /** Reads and enables pagination through a set of `TaskResource`. */
  allTaskResources: Maybe<TaskResourcesConnection>;
  /** Reads and enables pagination through a set of `TaskSource`. */
  allTaskSources: Maybe<TaskSourcesConnection>;
  /** Reads and enables pagination through a set of `Task`. */
  allTasks: Maybe<TasksConnection>;
  /** Reads and enables pagination through a set of `TenantContractAllowance`. */
  allTenantContractAllowances: Maybe<TenantContractAllowancesConnection>;
  /** Reads and enables pagination through a set of `TenantContractTransaction`. */
  allTenantContractTransactions: Maybe<TenantContractTransactionsConnection>;
  /** Reads and enables pagination through a set of `TenantContract`. */
  allTenantContracts: Maybe<TenantContractsConnection>;
  /** Reads and enables pagination through a set of `TenantUserMembershipNotification`. */
  allTenantUserMembershipNotifications: Maybe<TenantUserMembershipNotificationsConnection>;
  /** Reads and enables pagination through a set of `ToolParameter`. */
  allToolParameters: Maybe<ToolParametersConnection>;
  /** Reads and enables pagination through a set of `ToolResult`. */
  allToolResults: Maybe<ToolResultsConnection>;
  /** Reads and enables pagination through a set of `ToolSecret`. */
  allToolSecrets: Maybe<ToolSecretsConnection>;
  /** Reads and enables pagination through a set of `ToolSource`. */
  allToolSources: Maybe<ToolSourcesConnection>;
  /** Reads and enables pagination through a set of `ToolTenant`. */
  allToolTenants: Maybe<ToolTenantsConnection>;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  allToolVersions: Maybe<ToolVersionsConnection>;
  /** Reads and enables pagination through a set of `Tool`. */
  allTools: Maybe<ToolsConnection>;
  /** Reads and enables pagination through a set of `UserAccessToProject`. */
  allUserAccessToProjects: Maybe<UserAccessToProjectsConnection>;
  applicationUserByEmail: Maybe<ApplicationUser>;
  applicationUserByGlobalUserId: Maybe<ApplicationUser>;
  applicationUserById: Maybe<ApplicationUser>;
  applicationUserByUsername: Maybe<ApplicationUser>;
  applicationUserMembershipById: Maybe<ApplicationUserMembership>;
  applicationUserMembershipByUserIdAndTenantId: Maybe<ApplicationUserMembership>;
  applicationUserMetadatumById: Maybe<ApplicationUserMetadatum>;
  applicationUserMetadatumByUserIdAndKey: Maybe<ApplicationUserMetadatum>;
  applicationUserSessionById: Maybe<ApplicationUserSession>;
  assertUserAcceptedEula: Maybe<Scalars['Boolean']['output']>;
  assertUserCanSeeTenantInfo: Maybe<Scalars['Boolean']['output']>;
  assertUserCanSeeUserInfo: Maybe<Scalars['Boolean']['output']>;
  assertUserHasProjectSharedByTenant: Maybe<Scalars['Boolean']['output']>;
  assertUserHasTenantOfId: Maybe<Scalars['Boolean']['output']>;
  assertUserIsAdminOfProjectTenant: Maybe<Scalars['Boolean']['output']>;
  assertUserIsAdminOfTenant: Maybe<Scalars['Boolean']['output']>;
  assertUserIsInvitedToTenant: Maybe<Scalars['Boolean']['output']>;
  avatarById: Maybe<Avatar>;
  avatarByUserId: Maybe<Avatar>;
  codeFileById: Maybe<CodeFile>;
  dataTableById: Maybe<DataTable>;
  eulaVersionById: Maybe<EulaVersion>;
  eulaVersionByVersion: Maybe<EulaVersion>;
  eulaVersionUserAcceptanceById: Maybe<EulaVersionUserAcceptance>;
  eulaVersionUserAcceptanceByUserIdAndEulaVersionId: Maybe<EulaVersionUserAcceptance>;
  fileActivityById: Maybe<FileActivity>;
  fileById: Maybe<File>;
  fileByProjectIdAndReferenceId: Maybe<File>;
  fileMetadatumById: Maybe<FileMetadatum>;
  fileOutputGroupById: Maybe<FileOutputGroup>;
  fileOutputGroupByTaskId: Maybe<FileOutputGroup>;
  fileOutputGroupMetadatumById: Maybe<FileOutputGroupMetadatum>;
  fileProcessingNotificationById: Maybe<FileProcessingNotification>;
  gdtAnalysisTableById: Maybe<GdtAnalysisTable>;
  gdtAnalysisTableRowById: Maybe<GdtAnalysisTableRow>;
  gdtAnalysisTableRowByTableIdAndIndex: Maybe<GdtAnalysisTableRow>;
  gdtAnalysisTableRowByTableIdAndOrder: Maybe<GdtAnalysisTableRow>;
  getCurrentUser: Maybe<ApplicationUser>;
  getCurrentUserId: Maybe<Scalars['UUID']['output']>;
  getUserActiveSession: Maybe<ApplicationUserSession>;
  jwtHasGlobalUserIdClaim: Maybe<Scalars['Boolean']['output']>;
  metadataValueById: Maybe<MetadataValue>;
  metadatumById: Maybe<Metadatum>;
  notificationById: Maybe<Notification>;
  outputGroupFileById: Maybe<OutputGroupFile>;
  projectById: Maybe<Project>;
  projectByKeyAndTenantId: Maybe<Project>;
  projectClonedNotificationById: Maybe<ProjectClonedNotification>;
  projectFolderById: Maybe<ProjectFolder>;
  projectSharedNotificationById: Maybe<ProjectSharedNotification>;
  projectTagById: Maybe<ProjectTag>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  roleChangeNotificationById: Maybe<RoleChangeNotification>;
  sessionIsActive: Scalars['Boolean']['output'];
  sessionIsActiveSession: Maybe<Scalars['Boolean']['output']>;
  taskActivityById: Maybe<TaskActivity>;
  taskActivityByTaskId: Maybe<TaskActivity>;
  taskByExecutorId: Maybe<Task>;
  taskById: Maybe<Task>;
  taskResourceById: Maybe<TaskResource>;
  taskResourceUsageById: Maybe<TaskResourceUsage>;
  taskResourceUsageByTaskId: Maybe<TaskResourceUsage>;
  taskSourceById: Maybe<TaskSource>;
  tenantById: Maybe<Tenant>;
  tenantByKey: Maybe<Tenant>;
  tenantByRepositoryName: Maybe<Tenant>;
  tenantBySfid: Maybe<Tenant>;
  tenantContractAllowanceById: Maybe<TenantContractAllowance>;
  tenantContractAllowanceByTenantContractTransactionIdAndQuotaType: Maybe<TenantContractAllowance>;
  tenantContractById: Maybe<TenantContract>;
  tenantContractByName: Maybe<TenantContract>;
  tenantContractBySfid: Maybe<TenantContract>;
  tenantContractTransactionById: Maybe<TenantContractTransaction>;
  tenantUserMembershipNotificationById: Maybe<TenantUserMembershipNotification>;
  toolById: Maybe<Tool>;
  toolByProjectId: Maybe<Tool>;
  toolParameterById: Maybe<ToolParameter>;
  toolResultById: Maybe<ToolResult>;
  toolSecretById: Maybe<ToolSecret>;
  toolSourceById: Maybe<ToolSource>;
  toolTenantById: Maybe<ToolTenant>;
  toolTenantByToolIdAndTenantId: Maybe<ToolTenant>;
  toolVersionById: Maybe<ToolVersion>;
  userHasActiveSession: Maybe<Scalars['Boolean']['output']>;
  userIdIsSettingsGlobalUserId: Maybe<Scalars['Boolean']['output']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApplicationUserMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApplicationUserMembershipCondition>;
  filter?: InputMaybe<ApplicationUserMembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApplicationUserMembershipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApplicationUserMetadataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApplicationUserMetadatumCondition>;
  filter?: InputMaybe<ApplicationUserMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApplicationUserMetadataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApplicationUserSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApplicationUserSessionCondition>;
  filter?: InputMaybe<ApplicationUserSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAvatarsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AvatarCondition>;
  filter?: InputMaybe<AvatarFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AvatarsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCodeFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CodeFileCondition>;
  filter?: InputMaybe<CodeFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCurrentApplicationUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CurrentApplicationUserCondition>;
  filter?: InputMaybe<CurrentApplicationUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CurrentApplicationUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCurrentUserMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CurrentUserMembershipCondition>;
  filter?: InputMaybe<CurrentUserMembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CurrentUserMembershipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDataTablesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DataTableCondition>;
  filter?: InputMaybe<DataTableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTablesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEulaVersionUserAcceptancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EulaVersionUserAcceptanceCondition>;
  filter?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEulaVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EulaVersionCondition>;
  filter?: InputMaybe<EulaVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EulaVersionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFileActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFileMetadataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFileOutputGroupMetadataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFileOutputGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFileProcessingNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileProcessingNotificationCondition>;
  filter?: InputMaybe<FileProcessingNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileProcessingNotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGdtAnalysisTableRowsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGdtAnalysisTablesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOutputGroupFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OutputGroupFileCondition>;
  filter?: InputMaybe<OutputGroupFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProjectClonedNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProjectFoldersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectFolderCondition>;
  filter?: InputMaybe<ProjectFolderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectFoldersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProjectSharedNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProjectTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRoleChangeNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoleChangeNotificationCondition>;
  filter?: InputMaybe<RoleChangeNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoleChangeNotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTaskActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskActivityCondition>;
  filter?: InputMaybe<TaskActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTaskResourceUsagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskResourceUsageCondition>;
  filter?: InputMaybe<TaskResourceUsageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskResourceUsagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTaskResourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskResourceCondition>;
  filter?: InputMaybe<TaskResourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskResourcesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTaskSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskSourceCondition>;
  filter?: InputMaybe<TaskSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTenantContractAllowancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantContractAllowanceCondition>;
  filter?: InputMaybe<TenantContractAllowanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantContractAllowancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTenantContractTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantContractTransactionCondition>;
  filter?: InputMaybe<TenantContractTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantContractTransactionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTenantContractsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantContractCondition>;
  filter?: InputMaybe<TenantContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantContractsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTenantUserMembershipNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllToolParametersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolParameterCondition>;
  filter?: InputMaybe<ToolParameterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolParametersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllToolResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolResultCondition>;
  filter?: InputMaybe<ToolResultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolResultsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllToolSecretsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolSecretCondition>;
  filter?: InputMaybe<ToolSecretFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolSecretsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllToolSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolSourceCondition>;
  filter?: InputMaybe<ToolSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolSourcesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllToolTenantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolTenantCondition>;
  filter?: InputMaybe<ToolTenantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolTenantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllToolVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolVersionCondition>;
  filter?: InputMaybe<ToolVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllToolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolCondition>;
  filter?: InputMaybe<ToolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUserAccessToProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserAccessToProjectCondition>;
  filter?: InputMaybe<UserAccessToProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserAccessToProjectsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserByEmailArgs = {
  email: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserByGlobalUserIdArgs = {
  globalUserId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserByUsernameArgs = {
  username: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserMembershipByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserMembershipByUserIdAndTenantIdArgs = {
  tenantId: Scalars['Int']['input'];
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserMetadatumByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserMetadatumByUserIdAndKeyArgs = {
  key: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserSessionByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssertUserCanSeeTenantInfoArgs = {
  tenantId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAssertUserCanSeeUserInfoArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAssertUserHasProjectSharedByTenantArgs = {
  tenantId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAssertUserHasTenantOfIdArgs = {
  tenantId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAssertUserIsAdminOfProjectTenantArgs = {
  projectId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAssertUserIsAdminOfTenantArgs = {
  tenantId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAssertUserIsInvitedToTenantArgs = {
  tenantId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAvatarByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAvatarByUserIdArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCodeFileByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDataTableByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEulaVersionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEulaVersionByVersionArgs = {
  version: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEulaVersionUserAcceptanceByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEulaVersionUserAcceptanceByUserIdAndEulaVersionIdArgs = {
  eulaVersionId: Scalars['Int']['input'];
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFileActivityByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFileByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFileByProjectIdAndReferenceIdArgs = {
  projectId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFileMetadatumByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFileOutputGroupByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFileOutputGroupByTaskIdArgs = {
  taskId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFileOutputGroupMetadatumByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFileProcessingNotificationByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableRowByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableRowByTableIdAndIndexArgs = {
  index: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableRowByTableIdAndOrderArgs = {
  order: Scalars['Int']['input'];
  tableId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUserActiveSessionArgs = {
  userid: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMetadataValueByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMetadatumByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOutputGroupFileByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectByKeyAndTenantIdArgs = {
  key: Scalars['String']['input'];
  tenantId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectClonedNotificationByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectFolderByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectSharedNotificationByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTagByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoleChangeNotificationByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionIsActiveSessionArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskActivityByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskActivityByTaskIdArgs = {
  taskId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskByExecutorIdArgs = {
  executorId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskResourceByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskResourceUsageByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskResourceUsageByTaskIdArgs = {
  taskId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskSourceByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantByKeyArgs = {
  key: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantByRepositoryNameArgs = {
  repositoryName: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantBySfidArgs = {
  sfid: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantContractAllowanceByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeArgs = {
  quotaType: Scalars['Int']['input'];
  tenantContractTransactionId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantContractByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantContractByNameArgs = {
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantContractBySfidArgs = {
  sfid: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantContractTransactionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantUserMembershipNotificationByIdArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryToolByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryToolByProjectIdArgs = {
  projectId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryToolParameterByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryToolResultByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryToolSecretByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryToolSourceByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryToolTenantByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryToolTenantByToolIdAndTenantIdArgs = {
  tenantId: Scalars['Int']['input'];
  toolId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryToolVersionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserHasActiveSessionArgs = {
  userid: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserIdIsSettingsGlobalUserIdArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for the nested mutation of `applicationUser` in the `RoleChangeNotificationInput` mutation. */
export type RoleChangeNotificaUserId879Bd49AFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `roleChangeNotification` in the `ApplicationUserInput` mutation. */
export type RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput = {
  /** The primary key(s) for `roleChangeNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoleChangeNotificationRoleChangeNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `roleChangeNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate>>;
};

export type RoleChangeNotification = {
  __typename: 'RoleChangeNotification';
  /** Reads a single `ApplicationUser` that is related to this `RoleChangeNotification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars['UUID']['output'];
  /** Reads a single `Notification` that is related to this `RoleChangeNotification`. */
  notificationById: Maybe<Notification>;
  role: Scalars['Int']['output'];
  /** Reads a single `Tenant` that is related to this `RoleChangeNotification`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `RoleChangeNotification` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoleChangeNotificationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `RoleChangeNotification` object types. All fields are combined with a logical ‘and.’ */
export type RoleChangeNotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoleChangeNotificationFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoleChangeNotificationFilter>;
  /** Filter by the object’s `notificationById` relation. */
  notificationById?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoleChangeNotificationFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `notification` in the `RoleChangeNotificationInput` mutation. */
export type RoleChangeNotificationIdD576A528FkNotificationIdInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `roleChangeNotification` in the `NotificationInput` mutation. */
export type RoleChangeNotificationIdD576A528FkNotificationIdInverseInput = {
  /** The primary key(s) for `roleChangeNotification` for the far side of the relationship. */
  connectById?: InputMaybe<RoleChangeNotificationRoleChangeNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `roleChangeNotification` for the far side of the relationship. */
  updateById?: InputMaybe<RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate>;
};

/** The fields on `roleChangeNotification` to look up the row to update. */
export type RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
  roleChangeNotificationPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
};

/** The fields on `roleChangeNotification` to look up the row to update. */
export type RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
  roleChangeNotificationPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
};

/** The fields on `roleChangeNotification` to look up the row to update. */
export type RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
  roleChangeNotificationPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
};

/** The fields on `roleChangeNotification` to look up the row to connect. */
export type RoleChangeNotificationRoleChangeNotificationPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `tenant` in the `RoleChangeNotificationInput` mutation. */
export type RoleChangeNotificationTenantId36852Ce9FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `roleChangeNotification` in the `TenantInput` mutation. */
export type RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput = {
  /** The primary key(s) for `roleChangeNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoleChangeNotificationRoleChangeNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `roleChangeNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate>>;
};

/** A connection to a list of `RoleChangeNotification` values. */
export type RoleChangeNotificationsConnection = {
  __typename: 'RoleChangeNotificationsConnection';
  /** A list of edges which contains the `RoleChangeNotification` and cursor to aid in pagination. */
  edges: Array<RoleChangeNotificationsEdge>;
  /** A list of `RoleChangeNotification` objects. */
  nodes: Array<RoleChangeNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoleChangeNotification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RoleChangeNotification` edge in the connection. */
export type RoleChangeNotificationsEdge = {
  __typename: 'RoleChangeNotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `RoleChangeNotification` at the end of the edge. */
  node: RoleChangeNotification;
};

/** Methods to use when ordering `RoleChangeNotification`. */
export enum RoleChangeNotificationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

export type Task = {
  __typename: 'Task';
  /** Reads a single `ApplicationUser` that is related to this `Task`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  cloned: Scalars['Boolean']['output'];
  containerImageId: Maybe<Scalars['Int']['output']>;
  credits: Maybe<Scalars['Float']['output']>;
  dateCreated: Scalars['Datetime']['output'];
  errorDescription: Maybe<Scalars['JSON']['output']>;
  executorId: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `FileOutputGroup` that is related to this `Task`. */
  fileOutputGroupByTaskId: Maybe<FileOutputGroup>;
  /**
   * Reads and enables pagination through a set of `FileOutputGroup`.
   * @deprecated Please use fileOutputGroupByTaskId instead
   */
  fileOutputGroupsByTaskId: FileOutputGroupsConnection;
  /** Reads and enables pagination through a set of `File`. */
  filesByTaskId: FilesConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  gdtAnalysisTableRowsByTaskId: GdtAnalysisTableRowsConnection;
  id: Scalars['UUID']['output'];
  inputsHash: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `MetadataValue`. */
  metadataValuesByTaskId: MetadataValuesConnection;
  /** Reads a single `Project` that is related to this `Task`. */
  projectByProjectId: Maybe<Project>;
  projectId: Maybe<Scalars['UUID']['output']>;
  resourceTier: Maybe<Scalars['Int']['output']>;
  status: Scalars['Int']['output'];
  /**
   * Reads and enables pagination through a set of `TaskActivity`.
   * @deprecated Please use taskActivityByTaskId instead
   */
  taskActivitiesByTaskId: TaskActivitiesConnection;
  /** Reads a single `TaskActivity` that is related to this `Task`. */
  taskActivityByTaskId: Maybe<TaskActivity>;
  taskParameters: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `TaskResourceUsage` that is related to this `Task`. */
  taskResourceUsageByTaskId: Maybe<TaskResourceUsage>;
  /**
   * Reads and enables pagination through a set of `TaskResourceUsage`.
   * @deprecated Please use taskResourceUsageByTaskId instead
   */
  taskResourceUsagesByTaskId: TaskResourceUsagesConnection;
  /** Reads and enables pagination through a set of `TaskResource`. */
  taskResourcesByTaskId: TaskResourcesConnection;
  /** Reads and enables pagination through a set of `TaskSource`. */
  taskSourcesByTaskId: TaskSourcesConnection;
  /** Reads a single `Tenant` that is related to this `Task`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
  toolExitcode: Maybe<Scalars['String']['output']>;
  toolExitcodeDescription: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `ToolVersion` that is related to this `Task`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars['Int']['output'];
  userId: Scalars['UUID']['output'];
};


export type TaskFileOutputGroupsByTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};


export type TaskFilesByTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type TaskGdtAnalysisTableRowsByTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};


export type TaskMetadataValuesByTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MetadataValueCondition>;
  filter?: InputMaybe<MetadataValueFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};


export type TaskTaskActivitiesByTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskActivityCondition>;
  filter?: InputMaybe<TaskActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivitiesOrderBy>>;
};


export type TaskTaskResourceUsagesByTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskResourceUsageCondition>;
  filter?: InputMaybe<TaskResourceUsageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskResourceUsagesOrderBy>>;
};


export type TaskTaskResourcesByTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskResourceCondition>;
  filter?: InputMaybe<TaskResourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskResourcesOrderBy>>;
};


export type TaskTaskSourcesByTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskSourceCondition>;
  filter?: InputMaybe<TaskSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

/** A connection to a list of `TaskActivity` values. */
export type TaskActivitiesConnection = {
  __typename: 'TaskActivitiesConnection';
  /** A list of edges which contains the `TaskActivity` and cursor to aid in pagination. */
  edges: Array<TaskActivitiesEdge>;
  /** A list of `TaskActivity` objects. */
  nodes: Array<TaskActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskActivity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TaskActivity` edge in the connection. */
export type TaskActivitiesEdge = {
  __typename: 'TaskActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `TaskActivity` at the end of the edge. */
  node: TaskActivity;
};

/** Methods to use when ordering `TaskActivity`. */
export enum TaskActivitiesOrderBy {
  ClonedAsc = 'CLONED_ASC',
  ClonedDesc = 'CLONED_DESC',
  CostIdAsc = 'COST_ID_ASC',
  CostIdDesc = 'COST_ID_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InstanceTypeAsc = 'INSTANCE_TYPE_ASC',
  InstanceTypeDesc = 'INSTANCE_TYPE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC'
}

export type TaskActivity = {
  __typename: 'TaskActivity';
  cloned: Scalars['Boolean']['output'];
  costId: Maybe<Scalars['BigInt']['output']>;
  dateCreated: Scalars['Datetime']['output'];
  duration: Interval;
  id: Scalars['Int']['output'];
  instanceType: Maybe<Scalars['String']['output']>;
  /** Reads a single `Task` that is related to this `TaskActivity`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `TaskActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TaskActivityCondition = {
  /** Checks for equality with the object’s `cloned` field. */
  cloned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `costId` field. */
  costId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `instanceType` field. */
  instanceType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `TaskActivity` object types. All fields are combined with a logical ‘and.’ */
export type TaskActivityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskActivityFilter>>;
  /** Filter by the object’s `cloned` field. */
  cloned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `costId` field. */
  costId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `instanceType` field. */
  instanceType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskActivityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskActivityFilter>>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
};

/** The fields on `taskActivity` to look up the row to update. */
export type TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `taskActivity` being updated. */
  taskActivityPatch: UpdateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
};

/** The fields on `taskActivity` to look up the row to update. */
export type TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate = {
  /** An object where the defined keys will be set on the `taskActivity` being updated. */
  taskActivityPatch: UpdateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  taskId: Scalars['UUID']['input'];
};

/** The fields on `taskActivity` to look up the row to connect. */
export type TaskActivityTaskActivityPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** The fields on `taskActivity` to look up the row to connect. */
export type TaskActivityTaskActivityTaskIdKeyConnect = {
  taskId: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `task` in the `TaskActivityInput` mutation. */
export type TaskActivityTaskIdC451Ae92FkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskActivity` in the `TaskInput` mutation. */
export type TaskActivityTaskIdC451Ae92FkTaskIdInverseInput = {
  /** The primary key(s) for `taskActivity` for the far side of the relationship. */
  connectById?: InputMaybe<TaskActivityTaskActivityPkeyConnect>;
  /** The primary key(s) for `taskActivity` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<TaskActivityTaskActivityTaskIdKeyConnect>;
  /** The primary key(s) and patch data for `taskActivity` for the far side of the relationship. */
  updateById?: InputMaybe<TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate>;
  /** The primary key(s) and patch data for `taskActivity` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate>;
};

/** A condition to be used against `Task` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TaskCondition = {
  /** Checks for equality with the object’s `cloned` field. */
  cloned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `containerImageId` field. */
  containerImageId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `credits` field. */
  credits?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `errorDescription` field. */
  errorDescription?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `executorId` field. */
  executorId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `inputsHash` field. */
  inputsHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `resourceTier` field. */
  resourceTier?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `taskParameters` field. */
  taskParameters?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `toolExitcode` field. */
  toolExitcode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `toolExitcodeDescription` field. */
  toolExitcodeDescription?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `Task` object types. All fields are combined with a logical ‘and.’ */
export type TaskFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `cloned` field. */
  cloned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `containerImageId` field. */
  containerImageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `errorDescription` field. */
  errorDescription?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `executorId` field. */
  executorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fileOutputGroupByTaskId` relation. */
  fileOutputGroupByTaskId?: InputMaybe<FileOutputGroupFilter>;
  /** A related `fileOutputGroupByTaskId` exists. */
  fileOutputGroupByTaskIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `filesByTaskId` relation. */
  filesByTaskId?: InputMaybe<TaskToManyFileFilter>;
  /** Some related `filesByTaskId` exist. */
  filesByTaskIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `gdtAnalysisTableRowsByTaskId` relation. */
  gdtAnalysisTableRowsByTaskId?: InputMaybe<TaskToManyGdtAnalysisTableRowFilter>;
  /** Some related `gdtAnalysisTableRowsByTaskId` exist. */
  gdtAnalysisTableRowsByTaskIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inputsHash` field. */
  inputsHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadataValuesByTaskId` relation. */
  metadataValuesByTaskId?: InputMaybe<TaskToManyMetadataValueFilter>;
  /** Some related `metadataValuesByTaskId` exist. */
  metadataValuesByTaskIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<TaskFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** A related `projectByProjectId` exists. */
  projectByProjectIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `resourceTier` field. */
  resourceTier?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taskActivityByTaskId` relation. */
  taskActivityByTaskId?: InputMaybe<TaskActivityFilter>;
  /** A related `taskActivityByTaskId` exists. */
  taskActivityByTaskIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `taskParameters` field. */
  taskParameters?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `taskResourceUsageByTaskId` relation. */
  taskResourceUsageByTaskId?: InputMaybe<TaskResourceUsageFilter>;
  /** A related `taskResourceUsageByTaskId` exists. */
  taskResourceUsageByTaskIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `taskResourcesByTaskId` relation. */
  taskResourcesByTaskId?: InputMaybe<TaskToManyTaskResourceFilter>;
  /** Some related `taskResourcesByTaskId` exist. */
  taskResourcesByTaskIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `taskSourcesByTaskId` relation. */
  taskSourcesByTaskId?: InputMaybe<TaskToManyTaskSourceFilter>;
  /** Some related `taskSourcesByTaskId` exist. */
  taskSourcesByTaskIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolExitcode` field. */
  toolExitcode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `toolExitcodeDescription` field. */
  toolExitcodeDescription?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate = {
  executorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
};

/** Input for the nested mutation of `project` in the `TaskInput` mutation. */
export type TaskProjectId963D6354FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `task` in the `ProjectInput` mutation. */
export type TaskProjectId963D6354FkProjectIdInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyConnect>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<Array<TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate>>;
};

export type TaskResource = {
  __typename: 'TaskResource';
  id: Scalars['Int']['output'];
  /** Reads a single `Task` that is related to this `TaskResource`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars['UUID']['output'];
  type: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

/**
 * A condition to be used against `TaskResource` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TaskResourceCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `TaskResource` object types. All fields are combined with a logical ‘and.’ */
export type TaskResourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskResourceFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskResourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskResourceFilter>>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<IntFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
};

/** The fields on `taskResource` to look up the row to update. */
export type TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `taskResource` being updated. */
  taskResourcePatch: UpdateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
};

/** Input for the nested mutation of `task` in the `TaskResourceInput` mutation. */
export type TaskResourceTaskId73Fcabc0FkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskResource` in the `TaskInput` mutation. */
export type TaskResourceTaskId73Fcabc0FkTaskIdInverseInput = {
  /** The primary key(s) for `taskResource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskResourceTaskResourcePkeyConnect>>;
  /** The primary key(s) and patch data for `taskResource` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate>>;
};

/** The fields on `taskResource` to look up the row to connect. */
export type TaskResourceTaskResourcePkeyConnect = {
  id: Scalars['Int']['input'];
};

export type TaskResourceUsage = {
  __typename: 'TaskResourceUsage';
  cpuMax: Scalars['Float']['output'];
  cpuMean: Scalars['Float']['output'];
  cpuMedian: Scalars['Float']['output'];
  cpuMin: Scalars['Float']['output'];
  cpuStd: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  memoryMax: Scalars['Float']['output'];
  memoryMean: Scalars['Float']['output'];
  memoryMedian: Scalars['Float']['output'];
  memoryMin: Scalars['Float']['output'];
  memoryStd: Scalars['Float']['output'];
  storageMax: Scalars['Float']['output'];
  storageMean: Scalars['Float']['output'];
  storageMedian: Scalars['Float']['output'];
  storageMin: Scalars['Float']['output'];
  storageStd: Scalars['Float']['output'];
  /** Reads a single `Task` that is related to this `TaskResourceUsage`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `TaskResourceUsage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TaskResourceUsageCondition = {
  /** Checks for equality with the object’s `cpuMax` field. */
  cpuMax?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `cpuMean` field. */
  cpuMean?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `cpuMedian` field. */
  cpuMedian?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `cpuMin` field. */
  cpuMin?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `cpuStd` field. */
  cpuStd?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `memoryMax` field. */
  memoryMax?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `memoryMean` field. */
  memoryMean?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `memoryMedian` field. */
  memoryMedian?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `memoryMin` field. */
  memoryMin?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `memoryStd` field. */
  memoryStd?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `storageMax` field. */
  storageMax?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `storageMean` field. */
  storageMean?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `storageMedian` field. */
  storageMedian?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `storageMin` field. */
  storageMin?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `storageStd` field. */
  storageStd?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `TaskResourceUsage` object types. All fields are combined with a logical ‘and.’ */
export type TaskResourceUsageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskResourceUsageFilter>>;
  /** Filter by the object’s `cpuMax` field. */
  cpuMax?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `cpuMean` field. */
  cpuMean?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `cpuMedian` field. */
  cpuMedian?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `cpuMin` field. */
  cpuMin?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `cpuStd` field. */
  cpuStd?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memoryMax` field. */
  memoryMax?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `memoryMean` field. */
  memoryMean?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `memoryMedian` field. */
  memoryMedian?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `memoryMin` field. */
  memoryMin?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `memoryStd` field. */
  memoryStd?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskResourceUsageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskResourceUsageFilter>>;
  /** Filter by the object’s `storageMax` field. */
  storageMax?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `storageMean` field. */
  storageMean?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `storageMedian` field. */
  storageMedian?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `storageMin` field. */
  storageMin?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `storageStd` field. */
  storageStd?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
};

/** The fields on `taskResourceUsage` to look up the row to update. */
export type TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `taskResourceUsage` being updated. */
  taskResourceUsagePatch: UpdateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
};

/** The fields on `taskResourceUsage` to look up the row to update. */
export type TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate = {
  taskId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `taskResourceUsage` being updated. */
  taskResourceUsagePatch: UpdateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
};

/** Input for the nested mutation of `task` in the `TaskResourceUsageInput` mutation. */
export type TaskResourceUsageTaskIdA28F1580FkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskResourceUsage` in the `TaskInput` mutation. */
export type TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput = {
  /** The primary key(s) for `taskResourceUsage` for the far side of the relationship. */
  connectById?: InputMaybe<TaskResourceUsageTaskResourceUsagePkeyConnect>;
  /** The primary key(s) for `taskResourceUsage` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<TaskResourceUsageTaskResourceUsageTaskIdKeyConnect>;
  /** The primary key(s) and patch data for `taskResourceUsage` for the far side of the relationship. */
  updateById?: InputMaybe<TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate>;
  /** The primary key(s) and patch data for `taskResourceUsage` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate>;
};

/** The fields on `taskResourceUsage` to look up the row to connect. */
export type TaskResourceUsageTaskResourceUsagePkeyConnect = {
  id: Scalars['Int']['input'];
};

/** The fields on `taskResourceUsage` to look up the row to connect. */
export type TaskResourceUsageTaskResourceUsageTaskIdKeyConnect = {
  taskId: Scalars['UUID']['input'];
};

/** A connection to a list of `TaskResourceUsage` values. */
export type TaskResourceUsagesConnection = {
  __typename: 'TaskResourceUsagesConnection';
  /** A list of edges which contains the `TaskResourceUsage` and cursor to aid in pagination. */
  edges: Array<TaskResourceUsagesEdge>;
  /** A list of `TaskResourceUsage` objects. */
  nodes: Array<TaskResourceUsage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskResourceUsage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TaskResourceUsage` edge in the connection. */
export type TaskResourceUsagesEdge = {
  __typename: 'TaskResourceUsagesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `TaskResourceUsage` at the end of the edge. */
  node: TaskResourceUsage;
};

/** Methods to use when ordering `TaskResourceUsage`. */
export enum TaskResourceUsagesOrderBy {
  CpuMaxAsc = 'CPU_MAX_ASC',
  CpuMaxDesc = 'CPU_MAX_DESC',
  CpuMeanAsc = 'CPU_MEAN_ASC',
  CpuMeanDesc = 'CPU_MEAN_DESC',
  CpuMedianAsc = 'CPU_MEDIAN_ASC',
  CpuMedianDesc = 'CPU_MEDIAN_DESC',
  CpuMinAsc = 'CPU_MIN_ASC',
  CpuMinDesc = 'CPU_MIN_DESC',
  CpuStdAsc = 'CPU_STD_ASC',
  CpuStdDesc = 'CPU_STD_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemoryMaxAsc = 'MEMORY_MAX_ASC',
  MemoryMaxDesc = 'MEMORY_MAX_DESC',
  MemoryMeanAsc = 'MEMORY_MEAN_ASC',
  MemoryMeanDesc = 'MEMORY_MEAN_DESC',
  MemoryMedianAsc = 'MEMORY_MEDIAN_ASC',
  MemoryMedianDesc = 'MEMORY_MEDIAN_DESC',
  MemoryMinAsc = 'MEMORY_MIN_ASC',
  MemoryMinDesc = 'MEMORY_MIN_DESC',
  MemoryStdAsc = 'MEMORY_STD_ASC',
  MemoryStdDesc = 'MEMORY_STD_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StorageMaxAsc = 'STORAGE_MAX_ASC',
  StorageMaxDesc = 'STORAGE_MAX_DESC',
  StorageMeanAsc = 'STORAGE_MEAN_ASC',
  StorageMeanDesc = 'STORAGE_MEAN_DESC',
  StorageMedianAsc = 'STORAGE_MEDIAN_ASC',
  StorageMedianDesc = 'STORAGE_MEDIAN_DESC',
  StorageMinAsc = 'STORAGE_MIN_ASC',
  StorageMinDesc = 'STORAGE_MIN_DESC',
  StorageStdAsc = 'STORAGE_STD_ASC',
  StorageStdDesc = 'STORAGE_STD_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC'
}

/** A connection to a list of `TaskResource` values. */
export type TaskResourcesConnection = {
  __typename: 'TaskResourcesConnection';
  /** A list of edges which contains the `TaskResource` and cursor to aid in pagination. */
  edges: Array<TaskResourcesEdge>;
  /** A list of `TaskResource` objects. */
  nodes: Array<TaskResource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskResource` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TaskResource` edge in the connection. */
export type TaskResourcesEdge = {
  __typename: 'TaskResourcesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `TaskResource` at the end of the edge. */
  node: TaskResource;
};

/** Methods to use when ordering `TaskResource`. */
export enum TaskResourcesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type TaskSource = {
  __typename: 'TaskSource';
  /** Reads a single `File` that is related to this `TaskSource`. */
  fileByFileId: Maybe<File>;
  fileId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `Task` that is related to this `TaskSource`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars['UUID']['output'];
  /** Reads a single `ToolSource` that is related to this `TaskSource`. */
  toolSourceByToolSourceId: Maybe<ToolSource>;
  toolSourceId: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `TaskSource` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TaskSourceCondition = {
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `toolSourceId` field. */
  toolSourceId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for the nested mutation of `file` in the `TaskSourceInput` mutation. */
export type TaskSourceFileId2F628862FkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `taskSource` in the `FileInput` mutation. */
export type TaskSourceFileId2F628862FkFileIdInverseInput = {
  /** The primary key(s) for `taskSource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskSourceTaskSourcePkeyConnect>>;
  /** The primary key(s) and patch data for `taskSource` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate>>;
};

/** A filter to be used against `TaskSource` object types. All fields are combined with a logical ‘and.’ */
export type TaskSourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskSourceFilter>>;
  /** Filter by the object’s `fileByFileId` relation. */
  fileByFileId?: InputMaybe<FileFilter>;
  /** A related `fileByFileId` exists. */
  fileByFileIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskSourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskSourceFilter>>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `toolSourceByToolSourceId` relation. */
  toolSourceByToolSourceId?: InputMaybe<ToolSourceFilter>;
  /** A related `toolSourceByToolSourceId` exists. */
  toolSourceByToolSourceIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolSourceId` field. */
  toolSourceId?: InputMaybe<IntFilter>;
};

/** The fields on `taskSource` to look up the row to update. */
export type TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `taskSource` being updated. */
  taskSourcePatch: UpdateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
};

/** The fields on `taskSource` to look up the row to update. */
export type TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `taskSource` being updated. */
  taskSourcePatch: UpdateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
};

/** The fields on `taskSource` to look up the row to update. */
export type TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `taskSource` being updated. */
  taskSourcePatch: UpdateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
};

/** Input for the nested mutation of `task` in the `TaskSourceInput` mutation. */
export type TaskSourceTaskIdF241BaedFkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskSource` in the `TaskInput` mutation. */
export type TaskSourceTaskIdF241BaedFkTaskIdInverseInput = {
  /** The primary key(s) for `taskSource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskSourceTaskSourcePkeyConnect>>;
  /** The primary key(s) and patch data for `taskSource` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate>>;
};

/** The fields on `taskSource` to look up the row to connect. */
export type TaskSourceTaskSourcePkeyConnect = {
  id: Scalars['Int']['input'];
};

/** Input for the nested mutation of `toolSource` in the `TaskSourceInput` mutation. */
export type TaskSourceToolSourceId14453EdbFkToolSourceIdInput = {
  /** The primary key(s) for `toolSource` for the far side of the relationship. */
  connectById?: InputMaybe<ToolSourceToolSourcePkeyConnect>;
  /** The primary key(s) and patch data for `toolSource` for the far side of the relationship. */
  updateById?: InputMaybe<ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate>;
};

/** Input for the nested mutation of `taskSource` in the `ToolSourceInput` mutation. */
export type TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput = {
  /** The primary key(s) for `taskSource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskSourceTaskSourcePkeyConnect>>;
  /** The primary key(s) and patch data for `taskSource` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate>>;
};

/** A connection to a list of `TaskSource` values. */
export type TaskSourcesConnection = {
  __typename: 'TaskSourcesConnection';
  /** A list of edges which contains the `TaskSource` and cursor to aid in pagination. */
  edges: Array<TaskSourcesEdge>;
  /** A list of `TaskSource` objects. */
  nodes: Array<TaskSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskSource` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TaskSource` edge in the connection. */
export type TaskSourcesEdge = {
  __typename: 'TaskSourcesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `TaskSource` at the end of the edge. */
  node: TaskSource;
};

/** Methods to use when ordering `TaskSource`. */
export enum TaskSourcesOrderBy {
  FileIdAsc = 'FILE_ID_ASC',
  FileIdDesc = 'FILE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TaskIdAsc = 'TASK_ID_ASC',
  TaskIdDesc = 'TASK_ID_DESC',
  ToolSourceIdAsc = 'TOOL_SOURCE_ID_ASC',
  ToolSourceIdDesc = 'TOOL_SOURCE_ID_DESC'
}

/** The fields on `task` to look up the row to connect. */
export type TaskTaskExecutorIdKeyConnect = {
  executorId: Scalars['UUID']['input'];
};

/** The fields on `task` to look up the row to connect. */
export type TaskTaskPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `tenant` in the `TaskInput` mutation. */
export type TaskTenantId148E90DaFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `task` in the `TenantInput` mutation. */
export type TaskTenantId148E90DaFkTenantIdInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyConnect>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<Array<TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate>>;
};

/** A filter to be used against many `File` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyFileFilter = {
  /** Every related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileFilter>;
  /** No related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileFilter>;
  /** Some related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileFilter>;
};

/** A filter to be used against many `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyGdtAnalysisTableRowFilter = {
  /** Every related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** No related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Some related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableRowFilter>;
};

/** A filter to be used against many `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyMetadataValueFilter = {
  /** Every related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadataValueFilter>;
  /** No related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadataValueFilter>;
  /** Some related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadataValueFilter>;
};

/** A filter to be used against many `TaskResource` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyTaskResourceFilter = {
  /** Every related `TaskResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskResourceFilter>;
  /** No related `TaskResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskResourceFilter>;
  /** Some related `TaskResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskResourceFilter>;
};

/** A filter to be used against many `TaskSource` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyTaskSourceFilter = {
  /** Every related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskSourceFilter>;
  /** No related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskSourceFilter>;
  /** Some related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskSourceFilter>;
};

/** Input for the nested mutation of `toolVersion` in the `TaskInput` mutation. */
export type TaskToolVersionId14506837FkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `task` in the `ToolVersionInput` mutation. */
export type TaskToolVersionId14506837FkToolVersionIdInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyConnect>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<Array<TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate>>;
};

/** Input for the nested mutation of `applicationUser` in the `TaskInput` mutation. */
export type TaskUserId270D0Bb2FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `task` in the `ApplicationUserInput` mutation. */
export type TaskUserId270D0Bb2FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyConnect>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<Array<TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate>>;
};

/** A connection to a list of `Task` values. */
export type TasksConnection = {
  __typename: 'TasksConnection';
  /** A list of edges which contains the `Task` and cursor to aid in pagination. */
  edges: Array<TasksEdge>;
  /** A list of `Task` objects. */
  nodes: Array<Task>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Task` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Task` edge in the connection. */
export type TasksEdge = {
  __typename: 'TasksEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Task` at the end of the edge. */
  node: Task;
};

/** Methods to use when ordering `Task`. */
export enum TasksOrderBy {
  ClonedAsc = 'CLONED_ASC',
  ClonedDesc = 'CLONED_DESC',
  ContainerImageIdAsc = 'CONTAINER_IMAGE_ID_ASC',
  ContainerImageIdDesc = 'CONTAINER_IMAGE_ID_DESC',
  CreditsAsc = 'CREDITS_ASC',
  CreditsDesc = 'CREDITS_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  ErrorDescriptionAsc = 'ERROR_DESCRIPTION_ASC',
  ErrorDescriptionDesc = 'ERROR_DESCRIPTION_DESC',
  ExecutorIdAsc = 'EXECUTOR_ID_ASC',
  ExecutorIdDesc = 'EXECUTOR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InputsHashAsc = 'INPUTS_HASH_ASC',
  InputsHashDesc = 'INPUTS_HASH_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  ResourceTierAsc = 'RESOURCE_TIER_ASC',
  ResourceTierDesc = 'RESOURCE_TIER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TaskParametersAsc = 'TASK_PARAMETERS_ASC',
  TaskParametersDesc = 'TASK_PARAMETERS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  ToolExitcodeAsc = 'TOOL_EXITCODE_ASC',
  ToolExitcodeDesc = 'TOOL_EXITCODE_DESC',
  ToolExitcodeDescriptionAsc = 'TOOL_EXITCODE_DESCRIPTION_ASC',
  ToolExitcodeDescriptionDesc = 'TOOL_EXITCODE_DESCRIPTION_DESC',
  ToolVersionIdAsc = 'TOOL_VERSION_ID_ASC',
  ToolVersionIdDesc = 'TOOL_VERSION_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type Tenant = {
  __typename: 'Tenant';
  activeStorageSize: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `ApplicationUserMembership`. */
  applicationUserMembershipsByTenantId: ApplicationUserMembershipsConnection;
  /** Reads and enables pagination through a set of `ApplicationUserSession`. */
  applicationUserSessionsByTenantId: ApplicationUserSessionsConnection;
  archivedStorageSize: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `CodeFile`. */
  codeFilesByTenantId: CodeFilesConnection;
  dateCreated: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `FileActivity`. */
  fileActivitiesByTenantId: FileActivitiesConnection;
  /** Reads and enables pagination through a set of `FileMetadatum`. */
  fileMetadataByTenantId: FileMetadataConnection;
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. */
  fileOutputGroupMetadataByTenantId: FileOutputGroupMetadataConnection;
  /** Reads and enables pagination through a set of `FileOutputGroup`. */
  fileOutputGroupsByTenantId: FileOutputGroupsConnection;
  /** Reads and enables pagination through a set of `File`. */
  filesByTenantId: FilesConnection;
  id: Scalars['Int']['output'];
  internal: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Metadatum`. */
  metadataByTenantId: MetadataConnection;
  /** Reads and enables pagination through a set of `MetadataValue`. */
  metadataValuesByTenantId: MetadataValuesConnection;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Project`. */
  projectsByTenantId: ProjectsConnection;
  repositoryName: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `RoleChangeNotification`. */
  roleChangeNotificationsByTenantId: RoleChangeNotificationsConnection;
  sfid: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `Task`. */
  tasksByTenantId: TasksConnection;
  /** Reads and enables pagination through a set of `TenantContract`. */
  tenantContractsByTenantId: TenantContractsConnection;
  tenantType: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `TenantUserMembershipNotification`. */
  tenantUserMembershipNotificationsByTenantId: TenantUserMembershipNotificationsConnection;
  /** Reads and enables pagination through a set of `ToolTenant`. */
  toolTenantsByTenantId: ToolTenantsConnection;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  toolVersionsByTenantId: ToolVersionsConnection;
  /** Reads and enables pagination through a set of `Tool`. */
  toolsByTenantId: ToolsConnection;
};


export type TenantApplicationUserMembershipsByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApplicationUserMembershipCondition>;
  filter?: InputMaybe<ApplicationUserMembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApplicationUserMembershipsOrderBy>>;
};


export type TenantApplicationUserSessionsByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApplicationUserSessionCondition>;
  filter?: InputMaybe<ApplicationUserSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};


export type TenantCodeFilesByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CodeFileCondition>;
  filter?: InputMaybe<CodeFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};


export type TenantFileActivitiesByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};


export type TenantFileMetadataByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};


export type TenantFileOutputGroupMetadataByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};


export type TenantFileOutputGroupsByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};


export type TenantFilesByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type TenantMetadataByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MetadatumCondition>;
  filter?: InputMaybe<MetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetadataOrderBy>>;
};


export type TenantMetadataValuesByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MetadataValueCondition>;
  filter?: InputMaybe<MetadataValueFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};


export type TenantProjectsByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type TenantRoleChangeNotificationsByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoleChangeNotificationCondition>;
  filter?: InputMaybe<RoleChangeNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoleChangeNotificationsOrderBy>>;
};


export type TenantTasksByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


export type TenantTenantContractsByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantContractCondition>;
  filter?: InputMaybe<TenantContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantContractsOrderBy>>;
};


export type TenantTenantUserMembershipNotificationsByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};


export type TenantToolTenantsByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolTenantCondition>;
  filter?: InputMaybe<ToolTenantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolTenantsOrderBy>>;
};


export type TenantToolVersionsByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolVersionCondition>;
  filter?: InputMaybe<ToolVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};


export type TenantToolsByTenantIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolCondition>;
  filter?: InputMaybe<ToolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

export type TenantContract = {
  __typename: 'TenantContract';
  contractType: Scalars['Int']['output'];
  dateCreated: Scalars['Datetime']['output'];
  endDate: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  salesOrder: Maybe<Scalars['String']['output']>;
  sfid: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Datetime']['output'];
  /** Reads a single `Tenant` that is related to this `TenantContract`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads and enables pagination through a set of `TenantContractTransaction`. */
  tenantContractTransactionsByTenantContractId: TenantContractTransactionsConnection;
  tenantId: Scalars['Int']['output'];
};


export type TenantContractTenantContractTransactionsByTenantContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantContractTransactionCondition>;
  filter?: InputMaybe<TenantContractTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantContractTransactionsOrderBy>>;
};

/** Input for the nested mutation of `tenantContractTransaction` in the `TenantContractAllowanceInput` mutation. */
export type TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput = {
  /** The primary key(s) for `tenantContractTransaction` for the far side of the relationship. */
  connectById?: InputMaybe<TenantContractTransactionTenantContractTransactionPkeyConnect>;
  /** The primary key(s) and patch data for `tenantContractTransaction` for the far side of the relationship. */
  updateById?: InputMaybe<TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate>;
};

/** Input for the nested mutation of `tenantContractAllowance` in the `TenantContractTransactionInput` mutation. */
export type TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput = {
  /** The primary key(s) for `tenantContractAllowance` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TenantContractAllowanceTenantContractAllowancePkeyConnect>>;
  /** The primary key(s) for `tenantContractAllowance` for the far side of the relationship. */
  connectByTenantContractTransactionIdAndQuotaType?: InputMaybe<Array<TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect>>;
  /** The primary key(s) and patch data for `tenantContractAllowance` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate>>;
  /** The primary key(s) and patch data for `tenantContractAllowance` for the far side of the relationship. */
  updateByTenantContractTransactionIdAndQuotaType?: InputMaybe<Array<TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate>>;
};

export type TenantContractAllowance = {
  __typename: 'TenantContractAllowance';
  id: Scalars['Int']['output'];
  quotaType: Scalars['Int']['output'];
  /** Reads a single `TenantContractTransaction` that is related to this `TenantContractAllowance`. */
  tenantContractTransactionByTenantContractTransactionId: Maybe<TenantContractTransaction>;
  tenantContractTransactionId: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

/**
 * A condition to be used against `TenantContractAllowance` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TenantContractAllowanceCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `quotaType` field. */
  quotaType?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tenantContractTransactionId` field. */
  tenantContractTransactionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `TenantContractAllowance` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractAllowanceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantContractAllowanceFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantContractAllowanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantContractAllowanceFilter>>;
  /** Filter by the object’s `quotaType` field. */
  quotaType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantContractTransactionByTenantContractTransactionId` relation. */
  tenantContractTransactionByTenantContractTransactionId?: InputMaybe<TenantContractTransactionFilter>;
  /** Filter by the object’s `tenantContractTransactionId` field. */
  tenantContractTransactionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** The fields on `tenantContractAllowance` to look up the row to update. */
export type TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenantContractAllowance` being updated. */
  tenantContractAllowancePatch: UpdateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
};

/** The fields on `tenantContractAllowance` to look up the row to update. */
export type TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate = {
  quotaType: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenantContractAllowance` being updated. */
  tenantContractAllowancePatch: UpdateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  tenantContractTransactionId: Scalars['Int']['input'];
};

/** The fields on `tenantContractAllowance` to look up the row to connect. */
export type TenantContractAllowanceTenantContractAllowancePkeyConnect = {
  id: Scalars['Int']['input'];
};

/** The fields on `tenantContractAllowance` to look up the row to connect. */
export type TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect = {
  quotaType: Scalars['Int']['input'];
  tenantContractTransactionId: Scalars['Int']['input'];
};

/** A connection to a list of `TenantContractAllowance` values. */
export type TenantContractAllowancesConnection = {
  __typename: 'TenantContractAllowancesConnection';
  /** A list of edges which contains the `TenantContractAllowance` and cursor to aid in pagination. */
  edges: Array<TenantContractAllowancesEdge>;
  /** A list of `TenantContractAllowance` objects. */
  nodes: Array<TenantContractAllowance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantContractAllowance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TenantContractAllowance` edge in the connection. */
export type TenantContractAllowancesEdge = {
  __typename: 'TenantContractAllowancesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `TenantContractAllowance` at the end of the edge. */
  node: TenantContractAllowance;
};

/** Methods to use when ordering `TenantContractAllowance`. */
export enum TenantContractAllowancesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QuotaTypeAsc = 'QUOTA_TYPE_ASC',
  QuotaTypeDesc = 'QUOTA_TYPE_DESC',
  TenantContractTransactionIdAsc = 'TENANT_CONTRACT_TRANSACTION_ID_ASC',
  TenantContractTransactionIdDesc = 'TENANT_CONTRACT_TRANSACTION_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/**
 * A condition to be used against `TenantContract` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TenantContractCondition = {
  /** Checks for equality with the object’s `contractType` field. */
  contractType?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `salesOrder` field. */
  salesOrder?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sfid` field. */
  sfid?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `TenantContract` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantContractFilter>>;
  /** Filter by the object’s `contractType` field. */
  contractType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantContractFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantContractFilter>>;
  /** Filter by the object’s `salesOrder` field. */
  salesOrder?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sfid` field. */
  sfid?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantContractTransactionsByTenantContractId` relation. */
  tenantContractTransactionsByTenantContractId?: InputMaybe<TenantContractToManyTenantContractTransactionFilter>;
  /** Some related `tenantContractTransactionsByTenantContractId` exist. */
  tenantContractTransactionsByTenantContractIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
};

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate = {
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenantContract` being updated. */
  tenantContractPatch: UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
};

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenantContract` being updated. */
  tenantContractPatch: UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
};

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenantContract` being updated. */
  tenantContractPatch: UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
};

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate = {
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenantContract` being updated. */
  tenantContractPatch: UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
};

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenantContract` being updated. */
  tenantContractPatch: UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
};

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenantContract` being updated. */
  tenantContractPatch: UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
};

/** The fields on `tenantContract` to look up the row to connect. */
export type TenantContractTenantContractNameKeyConnect = {
  name: Scalars['String']['input'];
};

/** The fields on `tenantContract` to look up the row to connect. */
export type TenantContractTenantContractPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** The fields on `tenantContract` to look up the row to connect. */
export type TenantContractTenantContractSfidKeyConnect = {
  sfid: Scalars['String']['input'];
};

/** Input for the nested mutation of `tenant` in the `TenantContractInput` mutation. */
export type TenantContractTenantIdBa8Ac167FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `tenantContract` in the `TenantInput` mutation. */
export type TenantContractTenantIdBa8Ac167FkTenantIdInverseInput = {
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TenantContractTenantContractPkeyConnect>>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectByName?: InputMaybe<Array<TenantContractTenantContractNameKeyConnect>>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectBySfid?: InputMaybe<Array<TenantContractTenantContractSfidKeyConnect>>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate>>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateByName?: InputMaybe<Array<TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate>>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateBySfid?: InputMaybe<Array<TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate>>;
};

/** A filter to be used against many `TenantContractTransaction` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractToManyTenantContractTransactionFilter = {
  /** Every related `TenantContractTransaction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantContractTransactionFilter>;
  /** No related `TenantContractTransaction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantContractTransactionFilter>;
  /** Some related `TenantContractTransaction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantContractTransactionFilter>;
};

/** Input for the nested mutation of `tenantContract` in the `TenantContractTransactionInput` mutation. */
export type TenantContractTranTenantContractId1E374993FkTenantCoInput = {
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectById?: InputMaybe<TenantContractTenantContractPkeyConnect>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectByName?: InputMaybe<TenantContractTenantContractNameKeyConnect>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantContractTenantContractSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateById?: InputMaybe<TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateByName?: InputMaybe<TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate>;
};

/** Input for the nested mutation of `tenantContractTransaction` in the `TenantContractInput` mutation. */
export type TenantContractTranTenantContractId1E374993FkTenantCoInverseInput = {
  /** The primary key(s) for `tenantContractTransaction` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TenantContractTransactionTenantContractTransactionPkeyConnect>>;
  /** The primary key(s) and patch data for `tenantContractTransaction` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate>>;
};

export type TenantContractTransaction = {
  __typename: 'TenantContractTransaction';
  currency: Scalars['Int']['output'];
  dateCreated: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `TenantContractAllowance`. */
  tenantContractAllowancesByTenantContractTransactionId: TenantContractAllowancesConnection;
  /** Reads a single `TenantContract` that is related to this `TenantContractTransaction`. */
  tenantContractByTenantContractId: Maybe<TenantContract>;
  tenantContractId: Scalars['Int']['output'];
};


export type TenantContractTransactionTenantContractAllowancesByTenantContractTransactionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantContractAllowanceCondition>;
  filter?: InputMaybe<TenantContractAllowanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantContractAllowancesOrderBy>>;
};

/**
 * A condition to be used against `TenantContractTransaction` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TenantContractTransactionCondition = {
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `tenantContractId` field. */
  tenantContractId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `TenantContractTransaction` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractTransactionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantContractTransactionFilter>>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantContractTransactionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantContractTransactionFilter>>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `tenantContractAllowancesByTenantContractTransactionId` relation. */
  tenantContractAllowancesByTenantContractTransactionId?: InputMaybe<TenantContractTransactionToManyTenantContractAllowanceFilter>;
  /** Some related `tenantContractAllowancesByTenantContractTransactionId` exist. */
  tenantContractAllowancesByTenantContractTransactionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantContractByTenantContractId` relation. */
  tenantContractByTenantContractId?: InputMaybe<TenantContractFilter>;
  /** Filter by the object’s `tenantContractId` field. */
  tenantContractId?: InputMaybe<IntFilter>;
};

/** The fields on `tenantContractTransaction` to look up the row to update. */
export type TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenantContractTransaction` being updated. */
  tenantContractTransactionPatch: UpdateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
};

/** The fields on `tenantContractTransaction` to look up the row to update. */
export type TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenantContractTransaction` being updated. */
  tenantContractTransactionPatch: UpdateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
};

/** The fields on `tenantContractTransaction` to look up the row to connect. */
export type TenantContractTransactionTenantContractTransactionPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** A filter to be used against many `TenantContractAllowance` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractTransactionToManyTenantContractAllowanceFilter = {
  /** Every related `TenantContractAllowance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantContractAllowanceFilter>;
  /** No related `TenantContractAllowance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantContractAllowanceFilter>;
  /** Some related `TenantContractAllowance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantContractAllowanceFilter>;
};

/** A connection to a list of `TenantContractTransaction` values. */
export type TenantContractTransactionsConnection = {
  __typename: 'TenantContractTransactionsConnection';
  /** A list of edges which contains the `TenantContractTransaction` and cursor to aid in pagination. */
  edges: Array<TenantContractTransactionsEdge>;
  /** A list of `TenantContractTransaction` objects. */
  nodes: Array<TenantContractTransaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantContractTransaction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TenantContractTransaction` edge in the connection. */
export type TenantContractTransactionsEdge = {
  __typename: 'TenantContractTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `TenantContractTransaction` at the end of the edge. */
  node: TenantContractTransaction;
};

/** Methods to use when ordering `TenantContractTransaction`. */
export enum TenantContractTransactionsOrderBy {
  CurrencyAsc = 'CURRENCY_ASC',
  CurrencyDesc = 'CURRENCY_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantContractIdAsc = 'TENANT_CONTRACT_ID_ASC',
  TenantContractIdDesc = 'TENANT_CONTRACT_ID_DESC'
}

/** A connection to a list of `TenantContract` values. */
export type TenantContractsConnection = {
  __typename: 'TenantContractsConnection';
  /** A list of edges which contains the `TenantContract` and cursor to aid in pagination. */
  edges: Array<TenantContractsEdge>;
  /** A list of `TenantContract` objects. */
  nodes: Array<TenantContract>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantContract` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TenantContract` edge in the connection. */
export type TenantContractsEdge = {
  __typename: 'TenantContractsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `TenantContract` at the end of the edge. */
  node: TenantContract;
};

/** Methods to use when ordering `TenantContract`. */
export enum TenantContractsOrderBy {
  ContractTypeAsc = 'CONTRACT_TYPE_ASC',
  ContractTypeDesc = 'CONTRACT_TYPE_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SalesOrderAsc = 'SALES_ORDER_ASC',
  SalesOrderDesc = 'SALES_ORDER_DESC',
  SfidAsc = 'SFID_ASC',
  SfidDesc = 'SFID_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

/** A filter to be used against `Tenant` object types. All fields are combined with a logical ‘and.’ */
export type TenantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantFilter>>;
  /** Filter by the object’s `applicationUserMembershipsByTenantId` relation. */
  applicationUserMembershipsByTenantId?: InputMaybe<TenantToManyApplicationUserMembershipFilter>;
  /** Some related `applicationUserMembershipsByTenantId` exist. */
  applicationUserMembershipsByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `applicationUserSessionsByTenantId` relation. */
  applicationUserSessionsByTenantId?: InputMaybe<TenantToManyApplicationUserSessionFilter>;
  /** Some related `applicationUserSessionsByTenantId` exist. */
  applicationUserSessionsByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `codeFilesByTenantId` relation. */
  codeFilesByTenantId?: InputMaybe<TenantToManyCodeFileFilter>;
  /** Some related `codeFilesByTenantId` exist. */
  codeFilesByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileActivitiesByTenantId` relation. */
  fileActivitiesByTenantId?: InputMaybe<TenantToManyFileActivityFilter>;
  /** Some related `fileActivitiesByTenantId` exist. */
  fileActivitiesByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileMetadataByTenantId` relation. */
  fileMetadataByTenantId?: InputMaybe<TenantToManyFileMetadatumFilter>;
  /** Some related `fileMetadataByTenantId` exist. */
  fileMetadataByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileOutputGroupMetadataByTenantId` relation. */
  fileOutputGroupMetadataByTenantId?: InputMaybe<TenantToManyFileOutputGroupMetadatumFilter>;
  /** Some related `fileOutputGroupMetadataByTenantId` exist. */
  fileOutputGroupMetadataByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fileOutputGroupsByTenantId` relation. */
  fileOutputGroupsByTenantId?: InputMaybe<TenantToManyFileOutputGroupFilter>;
  /** Some related `fileOutputGroupsByTenantId` exist. */
  fileOutputGroupsByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `filesByTenantId` relation. */
  filesByTenantId?: InputMaybe<TenantToManyFileFilter>;
  /** Some related `filesByTenantId` exist. */
  filesByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `internal` field. */
  internal?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadataByTenantId` relation. */
  metadataByTenantId?: InputMaybe<TenantToManyMetadatumFilter>;
  /** Some related `metadataByTenantId` exist. */
  metadataByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `metadataValuesByTenantId` relation. */
  metadataValuesByTenantId?: InputMaybe<TenantToManyMetadataValueFilter>;
  /** Some related `metadataValuesByTenantId` exist. */
  metadataValuesByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantFilter>>;
  /** Filter by the object’s `projectsByTenantId` relation. */
  projectsByTenantId?: InputMaybe<TenantToManyProjectFilter>;
  /** Some related `projectsByTenantId` exist. */
  projectsByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `repositoryName` field. */
  repositoryName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `roleChangeNotificationsByTenantId` relation. */
  roleChangeNotificationsByTenantId?: InputMaybe<TenantToManyRoleChangeNotificationFilter>;
  /** Some related `roleChangeNotificationsByTenantId` exist. */
  roleChangeNotificationsByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `sfid` field. */
  sfid?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tasksByTenantId` relation. */
  tasksByTenantId?: InputMaybe<TenantToManyTaskFilter>;
  /** Some related `tasksByTenantId` exist. */
  tasksByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantContractsByTenantId` relation. */
  tenantContractsByTenantId?: InputMaybe<TenantToManyTenantContractFilter>;
  /** Some related `tenantContractsByTenantId` exist. */
  tenantContractsByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantType` field. */
  tenantType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantUserMembershipNotificationsByTenantId` relation. */
  tenantUserMembershipNotificationsByTenantId?: InputMaybe<TenantToManyTenantUserMembershipNotificationFilter>;
  /** Some related `tenantUserMembershipNotificationsByTenantId` exist. */
  tenantUserMembershipNotificationsByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolTenantsByTenantId` relation. */
  toolTenantsByTenantId?: InputMaybe<TenantToManyToolTenantFilter>;
  /** Some related `toolTenantsByTenantId` exist. */
  toolTenantsByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolVersionsByTenantId` relation. */
  toolVersionsByTenantId?: InputMaybe<TenantToManyToolVersionFilter>;
  /** Some related `toolVersionsByTenantId` exist. */
  toolVersionsByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolsByTenantId` relation. */
  toolsByTenantId?: InputMaybe<TenantToManyToolFilter>;
  /** Some related `toolsByTenantId` exist. */
  toolsByTenantIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate = {
  key: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate = {
  repositoryName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate = {
  sfid: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to connect. */
export type TenantTenantKeyKeyConnect = {
  key: Scalars['String']['input'];
};

/** The fields on `tenant` to look up the row to connect. */
export type TenantTenantPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** The fields on `tenant` to look up the row to connect. */
export type TenantTenantRepositoryNameKeyConnect = {
  repositoryName: Scalars['String']['input'];
};

/** The fields on `tenant` to look up the row to connect. */
export type TenantTenantSfidKeyConnect = {
  sfid: Scalars['String']['input'];
};

/** A filter to be used against many `ApplicationUserMembership` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyApplicationUserMembershipFilter = {
  /** Every related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserMembershipFilter>;
  /** No related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserMembershipFilter>;
  /** Some related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserMembershipFilter>;
};

/** A filter to be used against many `ApplicationUserSession` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyApplicationUserSessionFilter = {
  /** Every related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserSessionFilter>;
  /** No related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserSessionFilter>;
  /** Some related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserSessionFilter>;
};

/** A filter to be used against many `CodeFile` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyCodeFileFilter = {
  /** Every related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CodeFileFilter>;
  /** No related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CodeFileFilter>;
  /** Some related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CodeFileFilter>;
};

/** A filter to be used against many `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFileActivityFilter = {
  /** Every related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileActivityFilter>;
  /** No related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileActivityFilter>;
  /** Some related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileActivityFilter>;
};

/** A filter to be used against many `File` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFileFilter = {
  /** Every related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileFilter>;
  /** No related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileFilter>;
  /** Some related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileFilter>;
};

/** A filter to be used against many `FileMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFileMetadatumFilter = {
  /** Every related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileMetadatumFilter>;
  /** No related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileMetadatumFilter>;
  /** Some related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileMetadatumFilter>;
};

/** A filter to be used against many `FileOutputGroup` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFileOutputGroupFilter = {
  /** Every related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupFilter>;
  /** No related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupFilter>;
  /** Some related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupFilter>;
};

/** A filter to be used against many `FileOutputGroupMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFileOutputGroupMetadatumFilter = {
  /** Every related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** No related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** Some related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupMetadatumFilter>;
};

/** A filter to be used against many `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyMetadataValueFilter = {
  /** Every related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadataValueFilter>;
  /** No related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadataValueFilter>;
  /** Some related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadataValueFilter>;
};

/** A filter to be used against many `Metadatum` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyMetadatumFilter = {
  /** Every related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadatumFilter>;
  /** No related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadatumFilter>;
  /** Some related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadatumFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `RoleChangeNotification` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyRoleChangeNotificationFilter = {
  /** Every related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoleChangeNotificationFilter>;
  /** No related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoleChangeNotificationFilter>;
  /** Some related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoleChangeNotificationFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `TenantContract` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyTenantContractFilter = {
  /** Every related `TenantContract` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantContractFilter>;
  /** No related `TenantContract` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantContractFilter>;
  /** Some related `TenantContract` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantContractFilter>;
};

/** A filter to be used against many `TenantUserMembershipNotification` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyTenantUserMembershipNotificationFilter = {
  /** Every related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** No related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** Some related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantUserMembershipNotificationFilter>;
};

/** A filter to be used against many `Tool` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyToolFilter = {
  /** Every related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolFilter>;
  /** No related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolFilter>;
  /** Some related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolFilter>;
};

/** A filter to be used against many `ToolTenant` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyToolTenantFilter = {
  /** Every related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolTenantFilter>;
  /** No related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolTenantFilter>;
  /** Some related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolTenantFilter>;
};

/** A filter to be used against many `ToolVersion` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyToolVersionFilter = {
  /** Every related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolVersionFilter>;
  /** No related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolVersionFilter>;
  /** Some related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolVersionFilter>;
};

/** Input for the nested mutation of `notification` in the `TenantUserMembershipNotificationInput` mutation. */
export type TenantUserMembershId10Affa8DFkNotificatInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `tenantUserMembershipNotification` in the `NotificationInput` mutation. */
export type TenantUserMembershId10Affa8DFkNotificatInverseInput = {
  /** The primary key(s) for `tenantUserMembershipNotification` for the far side of the relationship. */
  connectById?: InputMaybe<TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `tenantUserMembershipNotification` for the far side of the relationship. */
  updateById?: InputMaybe<TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `applicationUser` in the `TenantUserMembershipNotificationInput` mutation. */
export type TenantUserMembershInviterId29476E5EFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `tenantUserMembershipNotification` in the `ApplicationUserInput` mutation. */
export type TenantUserMembershInviterId29476E5EFkApplicatiInverseInput = {
  /** The primary key(s) for `tenantUserMembershipNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `tenantUserMembershipNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate>>;
};

/** Input for the nested mutation of `tenant` in the `TenantUserMembershipNotificationInput` mutation. */
export type TenantUserMembershTenantIdC67818C5FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `tenantUserMembershipNotification` in the `TenantInput` mutation. */
export type TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput = {
  /** The primary key(s) for `tenantUserMembershipNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `tenantUserMembershipNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate>>;
};

/** Input for the nested mutation of `applicationUser` in the `TenantUserMembershipNotificationInput` mutation. */
export type TenantUserMembershUserId2B78E8A0FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `tenantUserMembershipNotification` in the `ApplicationUserInput` mutation. */
export type TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput = {
  /** The primary key(s) for `tenantUserMembershipNotification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `tenantUserMembershipNotification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate>>;
};

export type TenantUserMembershipNotification = {
  __typename: 'TenantUserMembershipNotification';
  /** Reads a single `ApplicationUser` that is related to this `TenantUserMembershipNotification`. */
  applicationUserByInviterId: Maybe<ApplicationUser>;
  /** Reads a single `ApplicationUser` that is related to this `TenantUserMembershipNotification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars['UUID']['output'];
  inviterId: Scalars['UUID']['output'];
  /** Reads a single `Notification` that is related to this `TenantUserMembershipNotification`. */
  notificationById: Maybe<Notification>;
  /** Reads a single `Tenant` that is related to this `TenantUserMembershipNotification`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `TenantUserMembershipNotification` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type TenantUserMembershipNotificationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `inviterId` field. */
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `TenantUserMembershipNotification` object types. All fields are combined with a logical ‘and.’ */
export type TenantUserMembershipNotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantUserMembershipNotificationFilter>>;
  /** Filter by the object’s `applicationUserByInviterId` relation. */
  applicationUserByInviterId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inviterId` field. */
  inviterId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** Filter by the object’s `notificationById` relation. */
  notificationById?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantUserMembershipNotificationFilter>>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `tenantUserMembershipNotification` to look up the row to update. */
export type TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
  tenantUserMembershipNotificationPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
};

/** The fields on `tenantUserMembershipNotification` to look up the row to update. */
export type TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
  tenantUserMembershipNotificationPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
};

/** The fields on `tenantUserMembershipNotification` to look up the row to update. */
export type TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
  tenantUserMembershipNotificationPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
};

/** The fields on `tenantUserMembershipNotification` to look up the row to update. */
export type TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
  tenantUserMembershipNotificationPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
};

/** The fields on `tenantUserMembershipNotification` to look up the row to connect. */
export type TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A connection to a list of `TenantUserMembershipNotification` values. */
export type TenantUserMembershipNotificationsConnection = {
  __typename: 'TenantUserMembershipNotificationsConnection';
  /** A list of edges which contains the `TenantUserMembershipNotification` and cursor to aid in pagination. */
  edges: Array<TenantUserMembershipNotificationsEdge>;
  /** A list of `TenantUserMembershipNotification` objects. */
  nodes: Array<TenantUserMembershipNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantUserMembershipNotification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TenantUserMembershipNotification` edge in the connection. */
export type TenantUserMembershipNotificationsEdge = {
  __typename: 'TenantUserMembershipNotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `TenantUserMembershipNotification` at the end of the edge. */
  node: TenantUserMembershipNotification;
};

/** Methods to use when ordering `TenantUserMembershipNotification`. */
export enum TenantUserMembershipNotificationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InviterIdAsc = 'INVITER_ID_ASC',
  InviterIdDesc = 'INVITER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type Tool = {
  __typename: 'Tool';
  /** Reads a single `ApplicationUser` that is related to this `Tool`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  codeLink: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['Datetime']['output'];
  docsLink: Maybe<Scalars['String']['output']>;
  helpText: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  maturity: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Reads a single `Project` that is related to this `Tool`. */
  projectByProjectId: Maybe<Project>;
  projectId: Maybe<Scalars['UUID']['output']>;
  searchTerms: Maybe<Scalars['JSON']['output']>;
  status: Scalars['Int']['output'];
  tags: Array<Maybe<Scalars['String']['output']>>;
  /** Reads a single `Tenant` that is related to this `Tool`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `ToolTenant`. */
  toolTenantsByToolId: ToolTenantsConnection;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  toolVersionsByToolId: ToolVersionsConnection;
  toolboxId: Maybe<Scalars['Int']['output']>;
  userId: Maybe<Scalars['UUID']['output']>;
  visibility: Scalars['Int']['output'];
};


export type ToolToolTenantsByToolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolTenantCondition>;
  filter?: InputMaybe<ToolTenantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolTenantsOrderBy>>;
};


export type ToolToolVersionsByToolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolVersionCondition>;
  filter?: InputMaybe<ToolVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};

/** A condition to be used against `Tool` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ToolCondition = {
  /** Checks for equality with the object’s `codeLink` field. */
  codeLink?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `docsLink` field. */
  docsLink?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `maturity` field. */
  maturity?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `searchTerms` field. */
  searchTerms?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `toolboxId` field. */
  toolboxId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `visibility` field. */
  visibility?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Tool` object types. All fields are combined with a logical ‘and.’ */
export type ToolFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `codeLink` field. */
  codeLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `docsLink` field. */
  docsLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `maturity` field. */
  maturity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** A related `projectByProjectId` exists. */
  projectByProjectIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `searchTerms` field. */
  searchTerms?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** A related `tenantByTenantId` exists. */
  tenantByTenantIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolTenantsByToolId` relation. */
  toolTenantsByToolId?: InputMaybe<ToolToManyToolTenantFilter>;
  /** Some related `toolTenantsByToolId` exist. */
  toolTenantsByToolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolVersionsByToolId` relation. */
  toolVersionsByToolId?: InputMaybe<ToolToManyToolVersionFilter>;
  /** Some related `toolVersionsByToolId` exist. */
  toolVersionsByToolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolboxId` field. */
  toolboxId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `visibility` field. */
  visibility?: InputMaybe<IntFilter>;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolForToolProjectId20A84210FkProjectIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate = {
  projectId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolForToolProjectId20A84210FkProjectIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate = {
  projectId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate = {
  projectId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate = {
  projectId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate = {
  projectId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
};

export type ToolParameter = {
  __typename: 'ToolParameter';
  default: Maybe<Scalars['JSON']['output']>;
  helpText: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Maybe<Scalars['JSON']['output']>;
  required: Scalars['Boolean']['output'];
  /** Reads a single `ToolVersion` that is related to this `ToolParameter`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars['Int']['output'];
  unit: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `ToolParameter` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ToolParameterCondition = {
  /** Checks for equality with the object’s `default` field. */
  default?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `options` field. */
  options?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ToolParameter` object types. All fields are combined with a logical ‘and.’ */
export type ToolParameterFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolParameterFilter>>;
  /** Filter by the object’s `default` field. */
  default?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolParameterFilter>;
  /** Filter by the object’s `options` field. */
  options?: InputMaybe<JsonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolParameterFilter>>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<StringFilter>;
};

/** The fields on `toolParameter` to look up the row to update. */
export type ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolParameter` being updated. */
  toolParameterPatch: UpdateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
};

/** The fields on `toolParameter` to look up the row to connect. */
export type ToolParameterToolParameterPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** Input for the nested mutation of `toolVersion` in the `ToolParameterInput` mutation. */
export type ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `toolParameter` in the `ToolVersionInput` mutation. */
export type ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput = {
  /** The primary key(s) for `toolParameter` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolParameterToolParameterPkeyConnect>>;
  /** The primary key(s) and patch data for `toolParameter` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate>>;
};

/** A connection to a list of `ToolParameter` values. */
export type ToolParametersConnection = {
  __typename: 'ToolParametersConnection';
  /** A list of edges which contains the `ToolParameter` and cursor to aid in pagination. */
  edges: Array<ToolParametersEdge>;
  /** A list of `ToolParameter` objects. */
  nodes: Array<ToolParameter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolParameter` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ToolParameter` edge in the connection. */
export type ToolParametersEdge = {
  __typename: 'ToolParametersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ToolParameter` at the end of the edge. */
  node: ToolParameter;
};

/** Methods to use when ordering `ToolParameter`. */
export enum ToolParametersOrderBy {
  DefaultAsc = 'DEFAULT_ASC',
  DefaultDesc = 'DEFAULT_DESC',
  HelpTextAsc = 'HELP_TEXT_ASC',
  HelpTextDesc = 'HELP_TEXT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OptionsAsc = 'OPTIONS_ASC',
  OptionsDesc = 'OPTIONS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RequiredAsc = 'REQUIRED_ASC',
  RequiredDesc = 'REQUIRED_DESC',
  ToolVersionIdAsc = 'TOOL_VERSION_ID_ASC',
  ToolVersionIdDesc = 'TOOL_VERSION_ID_DESC',
  UnitAsc = 'UNIT_ASC',
  UnitDesc = 'UNIT_DESC'
}

/** Input for the nested mutation of `project` in the `ToolInput` mutation. */
export type ToolProjectId20A84210FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `tool` in the `ProjectInput` mutation. */
export type ToolProjectId20A84210FkProjectIdInverseInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<ToolToolPkeyConnect>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<ToolToolProjectIdKeyConnect>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate>;
};

export type ToolResult = {
  __typename: 'ToolResult';
  fileFormats: Maybe<Scalars['JSON']['output']>;
  helpText: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  /** Reads a single `ToolVersion` that is related to this `ToolResult`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `ToolResult` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ToolResultCondition = {
  /** Checks for equality with the object’s `fileFormats` field. */
  fileFormats?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ToolResult` object types. All fields are combined with a logical ‘and.’ */
export type ToolResultFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolResultFilter>>;
  /** Filter by the object’s `fileFormats` field. */
  fileFormats?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolResultFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolResultFilter>>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
};

/** The fields on `toolResult` to look up the row to update. */
export type ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolResult` being updated. */
  toolResultPatch: UpdateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
};

/** The fields on `toolResult` to look up the row to connect. */
export type ToolResultToolResultPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** Input for the nested mutation of `toolVersion` in the `ToolResultInput` mutation. */
export type ToolResultToolVersionId41Fb163EFkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `toolResult` in the `ToolVersionInput` mutation. */
export type ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput = {
  /** The primary key(s) for `toolResult` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolResultToolResultPkeyConnect>>;
  /** The primary key(s) and patch data for `toolResult` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate>>;
};

/** A connection to a list of `ToolResult` values. */
export type ToolResultsConnection = {
  __typename: 'ToolResultsConnection';
  /** A list of edges which contains the `ToolResult` and cursor to aid in pagination. */
  edges: Array<ToolResultsEdge>;
  /** A list of `ToolResult` objects. */
  nodes: Array<ToolResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolResult` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ToolResult` edge in the connection. */
export type ToolResultsEdge = {
  __typename: 'ToolResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ToolResult` at the end of the edge. */
  node: ToolResult;
};

/** Methods to use when ordering `ToolResult`. */
export enum ToolResultsOrderBy {
  FileFormatsAsc = 'FILE_FORMATS_ASC',
  FileFormatsDesc = 'FILE_FORMATS_DESC',
  HelpTextAsc = 'HELP_TEXT_ASC',
  HelpTextDesc = 'HELP_TEXT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RequiredAsc = 'REQUIRED_ASC',
  RequiredDesc = 'REQUIRED_DESC',
  ToolVersionIdAsc = 'TOOL_VERSION_ID_ASC',
  ToolVersionIdDesc = 'TOOL_VERSION_ID_DESC'
}

export type ToolSecret = {
  __typename: 'ToolSecret';
  helpText: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  /** Reads a single `ToolVersion` that is related to this `ToolSecret`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `ToolSecret` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ToolSecretCondition = {
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ToolSecret` object types. All fields are combined with a logical ‘and.’ */
export type ToolSecretFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolSecretFilter>>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolSecretFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolSecretFilter>>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
};

/** The fields on `toolSecret` to look up the row to update. */
export type ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolSecret` being updated. */
  toolSecretPatch: UpdateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
};

/** The fields on `toolSecret` to look up the row to connect. */
export type ToolSecretToolSecretPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** Input for the nested mutation of `toolVersion` in the `ToolSecretInput` mutation. */
export type ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `toolSecret` in the `ToolVersionInput` mutation. */
export type ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput = {
  /** The primary key(s) for `toolSecret` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolSecretToolSecretPkeyConnect>>;
  /** The primary key(s) and patch data for `toolSecret` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate>>;
};

/** A connection to a list of `ToolSecret` values. */
export type ToolSecretsConnection = {
  __typename: 'ToolSecretsConnection';
  /** A list of edges which contains the `ToolSecret` and cursor to aid in pagination. */
  edges: Array<ToolSecretsEdge>;
  /** A list of `ToolSecret` objects. */
  nodes: Array<ToolSecret>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolSecret` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ToolSecret` edge in the connection. */
export type ToolSecretsEdge = {
  __typename: 'ToolSecretsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ToolSecret` at the end of the edge. */
  node: ToolSecret;
};

/** Methods to use when ordering `ToolSecret`. */
export enum ToolSecretsOrderBy {
  HelpTextAsc = 'HELP_TEXT_ASC',
  HelpTextDesc = 'HELP_TEXT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RequiredAsc = 'REQUIRED_ASC',
  RequiredDesc = 'REQUIRED_DESC',
  ToolVersionIdAsc = 'TOOL_VERSION_ID_ASC',
  ToolVersionIdDesc = 'TOOL_VERSION_ID_DESC'
}

export type ToolSource = {
  __typename: 'ToolSource';
  fileFormats: Maybe<Scalars['JSON']['output']>;
  helpText: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  multiple: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `TaskSource`. */
  taskSourcesByToolSourceId: TaskSourcesConnection;
  /** Reads a single `ToolVersion` that is related to this `ToolSource`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars['Int']['output'];
};


export type ToolSourceTaskSourcesByToolSourceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskSourceCondition>;
  filter?: InputMaybe<TaskSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

/**
 * A condition to be used against `ToolSource` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ToolSourceCondition = {
  /** Checks for equality with the object’s `fileFormats` field. */
  fileFormats?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `multiple` field. */
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ToolSource` object types. All fields are combined with a logical ‘and.’ */
export type ToolSourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolSourceFilter>>;
  /** Filter by the object’s `fileFormats` field. */
  fileFormats?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `multiple` field. */
  multiple?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolSourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolSourceFilter>>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `taskSourcesByToolSourceId` relation. */
  taskSourcesByToolSourceId?: InputMaybe<ToolSourceToManyTaskSourceFilter>;
  /** Some related `taskSourcesByToolSourceId` exist. */
  taskSourcesByToolSourceIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
};

/** The fields on `toolSource` to look up the row to update. */
export type ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolSource` being updated. */
  toolSourcePatch: UpdateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
};

/** The fields on `toolSource` to look up the row to update. */
export type ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolSource` being updated. */
  toolSourcePatch: UpdateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
};

/** A filter to be used against many `TaskSource` object types. All fields are combined with a logical ‘and.’ */
export type ToolSourceToManyTaskSourceFilter = {
  /** Every related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskSourceFilter>;
  /** No related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskSourceFilter>;
  /** Some related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskSourceFilter>;
};

/** The fields on `toolSource` to look up the row to connect. */
export type ToolSourceToolSourcePkeyConnect = {
  id: Scalars['Int']['input'];
};

/** Input for the nested mutation of `toolVersion` in the `ToolSourceInput` mutation. */
export type ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `toolSource` in the `ToolVersionInput` mutation. */
export type ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput = {
  /** The primary key(s) for `toolSource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolSourceToolSourcePkeyConnect>>;
  /** The primary key(s) and patch data for `toolSource` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate>>;
};

/** A connection to a list of `ToolSource` values. */
export type ToolSourcesConnection = {
  __typename: 'ToolSourcesConnection';
  /** A list of edges which contains the `ToolSource` and cursor to aid in pagination. */
  edges: Array<ToolSourcesEdge>;
  /** A list of `ToolSource` objects. */
  nodes: Array<ToolSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolSource` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ToolSource` edge in the connection. */
export type ToolSourcesEdge = {
  __typename: 'ToolSourcesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ToolSource` at the end of the edge. */
  node: ToolSource;
};

/** Methods to use when ordering `ToolSource`. */
export enum ToolSourcesOrderBy {
  FileFormatsAsc = 'FILE_FORMATS_ASC',
  FileFormatsDesc = 'FILE_FORMATS_DESC',
  HelpTextAsc = 'HELP_TEXT_ASC',
  HelpTextDesc = 'HELP_TEXT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  MultipleAsc = 'MULTIPLE_ASC',
  MultipleDesc = 'MULTIPLE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RequiredAsc = 'REQUIRED_ASC',
  RequiredDesc = 'REQUIRED_DESC',
  ToolVersionIdAsc = 'TOOL_VERSION_ID_ASC',
  ToolVersionIdDesc = 'TOOL_VERSION_ID_DESC'
}

export type ToolTenant = {
  __typename: 'ToolTenant';
  id: Scalars['BigInt']['output'];
  /** Reads a single `Tenant` that is related to this `ToolTenant`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars['Int']['output'];
  /** Reads a single `Tool` that is related to this `ToolTenant`. */
  toolByToolId: Maybe<Tool>;
  toolId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `ToolTenant` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ToolTenantCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `toolId` field. */
  toolId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ToolTenant` object types. All fields are combined with a logical ‘and.’ */
export type ToolTenantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolTenantFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolTenantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolTenantFilter>>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolByToolId` relation. */
  toolByToolId?: InputMaybe<ToolFilter>;
  /** Filter by the object’s `toolId` field. */
  toolId?: InputMaybe<IntFilter>;
};

/** Input for the nested mutation of `tenant` in the `ToolInput` mutation. */
export type ToolTenantId1Baab08EFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `tool` in the `TenantInput` mutation. */
export type ToolTenantId1Baab08EFkTenantIdInverseInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolToolPkeyConnect>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<Array<ToolToolProjectIdKeyConnect>>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate>>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<Array<ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate>>;
};

/** The fields on `toolTenant` to look up the row to update. */
export type ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate = {
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `toolTenant` being updated. */
  toolTenantPatch: UpdateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
};

/** The fields on `toolTenant` to look up the row to update. */
export type ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate = {
  tenantId: Scalars['Int']['input'];
  toolId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolTenant` being updated. */
  toolTenantPatch: UpdateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
};

/** The fields on `toolTenant` to look up the row to update. */
export type ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate = {
  id: Scalars['BigInt']['input'];
  /** An object where the defined keys will be set on the `toolTenant` being updated. */
  toolTenantPatch: UpdateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
};

/** The fields on `toolTenant` to look up the row to update. */
export type ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate = {
  tenantId: Scalars['Int']['input'];
  toolId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolTenant` being updated. */
  toolTenantPatch: UpdateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
};

/** The fields on `toolTenant` to look up the row to connect. */
export type ToolTenantToolTenantsPkeyConnect = {
  id: Scalars['BigInt']['input'];
};

/** The fields on `toolTenant` to look up the row to connect. */
export type ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect = {
  tenantId: Scalars['Int']['input'];
  toolId: Scalars['Int']['input'];
};

/** A connection to a list of `ToolTenant` values. */
export type ToolTenantsConnection = {
  __typename: 'ToolTenantsConnection';
  /** A list of edges which contains the `ToolTenant` and cursor to aid in pagination. */
  edges: Array<ToolTenantsEdge>;
  /** A list of `ToolTenant` objects. */
  nodes: Array<ToolTenant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolTenant` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ToolTenant` edge in the connection. */
export type ToolTenantsEdge = {
  __typename: 'ToolTenantsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ToolTenant` at the end of the edge. */
  node: ToolTenant;
};

/** Methods to use when ordering `ToolTenant`. */
export enum ToolTenantsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  ToolIdAsc = 'TOOL_ID_ASC',
  ToolIdDesc = 'TOOL_ID_DESC'
}

/** Input for the nested mutation of `tenant` in the `ToolTenantInput` mutation. */
export type ToolTenantsTenantId9C4A54FeFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `toolTenant` in the `TenantInput` mutation. */
export type ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput = {
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolTenantToolTenantsPkeyConnect>>;
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  connectByToolIdAndTenantId?: InputMaybe<Array<ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect>>;
  /** The primary key(s) and patch data for `toolTenant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate>>;
  /** The primary key(s) and patch data for `toolTenant` for the far side of the relationship. */
  updateByToolIdAndTenantId?: InputMaybe<Array<ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate>>;
};

/** Input for the nested mutation of `tool` in the `ToolTenantInput` mutation. */
export type ToolTenantsToolIdF77Ef6F7FkToolIdInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<ToolToolPkeyConnect>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<ToolToolProjectIdKeyConnect>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate>;
};

/** Input for the nested mutation of `toolTenant` in the `ToolInput` mutation. */
export type ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput = {
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolTenantToolTenantsPkeyConnect>>;
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  connectByToolIdAndTenantId?: InputMaybe<Array<ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect>>;
  /** The primary key(s) and patch data for `toolTenant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate>>;
  /** The primary key(s) and patch data for `toolTenant` for the far side of the relationship. */
  updateByToolIdAndTenantId?: InputMaybe<Array<ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate>>;
};

/** A filter to be used against many `ToolTenant` object types. All fields are combined with a logical ‘and.’ */
export type ToolToManyToolTenantFilter = {
  /** Every related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolTenantFilter>;
  /** No related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolTenantFilter>;
  /** Some related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolTenantFilter>;
};

/** A filter to be used against many `ToolVersion` object types. All fields are combined with a logical ‘and.’ */
export type ToolToManyToolVersionFilter = {
  /** Every related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolVersionFilter>;
  /** No related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolVersionFilter>;
  /** Some related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolVersionFilter>;
};

/** The fields on `tool` to look up the row to connect. */
export type ToolToolPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** The fields on `tool` to look up the row to connect. */
export type ToolToolProjectIdKeyConnect = {
  projectId: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `applicationUser` in the `ToolInput` mutation. */
export type ToolUserIdFd36Dfa4FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `tool` in the `ApplicationUserInput` mutation. */
export type ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolToolPkeyConnect>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<Array<ToolToolProjectIdKeyConnect>>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate>>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<Array<ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate>>;
};

export type ToolVersion = {
  __typename: 'ToolVersion';
  /** Reads a single `ApplicationUser` that is related to this `ToolVersion`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  changelog: Maybe<Scalars['String']['output']>;
  command: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  compatibleVersions: ToolVersionsConnection;
  containerImageId: Maybe<Scalars['Int']['output']>;
  credits: Maybe<Scalars['Float']['output']>;
  dateCreated: Scalars['Datetime']['output'];
  draftToolSpec: Maybe<Scalars['JSON']['output']>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  gdtAnalysisTableRowsByToolVersionId: GdtAnalysisTableRowsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. */
  gdtAnalysisTablesByToolVersionId: GdtAnalysisTablesConnection;
  id: Scalars['Int']['output'];
  isToolSpecForwardsCompatible: Scalars['Boolean']['output'];
  isUpgradableToNextVersion: Scalars['Boolean']['output'];
  maturity: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `Task`. */
  tasksByToolVersionId: TasksConnection;
  /** Reads a single `Tenant` that is related to this `ToolVersion`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Tool` that is related to this `ToolVersion`. */
  toolByToolId: Maybe<Tool>;
  toolId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `ToolParameter`. */
  toolParametersByToolVersionId: ToolParametersConnection;
  /** Reads and enables pagination through a set of `ToolResult`. */
  toolResultsByToolVersionId: ToolResultsConnection;
  /** Reads and enables pagination through a set of `ToolSecret`. */
  toolSecretsByToolVersionId: ToolSecretsConnection;
  /** Reads and enables pagination through a set of `ToolSource`. */
  toolSourcesByToolVersionId: ToolSourcesConnection;
  toolSpec: Maybe<Scalars['JSON']['output']>;
  toolSpecVersion: Scalars['Int']['output'];
  userId: Maybe<Scalars['UUID']['output']>;
  version: Scalars['String']['output'];
  visibility: Scalars['Int']['output'];
};


export type ToolVersionCompatibleVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ToolVersionGdtAnalysisTableRowsByToolVersionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};


export type ToolVersionGdtAnalysisTablesByToolVersionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};


export type ToolVersionTasksByToolVersionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


export type ToolVersionToolParametersByToolVersionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolParameterCondition>;
  filter?: InputMaybe<ToolParameterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolParametersOrderBy>>;
};


export type ToolVersionToolResultsByToolVersionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolResultCondition>;
  filter?: InputMaybe<ToolResultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolResultsOrderBy>>;
};


export type ToolVersionToolSecretsByToolVersionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolSecretCondition>;
  filter?: InputMaybe<ToolSecretFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolSecretsOrderBy>>;
};


export type ToolVersionToolSourcesByToolVersionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ToolSourceCondition>;
  filter?: InputMaybe<ToolSourceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ToolSourcesOrderBy>>;
};

/**
 * A condition to be used against `ToolVersion` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ToolVersionCondition = {
  /** Checks for equality with the object’s `changelog` field. */
  changelog?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `command` field. */
  command?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `containerImageId` field. */
  containerImageId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `credits` field. */
  credits?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `draftToolSpec` field. */
  draftToolSpec?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isToolSpecForwardsCompatible` field. */
  isToolSpecForwardsCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isUpgradableToNextVersion` field. */
  isUpgradableToNextVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `maturity` field. */
  maturity?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `toolId` field. */
  toolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `toolSpec` field. */
  toolSpec?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `toolSpecVersion` field. */
  toolSpecVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `visibility` field. */
  visibility?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ToolVersion` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolVersionFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `changelog` field. */
  changelog?: InputMaybe<StringFilter>;
  /** Filter by the object’s `command` field. */
  command?: InputMaybe<StringFilter>;
  /** Filter by the object’s `containerImageId` field. */
  containerImageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `draftToolSpec` field. */
  draftToolSpec?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `gdtAnalysisTableRowsByToolVersionId` relation. */
  gdtAnalysisTableRowsByToolVersionId?: InputMaybe<ToolVersionToManyGdtAnalysisTableRowFilter>;
  /** Some related `gdtAnalysisTableRowsByToolVersionId` exist. */
  gdtAnalysisTableRowsByToolVersionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `gdtAnalysisTablesByToolVersionId` relation. */
  gdtAnalysisTablesByToolVersionId?: InputMaybe<ToolVersionToManyGdtAnalysisTableFilter>;
  /** Some related `gdtAnalysisTablesByToolVersionId` exist. */
  gdtAnalysisTablesByToolVersionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isToolSpecForwardsCompatible` field. */
  isToolSpecForwardsCompatible?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isUpgradableToNextVersion` field. */
  isUpgradableToNextVersion?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `maturity` field. */
  maturity?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolVersionFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tasksByToolVersionId` relation. */
  tasksByToolVersionId?: InputMaybe<ToolVersionToManyTaskFilter>;
  /** Some related `tasksByToolVersionId` exist. */
  tasksByToolVersionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** A related `tenantByTenantId` exists. */
  tenantByTenantIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolByToolId` relation. */
  toolByToolId?: InputMaybe<ToolFilter>;
  /** Filter by the object’s `toolId` field. */
  toolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolParametersByToolVersionId` relation. */
  toolParametersByToolVersionId?: InputMaybe<ToolVersionToManyToolParameterFilter>;
  /** Some related `toolParametersByToolVersionId` exist. */
  toolParametersByToolVersionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolResultsByToolVersionId` relation. */
  toolResultsByToolVersionId?: InputMaybe<ToolVersionToManyToolResultFilter>;
  /** Some related `toolResultsByToolVersionId` exist. */
  toolResultsByToolVersionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolSecretsByToolVersionId` relation. */
  toolSecretsByToolVersionId?: InputMaybe<ToolVersionToManyToolSecretFilter>;
  /** Some related `toolSecretsByToolVersionId` exist. */
  toolSecretsByToolVersionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolSourcesByToolVersionId` relation. */
  toolSourcesByToolVersionId?: InputMaybe<ToolVersionToManyToolSourceFilter>;
  /** Some related `toolSourcesByToolVersionId` exist. */
  toolSourcesByToolVersionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `toolSpec` field. */
  toolSpec?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `toolSpecVersion` field. */
  toolSpecVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<StringFilter>;
  /** Filter by the object’s `visibility` field. */
  visibility?: InputMaybe<IntFilter>;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolVersion` being updated. */
  toolVersionPatch: UpdateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolVersion` being updated. */
  toolVersionPatch: UpdateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolVersion` being updated. */
  toolVersionPatch: UpdateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolVersion` being updated. */
  toolVersionPatch: UpdateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolVersion` being updated. */
  toolVersionPatch: UpdateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolVersion` being updated. */
  toolVersionPatch: UpdateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolVersion` being updated. */
  toolVersionPatch: UpdateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolVersion` being updated. */
  toolVersionPatch: UpdateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolVersion` being updated. */
  toolVersionPatch: UpdateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `toolVersion` being updated. */
  toolVersionPatch: UpdateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
};

/** Input for the nested mutation of `tenant` in the `ToolVersionInput` mutation. */
export type ToolVersionTenantId03A60B0CFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `toolVersion` in the `TenantInput` mutation. */
export type ToolVersionTenantId03A60B0CFkTenantIdInverseInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolVersionToolVersionPkeyConnect>>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate>>;
};

/** A filter to be used against many `GdtAnalysisTable` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyGdtAnalysisTableFilter = {
  /** Every related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableFilter>;
  /** No related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableFilter>;
  /** Some related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableFilter>;
};

/** A filter to be used against many `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyGdtAnalysisTableRowFilter = {
  /** Every related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** No related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Some related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableRowFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `ToolParameter` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyToolParameterFilter = {
  /** Every related `ToolParameter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolParameterFilter>;
  /** No related `ToolParameter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolParameterFilter>;
  /** Some related `ToolParameter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolParameterFilter>;
};

/** A filter to be used against many `ToolResult` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyToolResultFilter = {
  /** Every related `ToolResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolResultFilter>;
  /** No related `ToolResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolResultFilter>;
  /** Some related `ToolResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolResultFilter>;
};

/** A filter to be used against many `ToolSecret` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyToolSecretFilter = {
  /** Every related `ToolSecret` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolSecretFilter>;
  /** No related `ToolSecret` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolSecretFilter>;
  /** Some related `ToolSecret` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolSecretFilter>;
};

/** A filter to be used against many `ToolSource` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyToolSourceFilter = {
  /** Every related `ToolSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolSourceFilter>;
  /** No related `ToolSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolSourceFilter>;
  /** Some related `ToolSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolSourceFilter>;
};

/** Input for the nested mutation of `tool` in the `ToolVersionInput` mutation. */
export type ToolVersionToolId3B396B22FkToolIdInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<ToolToolPkeyConnect>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<ToolToolProjectIdKeyConnect>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate>;
};

/** Input for the nested mutation of `toolVersion` in the `ToolInput` mutation. */
export type ToolVersionToolId3B396B22FkToolIdInverseInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolVersionToolVersionPkeyConnect>>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate>>;
};

/** The fields on `toolVersion` to look up the row to connect. */
export type ToolVersionToolVersionPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** Input for the nested mutation of `applicationUser` in the `ToolVersionInput` mutation. */
export type ToolVersionUserId68A75E07FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `toolVersion` in the `ApplicationUserInput` mutation. */
export type ToolVersionUserId68A75E07FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolVersionToolVersionPkeyConnect>>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate>>;
};

/** A connection to a list of `ToolVersion` values. */
export type ToolVersionsConnection = {
  __typename: 'ToolVersionsConnection';
  /** A list of edges which contains the `ToolVersion` and cursor to aid in pagination. */
  edges: Array<ToolVersionsEdge>;
  /** A list of `ToolVersion` objects. */
  nodes: Array<ToolVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolVersion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ToolVersion` edge in the connection. */
export type ToolVersionsEdge = {
  __typename: 'ToolVersionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ToolVersion` at the end of the edge. */
  node: ToolVersion;
};

/** Methods to use when ordering `ToolVersion`. */
export enum ToolVersionsOrderBy {
  ChangelogAsc = 'CHANGELOG_ASC',
  ChangelogDesc = 'CHANGELOG_DESC',
  CommandAsc = 'COMMAND_ASC',
  CommandDesc = 'COMMAND_DESC',
  ContainerImageIdAsc = 'CONTAINER_IMAGE_ID_ASC',
  ContainerImageIdDesc = 'CONTAINER_IMAGE_ID_DESC',
  CreditsAsc = 'CREDITS_ASC',
  CreditsDesc = 'CREDITS_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DraftToolSpecAsc = 'DRAFT_TOOL_SPEC_ASC',
  DraftToolSpecDesc = 'DRAFT_TOOL_SPEC_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsToolSpecForwardsCompatibleAsc = 'IS_TOOL_SPEC_FORWARDS_COMPATIBLE_ASC',
  IsToolSpecForwardsCompatibleDesc = 'IS_TOOL_SPEC_FORWARDS_COMPATIBLE_DESC',
  IsUpgradableToNextVersionAsc = 'IS_UPGRADABLE_TO_NEXT_VERSION_ASC',
  IsUpgradableToNextVersionDesc = 'IS_UPGRADABLE_TO_NEXT_VERSION_DESC',
  MaturityAsc = 'MATURITY_ASC',
  MaturityDesc = 'MATURITY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  ToolIdAsc = 'TOOL_ID_ASC',
  ToolIdDesc = 'TOOL_ID_DESC',
  ToolSpecAsc = 'TOOL_SPEC_ASC',
  ToolSpecDesc = 'TOOL_SPEC_DESC',
  ToolSpecVersionAsc = 'TOOL_SPEC_VERSION_ASC',
  ToolSpecVersionDesc = 'TOOL_SPEC_VERSION_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC',
  VisibilityAsc = 'VISIBILITY_ASC',
  VisibilityDesc = 'VISIBILITY_DESC'
}

/** A connection to a list of `Tool` values. */
export type ToolsConnection = {
  __typename: 'ToolsConnection';
  /** A list of edges which contains the `Tool` and cursor to aid in pagination. */
  edges: Array<ToolsEdge>;
  /** A list of `Tool` objects. */
  nodes: Array<Tool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Tool` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Tool` edge in the connection. */
export type ToolsEdge = {
  __typename: 'ToolsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Tool` at the end of the edge. */
  node: Tool;
};

/** Methods to use when ordering `Tool`. */
export enum ToolsOrderBy {
  CodeLinkAsc = 'CODE_LINK_ASC',
  CodeLinkDesc = 'CODE_LINK_DESC',
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  DocsLinkAsc = 'DOCS_LINK_ASC',
  DocsLinkDesc = 'DOCS_LINK_DESC',
  HelpTextAsc = 'HELP_TEXT_ASC',
  HelpTextDesc = 'HELP_TEXT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  MaturityAsc = 'MATURITY_ASC',
  MaturityDesc = 'MATURITY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  SearchTermsAsc = 'SEARCH_TERMS_ASC',
  SearchTermsDesc = 'SEARCH_TERMS_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  ToolboxIdAsc = 'TOOLBOX_ID_ASC',
  ToolboxIdDesc = 'TOOLBOX_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  VisibilityAsc = 'VISIBILITY_ASC',
  VisibilityDesc = 'VISIBILITY_DESC'
}

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `updateApplicationUserByEmail` mutation. */
export type UpdateApplicationUserByEmailInput = {
  /** An object where the defined keys will be set on the `ApplicationUser` being updated. */
  applicationUserPatch: ApplicationUserPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** All input for the `updateApplicationUserByGlobalUserId` mutation. */
export type UpdateApplicationUserByGlobalUserIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUser` being updated. */
  applicationUserPatch: ApplicationUserPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  globalUserId: Scalars['UUID']['input'];
};

/** All input for the `updateApplicationUserById` mutation. */
export type UpdateApplicationUserByIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUser` being updated. */
  applicationUserPatch: ApplicationUserPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** All input for the `updateApplicationUserByUsername` mutation. */
export type UpdateApplicationUserByUsernameInput = {
  /** An object where the defined keys will be set on the `ApplicationUser` being updated. */
  applicationUserPatch: ApplicationUserPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

/** All input for the `updateApplicationUserMetadatumById` mutation. */
export type UpdateApplicationUserMetadatumByIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUserMetadatum` being updated. */
  applicationUserMetadatumPatch: ApplicationUserMetadatumPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** All input for the `updateApplicationUserMetadatumByUserIdAndKey` mutation. */
export type UpdateApplicationUserMetadatumByUserIdAndKeyInput = {
  /** An object where the defined keys will be set on the `ApplicationUserMetadatum` being updated. */
  applicationUserMetadatumPatch: ApplicationUserMetadatumPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

/** The output of our update `ApplicationUserMetadatum` mutation. */
export type UpdateApplicationUserMetadatumPayload = {
  __typename: 'UpdateApplicationUserMetadatumPayload';
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMetadatum`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserMetadatum` that was updated by this mutation. */
  applicationUserMetadatum: Maybe<ApplicationUserMetadatum>;
  /** An edge for our `ApplicationUserMetadatum`. May be used by Relay 1. */
  applicationUserMetadatumEdge: Maybe<ApplicationUserMetadataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `ApplicationUserMetadatum` mutation. */
export type UpdateApplicationUserMetadatumPayloadApplicationUserMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUserMetadataOrderBy>>;
};

/** The output of our update `ApplicationUser` mutation. */
export type UpdateApplicationUserPayload = {
  __typename: 'UpdateApplicationUserPayload';
  /** The `ApplicationUser` that was updated by this mutation. */
  applicationUser: Maybe<ApplicationUser>;
  /** An edge for our `ApplicationUser`. May be used by Relay 1. */
  applicationUserEdge: Maybe<ApplicationUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `ApplicationUser` mutation. */
export type UpdateApplicationUserPayloadApplicationUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUsersOrderBy>>;
};

/** All input for the `updateAvatarById` mutation. */
export type UpdateAvatarByIdInput = {
  /** An object where the defined keys will be set on the `Avatar` being updated. */
  avatarPatch: AvatarPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

/** All input for the `updateAvatarByUserId` mutation. */
export type UpdateAvatarByUserIdInput = {
  /** An object where the defined keys will be set on the `Avatar` being updated. */
  avatarPatch: AvatarPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};

/** The output of our update `Avatar` mutation. */
export type UpdateAvatarPayload = {
  __typename: 'UpdateAvatarPayload';
  /** Reads a single `ApplicationUser` that is related to this `Avatar`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `Avatar` that was updated by this mutation. */
  avatar: Maybe<Avatar>;
  /** An edge for our `Avatar`. May be used by Relay 1. */
  avatarEdge: Maybe<AvatarsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `Avatar` mutation. */
export type UpdateAvatarPayloadAvatarEdgeArgs = {
  orderBy?: InputMaybe<Array<AvatarsOrderBy>>;
};

export type UserAccessToProject = {
  __typename: 'UserAccessToProject';
  edit: Maybe<Scalars['Boolean']['output']>;
  grantAccess: Maybe<Scalars['Boolean']['output']>;
  projectId: Maybe<Scalars['UUID']['output']>;
  userId: Maybe<Scalars['UUID']['output']>;
  view: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A condition to be used against `UserAccessToProject` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserAccessToProjectCondition = {
  /** Checks for equality with the object’s `edit` field. */
  edit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `grantAccess` field. */
  grantAccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `view` field. */
  view?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `UserAccessToProject` object types. All fields are combined with a logical ‘and.’ */
export type UserAccessToProjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserAccessToProjectFilter>>;
  /** Filter by the object’s `edit` field. */
  edit?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `grantAccess` field. */
  grantAccess?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserAccessToProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserAccessToProjectFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `view` field. */
  view?: InputMaybe<BooleanFilter>;
};

/** A connection to a list of `UserAccessToProject` values. */
export type UserAccessToProjectsConnection = {
  __typename: 'UserAccessToProjectsConnection';
  /** A list of edges which contains the `UserAccessToProject` and cursor to aid in pagination. */
  edges: Array<UserAccessToProjectsEdge>;
  /** A list of `UserAccessToProject` objects. */
  nodes: Array<UserAccessToProject>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserAccessToProject` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserAccessToProject` edge in the connection. */
export type UserAccessToProjectsEdge = {
  __typename: 'UserAccessToProjectsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `UserAccessToProject` at the end of the edge. */
  node: UserAccessToProject;
};

/** Methods to use when ordering `UserAccessToProject`. */
export enum UserAccessToProjectsOrderBy {
  EditAsc = 'EDIT_ASC',
  EditDesc = 'EDIT_DESC',
  GrantAccessAsc = 'GRANT_ACCESS_ASC',
  GrantAccessDesc = 'GRANT_ACCESS_DESC',
  Natural = 'NATURAL',
  ProjectIdAsc = 'PROJECT_ID_ASC',
  ProjectIdDesc = 'PROJECT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ViewAsc = 'VIEW_ASC',
  ViewDesc = 'VIEW_DESC'
}

/** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
export type UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch = {
  applicationUserToUserId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
export type UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInput>;
  tenantToTenantId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `applicationUserMetadatum` being updated. */
export type UpdateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch = {
  applicationUserToUserId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars['String']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars['UUID']['input']>;
  homeRegion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars['String']['input']>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOrigin?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `applicationUserSession` being updated. */
export type UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch = {
  applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
};

/** An object where the defined keys will be set on the `applicationUserSession` being updated. */
export type UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
  tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `avatar` being updated. */
export type UpdateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  imageBase64?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  useImage?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An object where the defined keys will be set on the `codeFile` being updated. */
export type UpdateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch = {
  applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
  codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `codeFile` being updated. */
export type UpdateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
  codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `codeFile` being updated. */
export type UpdateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
  codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `dataTable` being updated. */
export type UpdateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch = {
  applicationUserToUserId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInput>;
  projectFolderToFolderId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `dataTable` being updated. */
export type UpdateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInput>;
  folderId?: InputMaybe<Scalars['UUID']['input']>;
  projectFolderToFolderId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInput>;
  projectToProjectId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `dataTable` being updated. */
export type UpdateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInput>;
  folderId?: InputMaybe<Scalars['UUID']['input']>;
  projectFolderToFolderId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInput>;
};

/** An object where the defined keys will be set on the `eulaVersion` being updated. */
export type UpdateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch = {
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput>;
};

/** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
export type UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch = {
  applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
  eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
export type UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch = {
  applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
  eulaVersionId?: InputMaybe<Scalars['Int']['input']>;
  eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
};

/** An object where the defined keys will be set on the `fileActivity` being updated. */
export type UpdateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch = {
  applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
  fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `fileActivity` being updated. */
export type UpdateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
  projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `fileActivity` being updated. */
export type UpdateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
  tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `fileActivity` being updated. */
export type UpdateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
};

/** An object where the defined keys will be set on the `fileMetadatum` being updated. */
export type UpdateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch = {
  fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `fileMetadatum` being updated. */
export type UpdateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch = {
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
  metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `fileMetadatum` being updated. */
export type UpdateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch = {
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
  projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `fileMetadatum` being updated. */
export type UpdateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch = {
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
  tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileForFileTenantId61625016FkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  seriesParentId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
export type UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch = {
  fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
export type UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch = {
  fileOutputGroupId?: InputMaybe<Scalars['UUID']['input']>;
  fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
  metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
export type UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch = {
  fileOutputGroupId?: InputMaybe<Scalars['UUID']['input']>;
  fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
  projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
export type UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch = {
  fileOutputGroupId?: InputMaybe<Scalars['UUID']['input']>;
  fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
  tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
  projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
  taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
  tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
};

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch = {
  applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch = {
  applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
export type UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch = {
  applicationUserToUserId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInput>;
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileToFileId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInput>;
};

/** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
export type UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch = {
  applicationUserToUserId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInput>;
  fileToFileId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
export type UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch = {
  applicationUserToUserId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInput>;
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileToFileId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInput>;
  notificationToId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch = {
  applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
  projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
  folderId?: InputMaybe<Scalars['UUID']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
  projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
  projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch = {
  applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
  folderId?: InputMaybe<Scalars['UUID']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
  projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
  toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
  folderId?: InputMaybe<Scalars['UUID']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
  projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
};

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch = {
  applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
  folderId?: InputMaybe<Scalars['UUID']['input']>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
  projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch = {
  applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
  gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch = {
  applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
  gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
  toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
  gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
  projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
  gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
  gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
  tableId?: InputMaybe<Scalars['UUID']['input']>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
};

/** An object where the defined keys will be set on the `metadataValue` being updated. */
export type UpdateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `metadataValue` being updated. */
export type UpdateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `metadataValue` being updated. */
export type UpdateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `metadataValue` being updated. */
export type UpdateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `metadataValue` being updated. */
export type UpdateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  metadataId?: InputMaybe<Scalars['UUID']['input']>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
};

/** An object where the defined keys will be set on the `metadatum` being updated. */
export type UpdateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch = {
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `metadatum` being updated. */
export type UpdateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch = {
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `metadatum` being updated. */
export type UpdateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch = {
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `metadatum` being updated. */
export type UpdateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch = {
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `metadatum` being updated. */
export type UpdateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch = {
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch = {
  applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
  fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
  projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
  projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
  roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
  tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
  fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
  projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
  projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
  roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
  tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch = {
  applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
  fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
  projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
  projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
  roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
  tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch = {
  applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
  fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
  projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
  projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
  roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
  tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch = {
  applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
  fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
  projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
  projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
  roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
  tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch = {
  applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
  fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
  projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
  projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
  roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
  tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `outputGroupFile` being updated. */
export type UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch = {
  fileOutputGroupId?: InputMaybe<Scalars['UUID']['input']>;
  fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
  fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
};

/** An object where the defined keys will be set on the `outputGroupFile` being updated. */
export type UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch = {
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
  fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
};

/** An object where the defined keys will be set on the `outputGroupFile` being updated. */
export type UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch = {
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileOutputGroupId?: InputMaybe<Scalars['UUID']['input']>;
  fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
  fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
  projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
};

/** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
export type UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch = {
  applicationUserToUserId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInput>;
  projectToSrcProjectId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
export type UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch = {
  applicationUserToUserId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInput>;
  projectToSrcProjectId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput>;
  srcProjectId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
export type UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInput>;
  notificationToId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInput>;
  projectToSrcProjectId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput>;
  srcProjectId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
export type UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInput>;
  projectToProjectId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInput>;
  projectToSrcProjectId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput>;
  srcProjectId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectFolder` being updated. */
export type UpdateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
  dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectFolder` being updated. */
export type UpdateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
  dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectFolder` being updated. */
export type UpdateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
  dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
  projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectFolder` being updated. */
export type UpdateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
  dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnToolForToolProjectId20A84210FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars['UUID']['input']>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
export type UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch = {
  applicationUserToSharerId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput>;
  applicationUserToUserId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
export type UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch = {
  applicationUserToSharerId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput>;
  applicationUserToUserId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput>;
  sharerId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
export type UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch = {
  applicationUserToSharerId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput>;
  applicationUserToUserId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInput>;
  notificationToId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput>;
  sharerId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
export type UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch = {
  applicationUserToSharerId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput>;
  applicationUserToUserId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput>;
  projectToProjectId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput>;
  sharerId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectTag` being updated. */
export type UpdateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInput>;
  projectToProjectId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `projectTag` being updated. */
export type UpdateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInput>;
};

/** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
export type UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch = {
  applicationUserToUserId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInput>;
};

/** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
export type UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch = {
  applicationUserToUserId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInput>;
  notificationToId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
export type UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInput>;
  tenantToTenantId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `taskActivity` being updated. */
export type UpdateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch = {
  taskToTaskId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInput>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `taskResource` being updated. */
export type UpdateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch = {
  taskToTaskId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInput>;
};

/** An object where the defined keys will be set on the `taskResourceUsage` being updated. */
export type UpdateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch = {
  taskToTaskId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInput>;
};

/** An object where the defined keys will be set on the `taskSource` being updated. */
export type UpdateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch = {
  fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
  toolSourceId?: InputMaybe<Scalars['Int']['input']>;
  toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
};

/** An object where the defined keys will be set on the `taskSource` being updated. */
export type UpdateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch = {
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
  taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
  toolSourceId?: InputMaybe<Scalars['Int']['input']>;
  toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
};

/** An object where the defined keys will be set on the `taskSource` being updated. */
export type UpdateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch = {
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
  taskId?: InputMaybe<Scalars['UUID']['input']>;
  taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
  toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
};

/** An object where the defined keys will be set on the `tenantContractAllowance` being updated. */
export type UpdateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch = {
  tenantContractTransactionToTenantContractTransactionId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput>;
};

/** An object where the defined keys will be set on the `tenantContract` being updated. */
export type UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch = {
  tenantContractTransactionsUsingId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInverseInput>;
  tenantToTenantId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInput>;
};

/** An object where the defined keys will be set on the `tenantContract` being updated. */
export type UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch = {
  tenantContractTransactionsUsingId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInput>;
};

/** An object where the defined keys will be set on the `tenantContractTransaction` being updated. */
export type UpdateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch = {
  tenantContractAllowancesUsingId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput>;
  tenantContractId?: InputMaybe<Scalars['Int']['input']>;
  tenantContractToTenantContractId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInput>;
};

/** An object where the defined keys will be set on the `tenantContractTransaction` being updated. */
export type UpdateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch = {
  tenantContractAllowancesUsingId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput>;
  tenantContractToTenantContractId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
export type UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch = {
  applicationUserToInviterId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInput>;
  applicationUserToUserId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInput>;
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
export type UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch = {
  applicationUserToInviterId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInput>;
  applicationUserToUserId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
export type UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch = {
  applicationUserToInviterId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInput>;
  applicationUserToUserId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInput>;
  tenantToTenantId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
export type UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch = {
  applicationUserToInviterId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInput>;
  applicationUserToUserId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
  notificationToId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInput>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolForToolProjectId20A84210FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `toolParameter` being updated. */
export type UpdateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch = {
  toolVersionToToolVersionId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput>;
};

/** An object where the defined keys will be set on the `toolResult` being updated. */
export type UpdateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch = {
  toolVersionToToolVersionId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInput>;
};

/** An object where the defined keys will be set on the `toolSecret` being updated. */
export type UpdateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch = {
  toolVersionToToolVersionId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput>;
};

/** An object where the defined keys will be set on the `toolSource` being updated. */
export type UpdateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch = {
  taskSourcesUsingId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput>;
  toolVersionId?: InputMaybe<Scalars['Int']['input']>;
  toolVersionToToolVersionId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput>;
};

/** An object where the defined keys will be set on the `toolSource` being updated. */
export type UpdateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch = {
  taskSourcesUsingId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput>;
  toolVersionToToolVersionId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput>;
};

/** An object where the defined keys will be set on the `toolTenant` being updated. */
export type UpdateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch = {
  tenantToTenantId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInput>;
  toolId?: InputMaybe<Scalars['Int']['input']>;
  toolToToolId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInput>;
};

/** An object where the defined keys will be set on the `toolTenant` being updated. */
export type UpdateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch = {
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInput>;
  toolToToolId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInput>;
};

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars['Int']['input']>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars['Int']['input']>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars['Int']['input']>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars['Int']['input']>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars['Int']['input']>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars['Int']['input']>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars['Int']['input']>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars['Int']['input']>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars['Int']['input']>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
};

export type GetTaskResourceUsageByTaskIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTaskResourceUsageByTaskIdQuery = (
  { __typename: 'Query' }
  & { task: Maybe<(
    { __typename: 'Task' }
    & Pick<Task, 'id' | 'resourceTier'>
    & { resourceUsage: Maybe<(
      { __typename: 'TaskResourceUsage' }
      & Pick<TaskResourceUsage, 'id' | 'cpuMin' | 'cpuMax' | 'memoryMin' | 'memoryMax' | 'storageMin' | 'storageMax'>
    )>, toolVersion: Maybe<(
      { __typename: 'ToolVersion' }
      & Pick<ToolVersion, 'id' | 'toolSpec'>
    )> }
  )> }
);

export type CreateEulaVersionUserAcceptanceMutationVariables = Exact<{
  input: CreateEulaVersionUserAcceptanceInput;
}>;


export type CreateEulaVersionUserAcceptanceMutation = (
  { __typename: 'Mutation' }
  & { createEulaVersionUserAcceptance: Maybe<(
    { __typename: 'CreateEulaVersionUserAcceptancePayload' }
    & { applicationUserByUserId: Maybe<(
      { __typename: 'ApplicationUser' }
      & Pick<ApplicationUser, 'id'>
    )> }
  )> }
);

export type GetAllEulaVersionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEulaVersionsQuery = (
  { __typename: 'Query' }
  & { allEulaVersions: Maybe<(
    { __typename: 'EulaVersionsConnection' }
    & { nodes: Array<(
      { __typename: 'EulaVersion' }
      & Pick<EulaVersion, 'id' | 'content'>
    )> }
  )> }
);

export type FileBrowserDetailRendererAnalysisResultQueryVariables = Exact<{
  drsFileId: Scalars['UUID']['input'];
}>;


export type FileBrowserDetailRendererAnalysisResultQuery = (
  { __typename: 'Query' }
  & { drsFile: Maybe<(
    { __typename: 'File' }
    & Pick<File, 'id'>
    & { project: Maybe<(
      { __typename: 'Project' }
      & Pick<Project, 'id' | 'key'>
    )>, outputGroupFiles: (
      { __typename: 'OutputGroupFilesConnection' }
      & { nodes: Array<(
        { __typename: 'OutputGroupFile' }
        & Pick<OutputGroupFile, 'id'>
        & { fileOutputGroup: Maybe<(
          { __typename: 'FileOutputGroup' }
          & Pick<FileOutputGroup, 'id'>
          & { task: Maybe<(
            { __typename: 'Task' }
            & Pick<Task, 'id' | 'userId' | 'status' | 'dateCreated'>
            & { analysisTableRow: (
              { __typename: 'GdtAnalysisTableRowsConnection' }
              & { nodes: Array<(
                { __typename: 'GdtAnalysisTableRow' }
                & Pick<GdtAnalysisTableRow, 'id'>
                & { analysisTable: Maybe<(
                  { __typename: 'GdtAnalysisTable' }
                  & Pick<GdtAnalysisTable, 'id' | 'name' | 'key'>
                )> }
              )> }
            ) }
          )> }
        )> }
      )> }
    ) }
  )> }
);

export type FlyoutDrsFileInfoQueryVariables = Exact<{
  drsFileId: Scalars['UUID']['input'];
}>;


export type FlyoutDrsFileInfoQuery = (
  { __typename: 'Query' }
  & { drsFile: Maybe<(
    { __typename: 'File' }
    & Pick<File, 'preview' | 'id' | 'referenceId' | 'dateArchived' | 'dateCreated' | 'dateDataDeleted' | 'dateDeleted' | 'fileType' | 'tags' | 'fileFormat' | 'fileStructure' | 'key' | 'location' | 'multipartUploadId' | 'name' | 'parentIds' | 'partSize' | 'projectId' | 'signal' | 'size' | 'status' | 'source' | 'tenantId' | 'uploadStatus' | 'userId' | 'originalName' | 'seriesParentId' | 'isSeries' | 'seriesOrder' | 'processingStatus'>
    & { seriesFiles: (
      { __typename: 'FilesConnection' }
      & { nodes: Array<(
        { __typename: 'File' }
        & Pick<File, 'preview' | 'id' | 'referenceId' | 'dateArchived' | 'dateCreated' | 'dateDataDeleted' | 'dateDeleted' | 'fileType' | 'tags' | 'fileFormat' | 'fileStructure' | 'key' | 'location' | 'multipartUploadId' | 'name' | 'parentIds' | 'partSize' | 'projectId' | 'signal' | 'size' | 'status' | 'source' | 'tenantId' | 'uploadStatus' | 'userId' | 'originalName' | 'seriesParentId' | 'isSeries' | 'seriesOrder' | 'processingStatus'>
      )> }
    ), outputGroupFiles: (
      { __typename: 'OutputGroupFilesConnection' }
      & { nodes: Array<(
        { __typename: 'OutputGroupFile' }
        & Pick<OutputGroupFile, 'id'>
        & { outputGroup: Maybe<(
          { __typename: 'FileOutputGroup' }
          & Pick<FileOutputGroup, 'id'>
          & { task: Maybe<(
            { __typename: 'Task' }
            & Pick<Task, 'id' | 'userId' | 'status' | 'dateCreated'>
            & { analysisTableRow: (
              { __typename: 'GdtAnalysisTableRowsConnection' }
              & { nodes: Array<(
                { __typename: 'GdtAnalysisTableRow' }
                & Pick<GdtAnalysisTableRow, 'id'>
                & { analysisTable: Maybe<(
                  { __typename: 'GdtAnalysisTable' }
                  & Pick<GdtAnalysisTable, 'id' | 'name' | 'key'>
                )> }
              )> }
            ) }
          )> }
        )> }
      )> }
    ) }
  )> }
);

export type FlyoutFilesGdtQueryVariables = Exact<{
  projectKey: Scalars['String']['input'];
  tenantId: Scalars['Int']['input'];
}>;


export type FlyoutFilesGdtQuery = (
  { __typename: 'Query' }
  & { project: Maybe<(
    { __typename: 'Project' }
    & Pick<Project, 'id' | 'key' | 'name' | 'tenantId'>
    & { files: (
      { __typename: 'FilesConnection' }
      & { nodes: Array<(
        { __typename: 'File' }
        & Pick<File, 'id' | 'name' | 'fileType' | 'fileFormat' | 'fileStructure' | 'status' | 'dateCreated' | 'uploadStatus' | 'projectId' | 'size' | 'seriesParentId' | 'processingStatus' | 'originalName' | 'source' | 'isSeries' | 'tags' | 'referenceId'>
        & { seriesFiles: (
          { __typename: 'FilesConnection' }
          & { nodes: Array<(
            { __typename: 'File' }
            & Pick<File, 'id' | 'name' | 'fileType' | 'fileFormat' | 'fileStructure' | 'status' | 'dateCreated' | 'uploadStatus' | 'projectId' | 'size' | 'seriesParentId' | 'processingStatus' | 'originalName' | 'tags'>
          )> }
        ), user: Maybe<(
          { __typename: 'ApplicationUser' }
          & Pick<ApplicationUser, 'id' | 'firstName' | 'lastName'>
        )> }
      )> }
    ) }
  )> }
);

export type ModalCreateSeriesQueryVariables = Exact<{
  drsFileIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  metadataKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ModalCreateSeriesQuery = (
  { __typename: 'Query' }
  & { drsFiles: Maybe<(
    { __typename: 'FilesConnection' }
    & { nodes: Array<(
      { __typename: 'File' }
      & Pick<File, 'id' | 'name' | 'status' | 'isSeries' | 'seriesParentId' | 'fileType' | 'fileFormat' | 'fileStructure' | 'size'>
      & { metadata: (
        { __typename: 'FileMetadataConnection' }
        & { nodes: Array<(
          { __typename: 'FileMetadatum' }
          & Pick<FileMetadatum, 'id'>
          & { metadatum: Maybe<(
            { __typename: 'Metadatum' }
            & Pick<Metadatum, 'id' | 'key' | 'activeValue'>
          )> }
        )> }
      ) }
    )> }
  )> }
);

export type NotificationsFeedBodyQueryVariables = Exact<{
  condition?: InputMaybe<NotificationCondition>;
  notificationIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type NotificationsFeedBodyQuery = (
  { __typename: 'Query' }
  & { notifications: Maybe<(
    { __typename: 'NotificationsConnection' }
    & { nodes: Array<(
      { __typename: 'Notification' }
      & Pick<Notification, 'id' | 'dateCreated' | 'hasSeen'>
      & { projectSharedNotification: Maybe<(
        { __typename: 'ProjectSharedNotification' }
        & Pick<ProjectSharedNotification, 'id' | 'accessLevel'>
        & { project: Maybe<(
          { __typename: 'Project' }
          & Pick<Project, 'id' | 'name' | 'key'>
          & { tenant: Maybe<(
            { __typename: 'Tenant' }
            & Pick<Tenant, 'id' | 'key'>
          )> }
        )>, sharer: Maybe<(
          { __typename: 'ApplicationUser' }
          & Pick<ApplicationUser, 'id' | 'firstName' | 'lastName'>
        )> }
      )>, fileProcessingNotification: Maybe<(
        { __typename: 'FileProcessingNotification' }
        & Pick<FileProcessingNotification, 'id' | 'status' | 'fileId' | 'userId'>
        & { file: Maybe<(
          { __typename: 'File' }
          & Pick<File, 'id' | 'name' | 'status' | 'fileType' | 'isSeries' | 'source' | 'processingStatus' | 'seriesParentId'>
          & { project: Maybe<(
            { __typename: 'Project' }
            & Pick<Project, 'id' | 'name' | 'key'>
            & { tenant: Maybe<(
              { __typename: 'Tenant' }
              & Pick<Tenant, 'id' | 'key'>
            )> }
          )> }
        )>, user: Maybe<(
          { __typename: 'ApplicationUser' }
          & Pick<ApplicationUser, 'id'>
        )> }
      )>, projectClonedNotification: Maybe<(
        { __typename: 'ProjectClonedNotification' }
        & Pick<ProjectClonedNotification, 'id' | 'projectName' | 'succeeded'>
        & { project: Maybe<(
          { __typename: 'Project' }
          & Pick<Project, 'id' | 'name' | 'key' | 'status'>
          & { tenant: Maybe<(
            { __typename: 'Tenant' }
            & Pick<Tenant, 'id' | 'key'>
          )> }
        )>, srcProject: Maybe<(
          { __typename: 'Project' }
          & Pick<Project, 'id' | 'name' | 'key'>
          & { tenant: Maybe<(
            { __typename: 'Tenant' }
            & Pick<Tenant, 'id' | 'key'>
          )> }
        )> }
      )>, tenantUserMembershipNotification: Maybe<(
        { __typename: 'TenantUserMembershipNotification' }
        & Pick<TenantUserMembershipNotification, 'id'>
        & { inviter: Maybe<(
          { __typename: 'ApplicationUser' }
          & Pick<ApplicationUser, 'id' | 'firstName' | 'lastName'>
        )>, tenant: Maybe<(
          { __typename: 'Tenant' }
          & Pick<Tenant, 'id' | 'key' | 'name'>
        )> }
      )>, roleChangeNotification: Maybe<(
        { __typename: 'RoleChangeNotification' }
        & Pick<RoleChangeNotification, 'id' | 'role'>
        & { tenant: Maybe<(
          { __typename: 'Tenant' }
          & Pick<Tenant, 'id' | 'key' | 'name'>
        )>, user: Maybe<(
          { __typename: 'ApplicationUser' }
          & Pick<ApplicationUser, 'id'>
        )> }
      )> }
    )> }
  )> }
);

export type PopoverFileUploadFragment = (
  { __typename: 'File' }
  & Pick<File, 'id' | 'name' | 'status' | 'fileType' | 'source' | 'processingStatus' | 'seriesParentId'>
);

export type ProjectInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ProjectInfoQuery = (
  { __typename: 'Query' }
  & { project: Maybe<(
    { __typename: 'Project' }
    & Pick<Project, 'id' | 'dateCreated' | 'dateLastActive' | 'key'>
    & { user: Maybe<(
      { __typename: 'ApplicationUser' }
      & Pick<ApplicationUser, 'id' | 'firstName' | 'lastName'>
    )>, tenant: Maybe<(
      { __typename: 'Tenant' }
      & Pick<Tenant, 'id' | 'key'>
    )>, cloneSource: Maybe<(
      { __typename: 'Project' }
      & Pick<Project, 'id' | 'name' | 'key'>
      & { tenant: Maybe<(
        { __typename: 'Tenant' }
        & Pick<Tenant, 'id' | 'key'>
      )> }
    )> }
  )> }
);

export type MetadataTableFileQueryVariables = Exact<{
  fileIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  metadatumKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MetadataTableFileQuery = (
  { __typename: 'Query' }
  & { fileMetadata: Maybe<(
    { __typename: 'FileMetadataConnection' }
    & { nodes: Array<(
      { __typename: 'FileMetadatum' }
      & Pick<FileMetadatum, 'id'>
      & { file: Maybe<(
        { __typename: 'File' }
        & Pick<File, 'id' | 'fileType'>
      )>, metadatum: Maybe<(
        { __typename: 'Metadatum' }
        & Pick<Metadatum, 'id' | 'key' | 'activeValue'>
      )> }
    )> }
  )> }
);

export type ModalToolCellStatusParamQueryVariables = Exact<{
  fileIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  metadatumKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ModalToolCellStatusParamQuery = (
  { __typename: 'Query' }
  & { files: Maybe<(
    { __typename: 'FilesConnection' }
    & { nodes: Array<(
      { __typename: 'File' }
      & Pick<File, 'id' | 'name' | 'source' | 'isSeries' | 'fileType'>
      & { metadata: (
        { __typename: 'FileMetadataConnection' }
        & { nodes: Array<(
          { __typename: 'FileMetadatum' }
          & Pick<FileMetadatum, 'id'>
          & { metadatum: Maybe<(
            { __typename: 'Metadatum' }
            & Pick<Metadatum, 'id' | 'key'>
            & { value: Metadatum['activeValue'] }
          )> }
        )> }
      ), seriesMembers: (
        { __typename: 'FilesConnection' }
        & { nodes: Array<(
          { __typename: 'File' }
          & Pick<File, 'id' | 'name' | 'source' | 'fileType'>
          & { metadata: (
            { __typename: 'FileMetadataConnection' }
            & { nodes: Array<(
              { __typename: 'FileMetadatum' }
              & Pick<FileMetadatum, 'id'>
              & { metadatum: Maybe<(
                { __typename: 'Metadatum' }
                & Pick<Metadatum, 'id' | 'key'>
                & { value: Metadatum['activeValue'] }
              )> }
            )> }
          ) }
        )> }
      ) }
    )> }
  )> }
);

export type ModalToolRoiFrameParamQueryVariables = Exact<{
  fileIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  metadatumKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ModalToolRoiFrameParamQuery = (
  { __typename: 'Query' }
  & { files: Maybe<(
    { __typename: 'FilesConnection' }
    & { nodes: Array<(
      { __typename: 'File' }
      & Pick<File, 'id' | 'name' | 'source' | 'isSeries'>
      & { metadata: (
        { __typename: 'FileMetadataConnection' }
        & { nodes: Array<(
          { __typename: 'FileMetadatum' }
          & Pick<FileMetadatum, 'id'>
          & { metadatum: Maybe<(
            { __typename: 'Metadatum' }
            & Pick<Metadatum, 'id' | 'key'>
            & { value: Metadatum['activeValue'] }
          )> }
        )> }
      ), seriesParent: Maybe<(
        { __typename: 'File' }
        & Pick<File, 'id'>
        & { metadata: (
          { __typename: 'FileMetadataConnection' }
          & { nodes: Array<(
            { __typename: 'FileMetadatum' }
            & Pick<FileMetadatum, 'id'>
            & { metadatum: Maybe<(
              { __typename: 'Metadatum' }
              & Pick<Metadatum, 'id' | 'key'>
              & { value: Metadatum['activeValue'] }
            )> }
          )> }
        ) }
      )>, seriesMembers: (
        { __typename: 'FilesConnection' }
        & { nodes: Array<(
          { __typename: 'File' }
          & Pick<File, 'id' | 'name' | 'source'>
          & { metadata: (
            { __typename: 'FileMetadataConnection' }
            & { nodes: Array<(
              { __typename: 'FileMetadatum' }
              & Pick<FileMetadatum, 'id'>
              & { metadatum: Maybe<(
                { __typename: 'Metadatum' }
                & Pick<Metadatum, 'id' | 'key'>
                & { value: Metadatum['activeValue'] }
              )> }
            )> }
          ) }
        )> }
      ) }
    )> }
  )> }
);

export type UserAvatarFieldsFragment = (
  { __typename: 'ApplicationUser' }
  & Pick<ApplicationUser, 'id' | 'firstName' | 'lastName'>
  & { avatar: Maybe<(
    { __typename: 'Avatar' }
    & Pick<Avatar, 'id' | 'imageBase64' | 'initials' | 'useImage' | 'color'>
  )> }
);

export type UserAvatarQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type UserAvatarQuery = (
  { __typename: 'Query' }
  & { user: Maybe<(
    { __typename: 'ApplicationUser' }
    & Pick<ApplicationUser, 'id' | 'firstName' | 'lastName'>
    & { avatar: Maybe<(
      { __typename: 'Avatar' }
      & Pick<Avatar, 'id' | 'imageBase64' | 'initials' | 'useImage' | 'color'>
    )> }
  )> }
);

export type ApplicationUserMembershipCacheFragment = (
  { __typename: 'ApplicationUserMembership' }
  & Pick<ApplicationUserMembership, 'id' | 'role' | 'tenantId' | 'userId'>
  & { user: Maybe<(
    { __typename: 'ApplicationUser' }
    & Pick<ApplicationUser, 'id'>
  )>, tenant: Maybe<(
    { __typename: 'Tenant' }
    & Pick<Tenant, 'id'>
  )> }
);

export type FileCacheFragment = (
  { __typename: 'File' }
  & Pick<File, 'id' | 'referenceId' | 'dateArchived' | 'dateCreated' | 'dateDataDeleted' | 'dateDeleted' | 'fileFormat' | 'fileStructure' | 'fileType' | 'tags' | 'key' | 'isSeries' | 'location' | 'multipartUploadId' | 'name' | 'parentIds' | 'partSize' | 'preview' | 'projectId' | 'signal' | 'size' | 'status' | 'source' | 'tenantId' | 'uploadStatus' | 'userId' | 'originalName' | 'seriesParentId' | 'seriesOrder' | 'processingStatus'>
  & { fileBySeriesParentId: Maybe<(
    { __typename: 'File' }
    & Pick<File, 'id'>
  )>, seriesFiles: (
    { __typename: 'FilesConnection' }
    & { nodes: Array<(
      { __typename: 'File' }
      & Pick<File, 'id'>
    )> }
  ), fileMetadata: (
    { __typename: 'FileMetadataConnection' }
    & { nodes: Array<(
      { __typename: 'FileMetadatum' }
      & Pick<FileMetadatum, 'id'>
    )> }
  ), taskSources: (
    { __typename: 'TaskSourcesConnection' }
    & { nodes: Array<(
      { __typename: 'TaskSource' }
      & Pick<TaskSource, 'id'>
    )> }
  ), tenant: Maybe<(
    { __typename: 'Tenant' }
    & Pick<Tenant, 'id'>
  )>, user: Maybe<(
    { __typename: 'ApplicationUser' }
    & Pick<ApplicationUser, 'id'>
  )>, fileActivities: (
    { __typename: 'FileActivitiesConnection' }
    & { nodes: Array<(
      { __typename: 'FileActivity' }
      & Pick<FileActivity, 'id'>
    )> }
  ), project: Maybe<(
    { __typename: 'Project' }
    & Pick<Project, 'id'>
  )>, outputGroupFiles: (
    { __typename: 'OutputGroupFilesConnection' }
    & { nodes: Array<(
      { __typename: 'OutputGroupFile' }
      & Pick<OutputGroupFile, 'id'>
    )> }
  ), fileProcessingNotifications: (
    { __typename: 'FileProcessingNotificationsConnection' }
    & { nodes: Array<(
      { __typename: 'FileProcessingNotification' }
      & Pick<FileProcessingNotification, 'id'>
    )> }
  ) }
);

export type MetadatumCacheFragment = (
  { __typename: 'Metadatum' }
  & Pick<Metadatum, 'id' | 'activeValue' | 'displayName' | 'key' | 'projectId' | 'tenantId'>
  & { fileMetadata: (
    { __typename: 'FileMetadataConnection' }
    & { nodes: Array<(
      { __typename: 'FileMetadatum' }
      & Pick<FileMetadatum, 'id'>
    )> }
  ), fileOutputGroupMetadata: (
    { __typename: 'FileOutputGroupMetadataConnection' }
    & { nodes: Array<(
      { __typename: 'FileOutputGroupMetadatum' }
      & Pick<FileOutputGroupMetadatum, 'id'>
    )> }
  ), metadataValues: (
    { __typename: 'MetadataValuesConnection' }
    & { nodes: Array<(
      { __typename: 'MetadataValue' }
      & Pick<MetadataValue, 'id'>
    )> }
  ), project: Maybe<(
    { __typename: 'Project' }
    & Pick<Project, 'id'>
  )>, tenant: Maybe<(
    { __typename: 'Tenant' }
    & Pick<Tenant, 'id'>
  )> }
);

export type NotificationCacheFragment = (
  { __typename: 'Notification' }
  & Pick<Notification, 'id' | 'dateCreated' | 'hasSeen' | 'userId'>
  & { user: Maybe<(
    { __typename: 'ApplicationUser' }
    & Pick<ApplicationUser, 'id'>
  )>, projectSharedNotification: Maybe<(
    { __typename: 'ProjectSharedNotification' }
    & Pick<ProjectSharedNotification, 'id'>
  )>, projectSharedNotifications: (
    { __typename: 'ProjectSharedNotificationsConnection' }
    & { nodes: Array<(
      { __typename: 'ProjectSharedNotification' }
      & Pick<ProjectSharedNotification, 'id'>
    )> }
  ), tenantMembershipNotification: Maybe<(
    { __typename: 'TenantUserMembershipNotification' }
    & Pick<TenantUserMembershipNotification, 'id'>
  )>, tenantMembershipNotifications: (
    { __typename: 'TenantUserMembershipNotificationsConnection' }
    & { nodes: Array<(
      { __typename: 'TenantUserMembershipNotification' }
      & Pick<TenantUserMembershipNotification, 'id'>
    )> }
  ), fileProcessingNotifications: (
    { __typename: 'FileProcessingNotificationsConnection' }
    & { nodes: Array<(
      { __typename: 'FileProcessingNotification' }
      & Pick<FileProcessingNotification, 'id'>
    )> }
  ), fileProcessingNotification: Maybe<(
    { __typename: 'FileProcessingNotification' }
    & Pick<FileProcessingNotification, 'id'>
  )>, roleChangeNotifications: (
    { __typename: 'RoleChangeNotificationsConnection' }
    & { nodes: Array<(
      { __typename: 'RoleChangeNotification' }
      & Pick<RoleChangeNotification, 'id'>
    )> }
  ), roleChangeNotification: Maybe<(
    { __typename: 'RoleChangeNotification' }
    & Pick<RoleChangeNotification, 'id'>
  )>, projectClonedNotifications: (
    { __typename: 'ProjectClonedNotificationsConnection' }
    & { nodes: Array<(
      { __typename: 'ProjectClonedNotification' }
      & Pick<ProjectClonedNotification, 'id'>
    )> }
  ), projectClonedNotification: Maybe<(
    { __typename: 'ProjectClonedNotification' }
    & Pick<ProjectClonedNotification, 'id'>
  )> }
);

export type ProjectCacheFragment = (
  { __typename: 'Project' }
  & Pick<Project, 'cloneSourceId' | 'id' | 'key' | 'name' | 'shortDescription' | 'status' | 'iconText' | 'iconColor' | 'icon' | 'description' | 'dateDeleted' | 'dateDataDeleted' | 'dateCreated' | 'dateArchived' | 'archivedStorageSize' | 'activeStorageSize' | 'tenantId' | 'prefix' | 'userId' | 'defaultUserAccessLevel' | 'usedCredits' | 'pinned' | 'dateLastActive'>
  & { tenant: Maybe<(
    { __typename: 'Tenant' }
    & Pick<Tenant, 'id'>
  )>, activeFiles: (
    { __typename: 'FilesConnection' }
    & { nodes: Array<(
      { __typename: 'File' }
      & Pick<File, 'id'>
    )> }
  ), user: Maybe<(
    { __typename: 'ApplicationUser' }
    & Pick<ApplicationUser, 'id'>
  )>, files: (
    { __typename: 'FilesConnection' }
    & { nodes: Array<(
      { __typename: 'File' }
      & Pick<File, 'id'>
    )> }
  ), tasks: (
    { __typename: 'TasksConnection' }
    & { nodes: Array<(
      { __typename: 'Task' }
      & Pick<Task, 'id'>
    )> }
  ), fileActivities: (
    { __typename: 'FileActivitiesConnection' }
    & { nodes: Array<(
      { __typename: 'FileActivity' }
      & Pick<FileActivity, 'id'>
    )> }
  ), fileMetadata: (
    { __typename: 'FileMetadataConnection' }
    & { nodes: Array<(
      { __typename: 'FileMetadatum' }
      & Pick<FileMetadatum, 'id'>
    )> }
  ), fileOutputGroupMetadata: (
    { __typename: 'FileOutputGroupMetadataConnection' }
    & { nodes: Array<(
      { __typename: 'FileOutputGroupMetadatum' }
      & Pick<FileOutputGroupMetadatum, 'id'>
    )> }
  ), fileOutputGroups: (
    { __typename: 'FileOutputGroupsConnection' }
    & { nodes: Array<(
      { __typename: 'FileOutputGroup' }
      & Pick<FileOutputGroup, 'id'>
    )> }
  ), metadata: (
    { __typename: 'MetadataConnection' }
    & { nodes: Array<(
      { __typename: 'Metadatum' }
      & Pick<Metadatum, 'id'>
    )> }
  ), metadataValues: (
    { __typename: 'MetadataValuesConnection' }
    & { nodes: Array<(
      { __typename: 'MetadataValue' }
      & Pick<MetadataValue, 'id'>
    )> }
  ), outputGroupFiles: (
    { __typename: 'OutputGroupFilesConnection' }
    & { nodes: Array<(
      { __typename: 'OutputGroupFile' }
      & Pick<OutputGroupFile, 'id'>
    )> }
  ), projectSharedNotifications: (
    { __typename: 'ProjectSharedNotificationsConnection' }
    & { nodes: Array<(
      { __typename: 'ProjectSharedNotification' }
      & Pick<ProjectSharedNotification, 'id'>
    )> }
  ), projectByCloneSourceId: Maybe<(
    { __typename: 'Project' }
    & Pick<Project, 'id'>
  )>, projectClonedNotifications: (
    { __typename: 'ProjectClonedNotificationsConnection' }
    & { nodes: Array<(
      { __typename: 'ProjectClonedNotification' }
      & Pick<ProjectClonedNotification, 'id'>
    )> }
  ), projectClonedNotificationsBySrcProjectId: (
    { __typename: 'ProjectClonedNotificationsConnection' }
    & { nodes: Array<(
      { __typename: 'ProjectClonedNotification' }
      & Pick<ProjectClonedNotification, 'id'>
    )> }
  ), projectTags: (
    { __typename: 'ProjectTagsConnection' }
    & { nodes: Array<(
      { __typename: 'ProjectTag' }
      & Pick<ProjectTag, 'id'>
    )> }
  ) }
);

export type AvatarFieldsFragment = (
  { __typename: 'Avatar' }
  & Pick<Avatar, 'id' | 'color' | 'initials' | 'useImage' | 'imageBase64'>
);

export type FileFieldsFragment = (
  { __typename: 'File' }
  & Pick<File, 'id' | 'referenceId' | 'dateArchived' | 'dateCreated' | 'dateDataDeleted' | 'dateDeleted' | 'fileType' | 'tags' | 'fileFormat' | 'fileStructure' | 'key' | 'location' | 'multipartUploadId' | 'name' | 'parentIds' | 'partSize' | 'projectId' | 'signal' | 'size' | 'status' | 'source' | 'tenantId' | 'uploadStatus' | 'userId' | 'originalName' | 'seriesParentId' | 'isSeries' | 'seriesOrder' | 'processingStatus'>
);

export type MetadataValueFieldsFragment = (
  { __typename: 'MetadataValue' }
  & Pick<MetadataValue, 'id' | 'value' | 'dateCreated' | 'metadataId' | 'taskId' | 'userId' | 'tenantId' | 'projectId'>
);

export type MetadatumFieldsFragment = (
  { __typename: 'Metadatum' }
  & Pick<Metadatum, 'id' | 'key' | 'displayName' | 'tenantId'>
);

export type FileOutputGroupFieldsFragment = (
  { __typename: 'FileOutputGroup' }
  & Pick<FileOutputGroup, 'id' | 'dateCreated' | 'taskId' | 'tenantId' | 'userId' | 'groupType'>
);

export type ProjectFieldsFragment = (
  { __typename: 'Project' }
  & Pick<Project, 'id' | 'key' | 'name' | 'shortDescription' | 'description' | 'icon' | 'iconColor' | 'iconText' | 'isDemo' | 'dateCreated' | 'tenantId' | 'userId' | 'dateArchived' | 'dateDeleted' | 'dateDataDeleted' | 'status' | 'activeStorageSize' | 'archivedStorageSize' | 'defaultUserAccessLevel' | 'pinned' | 'usedCredits' | 'dateLastActive'>
);

export type TaskFieldsFragment = (
  { __typename: 'Task' }
  & Pick<Task, 'id' | 'taskParameters' | 'toolExitcode' | 'toolExitcodeDescription' | 'dateCreated' | 'tenantId' | 'toolVersionId' | 'userId' | 'status' | 'credits' | 'cloned' | 'projectId'>
);

export type TenantContractAllowanceFieldsFragment = (
  { __typename: 'TenantContractAllowance' }
  & Pick<TenantContractAllowance, 'id' | 'quotaType' | 'value'>
);

export type TenantContractFieldsFragment = (
  { __typename: 'TenantContract' }
  & Pick<TenantContract, 'id' | 'name' | 'dateCreated' | 'startDate' | 'endDate'>
);

export type TenantFieldsFragment = (
  { __typename: 'Tenant' }
  & Pick<Tenant, 'id' | 'name' | 'key'>
);

export type ToolFieldsFragment = (
  { __typename: 'Tool' }
  & Pick<Tool, 'id' | 'name' | 'key' | 'helpText' | 'dateCreated'>
);

export type ToolParameterFieldsFragment = (
  { __typename: 'ToolParameter' }
  & Pick<ToolParameter, 'id' | 'name' | 'toolVersionId' | 'helpText' | 'default' | 'options' | 'unit' | 'key'>
);

export type ToolSourceFieldsFragment = (
  { __typename: 'ToolSource' }
  & Pick<ToolSource, 'id' | 'key' | 'name' | 'toolVersionId' | 'required' | 'helpText'>
);

export type ToolVersionFieldsFragment = (
  { __typename: 'ToolVersion' }
  & Pick<ToolVersion, 'id' | 'version' | 'dateCreated' | 'status' | 'maturity' | 'credits'>
  & { tool: Maybe<(
    { __typename: 'Tool' }
    & Pick<Tool, 'id' | 'name' | 'key' | 'helpText' | 'dateCreated'>
  )> }
);

export type UserFieldsFragment = (
  { __typename: 'ApplicationUser' }
  & Pick<ApplicationUser, 'id' | 'username' | 'firstName' | 'lastName' | 'email' | 'internal' | 'isActive'>
);

export type UserMetadatumFieldsFragment = (
  { __typename: 'ApplicationUserMetadatum' }
  & Pick<ApplicationUserMetadatum, 'id' | 'userId' | 'key' | 'value'>
);

export type UserSessionFieldsFragment = (
  { __typename: 'ApplicationUserSession' }
  & Pick<ApplicationUserSession, 'id' | 'userId' | 'tenantId' | 'active' | 'lastPath' | 'state' | 'datetimeLastActive'>
);

export type CreateMetadataValueMutationVariables = Exact<{
  metadataValue: MetadataValueInput;
}>;


export type CreateMetadataValueMutation = (
  { __typename: 'Mutation' }
  & { createMetadataValue: Maybe<(
    { __typename: 'CreateMetadataValuePayload' }
    & Pick<CreateMetadataValuePayload, 'clientMutationId'>
    & { metadataValue: Maybe<(
      { __typename: 'MetadataValue' }
      & Pick<MetadataValue, 'id' | 'value' | 'dateCreated' | 'metadataId' | 'taskId' | 'userId' | 'tenantId' | 'projectId'>
    )> }
  )> }
);

export type CreateMetadatumMutationVariables = Exact<{
  metadata: MetadatumInput;
}>;


export type CreateMetadatumMutation = (
  { __typename: 'Mutation' }
  & { createMetadata: Maybe<(
    { __typename: 'CreateMetadatumPayload' }
    & Pick<CreateMetadatumPayload, 'clientMutationId'>
    & { metadata: Maybe<(
      { __typename: 'Metadatum' }
      & Pick<Metadatum, 'id' | 'key' | 'displayName' | 'tenantId'>
    )> }
  )> }
);

export type CreateUserMetadatumMutationVariables = Exact<{
  userMetadatum: ApplicationUserMetadatumInput;
}>;


export type CreateUserMetadatumMutation = (
  { __typename: 'Mutation' }
  & { createUserMetadatum: Maybe<(
    { __typename: 'CreateApplicationUserMetadatumPayload' }
    & Pick<CreateApplicationUserMetadatumPayload, 'clientMutationId'>
    & { userMetadatum: Maybe<(
      { __typename: 'ApplicationUserMetadatum' }
      & Pick<ApplicationUserMetadatum, 'id' | 'userId' | 'key' | 'value'>
    )> }
  )> }
);

export type CreateUserSessionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  userid: Scalars['UUID']['input'];
  tenant?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateUserSessionMutation = (
  { __typename: 'Mutation' }
  & { createUserSession: Maybe<(
    { __typename: 'CreateSessionPayload' }
    & Pick<CreateSessionPayload, 'clientMutationId'>
    & { userSession: Maybe<(
      { __typename: 'ApplicationUserSession' }
      & Pick<ApplicationUserSession, 'id' | 'userId' | 'tenantId' | 'active' | 'lastPath' | 'state' | 'datetimeLastActive'>
    )> }
  )> }
);

export type UpdateApplicationUserByIdMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  patch: ApplicationUserPatch;
}>;


export type UpdateApplicationUserByIdMutation = (
  { __typename: 'Mutation' }
  & { updateApplicationUserById: Maybe<(
    { __typename: 'UpdateApplicationUserPayload' }
    & Pick<UpdateApplicationUserPayload, 'clientMutationId'>
    & { applicationUser: Maybe<(
      { __typename: 'ApplicationUser' }
      & Pick<ApplicationUser, 'id' | 'username' | 'firstName' | 'lastName' | 'email' | 'internal' | 'isActive'>
      & { metadata: (
        { __typename: 'ApplicationUserMetadataConnection' }
        & { nodes: Array<(
          { __typename: 'ApplicationUserMetadatum' }
          & Pick<ApplicationUserMetadatum, 'id' | 'userId' | 'key' | 'value'>
        )> }
      ) }
    )> }
  )> }
);

export type UpdateAvatarByIdMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  patch: AvatarPatch;
}>;


export type UpdateAvatarByIdMutation = (
  { __typename: 'Mutation' }
  & { updateAvatarById: Maybe<(
    { __typename: 'UpdateAvatarPayload' }
    & Pick<UpdateAvatarPayload, 'clientMutationId'>
    & { avatar: Maybe<(
      { __typename: 'Avatar' }
      & Pick<Avatar, 'id' | 'color' | 'initials' | 'useImage' | 'imageBase64'>
    )> }
  )> }
);

export type UpdateUserMetadatumByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  patch: ApplicationUserMetadatumPatch;
}>;


export type UpdateUserMetadatumByIdMutation = (
  { __typename: 'Mutation' }
  & { updateUserMetadatumById: Maybe<(
    { __typename: 'UpdateApplicationUserMetadatumPayload' }
    & Pick<UpdateApplicationUserMetadatumPayload, 'clientMutationId'>
    & { userMetadatum: Maybe<(
      { __typename: 'ApplicationUserMetadatum' }
      & Pick<ApplicationUserMetadatum, 'id' | 'userId' | 'key' | 'value'>
    )> }
  )> }
);

export type GetAllTasksQueryVariables = Exact<{
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
}>;


export type GetAllTasksQuery = (
  { __typename: 'Query' }
  & { tasks: Maybe<(
    { __typename: 'TasksConnection' }
    & { nodes: Array<(
      { __typename: 'Task' }
      & Pick<Task, 'id' | 'taskParameters' | 'toolExitcode' | 'toolExitcodeDescription' | 'dateCreated' | 'tenantId' | 'toolVersionId' | 'userId' | 'status' | 'credits' | 'cloned' | 'projectId'>
      & { toolVersion: Maybe<(
        { __typename: 'ToolVersion' }
        & Pick<ToolVersion, 'id' | 'version' | 'dateCreated' | 'status' | 'maturity' | 'credits'>
        & { tool: Maybe<(
          { __typename: 'Tool' }
          & Pick<Tool, 'id' | 'name' | 'key' | 'helpText' | 'dateCreated'>
        )> }
      )>, outputGroup: Maybe<(
        { __typename: 'FileOutputGroup' }
        & Pick<FileOutputGroup, 'id' | 'dateCreated' | 'taskId' | 'tenantId' | 'userId' | 'groupType'>
        & { task: Maybe<(
          { __typename: 'Task' }
          & Pick<Task, 'id' | 'status' | 'dateCreated'>
        )>, outputGroupFiles: (
          { __typename: 'OutputGroupFilesConnection' }
          & { nodes: Array<(
            { __typename: 'OutputGroupFile' }
            & Pick<OutputGroupFile, 'id'>
            & { drsFile: Maybe<(
              { __typename: 'File' }
              & Pick<File, 'id' | 'referenceId' | 'dateArchived' | 'dateCreated' | 'dateDataDeleted' | 'dateDeleted' | 'fileFormat' | 'fileStructure' | 'fileType' | 'tags' | 'key' | 'isSeries' | 'location' | 'multipartUploadId' | 'name' | 'parentIds' | 'partSize' | 'preview' | 'projectId' | 'signal' | 'size' | 'status' | 'source' | 'tenantId' | 'uploadStatus' | 'userId' | 'originalName' | 'seriesParentId' | 'seriesOrder' | 'processingStatus'>
              & { fileMetadata: (
                { __typename: 'FileMetadataConnection' }
                & { nodes: Array<(
                  { __typename: 'FileMetadatum' }
                  & Pick<FileMetadatum, 'id'>
                  & { metadata: Maybe<(
                    { __typename: 'Metadatum' }
                    & Pick<Metadatum, 'id' | 'key' | 'activeValue'>
                  )> }
                )> }
              ), fileBySeriesParentId: Maybe<(
                { __typename: 'File' }
                & Pick<File, 'id'>
              )>, seriesFiles: (
                { __typename: 'FilesConnection' }
                & { nodes: Array<(
                  { __typename: 'File' }
                  & Pick<File, 'id'>
                )> }
              ), taskSources: (
                { __typename: 'TaskSourcesConnection' }
                & { nodes: Array<(
                  { __typename: 'TaskSource' }
                  & Pick<TaskSource, 'id'>
                )> }
              ), tenant: Maybe<(
                { __typename: 'Tenant' }
                & Pick<Tenant, 'id'>
              )>, user: Maybe<(
                { __typename: 'ApplicationUser' }
                & Pick<ApplicationUser, 'id'>
              )>, fileActivities: (
                { __typename: 'FileActivitiesConnection' }
                & { nodes: Array<(
                  { __typename: 'FileActivity' }
                  & Pick<FileActivity, 'id'>
                )> }
              ), project: Maybe<(
                { __typename: 'Project' }
                & Pick<Project, 'id'>
              )>, outputGroupFiles: (
                { __typename: 'OutputGroupFilesConnection' }
                & { nodes: Array<(
                  { __typename: 'OutputGroupFile' }
                  & Pick<OutputGroupFile, 'id'>
                )> }
              ), fileProcessingNotifications: (
                { __typename: 'FileProcessingNotificationsConnection' }
                & { nodes: Array<(
                  { __typename: 'FileProcessingNotification' }
                  & Pick<FileProcessingNotification, 'id'>
                )> }
              ) }
            )> }
          )> }
        ), metadata: (
          { __typename: 'FileOutputGroupMetadataConnection' }
          & { nodes: Array<(
            { __typename: 'FileOutputGroupMetadatum' }
            & Pick<FileOutputGroupMetadatum, 'id'>
            & { metadatum: Maybe<(
              { __typename: 'Metadatum' }
              & Pick<Metadatum, 'id' | 'key' | 'displayName' | 'tenantId'>
              & { values: (
                { __typename: 'MetadataValuesConnection' }
                & { nodes: Array<(
                  { __typename: 'MetadataValue' }
                  & Pick<MetadataValue, 'id' | 'value' | 'dateCreated' | 'metadataId' | 'taskId' | 'userId' | 'tenantId' | 'projectId'>
                )> }
              ) }
            )> }
          )> }
        ) }
      )>, user: Maybe<(
        { __typename: 'ApplicationUser' }
        & Pick<ApplicationUser, 'id' | 'username' | 'firstName' | 'lastName' | 'email' | 'internal' | 'isActive'>
      )>, taskActivityByTaskId: Maybe<(
        { __typename: 'TaskActivity' }
        & Pick<TaskActivity, 'id'>
        & { duration: (
          { __typename: 'Interval' }
          & Pick<Interval, 'hours' | 'seconds' | 'minutes' | 'days' | 'years' | 'months'>
        ) }
      )>, taskResourcesByTaskId: (
        { __typename: 'TaskResourcesConnection' }
        & { nodes: Array<(
          { __typename: 'TaskResource' }
          & Pick<TaskResource, 'id' | 'type' | 'value'>
        )> }
      ) }
    )> }
  )> }
);

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = (
  { __typename: 'Query' }
  & { currentUser: Maybe<(
    { __typename: 'ApplicationUser' }
    & Pick<ApplicationUser, 'id' | 'username' | 'firstName' | 'lastName' | 'email' | 'internal' | 'isActive'>
    & { metadata: (
      { __typename: 'ApplicationUserMetadataConnection' }
      & { nodes: Array<(
        { __typename: 'ApplicationUserMetadatum' }
        & Pick<ApplicationUserMetadatum, 'id' | 'userId' | 'key' | 'value'>
      )> }
    ), memberships: (
      { __typename: 'ApplicationUserMembershipsConnection' }
      & { nodes: Array<(
        { __typename: 'ApplicationUserMembership' }
        & Pick<ApplicationUserMembership, 'id'>
        & { tenant: Maybe<(
          { __typename: 'Tenant' }
          & Pick<Tenant, 'id' | 'name' | 'key'>
        )> }
      )> }
    ) }
  )> }
);

export type GetFileMetadataByFileIdQueryVariables = Exact<{
  drsFileId: Scalars['UUID']['input'];
  metadataFilter?: InputMaybe<FileMetadatumFilter>;
}>;


export type GetFileMetadataByFileIdQuery = (
  { __typename: 'Query' }
  & { drsFile: Maybe<(
    { __typename: 'File' }
    & Pick<File, 'id'>
    & { metadata: (
      { __typename: 'FileMetadataConnection' }
      & { nodes: Array<(
        { __typename: 'FileMetadatum' }
        & Pick<FileMetadatum, 'id'>
        & { metadatum: Maybe<(
          { __typename: 'Metadatum' }
          & Pick<Metadatum, 'activeValue' | 'id' | 'key' | 'displayName' | 'tenantId'>
        )> }
      )> }
    ), seriesParentFile: Maybe<(
      { __typename: 'File' }
      & Pick<File, 'id'>
      & { metadata: (
        { __typename: 'FileMetadataConnection' }
        & { nodes: Array<(
          { __typename: 'FileMetadatum' }
          & Pick<FileMetadatum, 'id'>
          & { metadatum: Maybe<(
            { __typename: 'Metadatum' }
            & Pick<Metadatum, 'activeValue' | 'id' | 'key' | 'displayName' | 'tenantId'>
          )> }
        )> }
      ) }
    )> }
  )> }
);

export type GetProjectByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetProjectByIdQuery = (
  { __typename: 'Query' }
  & { projectById: Maybe<(
    { __typename: 'Project' }
    & Pick<Project, 'id' | 'key' | 'name' | 'shortDescription' | 'description' | 'icon' | 'iconColor' | 'iconText' | 'isDemo' | 'dateCreated' | 'tenantId' | 'userId' | 'dateArchived' | 'dateDeleted' | 'dateDataDeleted' | 'status' | 'activeStorageSize' | 'archivedStorageSize' | 'defaultUserAccessLevel' | 'pinned' | 'usedCredits' | 'dateLastActive'>
  )> }
);

export type GetTaskByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTaskByIdQuery = (
  { __typename: 'Query' }
  & { task: Maybe<(
    { __typename: 'Task' }
    & Pick<Task, 'id' | 'taskParameters' | 'toolExitcode' | 'toolExitcodeDescription' | 'dateCreated' | 'tenantId' | 'toolVersionId' | 'userId' | 'status' | 'credits' | 'cloned' | 'projectId'>
  )> }
);

export type GetUserSessionByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetUserSessionByIdQuery = (
  { __typename: 'Query' }
  & { userSession: Maybe<(
    { __typename: 'ApplicationUserSession' }
    & Pick<ApplicationUserSession, 'id' | 'userId' | 'tenantId' | 'active' | 'lastPath' | 'state' | 'datetimeLastActive'>
  )> }
);

export type ExportToDandiToolInfoQueryVariables = Exact<{
  activeStatus?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ExportToDandiToolInfoQuery = (
  { __typename: 'Query' }
  & { allTools: Maybe<(
    { __typename: 'ToolsConnection' }
    & { nodes: Array<(
      { __typename: 'Tool' }
      & Pick<Tool, 'id'>
      & { toolVersions: (
        { __typename: 'ToolVersionsConnection' }
        & { nodes: Array<(
          { __typename: 'ToolVersion' }
          & Pick<ToolVersion, 'id'>
          & { toolSources: (
            { __typename: 'ToolSourcesConnection' }
            & { nodes: Array<(
              { __typename: 'ToolSource' }
              & Pick<ToolSource, 'id' | 'key'>
            )> }
          ), toolParameters: (
            { __typename: 'ToolParametersConnection' }
            & { nodes: Array<(
              { __typename: 'ToolParameter' }
              & Pick<ToolParameter, 'id' | 'key'>
            )> }
          ), toolSecrets: (
            { __typename: 'ToolSecretsConnection' }
            & { nodes: Array<(
              { __typename: 'ToolSecret' }
              & Pick<ToolSecret, 'id' | 'key'>
            )> }
          ) }
        )> }
      ) }
    )> }
  )> }
);

export type GetProcessingStatusQueryVariables = Exact<{
  drsFileIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GetProcessingStatusQuery = (
  { __typename: 'Query' }
  & { files: Maybe<(
    { __typename: 'FilesConnection' }
    & { nodes: Array<(
      { __typename: 'File' }
      & Pick<File, 'id' | 'processingStatus'>
    )> }
  )> }
);

export type ProcessingStatusFragment = (
  { __typename: 'File' }
  & Pick<File, 'id' | 'processingStatus' | 'isSeries'>
);

export type GetExternalTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalTenantsQuery = (
  { __typename: 'Query' }
  & { currentUser: Maybe<(
    { __typename: 'ApplicationUser' }
    & Pick<ApplicationUser, 'id'>
    & { memberships: (
      { __typename: 'ApplicationUserMembershipsConnection' }
      & { nodes: Array<(
        { __typename: 'ApplicationUserMembership' }
        & Pick<ApplicationUserMembership, 'id'>
        & { tenant: Maybe<(
          { __typename: 'Tenant' }
          & Pick<Tenant, 'id' | 'key' | 'name' | 'tenantType'>
        )> }
      )> }
    ) }
  )> }
);

export type GetFileProcessTasksQueryVariables = Exact<{
  drsFileId: Scalars['UUID']['input'];
  failedStatuses: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetFileProcessTasksQuery = (
  { __typename: 'Query' }
  & { file: Maybe<(
    { __typename: 'File' }
    & Pick<File, 'id'>
    & { taskSources: (
      { __typename: 'TaskSourcesConnection' }
      & { nodes: Array<(
        { __typename: 'TaskSource' }
        & Pick<TaskSource, 'id'>
        & { task: Maybe<(
          { __typename: 'Task' }
          & Pick<Task, 'id' | 'status' | 'errorDescription' | 'dateCreated'>
          & { toolVersion: Maybe<(
            { __typename: 'ToolVersion' }
            & Pick<ToolVersion, 'id'>
            & { tool: Maybe<(
              { __typename: 'Tool' }
              & Pick<Tool, 'id' | 'name' | 'key'>
            )> }
          )> }
        )> }
      )> }
    ) }
  )> }
);

export type CellEditorFileQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type CellEditorFileQuery = (
  { __typename: 'Query' }
  & { project: Maybe<(
    { __typename: 'Project' }
    & Pick<Project, 'id' | 'isToolProject'>
    & { files: (
      { __typename: 'FilesConnection' }
      & { nodes: Array<(
        { __typename: 'File' }
        & Pick<File, 'id' | 'referenceId' | 'name' | 'fileType' | 'tags' | 'source' | 'isSeries' | 'originalName' | 'status' | 'fileFormat' | 'processingStatus' | 'seriesParentId' | 'projectId'>
        & { seriesFiles: (
          { __typename: 'FilesConnection' }
          & { nodes: Array<(
            { __typename: 'File' }
            & Pick<File, 'id' | 'name'>
          )> }
        ) }
      )> }
    ) }
  )> }
);

export type CellEditorToolVersionQueryVariables = Exact<{
  toolVersionId: Scalars['Int']['input'];
}>;


export type CellEditorToolVersionQuery = (
  { __typename: 'Query' }
  & { toolVersion: Maybe<(
    { __typename: 'ToolVersion' }
    & Pick<ToolVersion, 'id'>
    & { compatibleVersions: (
      { __typename: 'ToolVersionsConnection' }
      & { nodes: Array<(
        { __typename: 'ToolVersion' }
        & Pick<ToolVersion, 'id' | 'version' | 'toolSpec' | 'credits' | 'status'>
      )> }
    ) }
  )> }
);

export type CellValueRendererFileFieldsFragment = (
  { __typename: 'File' }
  & Pick<File, 'id' | 'name' | 'originalName' | 'status' | 'fileFormat' | 'fileType' | 'tags' | 'isSeries' | 'source' | 'processingStatus' | 'seriesParentId' | 'projectId' | 'referenceId'>
);

export type DataTableUpgradeButtonQueryVariables = Exact<{
  toolVersionId: Scalars['Int']['input'];
}>;


export type DataTableUpgradeButtonQuery = (
  { __typename: 'Query' }
  & { toolVersion: Maybe<(
    { __typename: 'ToolVersion' }
    & Pick<ToolVersion, 'id'>
    & { tool: Maybe<(
      { __typename: 'Tool' }
      & Pick<Tool, 'id'>
      & { toolVersions: (
        { __typename: 'ToolVersionsConnection' }
        & { nodes: Array<(
          { __typename: 'ToolVersion' }
          & Pick<ToolVersion, 'id'>
        )> }
      ) }
    )> }
  )> }
);

export type ModalMapAnalysisParametersQueryVariables = Exact<{
  toolVersionId: Scalars['Int']['input'];
}>;


export type ModalMapAnalysisParametersQuery = (
  { __typename: 'Query' }
  & { toolVersion: Maybe<(
    { __typename: 'ToolVersion' }
    & Pick<ToolVersion, 'id' | 'toolSpec'>
  )> }
);

export type GetDrsFilesQueryVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GetDrsFilesQuery = (
  { __typename: 'Query' }
  & { drsFiles: Maybe<(
    { __typename: 'FilesConnection' }
    & { nodes: Array<(
      { __typename: 'File' }
      & Pick<File, 'id' | 'referenceId' | 'dateArchived' | 'dateCreated' | 'dateDataDeleted' | 'dateDeleted' | 'fileFormat' | 'fileStructure' | 'fileType' | 'tags' | 'key' | 'isSeries' | 'location' | 'multipartUploadId' | 'name' | 'parentIds' | 'partSize' | 'preview' | 'projectId' | 'signal' | 'size' | 'status' | 'source' | 'tenantId' | 'uploadStatus' | 'userId' | 'originalName' | 'seriesParentId' | 'seriesOrder' | 'processingStatus'>
      & { fileBySeriesParentId: Maybe<(
        { __typename: 'File' }
        & Pick<File, 'id'>
      )>, seriesFiles: (
        { __typename: 'FilesConnection' }
        & { nodes: Array<(
          { __typename: 'File' }
          & Pick<File, 'id'>
        )> }
      ), fileMetadata: (
        { __typename: 'FileMetadataConnection' }
        & { nodes: Array<(
          { __typename: 'FileMetadatum' }
          & Pick<FileMetadatum, 'id'>
        )> }
      ), taskSources: (
        { __typename: 'TaskSourcesConnection' }
        & { nodes: Array<(
          { __typename: 'TaskSource' }
          & Pick<TaskSource, 'id'>
        )> }
      ), tenant: Maybe<(
        { __typename: 'Tenant' }
        & Pick<Tenant, 'id'>
      )>, user: Maybe<(
        { __typename: 'ApplicationUser' }
        & Pick<ApplicationUser, 'id'>
      )>, fileActivities: (
        { __typename: 'FileActivitiesConnection' }
        & { nodes: Array<(
          { __typename: 'FileActivity' }
          & Pick<FileActivity, 'id'>
        )> }
      ), project: Maybe<(
        { __typename: 'Project' }
        & Pick<Project, 'id'>
      )>, outputGroupFiles: (
        { __typename: 'OutputGroupFilesConnection' }
        & { nodes: Array<(
          { __typename: 'OutputGroupFile' }
          & Pick<OutputGroupFile, 'id'>
        )> }
      ), fileProcessingNotifications: (
        { __typename: 'FileProcessingNotificationsConnection' }
        & { nodes: Array<(
          { __typename: 'FileProcessingNotification' }
          & Pick<FileProcessingNotification, 'id'>
        )> }
      ) }
    )> }
  )> }
);

export type TasksTableGdtQueryVariables = Exact<{
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
}>;


export type TasksTableGdtQuery = (
  { __typename: 'Query' }
  & { allTasks: Maybe<(
    { __typename: 'TasksConnection' }
    & { nodes: Array<(
      { __typename: 'Task' }
      & Pick<Task, 'id' | 'credits' | 'cloned' | 'status' | 'dateCreated'>
      & { analysisTableRow: (
        { __typename: 'GdtAnalysisTableRowsConnection' }
        & { nodes: Array<(
          { __typename: 'GdtAnalysisTableRow' }
          & Pick<GdtAnalysisTableRow, 'id' | 'index' | 'dateDeleted'>
          & { table: Maybe<(
            { __typename: 'GdtAnalysisTable' }
            & Pick<GdtAnalysisTable, 'id' | 'name' | 'key' | 'dateDeleted'>
          )> }
        )> }
      ), toolVersion: Maybe<(
        { __typename: 'ToolVersion' }
        & Pick<ToolVersion, 'id' | 'toolSpec' | 'visibility'>
        & { tool: Maybe<(
          { __typename: 'Tool' }
          & Pick<Tool, 'id' | 'key'>
        )> }
      )>, taskActivityByTaskId: Maybe<(
        { __typename: 'TaskActivity' }
        & Pick<TaskActivity, 'id'>
        & { duration: (
          { __typename: 'Interval' }
          & Pick<Interval, 'hours' | 'seconds' | 'minutes' | 'days' | 'years' | 'months'>
        ) }
      )>, user: Maybe<(
        { __typename: 'ApplicationUser' }
        & Pick<ApplicationUser, 'id' | 'firstName' | 'lastName'>
      )>, outputGroup: Maybe<(
        { __typename: 'FileOutputGroup' }
        & Pick<FileOutputGroup, 'id'>
        & { outputGroupFiles: (
          { __typename: 'OutputGroupFilesConnection' }
          & { nodes: Array<(
            { __typename: 'OutputGroupFile' }
            & Pick<OutputGroupFile, 'id'>
            & { drsFile: Maybe<(
              { __typename: 'File' }
              & Pick<File, 'id' | 'name' | 'isSeries' | 'status' | 'key'>
            )> }
          )> }
        ) }
      )> }
    )> }
  )> }
);

export type TenantProviderQueryVariables = Exact<{
  tenantKey: Scalars['String']['input'];
}>;


export type TenantProviderQuery = (
  { __typename: 'Query' }
  & { tenant: Maybe<(
    { __typename: 'Tenant' }
    & Pick<Tenant, 'id' | 'name' | 'key' | 'internal' | 'tenantType'>
    & { memberships: (
      { __typename: 'ApplicationUserMembershipsConnection' }
      & { nodes: Array<(
        { __typename: 'ApplicationUserMembership' }
        & Pick<ApplicationUserMembership, 'id' | 'role'>
        & { user: Maybe<(
          { __typename: 'ApplicationUser' }
          & Pick<ApplicationUser, 'id' | 'firstName' | 'lastName' | 'email' | 'username' | 'internal' | 'isActive'>
          & { avatar: Maybe<(
            { __typename: 'Avatar' }
            & Pick<Avatar, 'id' | 'color' | 'initials' | 'useImage' | 'imageBase64'>
          )>, metadata: (
            { __typename: 'ApplicationUserMetadataConnection' }
            & { nodes: Array<(
              { __typename: 'ApplicationUserMetadatum' }
              & Pick<ApplicationUserMetadatum, 'id' | 'key' | 'value'>
            )> }
          ) }
        )> }
      )> }
    ) }
  )> }
);

export type UserProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProviderQuery = (
  { __typename: 'Query' }
  & { currentUser: Maybe<(
    { __typename: 'ApplicationUser' }
    & Pick<ApplicationUser, 'id' | 'firstName' | 'lastName' | 'email' | 'username' | 'internal' | 'isActive'>
    & { metadata: (
      { __typename: 'ApplicationUserMetadataConnection' }
      & { nodes: Array<(
        { __typename: 'ApplicationUserMetadatum' }
        & Pick<ApplicationUserMetadatum, 'id' | 'key' | 'value'>
      )> }
    ), eula: (
      { __typename: 'EulaVersionUserAcceptancesConnection' }
      & { nodes: Array<(
        { __typename: 'EulaVersionUserAcceptance' }
        & Pick<EulaVersionUserAcceptance, 'id' | 'accepted'>
      )> }
    ), memberships: (
      { __typename: 'ApplicationUserMembershipsConnection' }
      & { nodes: Array<(
        { __typename: 'ApplicationUserMembership' }
        & Pick<ApplicationUserMembership, 'id' | 'role'>
        & { tenant: Maybe<(
          { __typename: 'Tenant' }
          & Pick<Tenant, 'id' | 'key' | 'name' | 'tenantType'>
        )> }
      )> }
    ), avatar: Maybe<(
      { __typename: 'Avatar' }
      & Pick<Avatar, 'id' | 'imageBase64' | 'initials' | 'useImage' | 'color'>
    )> }
  )> }
);

export const PopoverFileUploadFragmentDoc = gql`
    fragment PopoverFileUpload on File {
  id
  name
  status
  fileType
  source
  processingStatus
  seriesParentId
}
    `;
export const UserAvatarFieldsFragmentDoc = gql`
    fragment UserAvatarFields on ApplicationUser {
  id
  firstName
  lastName
  avatar: avatarByUserId {
    id
    imageBase64
    initials
    useImage
    color
  }
}
    `;
export const ApplicationUserMembershipCacheFragmentDoc = gql`
    fragment ApplicationUserMembershipCache on ApplicationUserMembership {
  id
  role
  tenantId
  userId
  user: applicationUserByUserId {
    id
  }
  tenant: tenantByTenantId {
    id
  }
}
    `;
export const FileCacheFragmentDoc = gql`
    fragment FileCache on File {
  id
  referenceId
  dateArchived
  dateCreated
  dateDataDeleted
  dateDeleted
  fileFormat
  fileStructure
  fileType
  tags
  key
  isSeries
  location
  multipartUploadId
  name
  parentIds
  partSize
  preview
  projectId
  signal
  size
  status
  source
  tenantId
  uploadStatus
  userId
  originalName
  seriesParentId
  seriesOrder
  processingStatus
  fileBySeriesParentId {
    id
  }
  seriesFiles: filesBySeriesParentId {
    nodes {
      id
    }
  }
  fileMetadata: fileMetadataByFileId {
    nodes {
      id
    }
  }
  taskSources: taskSourcesByFileId {
    nodes {
      id
    }
  }
  tenant: tenantByTenantId {
    id
  }
  user: applicationUserByUserId {
    id
  }
  fileActivities: fileActivitiesByFileId {
    nodes {
      id
    }
  }
  project: projectByProjectId {
    id
  }
  seriesFiles: filesBySeriesParentId {
    nodes {
      id
    }
  }
  user: applicationUserByUserId {
    id
  }
  outputGroupFiles: outputGroupFilesByFileId {
    nodes {
      id
    }
  }
  fileMetadata: fileMetadataByFileId {
    nodes {
      id
    }
  }
  taskSources: taskSourcesByFileId {
    nodes {
      id
    }
  }
  fileProcessingNotifications: fileProcessingNotificationsByFileId {
    nodes {
      id
    }
  }
}
    `;
export const MetadatumCacheFragmentDoc = gql`
    fragment MetadatumCache on Metadatum {
  id
  activeValue
  displayName
  fileMetadata: fileMetadataByMetadataId {
    nodes {
      id
    }
  }
  fileOutputGroupMetadata: fileOutputGroupMetadataByMetadataId {
    nodes {
      id
    }
  }
  id
  key
  metadataValues: metadataValuesByMetadataId {
    nodes {
      id
    }
  }
  project: projectByProjectId {
    id
  }
  projectId
  tenant: tenantByTenantId {
    id
  }
  tenantId
}
    `;
export const NotificationCacheFragmentDoc = gql`
    fragment NotificationCache on Notification {
  id
  dateCreated
  hasSeen
  userId
  user: applicationUserByUserId {
    id
  }
  projectSharedNotification: projectSharedNotificationById {
    id
  }
  projectSharedNotifications: projectSharedNotificationsById {
    nodes {
      id
    }
  }
  tenantMembershipNotification: tenantUserMembershipNotificationById {
    id
  }
  tenantMembershipNotifications: tenantUserMembershipNotificationsById {
    nodes {
      id
    }
  }
  fileProcessingNotifications: fileProcessingNotificationsById {
    nodes {
      id
    }
  }
  fileProcessingNotification: fileProcessingNotificationById {
    id
  }
  roleChangeNotifications: roleChangeNotificationsById {
    nodes {
      id
    }
  }
  roleChangeNotification: roleChangeNotificationById {
    id
  }
  projectClonedNotifications: projectClonedNotificationsById {
    nodes {
      id
    }
  }
  projectClonedNotification: projectClonedNotificationById {
    id
  }
}
    `;
export const ProjectCacheFragmentDoc = gql`
    fragment ProjectCache on Project {
  cloneSourceId
  id
  key
  name
  shortDescription
  status
  iconText
  iconColor
  icon
  description
  dateDeleted
  dateDataDeleted
  dateCreated
  dateArchived
  archivedStorageSize
  activeStorageSize
  tenantId
  prefix
  userId
  defaultUserAccessLevel
  usedCredits
  pinned
  dateLastActive
  tenant: tenantByTenantId {
    id
  }
  activeFiles {
    nodes {
      id
    }
  }
  user: applicationUserByUserId {
    id
  }
  files: filesByProjectId {
    nodes {
      id
    }
  }
  tasks: tasksByProjectId {
    nodes {
      id
    }
  }
  fileActivities: fileActivitiesByProjectId {
    nodes {
      id
    }
  }
  fileMetadata: fileMetadataByProjectId {
    nodes {
      id
    }
  }
  fileOutputGroupMetadata: fileOutputGroupMetadataByProjectId {
    nodes {
      id
    }
  }
  fileOutputGroups: fileOutputGroupsByProjectId {
    nodes {
      id
    }
  }
  metadata: metadataByProjectId {
    nodes {
      id
    }
  }
  metadataValues: metadataValuesByProjectId {
    nodes {
      id
    }
  }
  outputGroupFiles: outputGroupFilesByProjectId {
    nodes {
      id
    }
  }
  projectSharedNotifications: projectSharedNotificationsByProjectId {
    nodes {
      id
    }
  }
  projectByCloneSourceId {
    id
  }
  projectClonedNotifications: projectClonedNotificationsByProjectId {
    nodes {
      id
    }
  }
  projectClonedNotificationsBySrcProjectId {
    nodes {
      id
    }
  }
  projectTags: projectTagsByProjectId {
    nodes {
      id
    }
  }
}
    `;
export const AvatarFieldsFragmentDoc = gql`
    fragment AvatarFields on Avatar {
  id
  color
  initials
  useImage
  imageBase64
}
    `;
export const FileFieldsFragmentDoc = gql`
    fragment FileFields on File {
  id
  referenceId
  dateArchived
  dateCreated
  dateDataDeleted
  dateDeleted
  fileType
  tags
  fileFormat
  fileStructure
  key
  location
  multipartUploadId
  name
  parentIds
  partSize
  projectId
  signal
  size
  status
  source
  tenantId
  uploadStatus
  userId
  originalName
  seriesParentId
  isSeries
  seriesOrder
  processingStatus
  tags
}
    `;
export const MetadataValueFieldsFragmentDoc = gql`
    fragment MetadataValueFields on MetadataValue {
  id
  value
  dateCreated
  metadataId
  taskId
  userId
  tenantId
  projectId
}
    `;
export const MetadatumFieldsFragmentDoc = gql`
    fragment MetadatumFields on Metadatum {
  id
  key
  displayName
  tenantId
}
    `;
export const FileOutputGroupFieldsFragmentDoc = gql`
    fragment FileOutputGroupFields on FileOutputGroup {
  id
  dateCreated
  taskId
  tenantId
  userId
  groupType
}
    `;
export const ProjectFieldsFragmentDoc = gql`
    fragment ProjectFields on Project {
  id
  key
  name
  shortDescription
  description
  icon
  iconColor
  iconText
  isDemo
  dateCreated
  tenantId
  userId
  dateArchived
  dateDeleted
  dateDataDeleted
  status
  activeStorageSize
  archivedStorageSize
  defaultUserAccessLevel
  pinned
  usedCredits
  dateLastActive
}
    `;
export const TaskFieldsFragmentDoc = gql`
    fragment TaskFields on Task {
  id
  taskParameters
  toolExitcode
  toolExitcodeDescription
  dateCreated
  tenantId
  toolVersionId
  userId
  status
  credits
  cloned
  projectId
}
    `;
export const TenantContractAllowanceFieldsFragmentDoc = gql`
    fragment TenantContractAllowanceFields on TenantContractAllowance {
  id
  quotaType
  value
}
    `;
export const TenantContractFieldsFragmentDoc = gql`
    fragment TenantContractFields on TenantContract {
  id
  name
  dateCreated
  startDate
  endDate
}
    `;
export const TenantFieldsFragmentDoc = gql`
    fragment TenantFields on Tenant {
  id
  name
  key
}
    `;
export const ToolParameterFieldsFragmentDoc = gql`
    fragment ToolParameterFields on ToolParameter {
  id
  name
  toolVersionId
  helpText
  default
  options
  unit
  key
}
    `;
export const ToolSourceFieldsFragmentDoc = gql`
    fragment ToolSourceFields on ToolSource {
  id
  key
  name
  toolVersionId
  required
  helpText
}
    `;
export const ToolFieldsFragmentDoc = gql`
    fragment ToolFields on Tool {
  id
  name
  key
  helpText
  dateCreated
}
    `;
export const ToolVersionFieldsFragmentDoc = gql`
    fragment ToolVersionFields on ToolVersion {
  id
  version
  dateCreated
  status
  maturity
  credits
  tool: toolByToolId {
    ...ToolFields
  }
}
    ${ToolFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on ApplicationUser {
  id
  username
  firstName
  lastName
  email
  internal
  isActive
}
    `;
export const UserMetadatumFieldsFragmentDoc = gql`
    fragment UserMetadatumFields on ApplicationUserMetadatum {
  id
  userId
  key
  value
}
    `;
export const UserSessionFieldsFragmentDoc = gql`
    fragment UserSessionFields on ApplicationUserSession {
  id
  userId
  tenantId
  active
  lastPath
  state
  datetimeLastActive
}
    `;
export const ProcessingStatusFragmentDoc = gql`
    fragment ProcessingStatus on File {
  id
  processingStatus
  isSeries
}
    `;
export const CellValueRendererFileFieldsFragmentDoc = gql`
    fragment CellValueRendererFileFields on File {
  id
  name
  originalName
  status
  fileFormat
  fileType
  tags
  isSeries
  source
  processingStatus
  seriesParentId
  projectId
  referenceId
}
    `;
export const GetTaskResourceUsageByTaskIdDocument = gql`
    query GetTaskResourceUsageByTaskId($id: UUID!) {
  task: taskById(id: $id) {
    id
    resourceUsage: taskResourceUsageByTaskId {
      id
      cpuMin
      cpuMax
      memoryMin
      memoryMax
      storageMin
      storageMax
    }
    toolVersion: toolVersionByToolVersionId {
      id
      toolSpec
    }
    resourceTier
  }
}
    `;

/**
 * __useGetTaskResourceUsageByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetTaskResourceUsageByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskResourceUsageByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskResourceUsageByTaskIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskResourceUsageByTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaskResourceUsageByTaskIdQuery, GetTaskResourceUsageByTaskIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskResourceUsageByTaskIdQuery, GetTaskResourceUsageByTaskIdQueryVariables>(GetTaskResourceUsageByTaskIdDocument, options);
      }
export function useGetTaskResourceUsageByTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskResourceUsageByTaskIdQuery, GetTaskResourceUsageByTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskResourceUsageByTaskIdQuery, GetTaskResourceUsageByTaskIdQueryVariables>(GetTaskResourceUsageByTaskIdDocument, options);
        }
export type GetTaskResourceUsageByTaskIdQueryHookResult = ReturnType<typeof useGetTaskResourceUsageByTaskIdQuery>;
export type GetTaskResourceUsageByTaskIdLazyQueryHookResult = ReturnType<typeof useGetTaskResourceUsageByTaskIdLazyQuery>;
export type GetTaskResourceUsageByTaskIdQueryResult = Apollo.QueryResult<GetTaskResourceUsageByTaskIdQuery, GetTaskResourceUsageByTaskIdQueryVariables>;
export const CreateEulaVersionUserAcceptanceDocument = gql`
    mutation CreateEulaVersionUserAcceptance($input: CreateEulaVersionUserAcceptanceInput!) {
  createEulaVersionUserAcceptance(input: $input) {
    applicationUserByUserId {
      id
    }
  }
}
    `;
export type CreateEulaVersionUserAcceptanceMutationFn = Apollo.MutationFunction<CreateEulaVersionUserAcceptanceMutation, CreateEulaVersionUserAcceptanceMutationVariables>;

/**
 * __useCreateEulaVersionUserAcceptanceMutation__
 *
 * To run a mutation, you first call `useCreateEulaVersionUserAcceptanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEulaVersionUserAcceptanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEulaVersionUserAcceptanceMutation, { data, loading, error }] = useCreateEulaVersionUserAcceptanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEulaVersionUserAcceptanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateEulaVersionUserAcceptanceMutation, CreateEulaVersionUserAcceptanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEulaVersionUserAcceptanceMutation, CreateEulaVersionUserAcceptanceMutationVariables>(CreateEulaVersionUserAcceptanceDocument, options);
      }
export type CreateEulaVersionUserAcceptanceMutationHookResult = ReturnType<typeof useCreateEulaVersionUserAcceptanceMutation>;
export type CreateEulaVersionUserAcceptanceMutationResult = Apollo.MutationResult<CreateEulaVersionUserAcceptanceMutation>;
export type CreateEulaVersionUserAcceptanceMutationOptions = Apollo.BaseMutationOptions<CreateEulaVersionUserAcceptanceMutation, CreateEulaVersionUserAcceptanceMutationVariables>;
export const GetAllEulaVersionsDocument = gql`
    query GetAllEulaVersions {
  allEulaVersions(first: 1, orderBy: VERSION_DESC) {
    nodes {
      id
      content
    }
  }
}
    `;

/**
 * __useGetAllEulaVersionsQuery__
 *
 * To run a query within a React component, call `useGetAllEulaVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEulaVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEulaVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEulaVersionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEulaVersionsQuery, GetAllEulaVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEulaVersionsQuery, GetAllEulaVersionsQueryVariables>(GetAllEulaVersionsDocument, options);
      }
export function useGetAllEulaVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEulaVersionsQuery, GetAllEulaVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEulaVersionsQuery, GetAllEulaVersionsQueryVariables>(GetAllEulaVersionsDocument, options);
        }
export type GetAllEulaVersionsQueryHookResult = ReturnType<typeof useGetAllEulaVersionsQuery>;
export type GetAllEulaVersionsLazyQueryHookResult = ReturnType<typeof useGetAllEulaVersionsLazyQuery>;
export type GetAllEulaVersionsQueryResult = Apollo.QueryResult<GetAllEulaVersionsQuery, GetAllEulaVersionsQueryVariables>;
export const FileBrowserDetailRendererAnalysisResultDocument = gql`
    query FileBrowserDetailRendererAnalysisResult($drsFileId: UUID!) {
  drsFile: fileById(id: $drsFileId) {
    id
    project: projectByProjectId {
      id
      key
    }
    outputGroupFiles: outputGroupFilesByFileId {
      nodes {
        id
        fileOutputGroup: fileOutputGroupByFileOutputGroupId {
          id
          task: taskByTaskId {
            id
            userId
            status
            dateCreated
            analysisTableRow: gdtAnalysisTableRowsByTaskId {
              nodes {
                id
                analysisTable: gdtAnalysisTableByTableId {
                  id
                  name
                  key
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFileBrowserDetailRendererAnalysisResultQuery__
 *
 * To run a query within a React component, call `useFileBrowserDetailRendererAnalysisResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileBrowserDetailRendererAnalysisResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileBrowserDetailRendererAnalysisResultQuery({
 *   variables: {
 *      drsFileId: // value for 'drsFileId'
 *   },
 * });
 */
export function useFileBrowserDetailRendererAnalysisResultQuery(baseOptions: Apollo.QueryHookOptions<FileBrowserDetailRendererAnalysisResultQuery, FileBrowserDetailRendererAnalysisResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileBrowserDetailRendererAnalysisResultQuery, FileBrowserDetailRendererAnalysisResultQueryVariables>(FileBrowserDetailRendererAnalysisResultDocument, options);
      }
export function useFileBrowserDetailRendererAnalysisResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileBrowserDetailRendererAnalysisResultQuery, FileBrowserDetailRendererAnalysisResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileBrowserDetailRendererAnalysisResultQuery, FileBrowserDetailRendererAnalysisResultQueryVariables>(FileBrowserDetailRendererAnalysisResultDocument, options);
        }
export type FileBrowserDetailRendererAnalysisResultQueryHookResult = ReturnType<typeof useFileBrowserDetailRendererAnalysisResultQuery>;
export type FileBrowserDetailRendererAnalysisResultLazyQueryHookResult = ReturnType<typeof useFileBrowserDetailRendererAnalysisResultLazyQuery>;
export type FileBrowserDetailRendererAnalysisResultQueryResult = Apollo.QueryResult<FileBrowserDetailRendererAnalysisResultQuery, FileBrowserDetailRendererAnalysisResultQueryVariables>;
export const FlyoutDrsFileInfoDocument = gql`
    query FlyoutDrsFileInfo($drsFileId: UUID!) {
  drsFile: fileById(id: $drsFileId) {
    ...FileFields
    preview
    seriesFiles: filesBySeriesParentId(orderBy: [SERIES_ORDER_ASC, NAME_ASC]) {
      nodes {
        ...FileFields
        preview
      }
    }
    outputGroupFiles: outputGroupFilesByFileId {
      nodes {
        id
        outputGroup: fileOutputGroupByFileOutputGroupId {
          id
          task: taskByTaskId {
            id
            userId
            status
            dateCreated
            analysisTableRow: gdtAnalysisTableRowsByTaskId {
              nodes {
                id
                analysisTable: gdtAnalysisTableByTableId {
                  id
                  name
                  key
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useFlyoutDrsFileInfoQuery__
 *
 * To run a query within a React component, call `useFlyoutDrsFileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlyoutDrsFileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlyoutDrsFileInfoQuery({
 *   variables: {
 *      drsFileId: // value for 'drsFileId'
 *   },
 * });
 */
export function useFlyoutDrsFileInfoQuery(baseOptions: Apollo.QueryHookOptions<FlyoutDrsFileInfoQuery, FlyoutDrsFileInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlyoutDrsFileInfoQuery, FlyoutDrsFileInfoQueryVariables>(FlyoutDrsFileInfoDocument, options);
      }
export function useFlyoutDrsFileInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlyoutDrsFileInfoQuery, FlyoutDrsFileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlyoutDrsFileInfoQuery, FlyoutDrsFileInfoQueryVariables>(FlyoutDrsFileInfoDocument, options);
        }
export type FlyoutDrsFileInfoQueryHookResult = ReturnType<typeof useFlyoutDrsFileInfoQuery>;
export type FlyoutDrsFileInfoLazyQueryHookResult = ReturnType<typeof useFlyoutDrsFileInfoLazyQuery>;
export type FlyoutDrsFileInfoQueryResult = Apollo.QueryResult<FlyoutDrsFileInfoQuery, FlyoutDrsFileInfoQueryVariables>;
export const FlyoutFilesGdtDocument = gql`
    query FlyoutFilesGDT($projectKey: String!, $tenantId: Int!) {
  project: projectByKeyAndTenantId(key: $projectKey, tenantId: $tenantId) {
    id
    key
    name
    tenantId
    files: filesByProjectId {
      nodes {
        ...CellValueRendererFileFields
        id
        name
        fileType
        fileFormat
        fileStructure
        status
        dateCreated
        uploadStatus
        projectId
        size
        seriesParentId
        processingStatus
        fileFormat
        originalName
        source
        isSeries
        tags
        seriesFiles: filesBySeriesParentId {
          nodes {
            id
            name
            fileType
            fileFormat
            fileStructure
            status
            dateCreated
            uploadStatus
            projectId
            size
            seriesParentId
            processingStatus
            fileFormat
            originalName
            tags
          }
        }
        user: applicationUserByUserId {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    ${CellValueRendererFileFieldsFragmentDoc}`;

/**
 * __useFlyoutFilesGdtQuery__
 *
 * To run a query within a React component, call `useFlyoutFilesGdtQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlyoutFilesGdtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlyoutFilesGdtQuery({
 *   variables: {
 *      projectKey: // value for 'projectKey'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useFlyoutFilesGdtQuery(baseOptions: Apollo.QueryHookOptions<FlyoutFilesGdtQuery, FlyoutFilesGdtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlyoutFilesGdtQuery, FlyoutFilesGdtQueryVariables>(FlyoutFilesGdtDocument, options);
      }
export function useFlyoutFilesGdtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlyoutFilesGdtQuery, FlyoutFilesGdtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlyoutFilesGdtQuery, FlyoutFilesGdtQueryVariables>(FlyoutFilesGdtDocument, options);
        }
export type FlyoutFilesGdtQueryHookResult = ReturnType<typeof useFlyoutFilesGdtQuery>;
export type FlyoutFilesGdtLazyQueryHookResult = ReturnType<typeof useFlyoutFilesGdtLazyQuery>;
export type FlyoutFilesGdtQueryResult = Apollo.QueryResult<FlyoutFilesGdtQuery, FlyoutFilesGdtQueryVariables>;
export const ModalCreateSeriesDocument = gql`
    query ModalCreateSeries($drsFileIds: [UUID!]!, $metadataKeys: [String!]!) {
  drsFiles: allFiles(filter: {id: {in: $drsFileIds}}) {
    nodes {
      id
      name
      status
      isSeries
      seriesParentId
      fileType
      fileFormat
      fileStructure
      size
      metadata: fileMetadataByFileId(
        orderBy: ID_DESC
        filter: {metadatumByMetadataId: {key: {in: $metadataKeys}}}
      ) {
        nodes {
          id
          metadatum: metadatumByMetadataId {
            id
            key
            activeValue
          }
        }
      }
    }
  }
}
    `;

/**
 * __useModalCreateSeriesQuery__
 *
 * To run a query within a React component, call `useModalCreateSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalCreateSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalCreateSeriesQuery({
 *   variables: {
 *      drsFileIds: // value for 'drsFileIds'
 *      metadataKeys: // value for 'metadataKeys'
 *   },
 * });
 */
export function useModalCreateSeriesQuery(baseOptions: Apollo.QueryHookOptions<ModalCreateSeriesQuery, ModalCreateSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModalCreateSeriesQuery, ModalCreateSeriesQueryVariables>(ModalCreateSeriesDocument, options);
      }
export function useModalCreateSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModalCreateSeriesQuery, ModalCreateSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModalCreateSeriesQuery, ModalCreateSeriesQueryVariables>(ModalCreateSeriesDocument, options);
        }
export type ModalCreateSeriesQueryHookResult = ReturnType<typeof useModalCreateSeriesQuery>;
export type ModalCreateSeriesLazyQueryHookResult = ReturnType<typeof useModalCreateSeriesLazyQuery>;
export type ModalCreateSeriesQueryResult = Apollo.QueryResult<ModalCreateSeriesQuery, ModalCreateSeriesQueryVariables>;
export const NotificationsFeedBodyDocument = gql`
    query NotificationsFeedBody($condition: NotificationCondition, $notificationIds: [UUID!]!) {
  notifications: allNotifications(
    orderBy: DATE_CREATED_DESC
    condition: $condition
    filter: {id: {in: $notificationIds}}
  ) {
    nodes {
      id
      dateCreated
      hasSeen
      projectSharedNotification: projectSharedNotificationById {
        id
        project: projectByProjectId {
          id
          name
          key
          tenant: tenantByTenantId {
            id
            key
          }
        }
        sharer: applicationUserBySharerId {
          id
          firstName
          lastName
        }
        accessLevel
      }
      fileProcessingNotification: fileProcessingNotificationById {
        id
        status
        fileId
        userId
        file: fileByFileId {
          id
          name
          status
          fileType
          isSeries
          source
          processingStatus
          seriesParentId
          project: projectByProjectId {
            id
            name
            key
            tenant: tenantByTenantId {
              id
              key
            }
          }
        }
        user: applicationUserByUserId {
          id
        }
      }
      projectClonedNotification: projectClonedNotificationById {
        id
        project: projectByProjectId {
          id
          name
          key
          status
          tenant: tenantByTenantId {
            id
            key
          }
        }
        srcProject: projectBySrcProjectId {
          id
          name
          key
          tenant: tenantByTenantId {
            id
            key
          }
        }
        projectName
        succeeded
      }
      tenantUserMembershipNotification: tenantUserMembershipNotificationById {
        id
        inviter: applicationUserByInviterId {
          id
          firstName
          lastName
        }
        tenant: tenantByTenantId {
          id
          key
          name
        }
      }
      roleChangeNotification: roleChangeNotificationById {
        id
        role
        tenant: tenantByTenantId {
          id
          key
          name
        }
        user: applicationUserByUserId {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useNotificationsFeedBodyQuery__
 *
 * To run a query within a React component, call `useNotificationsFeedBodyQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsFeedBodyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsFeedBodyQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useNotificationsFeedBodyQuery(baseOptions: Apollo.QueryHookOptions<NotificationsFeedBodyQuery, NotificationsFeedBodyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsFeedBodyQuery, NotificationsFeedBodyQueryVariables>(NotificationsFeedBodyDocument, options);
      }
export function useNotificationsFeedBodyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsFeedBodyQuery, NotificationsFeedBodyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsFeedBodyQuery, NotificationsFeedBodyQueryVariables>(NotificationsFeedBodyDocument, options);
        }
export type NotificationsFeedBodyQueryHookResult = ReturnType<typeof useNotificationsFeedBodyQuery>;
export type NotificationsFeedBodyLazyQueryHookResult = ReturnType<typeof useNotificationsFeedBodyLazyQuery>;
export type NotificationsFeedBodyQueryResult = Apollo.QueryResult<NotificationsFeedBodyQuery, NotificationsFeedBodyQueryVariables>;
export const ProjectInfoDocument = gql`
    query ProjectInfo($id: UUID!) {
  project: projectById(id: $id) {
    id
    dateCreated
    dateLastActive
    key
    user: applicationUserByUserId {
      id
      firstName
      lastName
    }
    tenant: tenantByTenantId {
      id
      key
    }
    cloneSource: projectByCloneSourceId {
      id
      name
      key
      tenant: tenantByTenantId {
        id
        key
      }
    }
  }
}
    `;

/**
 * __useProjectInfoQuery__
 *
 * To run a query within a React component, call `useProjectInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectInfoQuery(baseOptions: Apollo.QueryHookOptions<ProjectInfoQuery, ProjectInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectInfoQuery, ProjectInfoQueryVariables>(ProjectInfoDocument, options);
      }
export function useProjectInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectInfoQuery, ProjectInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectInfoQuery, ProjectInfoQueryVariables>(ProjectInfoDocument, options);
        }
export type ProjectInfoQueryHookResult = ReturnType<typeof useProjectInfoQuery>;
export type ProjectInfoLazyQueryHookResult = ReturnType<typeof useProjectInfoLazyQuery>;
export type ProjectInfoQueryResult = Apollo.QueryResult<ProjectInfoQuery, ProjectInfoQueryVariables>;
export const MetadataTableFileDocument = gql`
    query MetadataTableFile($fileIds: [UUID!], $metadatumKeys: [String!]) {
  fileMetadata: allFileMetadata(
    filter: {fileId: {in: $fileIds}, metadatumByMetadataId: {key: {in: $metadatumKeys}}}
  ) {
    nodes {
      id
      file: fileByFileId {
        id
        fileType
      }
      metadatum: metadatumByMetadataId {
        id
        key
        activeValue
      }
    }
  }
}
    `;

/**
 * __useMetadataTableFileQuery__
 *
 * To run a query within a React component, call `useMetadataTableFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetadataTableFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetadataTableFileQuery({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *      metadatumKeys: // value for 'metadatumKeys'
 *   },
 * });
 */
export function useMetadataTableFileQuery(baseOptions?: Apollo.QueryHookOptions<MetadataTableFileQuery, MetadataTableFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetadataTableFileQuery, MetadataTableFileQueryVariables>(MetadataTableFileDocument, options);
      }
export function useMetadataTableFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetadataTableFileQuery, MetadataTableFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetadataTableFileQuery, MetadataTableFileQueryVariables>(MetadataTableFileDocument, options);
        }
export type MetadataTableFileQueryHookResult = ReturnType<typeof useMetadataTableFileQuery>;
export type MetadataTableFileLazyQueryHookResult = ReturnType<typeof useMetadataTableFileLazyQuery>;
export type MetadataTableFileQueryResult = Apollo.QueryResult<MetadataTableFileQuery, MetadataTableFileQueryVariables>;
export const ModalToolCellStatusParamDocument = gql`
    query ModalToolCellStatusParam($fileIds: [UUID!]!, $metadatumKeys: [String!]!) {
  files: allFiles(filter: {id: {in: $fileIds}}) {
    nodes {
      id
      name
      source
      isSeries
      fileType
      metadata: fileMetadataByFileId(
        filter: {metadatumByMetadataId: {key: {in: $metadatumKeys}}}
      ) {
        nodes {
          id
          metadatum: metadatumByMetadataId {
            id
            key
            value: activeValue
          }
        }
      }
      seriesMembers: filesBySeriesParentId {
        nodes {
          id
          name
          source
          fileType
          metadata: fileMetadataByFileId(
            filter: {metadatumByMetadataId: {key: {in: $metadatumKeys}}}
          ) {
            nodes {
              id
              metadatum: metadatumByMetadataId {
                id
                key
                value: activeValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useModalToolCellStatusParamQuery__
 *
 * To run a query within a React component, call `useModalToolCellStatusParamQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalToolCellStatusParamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalToolCellStatusParamQuery({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *      metadatumKeys: // value for 'metadatumKeys'
 *   },
 * });
 */
export function useModalToolCellStatusParamQuery(baseOptions: Apollo.QueryHookOptions<ModalToolCellStatusParamQuery, ModalToolCellStatusParamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModalToolCellStatusParamQuery, ModalToolCellStatusParamQueryVariables>(ModalToolCellStatusParamDocument, options);
      }
export function useModalToolCellStatusParamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModalToolCellStatusParamQuery, ModalToolCellStatusParamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModalToolCellStatusParamQuery, ModalToolCellStatusParamQueryVariables>(ModalToolCellStatusParamDocument, options);
        }
export type ModalToolCellStatusParamQueryHookResult = ReturnType<typeof useModalToolCellStatusParamQuery>;
export type ModalToolCellStatusParamLazyQueryHookResult = ReturnType<typeof useModalToolCellStatusParamLazyQuery>;
export type ModalToolCellStatusParamQueryResult = Apollo.QueryResult<ModalToolCellStatusParamQuery, ModalToolCellStatusParamQueryVariables>;
export const ModalToolRoiFrameParamDocument = gql`
    query ModalToolRoiFrameParam($fileIds: [UUID!]!, $metadatumKeys: [String!]!) {
  files: allFiles(filter: {id: {in: $fileIds}}) {
    nodes {
      id
      name
      source
      isSeries
      metadata: fileMetadataByFileId(
        filter: {metadatumByMetadataId: {key: {in: $metadatumKeys}}}
      ) {
        nodes {
          id
          metadatum: metadatumByMetadataId {
            id
            key
            value: activeValue
          }
        }
      }
      seriesParent: fileBySeriesParentId {
        id
        metadata: fileMetadataByFileId(
          filter: {metadatumByMetadataId: {key: {in: $metadatumKeys}}}
        ) {
          nodes {
            id
            metadatum: metadatumByMetadataId {
              id
              key
              value: activeValue
            }
          }
        }
      }
      seriesMembers: filesBySeriesParentId {
        nodes {
          id
          name
          source
          metadata: fileMetadataByFileId(
            filter: {metadatumByMetadataId: {key: {in: $metadatumKeys}}}
          ) {
            nodes {
              id
              metadatum: metadatumByMetadataId {
                id
                key
                value: activeValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useModalToolRoiFrameParamQuery__
 *
 * To run a query within a React component, call `useModalToolRoiFrameParamQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalToolRoiFrameParamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalToolRoiFrameParamQuery({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *      metadatumKeys: // value for 'metadatumKeys'
 *   },
 * });
 */
export function useModalToolRoiFrameParamQuery(baseOptions: Apollo.QueryHookOptions<ModalToolRoiFrameParamQuery, ModalToolRoiFrameParamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModalToolRoiFrameParamQuery, ModalToolRoiFrameParamQueryVariables>(ModalToolRoiFrameParamDocument, options);
      }
export function useModalToolRoiFrameParamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModalToolRoiFrameParamQuery, ModalToolRoiFrameParamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModalToolRoiFrameParamQuery, ModalToolRoiFrameParamQueryVariables>(ModalToolRoiFrameParamDocument, options);
        }
export type ModalToolRoiFrameParamQueryHookResult = ReturnType<typeof useModalToolRoiFrameParamQuery>;
export type ModalToolRoiFrameParamLazyQueryHookResult = ReturnType<typeof useModalToolRoiFrameParamLazyQuery>;
export type ModalToolRoiFrameParamQueryResult = Apollo.QueryResult<ModalToolRoiFrameParamQuery, ModalToolRoiFrameParamQueryVariables>;
export const UserAvatarDocument = gql`
    query UserAvatar($userId: UUID!) {
  user: applicationUserById(id: $userId) {
    ...UserAvatarFields
  }
}
    ${UserAvatarFieldsFragmentDoc}`;

/**
 * __useUserAvatarQuery__
 *
 * To run a query within a React component, call `useUserAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAvatarQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserAvatarQuery(baseOptions: Apollo.QueryHookOptions<UserAvatarQuery, UserAvatarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAvatarQuery, UserAvatarQueryVariables>(UserAvatarDocument, options);
      }
export function useUserAvatarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAvatarQuery, UserAvatarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAvatarQuery, UserAvatarQueryVariables>(UserAvatarDocument, options);
        }
export type UserAvatarQueryHookResult = ReturnType<typeof useUserAvatarQuery>;
export type UserAvatarLazyQueryHookResult = ReturnType<typeof useUserAvatarLazyQuery>;
export type UserAvatarQueryResult = Apollo.QueryResult<UserAvatarQuery, UserAvatarQueryVariables>;
export const CreateMetadataValueDocument = gql`
    mutation CreateMetadataValue($metadataValue: MetadataValueInput!) {
  createMetadataValue(input: {metadataValue: $metadataValue}) {
    clientMutationId
    metadataValue {
      ...MetadataValueFields
    }
  }
}
    ${MetadataValueFieldsFragmentDoc}`;
export type CreateMetadataValueMutationFn = Apollo.MutationFunction<CreateMetadataValueMutation, CreateMetadataValueMutationVariables>;

/**
 * __useCreateMetadataValueMutation__
 *
 * To run a mutation, you first call `useCreateMetadataValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetadataValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetadataValueMutation, { data, loading, error }] = useCreateMetadataValueMutation({
 *   variables: {
 *      metadataValue: // value for 'metadataValue'
 *   },
 * });
 */
export function useCreateMetadataValueMutation(baseOptions?: Apollo.MutationHookOptions<CreateMetadataValueMutation, CreateMetadataValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMetadataValueMutation, CreateMetadataValueMutationVariables>(CreateMetadataValueDocument, options);
      }
export type CreateMetadataValueMutationHookResult = ReturnType<typeof useCreateMetadataValueMutation>;
export type CreateMetadataValueMutationResult = Apollo.MutationResult<CreateMetadataValueMutation>;
export type CreateMetadataValueMutationOptions = Apollo.BaseMutationOptions<CreateMetadataValueMutation, CreateMetadataValueMutationVariables>;
export const CreateMetadatumDocument = gql`
    mutation CreateMetadatum($metadata: MetadatumInput!) {
  createMetadata: createMetadatum(input: {metadatum: $metadata}) {
    clientMutationId
    metadata: metadatum {
      ...MetadatumFields
    }
  }
}
    ${MetadatumFieldsFragmentDoc}`;
export type CreateMetadatumMutationFn = Apollo.MutationFunction<CreateMetadatumMutation, CreateMetadatumMutationVariables>;

/**
 * __useCreateMetadatumMutation__
 *
 * To run a mutation, you first call `useCreateMetadatumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetadatumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetadatumMutation, { data, loading, error }] = useCreateMetadatumMutation({
 *   variables: {
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateMetadatumMutation(baseOptions?: Apollo.MutationHookOptions<CreateMetadatumMutation, CreateMetadatumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMetadatumMutation, CreateMetadatumMutationVariables>(CreateMetadatumDocument, options);
      }
export type CreateMetadatumMutationHookResult = ReturnType<typeof useCreateMetadatumMutation>;
export type CreateMetadatumMutationResult = Apollo.MutationResult<CreateMetadatumMutation>;
export type CreateMetadatumMutationOptions = Apollo.BaseMutationOptions<CreateMetadatumMutation, CreateMetadatumMutationVariables>;
export const CreateUserMetadatumDocument = gql`
    mutation CreateUserMetadatum($userMetadatum: ApplicationUserMetadatumInput!) {
  createUserMetadatum: createApplicationUserMetadatum(
    input: {applicationUserMetadatum: $userMetadatum}
  ) {
    clientMutationId
    userMetadatum: applicationUserMetadatum {
      ...UserMetadatumFields
    }
  }
}
    ${UserMetadatumFieldsFragmentDoc}`;
export type CreateUserMetadatumMutationFn = Apollo.MutationFunction<CreateUserMetadatumMutation, CreateUserMetadatumMutationVariables>;

/**
 * __useCreateUserMetadatumMutation__
 *
 * To run a mutation, you first call `useCreateUserMetadatumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMetadatumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMetadatumMutation, { data, loading, error }] = useCreateUserMetadatumMutation({
 *   variables: {
 *      userMetadatum: // value for 'userMetadatum'
 *   },
 * });
 */
export function useCreateUserMetadatumMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMetadatumMutation, CreateUserMetadatumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMetadatumMutation, CreateUserMetadatumMutationVariables>(CreateUserMetadatumDocument, options);
      }
export type CreateUserMetadatumMutationHookResult = ReturnType<typeof useCreateUserMetadatumMutation>;
export type CreateUserMetadatumMutationResult = Apollo.MutationResult<CreateUserMetadatumMutation>;
export type CreateUserMetadatumMutationOptions = Apollo.BaseMutationOptions<CreateUserMetadatumMutation, CreateUserMetadatumMutationVariables>;
export const CreateUserSessionDocument = gql`
    mutation CreateUserSession($id: UUID!, $userid: UUID!, $tenant: Int) {
  createUserSession: createSession(
    input: {id: $id, userid: $userid, tenant: $tenant}
  ) {
    clientMutationId
    userSession: applicationUserSession {
      ...UserSessionFields
    }
  }
}
    ${UserSessionFieldsFragmentDoc}`;
export type CreateUserSessionMutationFn = Apollo.MutationFunction<CreateUserSessionMutation, CreateUserSessionMutationVariables>;

/**
 * __useCreateUserSessionMutation__
 *
 * To run a mutation, you first call `useCreateUserSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserSessionMutation, { data, loading, error }] = useCreateUserSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userid: // value for 'userid'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useCreateUserSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserSessionMutation, CreateUserSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserSessionMutation, CreateUserSessionMutationVariables>(CreateUserSessionDocument, options);
      }
export type CreateUserSessionMutationHookResult = ReturnType<typeof useCreateUserSessionMutation>;
export type CreateUserSessionMutationResult = Apollo.MutationResult<CreateUserSessionMutation>;
export type CreateUserSessionMutationOptions = Apollo.BaseMutationOptions<CreateUserSessionMutation, CreateUserSessionMutationVariables>;
export const UpdateApplicationUserByIdDocument = gql`
    mutation UpdateApplicationUserById($id: UUID!, $patch: ApplicationUserPatch!) {
  updateApplicationUserById(input: {id: $id, applicationUserPatch: $patch}) {
    clientMutationId
    applicationUser {
      ...UserFields
      metadata: applicationUserMetadataByUserId {
        nodes {
          ...UserMetadatumFields
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserMetadatumFieldsFragmentDoc}`;
export type UpdateApplicationUserByIdMutationFn = Apollo.MutationFunction<UpdateApplicationUserByIdMutation, UpdateApplicationUserByIdMutationVariables>;

/**
 * __useUpdateApplicationUserByIdMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationUserByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationUserByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationUserByIdMutation, { data, loading, error }] = useUpdateApplicationUserByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateApplicationUserByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationUserByIdMutation, UpdateApplicationUserByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationUserByIdMutation, UpdateApplicationUserByIdMutationVariables>(UpdateApplicationUserByIdDocument, options);
      }
export type UpdateApplicationUserByIdMutationHookResult = ReturnType<typeof useUpdateApplicationUserByIdMutation>;
export type UpdateApplicationUserByIdMutationResult = Apollo.MutationResult<UpdateApplicationUserByIdMutation>;
export type UpdateApplicationUserByIdMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationUserByIdMutation, UpdateApplicationUserByIdMutationVariables>;
export const UpdateAvatarByIdDocument = gql`
    mutation UpdateAvatarById($id: BigInt!, $patch: AvatarPatch!) {
  updateAvatarById(input: {id: $id, avatarPatch: $patch}) {
    clientMutationId
    avatar {
      ...AvatarFields
    }
  }
}
    ${AvatarFieldsFragmentDoc}`;
export type UpdateAvatarByIdMutationFn = Apollo.MutationFunction<UpdateAvatarByIdMutation, UpdateAvatarByIdMutationVariables>;

/**
 * __useUpdateAvatarByIdMutation__
 *
 * To run a mutation, you first call `useUpdateAvatarByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvatarByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvatarByIdMutation, { data, loading, error }] = useUpdateAvatarByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateAvatarByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvatarByIdMutation, UpdateAvatarByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvatarByIdMutation, UpdateAvatarByIdMutationVariables>(UpdateAvatarByIdDocument, options);
      }
export type UpdateAvatarByIdMutationHookResult = ReturnType<typeof useUpdateAvatarByIdMutation>;
export type UpdateAvatarByIdMutationResult = Apollo.MutationResult<UpdateAvatarByIdMutation>;
export type UpdateAvatarByIdMutationOptions = Apollo.BaseMutationOptions<UpdateAvatarByIdMutation, UpdateAvatarByIdMutationVariables>;
export const UpdateUserMetadatumByIdDocument = gql`
    mutation UpdateUserMetadatumById($id: Int!, $patch: ApplicationUserMetadatumPatch!) {
  updateUserMetadatumById: updateApplicationUserMetadatumById(
    input: {id: $id, applicationUserMetadatumPatch: $patch}
  ) {
    clientMutationId
    userMetadatum: applicationUserMetadatum {
      ...UserMetadatumFields
    }
  }
}
    ${UserMetadatumFieldsFragmentDoc}`;
export type UpdateUserMetadatumByIdMutationFn = Apollo.MutationFunction<UpdateUserMetadatumByIdMutation, UpdateUserMetadatumByIdMutationVariables>;

/**
 * __useUpdateUserMetadatumByIdMutation__
 *
 * To run a mutation, you first call `useUpdateUserMetadatumByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMetadatumByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMetadatumByIdMutation, { data, loading, error }] = useUpdateUserMetadatumByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateUserMetadatumByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMetadatumByIdMutation, UpdateUserMetadatumByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMetadatumByIdMutation, UpdateUserMetadatumByIdMutationVariables>(UpdateUserMetadatumByIdDocument, options);
      }
export type UpdateUserMetadatumByIdMutationHookResult = ReturnType<typeof useUpdateUserMetadatumByIdMutation>;
export type UpdateUserMetadatumByIdMutationResult = Apollo.MutationResult<UpdateUserMetadatumByIdMutation>;
export type UpdateUserMetadatumByIdMutationOptions = Apollo.BaseMutationOptions<UpdateUserMetadatumByIdMutation, UpdateUserMetadatumByIdMutationVariables>;
export const GetAllTasksDocument = gql`
    query GetAllTasks($condition: TaskCondition, $filter: TaskFilter) {
  tasks: allTasks(
    condition: $condition
    filter: $filter
    orderBy: DATE_CREATED_DESC
  ) {
    nodes {
      id
      toolVersion: toolVersionByToolVersionId {
        ...ToolVersionFields
      }
      outputGroup: fileOutputGroupByTaskId {
        ...FileOutputGroupFields
        task: taskByTaskId {
          id
          status
          dateCreated
        }
        outputGroupFiles: outputGroupFilesByFileOutputGroupId {
          nodes {
            id
            drsFile: fileByFileId {
              ...FileCache
              fileMetadata: fileMetadataByFileId {
                nodes {
                  id
                  metadata: metadatumByMetadataId {
                    id
                    key
                    activeValue
                  }
                }
              }
            }
          }
        }
        metadata: fileOutputGroupMetadataByFileOutputGroupId {
          nodes {
            id
            metadatum: metadatumByMetadataId {
              ...MetadatumFields
              values: metadataValuesByMetadataId(orderBy: DATE_CREATED_ASC, last: 1) {
                nodes {
                  ...MetadataValueFields
                }
              }
            }
          }
        }
      }
      user: applicationUserByUserId {
        ...UserFields
      }
      ...TaskFields
      taskActivityByTaskId {
        id
        duration {
          hours
          seconds
          minutes
          days
          years
          months
        }
      }
      taskResourcesByTaskId {
        nodes {
          id
          type
          value
        }
      }
    }
  }
}
    ${ToolVersionFieldsFragmentDoc}
${FileOutputGroupFieldsFragmentDoc}
${FileCacheFragmentDoc}
${MetadatumFieldsFragmentDoc}
${MetadataValueFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${TaskFieldsFragmentDoc}`;

/**
 * __useGetAllTasksQuery__
 *
 * To run a query within a React component, call `useGetAllTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTasksQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTasksQuery, GetAllTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTasksQuery, GetAllTasksQueryVariables>(GetAllTasksDocument, options);
      }
export function useGetAllTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTasksQuery, GetAllTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTasksQuery, GetAllTasksQueryVariables>(GetAllTasksDocument, options);
        }
export type GetAllTasksQueryHookResult = ReturnType<typeof useGetAllTasksQuery>;
export type GetAllTasksLazyQueryHookResult = ReturnType<typeof useGetAllTasksLazyQuery>;
export type GetAllTasksQueryResult = Apollo.QueryResult<GetAllTasksQuery, GetAllTasksQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser: getCurrentUser {
    ...UserFields
    metadata: applicationUserMetadataByUserId {
      nodes {
        ...UserMetadatumFields
      }
    }
    memberships: applicationUserMembershipsByUserId {
      nodes {
        id
        tenant: tenantByTenantId {
          ...TenantFields
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserMetadatumFieldsFragmentDoc}
${TenantFieldsFragmentDoc}`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetFileMetadataByFileIdDocument = gql`
    query GetFileMetadataByFileId($drsFileId: UUID!, $metadataFilter: FileMetadatumFilter) {
  drsFile: fileById(id: $drsFileId) {
    id
    metadata: fileMetadataByFileId(
      orderBy: DATE_CREATED_ASC
      filter: $metadataFilter
    ) {
      nodes {
        id
        metadatum: metadatumByMetadataId {
          ...MetadatumFields
          activeValue
        }
      }
    }
    seriesParentFile: fileBySeriesParentId {
      id
      metadata: fileMetadataByFileId(
        orderBy: DATE_CREATED_ASC
        filter: $metadataFilter
      ) {
        nodes {
          id
          metadatum: metadatumByMetadataId {
            ...MetadatumFields
            activeValue
          }
        }
      }
    }
  }
}
    ${MetadatumFieldsFragmentDoc}`;

/**
 * __useGetFileMetadataByFileIdQuery__
 *
 * To run a query within a React component, call `useGetFileMetadataByFileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileMetadataByFileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileMetadataByFileIdQuery({
 *   variables: {
 *      drsFileId: // value for 'drsFileId'
 *      metadataFilter: // value for 'metadataFilter'
 *   },
 * });
 */
export function useGetFileMetadataByFileIdQuery(baseOptions: Apollo.QueryHookOptions<GetFileMetadataByFileIdQuery, GetFileMetadataByFileIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileMetadataByFileIdQuery, GetFileMetadataByFileIdQueryVariables>(GetFileMetadataByFileIdDocument, options);
      }
export function useGetFileMetadataByFileIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileMetadataByFileIdQuery, GetFileMetadataByFileIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileMetadataByFileIdQuery, GetFileMetadataByFileIdQueryVariables>(GetFileMetadataByFileIdDocument, options);
        }
export type GetFileMetadataByFileIdQueryHookResult = ReturnType<typeof useGetFileMetadataByFileIdQuery>;
export type GetFileMetadataByFileIdLazyQueryHookResult = ReturnType<typeof useGetFileMetadataByFileIdLazyQuery>;
export type GetFileMetadataByFileIdQueryResult = Apollo.QueryResult<GetFileMetadataByFileIdQuery, GetFileMetadataByFileIdQueryVariables>;
export const GetProjectByIdDocument = gql`
    query GetProjectById($id: UUID!) {
  projectById(id: $id) {
    ...ProjectFields
  }
}
    ${ProjectFieldsFragmentDoc}`;

/**
 * __useGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, options);
      }
export function useGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, options);
        }
export type GetProjectByIdQueryHookResult = ReturnType<typeof useGetProjectByIdQuery>;
export type GetProjectByIdLazyQueryHookResult = ReturnType<typeof useGetProjectByIdLazyQuery>;
export type GetProjectByIdQueryResult = Apollo.QueryResult<GetProjectByIdQuery, GetProjectByIdQueryVariables>;
export const GetTaskByIdDocument = gql`
    query GetTaskById($id: UUID!) {
  task: taskById(id: $id) {
    ...TaskFields
  }
}
    ${TaskFieldsFragmentDoc}`;

/**
 * __useGetTaskByIdQuery__
 *
 * To run a query within a React component, call `useGetTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(GetTaskByIdDocument, options);
      }
export function useGetTaskByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(GetTaskByIdDocument, options);
        }
export type GetTaskByIdQueryHookResult = ReturnType<typeof useGetTaskByIdQuery>;
export type GetTaskByIdLazyQueryHookResult = ReturnType<typeof useGetTaskByIdLazyQuery>;
export type GetTaskByIdQueryResult = Apollo.QueryResult<GetTaskByIdQuery, GetTaskByIdQueryVariables>;
export const GetUserSessionByIdDocument = gql`
    query GetUserSessionById($id: UUID!) {
  userSession: applicationUserSessionById(id: $id) {
    ...UserSessionFields
  }
}
    ${UserSessionFieldsFragmentDoc}`;

/**
 * __useGetUserSessionByIdQuery__
 *
 * To run a query within a React component, call `useGetUserSessionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSessionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSessionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserSessionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserSessionByIdQuery, GetUserSessionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSessionByIdQuery, GetUserSessionByIdQueryVariables>(GetUserSessionByIdDocument, options);
      }
export function useGetUserSessionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSessionByIdQuery, GetUserSessionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSessionByIdQuery, GetUserSessionByIdQueryVariables>(GetUserSessionByIdDocument, options);
        }
export type GetUserSessionByIdQueryHookResult = ReturnType<typeof useGetUserSessionByIdQuery>;
export type GetUserSessionByIdLazyQueryHookResult = ReturnType<typeof useGetUserSessionByIdLazyQuery>;
export type GetUserSessionByIdQueryResult = Apollo.QueryResult<GetUserSessionByIdQuery, GetUserSessionByIdQueryVariables>;
export const ExportToDandiToolInfoDocument = gql`
    query ExportToDandiToolInfo($activeStatus: Int) {
  allTools(
    filter: {status: {equalTo: $activeStatus}, key: {equalTo: "export_to_dandi"}}
  ) {
    nodes {
      id
      toolVersions: toolVersionsByToolId(orderBy: VERSION_ASC, last: 1) {
        nodes {
          id
          toolSources: toolSourcesByToolVersionId {
            nodes {
              id
              key
            }
          }
          toolParameters: toolParametersByToolVersionId {
            nodes {
              id
              key
            }
          }
          toolSecrets: toolSecretsByToolVersionId {
            nodes {
              id
              key
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useExportToDandiToolInfoQuery__
 *
 * To run a query within a React component, call `useExportToDandiToolInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportToDandiToolInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportToDandiToolInfoQuery({
 *   variables: {
 *      activeStatus: // value for 'activeStatus'
 *   },
 * });
 */
export function useExportToDandiToolInfoQuery(baseOptions?: Apollo.QueryHookOptions<ExportToDandiToolInfoQuery, ExportToDandiToolInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportToDandiToolInfoQuery, ExportToDandiToolInfoQueryVariables>(ExportToDandiToolInfoDocument, options);
      }
export function useExportToDandiToolInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportToDandiToolInfoQuery, ExportToDandiToolInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportToDandiToolInfoQuery, ExportToDandiToolInfoQueryVariables>(ExportToDandiToolInfoDocument, options);
        }
export type ExportToDandiToolInfoQueryHookResult = ReturnType<typeof useExportToDandiToolInfoQuery>;
export type ExportToDandiToolInfoLazyQueryHookResult = ReturnType<typeof useExportToDandiToolInfoLazyQuery>;
export type ExportToDandiToolInfoQueryResult = Apollo.QueryResult<ExportToDandiToolInfoQuery, ExportToDandiToolInfoQueryVariables>;
export const GetProcessingStatusDocument = gql`
    query GetProcessingStatus($drsFileIds: [UUID!]!) {
  files: allFiles(filter: {id: {in: $drsFileIds}}) {
    nodes {
      id
      processingStatus
    }
  }
}
    `;

/**
 * __useGetProcessingStatusQuery__
 *
 * To run a query within a React component, call `useGetProcessingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessingStatusQuery({
 *   variables: {
 *      drsFileIds: // value for 'drsFileIds'
 *   },
 * });
 */
export function useGetProcessingStatusQuery(baseOptions: Apollo.QueryHookOptions<GetProcessingStatusQuery, GetProcessingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessingStatusQuery, GetProcessingStatusQueryVariables>(GetProcessingStatusDocument, options);
      }
export function useGetProcessingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessingStatusQuery, GetProcessingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessingStatusQuery, GetProcessingStatusQueryVariables>(GetProcessingStatusDocument, options);
        }
export type GetProcessingStatusQueryHookResult = ReturnType<typeof useGetProcessingStatusQuery>;
export type GetProcessingStatusLazyQueryHookResult = ReturnType<typeof useGetProcessingStatusLazyQuery>;
export type GetProcessingStatusQueryResult = Apollo.QueryResult<GetProcessingStatusQuery, GetProcessingStatusQueryVariables>;
export const GetExternalTenantsDocument = gql`
    query GetExternalTenants {
  currentUser: getCurrentUser {
    id
    memberships: applicationUserMembershipsByUserId {
      nodes {
        id
        tenant: tenantByTenantId {
          id
          key
          name
          tenantType
        }
      }
    }
  }
}
    `;

/**
 * __useGetExternalTenantsQuery__
 *
 * To run a query within a React component, call `useGetExternalTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalTenantsQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalTenantsQuery, GetExternalTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalTenantsQuery, GetExternalTenantsQueryVariables>(GetExternalTenantsDocument, options);
      }
export function useGetExternalTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalTenantsQuery, GetExternalTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalTenantsQuery, GetExternalTenantsQueryVariables>(GetExternalTenantsDocument, options);
        }
export type GetExternalTenantsQueryHookResult = ReturnType<typeof useGetExternalTenantsQuery>;
export type GetExternalTenantsLazyQueryHookResult = ReturnType<typeof useGetExternalTenantsLazyQuery>;
export type GetExternalTenantsQueryResult = Apollo.QueryResult<GetExternalTenantsQuery, GetExternalTenantsQueryVariables>;
export const GetFileProcessTasksDocument = gql`
    query GetFileProcessTasks($drsFileId: UUID!, $failedStatuses: [Int!]!) {
  file: fileById(id: $drsFileId) {
    id
    taskSources: taskSourcesByFileId(
      filter: {taskByTaskId: {and: [{toolVersionByToolVersionId: {toolByToolId: {key: {equalTo: "process_file"}}}}, {status: {in: $failedStatuses}}]}}
    ) {
      nodes {
        id
        task: taskByTaskId {
          id
          status
          errorDescription
          dateCreated
          toolVersion: toolVersionByToolVersionId {
            id
            tool: toolByToolId {
              id
              name
              key
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetFileProcessTasksQuery__
 *
 * To run a query within a React component, call `useGetFileProcessTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileProcessTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileProcessTasksQuery({
 *   variables: {
 *      drsFileId: // value for 'drsFileId'
 *      failedStatuses: // value for 'failedStatuses'
 *   },
 * });
 */
export function useGetFileProcessTasksQuery(baseOptions: Apollo.QueryHookOptions<GetFileProcessTasksQuery, GetFileProcessTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileProcessTasksQuery, GetFileProcessTasksQueryVariables>(GetFileProcessTasksDocument, options);
      }
export function useGetFileProcessTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileProcessTasksQuery, GetFileProcessTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileProcessTasksQuery, GetFileProcessTasksQueryVariables>(GetFileProcessTasksDocument, options);
        }
export type GetFileProcessTasksQueryHookResult = ReturnType<typeof useGetFileProcessTasksQuery>;
export type GetFileProcessTasksLazyQueryHookResult = ReturnType<typeof useGetFileProcessTasksLazyQuery>;
export type GetFileProcessTasksQueryResult = Apollo.QueryResult<GetFileProcessTasksQuery, GetFileProcessTasksQueryVariables>;
export const CellEditorFileDocument = gql`
    query CellEditorFile($projectId: UUID!) {
  project: projectById(id: $projectId) {
    id
    isToolProject
    files: filesByProjectId(
      filter: {dateDeleted: {isNull: true}, dateDataDeleted: {isNull: true}, seriesParentId: {isNull: true}}
    ) {
      nodes {
        id
        referenceId
        name
        fileType
        tags
        source
        isSeries
        seriesFiles: filesBySeriesParentId(orderBy: [SERIES_ORDER_ASC, NAME_ASC]) {
          nodes {
            id
            name
          }
        }
        ...CellValueRendererFileFields
      }
    }
  }
}
    ${CellValueRendererFileFieldsFragmentDoc}`;

/**
 * __useCellEditorFileQuery__
 *
 * To run a query within a React component, call `useCellEditorFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCellEditorFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCellEditorFileQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCellEditorFileQuery(baseOptions: Apollo.QueryHookOptions<CellEditorFileQuery, CellEditorFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CellEditorFileQuery, CellEditorFileQueryVariables>(CellEditorFileDocument, options);
      }
export function useCellEditorFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CellEditorFileQuery, CellEditorFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CellEditorFileQuery, CellEditorFileQueryVariables>(CellEditorFileDocument, options);
        }
export type CellEditorFileQueryHookResult = ReturnType<typeof useCellEditorFileQuery>;
export type CellEditorFileLazyQueryHookResult = ReturnType<typeof useCellEditorFileLazyQuery>;
export type CellEditorFileQueryResult = Apollo.QueryResult<CellEditorFileQuery, CellEditorFileQueryVariables>;
export const CellEditorToolVersionDocument = gql`
    query CellEditorToolVersion($toolVersionId: Int!) {
  toolVersion: toolVersionById(id: $toolVersionId) {
    id
    compatibleVersions {
      nodes {
        id
        version
        toolSpec
        credits
        status
      }
    }
  }
}
    `;

/**
 * __useCellEditorToolVersionQuery__
 *
 * To run a query within a React component, call `useCellEditorToolVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCellEditorToolVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCellEditorToolVersionQuery({
 *   variables: {
 *      toolVersionId: // value for 'toolVersionId'
 *   },
 * });
 */
export function useCellEditorToolVersionQuery(baseOptions: Apollo.QueryHookOptions<CellEditorToolVersionQuery, CellEditorToolVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CellEditorToolVersionQuery, CellEditorToolVersionQueryVariables>(CellEditorToolVersionDocument, options);
      }
export function useCellEditorToolVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CellEditorToolVersionQuery, CellEditorToolVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CellEditorToolVersionQuery, CellEditorToolVersionQueryVariables>(CellEditorToolVersionDocument, options);
        }
export type CellEditorToolVersionQueryHookResult = ReturnType<typeof useCellEditorToolVersionQuery>;
export type CellEditorToolVersionLazyQueryHookResult = ReturnType<typeof useCellEditorToolVersionLazyQuery>;
export type CellEditorToolVersionQueryResult = Apollo.QueryResult<CellEditorToolVersionQuery, CellEditorToolVersionQueryVariables>;
export const DataTableUpgradeButtonDocument = gql`
    query DataTableUpgradeButton($toolVersionId: Int!) {
  toolVersion: toolVersionById(id: $toolVersionId) {
    id
    tool: toolByToolId {
      id
      toolVersions: toolVersionsByToolId(
        orderBy: DATE_CREATED_ASC
        last: 1
        filter: {status: {equalTo: 2}}
      ) {
        nodes {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useDataTableUpgradeButtonQuery__
 *
 * To run a query within a React component, call `useDataTableUpgradeButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTableUpgradeButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTableUpgradeButtonQuery({
 *   variables: {
 *      toolVersionId: // value for 'toolVersionId'
 *   },
 * });
 */
export function useDataTableUpgradeButtonQuery(baseOptions: Apollo.QueryHookOptions<DataTableUpgradeButtonQuery, DataTableUpgradeButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataTableUpgradeButtonQuery, DataTableUpgradeButtonQueryVariables>(DataTableUpgradeButtonDocument, options);
      }
export function useDataTableUpgradeButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataTableUpgradeButtonQuery, DataTableUpgradeButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataTableUpgradeButtonQuery, DataTableUpgradeButtonQueryVariables>(DataTableUpgradeButtonDocument, options);
        }
export type DataTableUpgradeButtonQueryHookResult = ReturnType<typeof useDataTableUpgradeButtonQuery>;
export type DataTableUpgradeButtonLazyQueryHookResult = ReturnType<typeof useDataTableUpgradeButtonLazyQuery>;
export type DataTableUpgradeButtonQueryResult = Apollo.QueryResult<DataTableUpgradeButtonQuery, DataTableUpgradeButtonQueryVariables>;
export const ModalMapAnalysisParametersDocument = gql`
    query ModalMapAnalysisParameters($toolVersionId: Int!) {
  toolVersion: toolVersionById(id: $toolVersionId) {
    id
    toolSpec
  }
}
    `;

/**
 * __useModalMapAnalysisParametersQuery__
 *
 * To run a query within a React component, call `useModalMapAnalysisParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalMapAnalysisParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalMapAnalysisParametersQuery({
 *   variables: {
 *      toolVersionId: // value for 'toolVersionId'
 *   },
 * });
 */
export function useModalMapAnalysisParametersQuery(baseOptions: Apollo.QueryHookOptions<ModalMapAnalysisParametersQuery, ModalMapAnalysisParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModalMapAnalysisParametersQuery, ModalMapAnalysisParametersQueryVariables>(ModalMapAnalysisParametersDocument, options);
      }
export function useModalMapAnalysisParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModalMapAnalysisParametersQuery, ModalMapAnalysisParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModalMapAnalysisParametersQuery, ModalMapAnalysisParametersQueryVariables>(ModalMapAnalysisParametersDocument, options);
        }
export type ModalMapAnalysisParametersQueryHookResult = ReturnType<typeof useModalMapAnalysisParametersQuery>;
export type ModalMapAnalysisParametersLazyQueryHookResult = ReturnType<typeof useModalMapAnalysisParametersLazyQuery>;
export type ModalMapAnalysisParametersQueryResult = Apollo.QueryResult<ModalMapAnalysisParametersQuery, ModalMapAnalysisParametersQueryVariables>;
export const GetDrsFilesDocument = gql`
    query GetDrsFiles($ids: [UUID!]!) {
  drsFiles: allFiles(filter: {id: {in: $ids}}) {
    nodes {
      ...FileCache
    }
  }
}
    ${FileCacheFragmentDoc}`;

/**
 * __useGetDrsFilesQuery__
 *
 * To run a query within a React component, call `useGetDrsFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrsFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrsFilesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetDrsFilesQuery(baseOptions: Apollo.QueryHookOptions<GetDrsFilesQuery, GetDrsFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDrsFilesQuery, GetDrsFilesQueryVariables>(GetDrsFilesDocument, options);
      }
export function useGetDrsFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDrsFilesQuery, GetDrsFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDrsFilesQuery, GetDrsFilesQueryVariables>(GetDrsFilesDocument, options);
        }
export type GetDrsFilesQueryHookResult = ReturnType<typeof useGetDrsFilesQuery>;
export type GetDrsFilesLazyQueryHookResult = ReturnType<typeof useGetDrsFilesLazyQuery>;
export type GetDrsFilesQueryResult = Apollo.QueryResult<GetDrsFilesQuery, GetDrsFilesQueryVariables>;
export const TasksTableGdtDocument = gql`
    query TasksTableGdt($condition: TaskCondition, $filter: TaskFilter) {
  allTasks: allTasks(condition: $condition, filter: $filter) {
    nodes {
      analysisTableRow: gdtAnalysisTableRowsByTaskId {
        nodes {
          id
          index
          dateDeleted
          table: gdtAnalysisTableByTableId {
            id
            name
            key
            dateDeleted
          }
        }
      }
      id
      credits
      cloned
      status
      dateCreated
      toolVersion: toolVersionByToolVersionId {
        id
        tool: toolByToolId {
          id
          key
        }
        toolSpec
        visibility
      }
      taskActivityByTaskId {
        id
        duration {
          hours
          seconds
          minutes
          days
          years
          months
        }
      }
      user: applicationUserByUserId {
        id
        firstName
        lastName
      }
      outputGroup: fileOutputGroupByTaskId {
        id
        outputGroupFiles: outputGroupFilesByFileOutputGroupId {
          nodes {
            id
            drsFile: fileByFileId {
              id
              name
              isSeries
              status
              key
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTasksTableGdtQuery__
 *
 * To run a query within a React component, call `useTasksTableGdtQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksTableGdtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksTableGdtQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTasksTableGdtQuery(baseOptions?: Apollo.QueryHookOptions<TasksTableGdtQuery, TasksTableGdtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksTableGdtQuery, TasksTableGdtQueryVariables>(TasksTableGdtDocument, options);
      }
export function useTasksTableGdtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksTableGdtQuery, TasksTableGdtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksTableGdtQuery, TasksTableGdtQueryVariables>(TasksTableGdtDocument, options);
        }
export type TasksTableGdtQueryHookResult = ReturnType<typeof useTasksTableGdtQuery>;
export type TasksTableGdtLazyQueryHookResult = ReturnType<typeof useTasksTableGdtLazyQuery>;
export type TasksTableGdtQueryResult = Apollo.QueryResult<TasksTableGdtQuery, TasksTableGdtQueryVariables>;
export const TenantProviderDocument = gql`
    query TenantProvider($tenantKey: String!) {
  tenant: tenantByKey(key: $tenantKey) {
    id
    name
    key
    internal
    tenantType
    memberships: applicationUserMembershipsByTenantId {
      nodes {
        id
        role
        user: applicationUserByUserId {
          id
          firstName
          lastName
          email
          username
          internal
          isActive
          avatar: avatarByUserId {
            id
            color
            initials
            useImage
            imageBase64
          }
          metadata: applicationUserMetadataByUserId {
            nodes {
              id
              key
              value
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTenantProviderQuery__
 *
 * To run a query within a React component, call `useTenantProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantProviderQuery({
 *   variables: {
 *      tenantKey: // value for 'tenantKey'
 *   },
 * });
 */
export function useTenantProviderQuery(baseOptions: Apollo.QueryHookOptions<TenantProviderQuery, TenantProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantProviderQuery, TenantProviderQueryVariables>(TenantProviderDocument, options);
      }
export function useTenantProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantProviderQuery, TenantProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantProviderQuery, TenantProviderQueryVariables>(TenantProviderDocument, options);
        }
export type TenantProviderQueryHookResult = ReturnType<typeof useTenantProviderQuery>;
export type TenantProviderLazyQueryHookResult = ReturnType<typeof useTenantProviderLazyQuery>;
export type TenantProviderQueryResult = Apollo.QueryResult<TenantProviderQuery, TenantProviderQueryVariables>;
export const UserProviderDocument = gql`
    query UserProvider {
  currentUser: getCurrentUser {
    id
    firstName
    lastName
    email
    username
    internal
    isActive
    metadata: applicationUserMetadataByUserId {
      nodes {
        id
        key
        value
      }
    }
    eula: eulaVersionUserAcceptancesByUserId {
      nodes {
        id
        accepted
      }
    }
    ...UserAvatarFields
    memberships: applicationUserMembershipsByUserId {
      nodes {
        id
        role
        tenant: tenantByTenantId {
          id
          key
          name
          tenantType
        }
      }
    }
  }
}
    ${UserAvatarFieldsFragmentDoc}`;

/**
 * __useUserProviderQuery__
 *
 * To run a query within a React component, call `useUserProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProviderQuery(baseOptions?: Apollo.QueryHookOptions<UserProviderQuery, UserProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProviderQuery, UserProviderQueryVariables>(UserProviderDocument, options);
      }
export function useUserProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProviderQuery, UserProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProviderQuery, UserProviderQueryVariables>(UserProviderDocument, options);
        }
export type UserProviderQueryHookResult = ReturnType<typeof useUserProviderQuery>;
export type UserProviderLazyQueryHookResult = ReturnType<typeof useUserProviderLazyQuery>;
export type UserProviderQueryResult = Apollo.QueryResult<UserProviderQuery, UserProviderQueryVariables>;


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ApplicationUser: ResolverTypeWrapper<ApplicationUser>;
  ApplicationUserApplicationUserEmailKeyConnect: ApplicationUserApplicationUserEmailKeyConnect;
  ApplicationUserApplicationUserGlobalUserIdKeyConnect: ApplicationUserApplicationUserGlobalUserIdKeyConnect;
  ApplicationUserApplicationUserPkeyConnect: ApplicationUserApplicationUserPkeyConnect;
  ApplicationUserApplicationUserUsernameKeyConnect: ApplicationUserApplicationUserUsernameKeyConnect;
  ApplicationUserFilter: ApplicationUserFilter;
  ApplicationUserMemUserId631Fddc5FkApplicatiInput: ApplicationUserMemUserId631Fddc5FkApplicatiInput;
  ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput: ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput;
  ApplicationUserMembership: ResolverTypeWrapper<ApplicationUserMembership>;
  ApplicationUserMembershipApplicationUserMembershipPkeyConnect: ApplicationUserMembershipApplicationUserMembershipPkeyConnect;
  ApplicationUserMembershipCondition: ApplicationUserMembershipCondition;
  ApplicationUserMembershipFilter: ApplicationUserMembershipFilter;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput;
  ApplicationUserMembershipUserTenantUniqueConnect: ApplicationUserMembershipUserTenantUniqueConnect;
  ApplicationUserMembershipsConnection: ResolverTypeWrapper<ApplicationUserMembershipsConnection>;
  ApplicationUserMembershipsEdge: ResolverTypeWrapper<ApplicationUserMembershipsEdge>;
  ApplicationUserMembershipsOrderBy: ApplicationUserMembershipsOrderBy;
  ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput: ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput;
  ApplicationUserMetUserId897Fbde1FkApplicatiInput: ApplicationUserMetUserId897Fbde1FkApplicatiInput;
  ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput: ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput;
  ApplicationUserMetadataConnection: ResolverTypeWrapper<ApplicationUserMetadataConnection>;
  ApplicationUserMetadataEdge: ResolverTypeWrapper<ApplicationUserMetadataEdge>;
  ApplicationUserMetadataOrderBy: ApplicationUserMetadataOrderBy;
  ApplicationUserMetadatum: ResolverTypeWrapper<ApplicationUserMetadatum>;
  ApplicationUserMetadatumApplicationUserMetadataPkeyConnect: ApplicationUserMetadatumApplicationUserMetadataPkeyConnect;
  ApplicationUserMetadatumCondition: ApplicationUserMetadatumCondition;
  ApplicationUserMetadatumFilter: ApplicationUserMetadatumFilter;
  ApplicationUserMetadatumInput: ApplicationUserMetadatumInput;
  ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate: ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate;
  ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate: ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate;
  ApplicationUserMetadatumPatch: ApplicationUserMetadatumPatch;
  ApplicationUserMetadatumUserKeyConnect: ApplicationUserMetadatumUserKeyConnect;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserPatch: ApplicationUserPatch;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiInput;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput;
  ApplicationUserSession: ResolverTypeWrapper<ApplicationUserSession>;
  ApplicationUserSessionApplicationUserSessionPkeyConnect: ApplicationUserSessionApplicationUserSessionPkeyConnect;
  ApplicationUserSessionCondition: ApplicationUserSessionCondition;
  ApplicationUserSessionFilter: ApplicationUserSessionFilter;
  ApplicationUserSessionInput: ApplicationUserSessionInput;
  ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate: ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate;
  ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate: ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput;
  ApplicationUserSessionsConnection: ResolverTypeWrapper<ApplicationUserSessionsConnection>;
  ApplicationUserSessionsEdge: ResolverTypeWrapper<ApplicationUserSessionsEdge>;
  ApplicationUserSessionsOrderBy: ApplicationUserSessionsOrderBy;
  ApplicationUserToManyApplicationUserMembershipFilter: ApplicationUserToManyApplicationUserMembershipFilter;
  ApplicationUserToManyApplicationUserMetadatumFilter: ApplicationUserToManyApplicationUserMetadatumFilter;
  ApplicationUserToManyApplicationUserSessionFilter: ApplicationUserToManyApplicationUserSessionFilter;
  ApplicationUserToManyCodeFileFilter: ApplicationUserToManyCodeFileFilter;
  ApplicationUserToManyDataTableFilter: ApplicationUserToManyDataTableFilter;
  ApplicationUserToManyEulaVersionUserAcceptanceFilter: ApplicationUserToManyEulaVersionUserAcceptanceFilter;
  ApplicationUserToManyFileActivityFilter: ApplicationUserToManyFileActivityFilter;
  ApplicationUserToManyFileFilter: ApplicationUserToManyFileFilter;
  ApplicationUserToManyFileOutputGroupFilter: ApplicationUserToManyFileOutputGroupFilter;
  ApplicationUserToManyFileProcessingNotificationFilter: ApplicationUserToManyFileProcessingNotificationFilter;
  ApplicationUserToManyGdtAnalysisTableFilter: ApplicationUserToManyGdtAnalysisTableFilter;
  ApplicationUserToManyGdtAnalysisTableRowFilter: ApplicationUserToManyGdtAnalysisTableRowFilter;
  ApplicationUserToManyMetadataValueFilter: ApplicationUserToManyMetadataValueFilter;
  ApplicationUserToManyNotificationFilter: ApplicationUserToManyNotificationFilter;
  ApplicationUserToManyProjectClonedNotificationFilter: ApplicationUserToManyProjectClonedNotificationFilter;
  ApplicationUserToManyProjectFilter: ApplicationUserToManyProjectFilter;
  ApplicationUserToManyProjectFolderFilter: ApplicationUserToManyProjectFolderFilter;
  ApplicationUserToManyProjectSharedNotificationFilter: ApplicationUserToManyProjectSharedNotificationFilter;
  ApplicationUserToManyProjectTagFilter: ApplicationUserToManyProjectTagFilter;
  ApplicationUserToManyRoleChangeNotificationFilter: ApplicationUserToManyRoleChangeNotificationFilter;
  ApplicationUserToManyTaskFilter: ApplicationUserToManyTaskFilter;
  ApplicationUserToManyTenantUserMembershipNotificationFilter: ApplicationUserToManyTenantUserMembershipNotificationFilter;
  ApplicationUserToManyToolFilter: ApplicationUserToManyToolFilter;
  ApplicationUserToManyToolVersionFilter: ApplicationUserToManyToolVersionFilter;
  ApplicationUsersEdge: ResolverTypeWrapper<ApplicationUsersEdge>;
  ApplicationUsersOrderBy: ApplicationUsersOrderBy;
  Avatar: ResolverTypeWrapper<Avatar>;
  AvatarAvatarPkeyConnect: AvatarAvatarPkeyConnect;
  AvatarAvatarUserIdKeyConnect: AvatarAvatarUserIdKeyConnect;
  AvatarCondition: AvatarCondition;
  AvatarFilter: AvatarFilter;
  AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate: AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate;
  AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate: AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate;
  AvatarPatch: AvatarPatch;
  AvatarUserId771332F2FkApplicationUserIdInput: AvatarUserId771332F2FkApplicationUserIdInput;
  AvatarUserId771332F2FkApplicationUserIdInverseInput: AvatarUserId771332F2FkApplicationUserIdInverseInput;
  AvatarsConnection: ResolverTypeWrapper<AvatarsConnection>;
  AvatarsEdge: ResolverTypeWrapper<AvatarsEdge>;
  AvatarsOrderBy: AvatarsOrderBy;
  BigFloat: ResolverTypeWrapper<Scalars['BigFloat']['output']>;
  BigFloatFilter: BigFloatFilter;
  BigInt: ResolverTypeWrapper<Scalars['BigInt']['output']>;
  BigIntFilter: BigIntFilter;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BooleanFilter: BooleanFilter;
  ChangeUserSessionInput: ChangeUserSessionInput;
  ChangeUserSessionPayload: ResolverTypeWrapper<ChangeUserSessionPayload>;
  CodeFile: ResolverTypeWrapper<CodeFile>;
  CodeFileCodeFilePkeyConnect: CodeFileCodeFilePkeyConnect;
  CodeFileCondition: CodeFileCondition;
  CodeFileFilter: CodeFileFilter;
  CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate;
  CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate;
  CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate;
  CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput: CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput;
  CodeFileTenantIdC35D8B4EFkTenantIdInput: CodeFileTenantIdC35D8B4EFkTenantIdInput;
  CodeFileTenantIdC35D8B4EFkTenantIdInverseInput: CodeFileTenantIdC35D8B4EFkTenantIdInverseInput;
  CodeFileToManyCodeFileFilter: CodeFileToManyCodeFileFilter;
  CodeFileUserIdAb9E5143FkApplicationUserIdInput: CodeFileUserIdAb9E5143FkApplicationUserIdInput;
  CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput: CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput;
  CodeFilesConnection: ResolverTypeWrapper<CodeFilesConnection>;
  CodeFilesEdge: ResolverTypeWrapper<CodeFilesEdge>;
  CodeFilesOrderBy: CodeFilesOrderBy;
  CreateApplicationUserMetadatumInput: CreateApplicationUserMetadatumInput;
  CreateApplicationUserMetadatumPayload: ResolverTypeWrapper<CreateApplicationUserMetadatumPayload>;
  CreateApplicationUserSessionInput: CreateApplicationUserSessionInput;
  CreateApplicationUserSessionPayload: ResolverTypeWrapper<CreateApplicationUserSessionPayload>;
  CreateEulaVersionUserAcceptanceInput: CreateEulaVersionUserAcceptanceInput;
  CreateEulaVersionUserAcceptancePayload: ResolverTypeWrapper<CreateEulaVersionUserAcceptancePayload>;
  CreateMetadataValueInput: CreateMetadataValueInput;
  CreateMetadataValuePayload: ResolverTypeWrapper<CreateMetadataValuePayload>;
  CreateMetadatumInput: CreateMetadatumInput;
  CreateMetadatumPayload: ResolverTypeWrapper<CreateMetadatumPayload>;
  CreateRoleInput: CreateRoleInput;
  CreateRolePayload: ResolverTypeWrapper<CreateRolePayload>;
  CreateSessionInput: CreateSessionInput;
  CreateSessionPayload: ResolverTypeWrapper<CreateSessionPayload>;
  CurrentApplicationUser: ResolverTypeWrapper<CurrentApplicationUser>;
  CurrentApplicationUserCondition: CurrentApplicationUserCondition;
  CurrentApplicationUserFilter: CurrentApplicationUserFilter;
  CurrentApplicationUsersConnection: ResolverTypeWrapper<CurrentApplicationUsersConnection>;
  CurrentApplicationUsersEdge: ResolverTypeWrapper<CurrentApplicationUsersEdge>;
  CurrentApplicationUsersOrderBy: CurrentApplicationUsersOrderBy;
  CurrentUserMembership: ResolverTypeWrapper<CurrentUserMembership>;
  CurrentUserMembershipCondition: CurrentUserMembershipCondition;
  CurrentUserMembershipFilter: CurrentUserMembershipFilter;
  CurrentUserMembershipsConnection: ResolverTypeWrapper<CurrentUserMembershipsConnection>;
  CurrentUserMembershipsEdge: ResolverTypeWrapper<CurrentUserMembershipsEdge>;
  CurrentUserMembershipsOrderBy: CurrentUserMembershipsOrderBy;
  Cursor: ResolverTypeWrapper<Scalars['Cursor']['output']>;
  DataTable: ResolverTypeWrapper<DataTable>;
  DataTableCondition: DataTableCondition;
  DataTableDataTablePkeyConnect: DataTableDataTablePkeyConnect;
  DataTableFilter: DataTableFilter;
  DataTableFolderId4Fe6C7FeFkProjectFolderIdInput: DataTableFolderId4Fe6C7FeFkProjectFolderIdInput;
  DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput: DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput;
  DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate;
  DataTableProjectId59F60EaeFkProjectIdInput: DataTableProjectId59F60EaeFkProjectIdInput;
  DataTableProjectId59F60EaeFkProjectIdInverseInput: DataTableProjectId59F60EaeFkProjectIdInverseInput;
  DataTableUserIdAb79B056FkApplicationUserIdInput: DataTableUserIdAb79B056FkApplicationUserIdInput;
  DataTableUserIdAb79B056FkApplicationUserIdInverseInput: DataTableUserIdAb79B056FkApplicationUserIdInverseInput;
  DataTablesConnection: ResolverTypeWrapper<DataTablesConnection>;
  DataTablesEdge: ResolverTypeWrapper<DataTablesEdge>;
  DataTablesOrderBy: DataTablesOrderBy;
  Datetime: ResolverTypeWrapper<Scalars['Datetime']['output']>;
  DatetimeFilter: DatetimeFilter;
  DeleteSessionInput: DeleteSessionInput;
  DeleteSessionPayload: ResolverTypeWrapper<DeleteSessionPayload>;
  EulaVersion: ResolverTypeWrapper<EulaVersion>;
  EulaVersionCondition: EulaVersionCondition;
  EulaVersionEulaVersionPkeyConnect: EulaVersionEulaVersionPkeyConnect;
  EulaVersionEulaVersionVersionKeyConnect: EulaVersionEulaVersionVersionKeyConnect;
  EulaVersionFilter: EulaVersionFilter;
  EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate: EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate;
  EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate: EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate;
  EulaVersionToManyEulaVersionUserAcceptanceFilter: EulaVersionToManyEulaVersionUserAcceptanceFilter;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput;
  EulaVersionUserAcceptance: ResolverTypeWrapper<EulaVersionUserAcceptance>;
  EulaVersionUserAcceptanceCondition: EulaVersionUserAcceptanceCondition;
  EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect: EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect;
  EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect: EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect;
  EulaVersionUserAcceptanceFilter: EulaVersionUserAcceptanceFilter;
  EulaVersionUserAcceptanceInput: EulaVersionUserAcceptanceInput;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate;
  EulaVersionUserAcceptancesConnection: ResolverTypeWrapper<EulaVersionUserAcceptancesConnection>;
  EulaVersionUserAcceptancesEdge: ResolverTypeWrapper<EulaVersionUserAcceptancesEdge>;
  EulaVersionUserAcceptancesOrderBy: EulaVersionUserAcceptancesOrderBy;
  EulaVersionsConnection: ResolverTypeWrapper<EulaVersionsConnection>;
  EulaVersionsEdge: ResolverTypeWrapper<EulaVersionsEdge>;
  EulaVersionsOrderBy: EulaVersionsOrderBy;
  File: ResolverTypeWrapper<File>;
  FileActivitiesConnection: ResolverTypeWrapper<FileActivitiesConnection>;
  FileActivitiesEdge: ResolverTypeWrapper<FileActivitiesEdge>;
  FileActivitiesOrderBy: FileActivitiesOrderBy;
  FileActivity: ResolverTypeWrapper<FileActivity>;
  FileActivityCondition: FileActivityCondition;
  FileActivityFileActivityPkeyConnect: FileActivityFileActivityPkeyConnect;
  FileActivityFileId015763A9FkFileIdInput: FileActivityFileId015763A9FkFileIdInput;
  FileActivityFileId015763A9FkFileIdInverseInput: FileActivityFileId015763A9FkFileIdInverseInput;
  FileActivityFilter: FileActivityFilter;
  FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate;
  FileActivityProjectId6F35B8CcFkProjectIdInput: FileActivityProjectId6F35B8CcFkProjectIdInput;
  FileActivityProjectId6F35B8CcFkProjectIdInverseInput: FileActivityProjectId6F35B8CcFkProjectIdInverseInput;
  FileActivityTenantIdC46A4F01FkTenantIdInput: FileActivityTenantIdC46A4F01FkTenantIdInput;
  FileActivityTenantIdC46A4F01FkTenantIdInverseInput: FileActivityTenantIdC46A4F01FkTenantIdInverseInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdInput: FileActivityUserId868Ad8A9FkApplicationUserIdInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput: FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput;
  FileCondition: FileCondition;
  FileFilePkeyConnect: FileFilePkeyConnect;
  FileFilter: FileFilter;
  FileMetadataConnection: ResolverTypeWrapper<FileMetadataConnection>;
  FileMetadataEdge: ResolverTypeWrapper<FileMetadataEdge>;
  FileMetadataFileId78256936FkFileIdInput: FileMetadataFileId78256936FkFileIdInput;
  FileMetadataFileId78256936FkFileIdInverseInput: FileMetadataFileId78256936FkFileIdInverseInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdInput: FileMetadataMetadataIdFefc0061FkMetadataIdInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput: FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput;
  FileMetadataOrderBy: FileMetadataOrderBy;
  FileMetadataProjectId3474994EFkProjectIdInput: FileMetadataProjectId3474994EFkProjectIdInput;
  FileMetadataProjectId3474994EFkProjectIdInverseInput: FileMetadataProjectId3474994EFkProjectIdInverseInput;
  FileMetadataTenantId79Fe438BFkTenantIdInput: FileMetadataTenantId79Fe438BFkTenantIdInput;
  FileMetadataTenantId79Fe438BFkTenantIdInverseInput: FileMetadataTenantId79Fe438BFkTenantIdInverseInput;
  FileMetadatum: ResolverTypeWrapper<FileMetadatum>;
  FileMetadatumCondition: FileMetadatumCondition;
  FileMetadatumFileMetadataPkeyConnect: FileMetadatumFileMetadataPkeyConnect;
  FileMetadatumFilter: FileMetadatumFilter;
  FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate;
  FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate: FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate;
  FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate: FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate;
  FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate: FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate;
  FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate: FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate;
  FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate: FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate;
  FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate: FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate;
  FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate: FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate;
  FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate: FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate;
  FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate: FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate;
  FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate: FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate;
  FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOutputGroup: ResolverTypeWrapper<FileOutputGroup>;
  FileOutputGroupCondition: FileOutputGroupCondition;
  FileOutputGroupFileOutputGroupPkeyConnect: FileOutputGroupFileOutputGroupPkeyConnect;
  FileOutputGroupFileOutputGroupTaskIdKeyConnect: FileOutputGroupFileOutputGroupTaskIdKeyConnect;
  FileOutputGroupFilter: FileOutputGroupFilter;
  FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput: FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput;
  FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput: FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput;
  FileOutputGroupMetadataConnection: ResolverTypeWrapper<FileOutputGroupMetadataConnection>;
  FileOutputGroupMetadataEdge: ResolverTypeWrapper<FileOutputGroupMetadataEdge>;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput;
  FileOutputGroupMetadataOrderBy: FileOutputGroupMetadataOrderBy;
  FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput: FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput;
  FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput: FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput;
  FileOutputGroupMetadatum: ResolverTypeWrapper<FileOutputGroupMetadatum>;
  FileOutputGroupMetadatumCondition: FileOutputGroupMetadatumCondition;
  FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect: FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect;
  FileOutputGroupMetadatumFilter: FileOutputGroupMetadatumFilter;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupProjectId908Fb9FfFkProjectIdInput: FileOutputGroupProjectId908Fb9FfFkProjectIdInput;
  FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput: FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput;
  FileOutputGroupTaskId2B1Df6A1FkTaskIdInput: FileOutputGroupTaskId2B1Df6A1FkTaskIdInput;
  FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput: FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput;
  FileOutputGroupTenantId3Fa46D44FkTenantIdInput: FileOutputGroupTenantId3Fa46D44FkTenantIdInput;
  FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput: FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput;
  FileOutputGroupToManyFileOutputGroupMetadatumFilter: FileOutputGroupToManyFileOutputGroupMetadatumFilter;
  FileOutputGroupToManyOutputGroupFileFilter: FileOutputGroupToManyOutputGroupFileFilter;
  FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput: FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput;
  FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput: FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput;
  FileOutputGroupsConnection: ResolverTypeWrapper<FileOutputGroupsConnection>;
  FileOutputGroupsEdge: ResolverTypeWrapper<FileOutputGroupsEdge>;
  FileOutputGroupsOrderBy: FileOutputGroupsOrderBy;
  FileProcessingNotiUserId08265156FkApplicatiInput: FileProcessingNotiUserId08265156FkApplicatiInput;
  FileProcessingNotiUserId08265156FkApplicatiInverseInput: FileProcessingNotiUserId08265156FkApplicatiInverseInput;
  FileProcessingNotification: ResolverTypeWrapper<FileProcessingNotification>;
  FileProcessingNotificationCondition: FileProcessingNotificationCondition;
  FileProcessingNotificationFileId717B514EFkFileIdInput: FileProcessingNotificationFileId717B514EFkFileIdInput;
  FileProcessingNotificationFileId717B514EFkFileIdInverseInput: FileProcessingNotificationFileId717B514EFkFileIdInverseInput;
  FileProcessingNotificationFileProcessingNotificationPkeyConnect: FileProcessingNotificationFileProcessingNotificationPkeyConnect;
  FileProcessingNotificationFilter: FileProcessingNotificationFilter;
  FileProcessingNotificationId630E6495FkNotificationIdInput: FileProcessingNotificationId630E6495FkNotificationIdInput;
  FileProcessingNotificationId630E6495FkNotificationIdInverseInput: FileProcessingNotificationId630E6495FkNotificationIdInverseInput;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationsConnection: ResolverTypeWrapper<FileProcessingNotificationsConnection>;
  FileProcessingNotificationsEdge: ResolverTypeWrapper<FileProcessingNotificationsEdge>;
  FileProcessingNotificationsOrderBy: FileProcessingNotificationsOrderBy;
  FileProjectId3Ecca975FkProjectIdInput: FileProjectId3Ecca975FkProjectIdInput;
  FileProjectId3Ecca975FkProjectIdInverseInput: FileProjectId3Ecca975FkProjectIdInverseInput;
  FileProjectReferenceIdUniqueConnect: FileProjectReferenceIdUniqueConnect;
  FileSeriesParentIdF7A07E20FkFileIdInput: FileSeriesParentIdF7A07E20FkFileIdInput;
  FileTaskIdE4Da87AeFkTaskIdInput: FileTaskIdE4Da87AeFkTaskIdInput;
  FileTaskIdE4Da87AeFkTaskIdInverseInput: FileTaskIdE4Da87AeFkTaskIdInverseInput;
  FileTenantId61625016FkTenantIdInput: FileTenantId61625016FkTenantIdInput;
  FileTenantId61625016FkTenantIdInverseInput: FileTenantId61625016FkTenantIdInverseInput;
  FileToManyFileActivityFilter: FileToManyFileActivityFilter;
  FileToManyFileFilter: FileToManyFileFilter;
  FileToManyFileMetadatumFilter: FileToManyFileMetadatumFilter;
  FileToManyFileProcessingNotificationFilter: FileToManyFileProcessingNotificationFilter;
  FileToManyOutputGroupFileFilter: FileToManyOutputGroupFileFilter;
  FileToManyTaskSourceFilter: FileToManyTaskSourceFilter;
  FileUserId01D90B53FkApplicationUserIdInput: FileUserId01D90B53FkApplicationUserIdInput;
  FileUserId01D90B53FkApplicationUserIdInverseInput: FileUserId01D90B53FkApplicationUserIdInverseInput;
  FilesConnection: ResolverTypeWrapper<FilesConnection>;
  FilesEdge: ResolverTypeWrapper<FilesEdge>;
  FilesOrderBy: FilesOrderBy;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FloatFilter: FloatFilter;
  GdtAnalysisTable: ResolverTypeWrapper<GdtAnalysisTable>;
  GdtAnalysisTableCondition: GdtAnalysisTableCondition;
  GdtAnalysisTableFilter: GdtAnalysisTableFilter;
  GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput: GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput;
  GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput: GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput;
  GdtAnalysisTableGdtAnalysisTablePkeyConnect: GdtAnalysisTableGdtAnalysisTablePkeyConnect;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableProjectId544B76D9FkProjectIdInput: GdtAnalysisTableProjectId544B76D9FkProjectIdInput;
  GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput: GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput;
  GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput: GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput;
  GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput: GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput;
  GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput: GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput;
  GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput: GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput;
  GdtAnalysisTableRow: ResolverTypeWrapper<GdtAnalysisTableRow>;
  GdtAnalysisTableRowCondition: GdtAnalysisTableRowCondition;
  GdtAnalysisTableRowFilter: GdtAnalysisTableRowFilter;
  GdtAnalysisTableRowGdtAnalysisTableRowOrderUniqueConnect: GdtAnalysisTableRowGdtAnalysisTableRowOrderUniqueConnect;
  GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect: GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect;
  GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect: GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowOrderUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowOrderUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowOrderUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowOrderUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowOrderUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowOrderUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowOrderUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowOrderUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowOrderUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowOrderUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput: GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput;
  GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput: GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput;
  GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput: GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput;
  GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput: GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput;
  GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput: GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput;
  GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput: GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput;
  GdtAnalysisTableRowsConnection: ResolverTypeWrapper<GdtAnalysisTableRowsConnection>;
  GdtAnalysisTableRowsEdge: ResolverTypeWrapper<GdtAnalysisTableRowsEdge>;
  GdtAnalysisTableRowsOrderBy: GdtAnalysisTableRowsOrderBy;
  GdtAnalysisTableToManyGdtAnalysisTableRowFilter: GdtAnalysisTableToManyGdtAnalysisTableRowFilter;
  GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput: GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput;
  GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput: GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput;
  GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput: GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput;
  GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput: GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput;
  GdtAnalysisTablesConnection: ResolverTypeWrapper<GdtAnalysisTablesConnection>;
  GdtAnalysisTablesEdge: ResolverTypeWrapper<GdtAnalysisTablesEdge>;
  GdtAnalysisTablesOrderBy: GdtAnalysisTablesOrderBy;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  IntFilter: IntFilter;
  Interval: ResolverTypeWrapper<Interval>;
  IntervalFilter: IntervalFilter;
  IntervalInput: IntervalInput;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JSONFilter: JsonFilter;
  MetadataConnection: ResolverTypeWrapper<MetadataConnection>;
  MetadataEdge: ResolverTypeWrapper<MetadataEdge>;
  MetadataOrderBy: MetadataOrderBy;
  MetadataProjectId3333C2AdFkProjectIdInput: MetadataProjectId3333C2AdFkProjectIdInput;
  MetadataProjectId3333C2AdFkProjectIdInverseInput: MetadataProjectId3333C2AdFkProjectIdInverseInput;
  MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput: MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput;
  MetadataTenantIdC1D8772DFkTenantIdInput: MetadataTenantIdC1D8772DFkTenantIdInput;
  MetadataTenantIdC1D8772DFkTenantIdInverseInput: MetadataTenantIdC1D8772DFkTenantIdInverseInput;
  MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput: MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput;
  MetadataValue: ResolverTypeWrapper<MetadataValue>;
  MetadataValueCondition: MetadataValueCondition;
  MetadataValueFilter: MetadataValueFilter;
  MetadataValueInput: MetadataValueInput;
  MetadataValueMetadataId063A53B6FkMetadataIdInput: MetadataValueMetadataId063A53B6FkMetadataIdInput;
  MetadataValueMetadataId063A53B6FkMetadataIdInverseInput: MetadataValueMetadataId063A53B6FkMetadataIdInverseInput;
  MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput: MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput;
  MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput: MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput;
  MetadataValueMetadataValuePkeyConnect: MetadataValueMetadataValuePkeyConnect;
  MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate;
  MetadataValueProjectId87227D96FkProjectIdInput: MetadataValueProjectId87227D96FkProjectIdInput;
  MetadataValueProjectId87227D96FkProjectIdInverseInput: MetadataValueProjectId87227D96FkProjectIdInverseInput;
  MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput: MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput;
  MetadataValueTaskId3D37D135FkTaskIdInput: MetadataValueTaskId3D37D135FkTaskIdInput;
  MetadataValueTaskId3D37D135FkTaskIdInverseInput: MetadataValueTaskId3D37D135FkTaskIdInverseInput;
  MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput: MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdInput: MetadataValueTenantIdB4C2D5D6FkTenantIdInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput: MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput: MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput;
  MetadataValuesConnection: ResolverTypeWrapper<MetadataValuesConnection>;
  MetadataValuesEdge: ResolverTypeWrapper<MetadataValuesEdge>;
  MetadataValuesOrderBy: MetadataValuesOrderBy;
  Metadatum: ResolverTypeWrapper<Metadatum>;
  MetadatumCondition: MetadatumCondition;
  MetadatumFilter: MetadatumFilter;
  MetadatumInput: MetadatumInput;
  MetadatumMetadataPkeyConnect: MetadatumMetadataPkeyConnect;
  MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate: MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate: MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate;
  MetadatumToManyFileMetadatumFilter: MetadatumToManyFileMetadatumFilter;
  MetadatumToManyFileOutputGroupMetadatumFilter: MetadatumToManyFileOutputGroupMetadatumFilter;
  MetadatumToManyMetadataValueFilter: MetadatumToManyMetadataValueFilter;
  Mutation: ResolverTypeWrapper<{}>;
  Notification: ResolverTypeWrapper<Notification>;
  NotificationCondition: NotificationCondition;
  NotificationFilter: NotificationFilter;
  NotificationNotificationPkeyConnect: NotificationNotificationPkeyConnect;
  NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate: NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate;
  NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate: NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate;
  NotificationUserId1002Fc38FkApplicationUserIdInput: NotificationUserId1002Fc38FkApplicationUserIdInput;
  NotificationUserId1002Fc38FkApplicationUserIdInverseInput: NotificationUserId1002Fc38FkApplicationUserIdInverseInput;
  NotificationsConnection: ResolverTypeWrapper<NotificationsConnection>;
  NotificationsEdge: ResolverTypeWrapper<NotificationsEdge>;
  NotificationsOrderBy: NotificationsOrderBy;
  OutputGroupFile: ResolverTypeWrapper<OutputGroupFile>;
  OutputGroupFileCondition: OutputGroupFileCondition;
  OutputGroupFileFilter: OutputGroupFileFilter;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOutputGroupFilesPkeyConnect: OutputGroupFileOutputGroupFilesPkeyConnect;
  OutputGroupFilesConnection: ResolverTypeWrapper<OutputGroupFilesConnection>;
  OutputGroupFilesEdge: ResolverTypeWrapper<OutputGroupFilesEdge>;
  OutputGroupFilesFileIdEdeabb23FkFileIdInput: OutputGroupFilesFileIdEdeabb23FkFileIdInput;
  OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput: OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput;
  OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput: OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput;
  OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput: OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput;
  OutputGroupFilesOrderBy: OutputGroupFilesOrderBy;
  OutputGroupFilesProjectId8709B561FkProjectIdInput: OutputGroupFilesProjectId8709B561FkProjectIdInput;
  OutputGroupFilesProjectId8709B561FkProjectIdInverseInput: OutputGroupFilesProjectId8709B561FkProjectIdInverseInput;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Project: ResolverTypeWrapper<Project>;
  ProjectCloneSourceId92Ccacf5FkProjectIdInput: ProjectCloneSourceId92Ccacf5FkProjectIdInput;
  ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput: ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput;
  ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput: ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput;
  ProjectClonedNotifUserId4Fd693D7FkApplicatiInput: ProjectClonedNotifUserId4Fd693D7FkApplicatiInput;
  ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput: ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput;
  ProjectClonedNotification: ResolverTypeWrapper<ProjectClonedNotification>;
  ProjectClonedNotificationCondition: ProjectClonedNotificationCondition;
  ProjectClonedNotificationFilter: ProjectClonedNotificationFilter;
  ProjectClonedNotificationIdD235A018FkNotificationIdInput: ProjectClonedNotificationIdD235A018FkNotificationIdInput;
  ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput: ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationProjectClonedNotificationPkeyConnect: ProjectClonedNotificationProjectClonedNotificationPkeyConnect;
  ProjectClonedNotificationProjectIdF6267374FkProjectIdInput: ProjectClonedNotificationProjectIdF6267374FkProjectIdInput;
  ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput: ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput;
  ProjectClonedNotificationsConnection: ResolverTypeWrapper<ProjectClonedNotificationsConnection>;
  ProjectClonedNotificationsEdge: ResolverTypeWrapper<ProjectClonedNotificationsEdge>;
  ProjectClonedNotificationsOrderBy: ProjectClonedNotificationsOrderBy;
  ProjectCondition: ProjectCondition;
  ProjectFilter: ProjectFilter;
  ProjectFolder: ResolverTypeWrapper<ProjectFolder>;
  ProjectFolderCondition: ProjectFolderCondition;
  ProjectFolderFilter: ProjectFolderFilter;
  ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate: ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate: ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate: ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate: ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate;
  ProjectFolderProjectFolderPkeyConnect: ProjectFolderProjectFolderPkeyConnect;
  ProjectFolderProjectIdEf44DadfFkProjectIdInput: ProjectFolderProjectIdEf44DadfFkProjectIdInput;
  ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput: ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput;
  ProjectFolderToManyDataTableFilter: ProjectFolderToManyDataTableFilter;
  ProjectFolderToManyGdtAnalysisTableFilter: ProjectFolderToManyGdtAnalysisTableFilter;
  ProjectFolderUserIdF2E16179FkApplicationUserIdInput: ProjectFolderUserIdF2E16179FkApplicationUserIdInput;
  ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput: ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput;
  ProjectFoldersConnection: ResolverTypeWrapper<ProjectFoldersConnection>;
  ProjectFoldersEdge: ResolverTypeWrapper<ProjectFoldersEdge>;
  ProjectFoldersOrderBy: ProjectFoldersOrderBy;
  ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate: ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate: ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate: ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate: ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate: ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate;
  ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate: ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate: ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate;
  ProjectProjectKeyTenantUniqueConnect: ProjectProjectKeyTenantUniqueConnect;
  ProjectProjectPkeyConnect: ProjectProjectPkeyConnect;
  ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput: ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput;
  ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput: ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput;
  ProjectSharedNotifUserId9A19122FFkApplicatiInput: ProjectSharedNotifUserId9A19122FFkApplicatiInput;
  ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput: ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput;
  ProjectSharedNotification: ResolverTypeWrapper<ProjectSharedNotification>;
  ProjectSharedNotificationCondition: ProjectSharedNotificationCondition;
  ProjectSharedNotificationFilter: ProjectSharedNotificationFilter;
  ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput: ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput;
  ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput: ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput: ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput;
  ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput: ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput;
  ProjectSharedNotificationProjectSharedNotificationPkeyConnect: ProjectSharedNotificationProjectSharedNotificationPkeyConnect;
  ProjectSharedNotificationsConnection: ResolverTypeWrapper<ProjectSharedNotificationsConnection>;
  ProjectSharedNotificationsEdge: ResolverTypeWrapper<ProjectSharedNotificationsEdge>;
  ProjectSharedNotificationsOrderBy: ProjectSharedNotificationsOrderBy;
  ProjectTag: ResolverTypeWrapper<ProjectTag>;
  ProjectTagCondition: ProjectTagCondition;
  ProjectTagFilter: ProjectTagFilter;
  ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate: ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate;
  ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate: ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate;
  ProjectTagProjectId5Ab280C9FkProjectIdInput: ProjectTagProjectId5Ab280C9FkProjectIdInput;
  ProjectTagProjectId5Ab280C9FkProjectIdInverseInput: ProjectTagProjectId5Ab280C9FkProjectIdInverseInput;
  ProjectTagProjectTagPkeyConnect: ProjectTagProjectTagPkeyConnect;
  ProjectTagUserId780C8348FkApplicationUserIdInput: ProjectTagUserId780C8348FkApplicationUserIdInput;
  ProjectTagUserId780C8348FkApplicationUserIdInverseInput: ProjectTagUserId780C8348FkApplicationUserIdInverseInput;
  ProjectTagsConnection: ResolverTypeWrapper<ProjectTagsConnection>;
  ProjectTagsEdge: ResolverTypeWrapper<ProjectTagsEdge>;
  ProjectTagsOrderBy: ProjectTagsOrderBy;
  ProjectTenantId03F0Ca53FkTenantIdInput: ProjectTenantId03F0Ca53FkTenantIdInput;
  ProjectTenantId03F0Ca53FkTenantIdInverseInput: ProjectTenantId03F0Ca53FkTenantIdInverseInput;
  ProjectToManyDataTableFilter: ProjectToManyDataTableFilter;
  ProjectToManyFileActivityFilter: ProjectToManyFileActivityFilter;
  ProjectToManyFileFilter: ProjectToManyFileFilter;
  ProjectToManyFileMetadatumFilter: ProjectToManyFileMetadatumFilter;
  ProjectToManyFileOutputGroupFilter: ProjectToManyFileOutputGroupFilter;
  ProjectToManyFileOutputGroupMetadatumFilter: ProjectToManyFileOutputGroupMetadatumFilter;
  ProjectToManyGdtAnalysisTableFilter: ProjectToManyGdtAnalysisTableFilter;
  ProjectToManyGdtAnalysisTableRowFilter: ProjectToManyGdtAnalysisTableRowFilter;
  ProjectToManyMetadataValueFilter: ProjectToManyMetadataValueFilter;
  ProjectToManyMetadatumFilter: ProjectToManyMetadatumFilter;
  ProjectToManyOutputGroupFileFilter: ProjectToManyOutputGroupFileFilter;
  ProjectToManyProjectClonedNotificationFilter: ProjectToManyProjectClonedNotificationFilter;
  ProjectToManyProjectFilter: ProjectToManyProjectFilter;
  ProjectToManyProjectFolderFilter: ProjectToManyProjectFolderFilter;
  ProjectToManyProjectSharedNotificationFilter: ProjectToManyProjectSharedNotificationFilter;
  ProjectToManyProjectTagFilter: ProjectToManyProjectTagFilter;
  ProjectToManyTaskFilter: ProjectToManyTaskFilter;
  ProjectUserIdB5Fbb914FkApplicationUserIdInput: ProjectUserIdB5Fbb914FkApplicationUserIdInput;
  ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput: ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput;
  ProjectsConnection: ResolverTypeWrapper<ProjectsConnection>;
  ProjectsEdge: ResolverTypeWrapper<ProjectsEdge>;
  ProjectsOrderBy: ProjectsOrderBy;
  Query: ResolverTypeWrapper<{}>;
  RoleChangeNotificaUserId879Bd49AFkApplicatiInput: RoleChangeNotificaUserId879Bd49AFkApplicatiInput;
  RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput: RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput;
  RoleChangeNotification: ResolverTypeWrapper<RoleChangeNotification>;
  RoleChangeNotificationCondition: RoleChangeNotificationCondition;
  RoleChangeNotificationFilter: RoleChangeNotificationFilter;
  RoleChangeNotificationIdD576A528FkNotificationIdInput: RoleChangeNotificationIdD576A528FkNotificationIdInput;
  RoleChangeNotificationIdD576A528FkNotificationIdInverseInput: RoleChangeNotificationIdD576A528FkNotificationIdInverseInput;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationRoleChangeNotificationPkeyConnect: RoleChangeNotificationRoleChangeNotificationPkeyConnect;
  RoleChangeNotificationTenantId36852Ce9FkTenantIdInput: RoleChangeNotificationTenantId36852Ce9FkTenantIdInput;
  RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput: RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput;
  RoleChangeNotificationsConnection: ResolverTypeWrapper<RoleChangeNotificationsConnection>;
  RoleChangeNotificationsEdge: ResolverTypeWrapper<RoleChangeNotificationsEdge>;
  RoleChangeNotificationsOrderBy: RoleChangeNotificationsOrderBy;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StringFilter: StringFilter;
  Task: ResolverTypeWrapper<Task>;
  TaskActivitiesConnection: ResolverTypeWrapper<TaskActivitiesConnection>;
  TaskActivitiesEdge: ResolverTypeWrapper<TaskActivitiesEdge>;
  TaskActivitiesOrderBy: TaskActivitiesOrderBy;
  TaskActivity: ResolverTypeWrapper<TaskActivity>;
  TaskActivityCondition: TaskActivityCondition;
  TaskActivityFilter: TaskActivityFilter;
  TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate: TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate;
  TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate: TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate;
  TaskActivityTaskActivityPkeyConnect: TaskActivityTaskActivityPkeyConnect;
  TaskActivityTaskActivityTaskIdKeyConnect: TaskActivityTaskActivityTaskIdKeyConnect;
  TaskActivityTaskIdC451Ae92FkTaskIdInput: TaskActivityTaskIdC451Ae92FkTaskIdInput;
  TaskActivityTaskIdC451Ae92FkTaskIdInverseInput: TaskActivityTaskIdC451Ae92FkTaskIdInverseInput;
  TaskCondition: TaskCondition;
  TaskFilter: TaskFilter;
  TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate: TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate;
  TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate: TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate;
  TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate: TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate;
  TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate: TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate: TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate: TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate: TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate: TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate;
  TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate: TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate;
  TaskProjectId963D6354FkProjectIdInput: TaskProjectId963D6354FkProjectIdInput;
  TaskProjectId963D6354FkProjectIdInverseInput: TaskProjectId963D6354FkProjectIdInverseInput;
  TaskResource: ResolverTypeWrapper<TaskResource>;
  TaskResourceCondition: TaskResourceCondition;
  TaskResourceFilter: TaskResourceFilter;
  TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate: TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate;
  TaskResourceTaskId73Fcabc0FkTaskIdInput: TaskResourceTaskId73Fcabc0FkTaskIdInput;
  TaskResourceTaskId73Fcabc0FkTaskIdInverseInput: TaskResourceTaskId73Fcabc0FkTaskIdInverseInput;
  TaskResourceTaskResourcePkeyConnect: TaskResourceTaskResourcePkeyConnect;
  TaskResourceUsage: ResolverTypeWrapper<TaskResourceUsage>;
  TaskResourceUsageCondition: TaskResourceUsageCondition;
  TaskResourceUsageFilter: TaskResourceUsageFilter;
  TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate: TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate;
  TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate: TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate;
  TaskResourceUsageTaskIdA28F1580FkTaskIdInput: TaskResourceUsageTaskIdA28F1580FkTaskIdInput;
  TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput: TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput;
  TaskResourceUsageTaskResourceUsagePkeyConnect: TaskResourceUsageTaskResourceUsagePkeyConnect;
  TaskResourceUsageTaskResourceUsageTaskIdKeyConnect: TaskResourceUsageTaskResourceUsageTaskIdKeyConnect;
  TaskResourceUsagesConnection: ResolverTypeWrapper<TaskResourceUsagesConnection>;
  TaskResourceUsagesEdge: ResolverTypeWrapper<TaskResourceUsagesEdge>;
  TaskResourceUsagesOrderBy: TaskResourceUsagesOrderBy;
  TaskResourcesConnection: ResolverTypeWrapper<TaskResourcesConnection>;
  TaskResourcesEdge: ResolverTypeWrapper<TaskResourcesEdge>;
  TaskResourcesOrderBy: TaskResourcesOrderBy;
  TaskSource: ResolverTypeWrapper<TaskSource>;
  TaskSourceCondition: TaskSourceCondition;
  TaskSourceFileId2F628862FkFileIdInput: TaskSourceFileId2F628862FkFileIdInput;
  TaskSourceFileId2F628862FkFileIdInverseInput: TaskSourceFileId2F628862FkFileIdInverseInput;
  TaskSourceFilter: TaskSourceFilter;
  TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate;
  TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate;
  TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate;
  TaskSourceTaskIdF241BaedFkTaskIdInput: TaskSourceTaskIdF241BaedFkTaskIdInput;
  TaskSourceTaskIdF241BaedFkTaskIdInverseInput: TaskSourceTaskIdF241BaedFkTaskIdInverseInput;
  TaskSourceTaskSourcePkeyConnect: TaskSourceTaskSourcePkeyConnect;
  TaskSourceToolSourceId14453EdbFkToolSourceIdInput: TaskSourceToolSourceId14453EdbFkToolSourceIdInput;
  TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput: TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput;
  TaskSourcesConnection: ResolverTypeWrapper<TaskSourcesConnection>;
  TaskSourcesEdge: ResolverTypeWrapper<TaskSourcesEdge>;
  TaskSourcesOrderBy: TaskSourcesOrderBy;
  TaskTaskExecutorIdKeyConnect: TaskTaskExecutorIdKeyConnect;
  TaskTaskPkeyConnect: TaskTaskPkeyConnect;
  TaskTenantId148E90DaFkTenantIdInput: TaskTenantId148E90DaFkTenantIdInput;
  TaskTenantId148E90DaFkTenantIdInverseInput: TaskTenantId148E90DaFkTenantIdInverseInput;
  TaskToManyFileFilter: TaskToManyFileFilter;
  TaskToManyGdtAnalysisTableRowFilter: TaskToManyGdtAnalysisTableRowFilter;
  TaskToManyMetadataValueFilter: TaskToManyMetadataValueFilter;
  TaskToManyTaskResourceFilter: TaskToManyTaskResourceFilter;
  TaskToManyTaskSourceFilter: TaskToManyTaskSourceFilter;
  TaskToolVersionId14506837FkToolVersionIdInput: TaskToolVersionId14506837FkToolVersionIdInput;
  TaskToolVersionId14506837FkToolVersionIdInverseInput: TaskToolVersionId14506837FkToolVersionIdInverseInput;
  TaskUserId270D0Bb2FkApplicationUserIdInput: TaskUserId270D0Bb2FkApplicationUserIdInput;
  TaskUserId270D0Bb2FkApplicationUserIdInverseInput: TaskUserId270D0Bb2FkApplicationUserIdInverseInput;
  TasksConnection: ResolverTypeWrapper<TasksConnection>;
  TasksEdge: ResolverTypeWrapper<TasksEdge>;
  TasksOrderBy: TasksOrderBy;
  Tenant: ResolverTypeWrapper<Tenant>;
  TenantContract: ResolverTypeWrapper<TenantContract>;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput;
  TenantContractAllowance: ResolverTypeWrapper<TenantContractAllowance>;
  TenantContractAllowanceCondition: TenantContractAllowanceCondition;
  TenantContractAllowanceFilter: TenantContractAllowanceFilter;
  TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate: TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate;
  TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate: TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate;
  TenantContractAllowanceTenantContractAllowancePkeyConnect: TenantContractAllowanceTenantContractAllowancePkeyConnect;
  TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect: TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect;
  TenantContractAllowancesConnection: ResolverTypeWrapper<TenantContractAllowancesConnection>;
  TenantContractAllowancesEdge: ResolverTypeWrapper<TenantContractAllowancesEdge>;
  TenantContractAllowancesOrderBy: TenantContractAllowancesOrderBy;
  TenantContractCondition: TenantContractCondition;
  TenantContractFilter: TenantContractFilter;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate;
  TenantContractTenantContractNameKeyConnect: TenantContractTenantContractNameKeyConnect;
  TenantContractTenantContractPkeyConnect: TenantContractTenantContractPkeyConnect;
  TenantContractTenantContractSfidKeyConnect: TenantContractTenantContractSfidKeyConnect;
  TenantContractTenantIdBa8Ac167FkTenantIdInput: TenantContractTenantIdBa8Ac167FkTenantIdInput;
  TenantContractTenantIdBa8Ac167FkTenantIdInverseInput: TenantContractTenantIdBa8Ac167FkTenantIdInverseInput;
  TenantContractToManyTenantContractTransactionFilter: TenantContractToManyTenantContractTransactionFilter;
  TenantContractTranTenantContractId1E374993FkTenantCoInput: TenantContractTranTenantContractId1E374993FkTenantCoInput;
  TenantContractTranTenantContractId1E374993FkTenantCoInverseInput: TenantContractTranTenantContractId1E374993FkTenantCoInverseInput;
  TenantContractTransaction: ResolverTypeWrapper<TenantContractTransaction>;
  TenantContractTransactionCondition: TenantContractTransactionCondition;
  TenantContractTransactionFilter: TenantContractTransactionFilter;
  TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate: TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate;
  TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate: TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate;
  TenantContractTransactionTenantContractTransactionPkeyConnect: TenantContractTransactionTenantContractTransactionPkeyConnect;
  TenantContractTransactionToManyTenantContractAllowanceFilter: TenantContractTransactionToManyTenantContractAllowanceFilter;
  TenantContractTransactionsConnection: ResolverTypeWrapper<TenantContractTransactionsConnection>;
  TenantContractTransactionsEdge: ResolverTypeWrapper<TenantContractTransactionsEdge>;
  TenantContractTransactionsOrderBy: TenantContractTransactionsOrderBy;
  TenantContractsConnection: ResolverTypeWrapper<TenantContractsConnection>;
  TenantContractsEdge: ResolverTypeWrapper<TenantContractsEdge>;
  TenantContractsOrderBy: TenantContractsOrderBy;
  TenantFilter: TenantFilter;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate;
  TenantTenantKeyKeyConnect: TenantTenantKeyKeyConnect;
  TenantTenantPkeyConnect: TenantTenantPkeyConnect;
  TenantTenantRepositoryNameKeyConnect: TenantTenantRepositoryNameKeyConnect;
  TenantTenantSfidKeyConnect: TenantTenantSfidKeyConnect;
  TenantToManyApplicationUserMembershipFilter: TenantToManyApplicationUserMembershipFilter;
  TenantToManyApplicationUserSessionFilter: TenantToManyApplicationUserSessionFilter;
  TenantToManyCodeFileFilter: TenantToManyCodeFileFilter;
  TenantToManyFileActivityFilter: TenantToManyFileActivityFilter;
  TenantToManyFileFilter: TenantToManyFileFilter;
  TenantToManyFileMetadatumFilter: TenantToManyFileMetadatumFilter;
  TenantToManyFileOutputGroupFilter: TenantToManyFileOutputGroupFilter;
  TenantToManyFileOutputGroupMetadatumFilter: TenantToManyFileOutputGroupMetadatumFilter;
  TenantToManyMetadataValueFilter: TenantToManyMetadataValueFilter;
  TenantToManyMetadatumFilter: TenantToManyMetadatumFilter;
  TenantToManyProjectFilter: TenantToManyProjectFilter;
  TenantToManyRoleChangeNotificationFilter: TenantToManyRoleChangeNotificationFilter;
  TenantToManyTaskFilter: TenantToManyTaskFilter;
  TenantToManyTenantContractFilter: TenantToManyTenantContractFilter;
  TenantToManyTenantUserMembershipNotificationFilter: TenantToManyTenantUserMembershipNotificationFilter;
  TenantToManyToolFilter: TenantToManyToolFilter;
  TenantToManyToolTenantFilter: TenantToManyToolTenantFilter;
  TenantToManyToolVersionFilter: TenantToManyToolVersionFilter;
  TenantUserMembershId10Affa8DFkNotificatInput: TenantUserMembershId10Affa8DFkNotificatInput;
  TenantUserMembershId10Affa8DFkNotificatInverseInput: TenantUserMembershId10Affa8DFkNotificatInverseInput;
  TenantUserMembershInviterId29476E5EFkApplicatiInput: TenantUserMembershInviterId29476E5EFkApplicatiInput;
  TenantUserMembershInviterId29476E5EFkApplicatiInverseInput: TenantUserMembershInviterId29476E5EFkApplicatiInverseInput;
  TenantUserMembershTenantIdC67818C5FkTenantIdInput: TenantUserMembershTenantIdC67818C5FkTenantIdInput;
  TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput: TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput;
  TenantUserMembershUserId2B78E8A0FkApplicatiInput: TenantUserMembershUserId2B78E8A0FkApplicatiInput;
  TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput: TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput;
  TenantUserMembershipNotification: ResolverTypeWrapper<TenantUserMembershipNotification>;
  TenantUserMembershipNotificationCondition: TenantUserMembershipNotificationCondition;
  TenantUserMembershipNotificationFilter: TenantUserMembershipNotificationFilter;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect: TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect;
  TenantUserMembershipNotificationsConnection: ResolverTypeWrapper<TenantUserMembershipNotificationsConnection>;
  TenantUserMembershipNotificationsEdge: ResolverTypeWrapper<TenantUserMembershipNotificationsEdge>;
  TenantUserMembershipNotificationsOrderBy: TenantUserMembershipNotificationsOrderBy;
  Tool: ResolverTypeWrapper<Tool>;
  ToolCondition: ToolCondition;
  ToolFilter: ToolFilter;
  ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate: ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate;
  ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate: ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate;
  ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate: ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate;
  ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate;
  ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate: ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate;
  ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate: ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate;
  ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate: ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate;
  ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate: ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate;
  ToolParameter: ResolverTypeWrapper<ToolParameter>;
  ToolParameterCondition: ToolParameterCondition;
  ToolParameterFilter: ToolParameterFilter;
  ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate: ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate;
  ToolParameterToolParameterPkeyConnect: ToolParameterToolParameterPkeyConnect;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput;
  ToolParametersConnection: ResolverTypeWrapper<ToolParametersConnection>;
  ToolParametersEdge: ResolverTypeWrapper<ToolParametersEdge>;
  ToolParametersOrderBy: ToolParametersOrderBy;
  ToolProjectId20A84210FkProjectIdInput: ToolProjectId20A84210FkProjectIdInput;
  ToolProjectId20A84210FkProjectIdInverseInput: ToolProjectId20A84210FkProjectIdInverseInput;
  ToolResult: ResolverTypeWrapper<ToolResult>;
  ToolResultCondition: ToolResultCondition;
  ToolResultFilter: ToolResultFilter;
  ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate: ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate;
  ToolResultToolResultPkeyConnect: ToolResultToolResultPkeyConnect;
  ToolResultToolVersionId41Fb163EFkToolVersionIdInput: ToolResultToolVersionId41Fb163EFkToolVersionIdInput;
  ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput: ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput;
  ToolResultsConnection: ResolverTypeWrapper<ToolResultsConnection>;
  ToolResultsEdge: ResolverTypeWrapper<ToolResultsEdge>;
  ToolResultsOrderBy: ToolResultsOrderBy;
  ToolSecret: ResolverTypeWrapper<ToolSecret>;
  ToolSecretCondition: ToolSecretCondition;
  ToolSecretFilter: ToolSecretFilter;
  ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate: ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate;
  ToolSecretToolSecretPkeyConnect: ToolSecretToolSecretPkeyConnect;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput;
  ToolSecretsConnection: ResolverTypeWrapper<ToolSecretsConnection>;
  ToolSecretsEdge: ResolverTypeWrapper<ToolSecretsEdge>;
  ToolSecretsOrderBy: ToolSecretsOrderBy;
  ToolSource: ResolverTypeWrapper<ToolSource>;
  ToolSourceCondition: ToolSourceCondition;
  ToolSourceFilter: ToolSourceFilter;
  ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate: ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate;
  ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate: ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate;
  ToolSourceToManyTaskSourceFilter: ToolSourceToManyTaskSourceFilter;
  ToolSourceToolSourcePkeyConnect: ToolSourceToolSourcePkeyConnect;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput;
  ToolSourcesConnection: ResolverTypeWrapper<ToolSourcesConnection>;
  ToolSourcesEdge: ResolverTypeWrapper<ToolSourcesEdge>;
  ToolSourcesOrderBy: ToolSourcesOrderBy;
  ToolTenant: ResolverTypeWrapper<ToolTenant>;
  ToolTenantCondition: ToolTenantCondition;
  ToolTenantFilter: ToolTenantFilter;
  ToolTenantId1Baab08EFkTenantIdInput: ToolTenantId1Baab08EFkTenantIdInput;
  ToolTenantId1Baab08EFkTenantIdInverseInput: ToolTenantId1Baab08EFkTenantIdInverseInput;
  ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate: ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate;
  ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate: ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate;
  ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate: ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate;
  ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate: ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate;
  ToolTenantToolTenantsPkeyConnect: ToolTenantToolTenantsPkeyConnect;
  ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect: ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect;
  ToolTenantsConnection: ResolverTypeWrapper<ToolTenantsConnection>;
  ToolTenantsEdge: ResolverTypeWrapper<ToolTenantsEdge>;
  ToolTenantsOrderBy: ToolTenantsOrderBy;
  ToolTenantsTenantId9C4A54FeFkTenantIdInput: ToolTenantsTenantId9C4A54FeFkTenantIdInput;
  ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput: ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdInput: ToolTenantsToolIdF77Ef6F7FkToolIdInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput: ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput;
  ToolToManyToolTenantFilter: ToolToManyToolTenantFilter;
  ToolToManyToolVersionFilter: ToolToManyToolVersionFilter;
  ToolToolPkeyConnect: ToolToolPkeyConnect;
  ToolToolProjectIdKeyConnect: ToolToolProjectIdKeyConnect;
  ToolUserIdFd36Dfa4FkApplicationUserIdInput: ToolUserIdFd36Dfa4FkApplicationUserIdInput;
  ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput: ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput;
  ToolVersion: ResolverTypeWrapper<ToolVersion>;
  ToolVersionCondition: ToolVersionCondition;
  ToolVersionFilter: ToolVersionFilter;
  ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate: ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate;
  ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate;
  ToolVersionTenantId03A60B0CFkTenantIdInput: ToolVersionTenantId03A60B0CFkTenantIdInput;
  ToolVersionTenantId03A60B0CFkTenantIdInverseInput: ToolVersionTenantId03A60B0CFkTenantIdInverseInput;
  ToolVersionToManyGdtAnalysisTableFilter: ToolVersionToManyGdtAnalysisTableFilter;
  ToolVersionToManyGdtAnalysisTableRowFilter: ToolVersionToManyGdtAnalysisTableRowFilter;
  ToolVersionToManyTaskFilter: ToolVersionToManyTaskFilter;
  ToolVersionToManyToolParameterFilter: ToolVersionToManyToolParameterFilter;
  ToolVersionToManyToolResultFilter: ToolVersionToManyToolResultFilter;
  ToolVersionToManyToolSecretFilter: ToolVersionToManyToolSecretFilter;
  ToolVersionToManyToolSourceFilter: ToolVersionToManyToolSourceFilter;
  ToolVersionToolId3B396B22FkToolIdInput: ToolVersionToolId3B396B22FkToolIdInput;
  ToolVersionToolId3B396B22FkToolIdInverseInput: ToolVersionToolId3B396B22FkToolIdInverseInput;
  ToolVersionToolVersionPkeyConnect: ToolVersionToolVersionPkeyConnect;
  ToolVersionUserId68A75E07FkApplicationUserIdInput: ToolVersionUserId68A75E07FkApplicationUserIdInput;
  ToolVersionUserId68A75E07FkApplicationUserIdInverseInput: ToolVersionUserId68A75E07FkApplicationUserIdInverseInput;
  ToolVersionsConnection: ResolverTypeWrapper<ToolVersionsConnection>;
  ToolVersionsEdge: ResolverTypeWrapper<ToolVersionsEdge>;
  ToolVersionsOrderBy: ToolVersionsOrderBy;
  ToolsConnection: ResolverTypeWrapper<ToolsConnection>;
  ToolsEdge: ResolverTypeWrapper<ToolsEdge>;
  ToolsOrderBy: ToolsOrderBy;
  UUID: ResolverTypeWrapper<Scalars['UUID']['output']>;
  UUIDFilter: UuidFilter;
  UpdateApplicationUserByEmailInput: UpdateApplicationUserByEmailInput;
  UpdateApplicationUserByGlobalUserIdInput: UpdateApplicationUserByGlobalUserIdInput;
  UpdateApplicationUserByIdInput: UpdateApplicationUserByIdInput;
  UpdateApplicationUserByUsernameInput: UpdateApplicationUserByUsernameInput;
  UpdateApplicationUserMetadatumByIdInput: UpdateApplicationUserMetadatumByIdInput;
  UpdateApplicationUserMetadatumByUserIdAndKeyInput: UpdateApplicationUserMetadatumByUserIdAndKeyInput;
  UpdateApplicationUserMetadatumPayload: ResolverTypeWrapper<UpdateApplicationUserMetadatumPayload>;
  UpdateApplicationUserPayload: ResolverTypeWrapper<UpdateApplicationUserPayload>;
  UpdateAvatarByIdInput: UpdateAvatarByIdInput;
  UpdateAvatarByUserIdInput: UpdateAvatarByUserIdInput;
  UpdateAvatarPayload: ResolverTypeWrapper<UpdateAvatarPayload>;
  UserAccessToProject: ResolverTypeWrapper<UserAccessToProject>;
  UserAccessToProjectCondition: UserAccessToProjectCondition;
  UserAccessToProjectFilter: UserAccessToProjectFilter;
  UserAccessToProjectsConnection: ResolverTypeWrapper<UserAccessToProjectsConnection>;
  UserAccessToProjectsEdge: ResolverTypeWrapper<UserAccessToProjectsEdge>;
  UserAccessToProjectsOrderBy: UserAccessToProjectsOrderBy;
  updateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  updateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  updateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch: UpdateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  updateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  updateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  updateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  updateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  updateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  updateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  updateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  updateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  updateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  updateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  updateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  updateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  updateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  updateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  updateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  updateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  updateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  updateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  updateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  updateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  updateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  updateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  updateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  updateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  updateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  updateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  updateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  updateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  updateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  updateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch: UpdateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  updateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch: UpdateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch;
  updateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch: UpdateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  updateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch: UpdateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  updateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch: UpdateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
  updateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch: UpdateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  updateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch: UpdateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  updateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch: UpdateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  updateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  updateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  updateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch: UpdateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  updateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch: UpdateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  updateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch: UpdateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  updateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch: UpdateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  updateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch: UpdateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  updateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch: UpdateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  updateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch: UpdateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch;
  updateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch: UpdateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  updateFileOnFileForFileTenantId61625016FkTenantIdPatch: UpdateFileOnFileForFileTenantId61625016FkTenantIdPatch;
  updateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch: UpdateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  updateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch: UpdateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  updateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch: UpdateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  updateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch: UpdateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  updateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch: UpdateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  updateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch: UpdateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  updateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch: UpdateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  updateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch: UpdateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
  updateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch: UpdateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
  updateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch: UpdateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
  updateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch: UpdateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  updateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch: UpdateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  updateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch: UpdateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
  updateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch: UpdateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  updateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch: UpdateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
  updateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch: UpdateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
  updateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch: UpdateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
  updateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch: UpdateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  updateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch: UpdateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
  updateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch: UpdateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
  updateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch: UpdateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  updateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch: UpdateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  updateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch: UpdateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  updateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch: UpdateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  updateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch: UpdateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  updateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch: UpdateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  updateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch: UpdateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  updateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch: UpdateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  updateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch: UpdateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  updateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch: UpdateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  updateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch: UpdateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  updateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch: UpdateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  updateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch: UpdateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  updateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  updateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  updateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch: UpdateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  updateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch: UpdateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch;
  updateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch: UpdateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  updateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch: UpdateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  updateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch: UpdateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  updateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch: UpdateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  updateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch: UpdateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  updateProjectOnToolForToolProjectId20A84210FkProjectIdPatch: UpdateProjectOnToolForToolProjectId20A84210FkProjectIdPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  updateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch: UpdateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  updateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch: UpdateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  updateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch: UpdateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  updateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch: UpdateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  updateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch: UpdateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  updateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch: UpdateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  updateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch: UpdateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  updateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch: UpdateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  updateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch: UpdateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  updateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch: UpdateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  updateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch: UpdateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  updateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch: UpdateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  updateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch: UpdateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  updateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch: UpdateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  updateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch: UpdateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  updateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch: UpdateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  updateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch: UpdateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
  updateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch: UpdateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  updateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch: UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  updateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch: UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  updateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch: UpdateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  updateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch: UpdateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  updateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  updateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  updateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  updateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  updateTenantOnFileForFileTenantId61625016FkTenantIdPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
  updateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  updateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  updateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  updateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  updateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  updateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  updateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  updateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  updateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  updateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  updateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  updateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  updateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  updateToolOnToolForToolProjectId20A84210FkProjectIdPatch: UpdateToolOnToolForToolProjectId20A84210FkProjectIdPatch;
  updateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch: UpdateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  updateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch: UpdateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  updateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch: UpdateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  updateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch: UpdateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  updateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch: UpdateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
  updateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch: UpdateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
  updateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch: UpdateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
  updateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch: UpdateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
  updateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch: UpdateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
  updateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch: UpdateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  updateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch: UpdateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  updateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch: UpdateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
  updateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch: UpdateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  updateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch: UpdateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  updateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch: UpdateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
  updateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch: UpdateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
  updateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch: UpdateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
  updateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch: UpdateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
  updateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch: UpdateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  updateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch: UpdateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  updateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch: UpdateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ApplicationUser: ApplicationUser;
  ApplicationUserApplicationUserEmailKeyConnect: ApplicationUserApplicationUserEmailKeyConnect;
  ApplicationUserApplicationUserGlobalUserIdKeyConnect: ApplicationUserApplicationUserGlobalUserIdKeyConnect;
  ApplicationUserApplicationUserPkeyConnect: ApplicationUserApplicationUserPkeyConnect;
  ApplicationUserApplicationUserUsernameKeyConnect: ApplicationUserApplicationUserUsernameKeyConnect;
  ApplicationUserFilter: ApplicationUserFilter;
  ApplicationUserMemUserId631Fddc5FkApplicatiInput: ApplicationUserMemUserId631Fddc5FkApplicatiInput;
  ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput: ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput;
  ApplicationUserMembership: ApplicationUserMembership;
  ApplicationUserMembershipApplicationUserMembershipPkeyConnect: ApplicationUserMembershipApplicationUserMembershipPkeyConnect;
  ApplicationUserMembershipCondition: ApplicationUserMembershipCondition;
  ApplicationUserMembershipFilter: ApplicationUserMembershipFilter;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput;
  ApplicationUserMembershipUserTenantUniqueConnect: ApplicationUserMembershipUserTenantUniqueConnect;
  ApplicationUserMembershipsConnection: ApplicationUserMembershipsConnection;
  ApplicationUserMembershipsEdge: ApplicationUserMembershipsEdge;
  ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput: ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput;
  ApplicationUserMetUserId897Fbde1FkApplicatiInput: ApplicationUserMetUserId897Fbde1FkApplicatiInput;
  ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput: ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput;
  ApplicationUserMetadataConnection: ApplicationUserMetadataConnection;
  ApplicationUserMetadataEdge: ApplicationUserMetadataEdge;
  ApplicationUserMetadatum: ApplicationUserMetadatum;
  ApplicationUserMetadatumApplicationUserMetadataPkeyConnect: ApplicationUserMetadatumApplicationUserMetadataPkeyConnect;
  ApplicationUserMetadatumCondition: ApplicationUserMetadatumCondition;
  ApplicationUserMetadatumFilter: ApplicationUserMetadatumFilter;
  ApplicationUserMetadatumInput: ApplicationUserMetadatumInput;
  ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate: ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate;
  ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate: ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate;
  ApplicationUserMetadatumPatch: ApplicationUserMetadatumPatch;
  ApplicationUserMetadatumUserKeyConnect: ApplicationUserMetadatumUserKeyConnect;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserPatch: ApplicationUserPatch;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiInput;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput;
  ApplicationUserSession: ApplicationUserSession;
  ApplicationUserSessionApplicationUserSessionPkeyConnect: ApplicationUserSessionApplicationUserSessionPkeyConnect;
  ApplicationUserSessionCondition: ApplicationUserSessionCondition;
  ApplicationUserSessionFilter: ApplicationUserSessionFilter;
  ApplicationUserSessionInput: ApplicationUserSessionInput;
  ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate: ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate;
  ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate: ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput;
  ApplicationUserSessionsConnection: ApplicationUserSessionsConnection;
  ApplicationUserSessionsEdge: ApplicationUserSessionsEdge;
  ApplicationUserToManyApplicationUserMembershipFilter: ApplicationUserToManyApplicationUserMembershipFilter;
  ApplicationUserToManyApplicationUserMetadatumFilter: ApplicationUserToManyApplicationUserMetadatumFilter;
  ApplicationUserToManyApplicationUserSessionFilter: ApplicationUserToManyApplicationUserSessionFilter;
  ApplicationUserToManyCodeFileFilter: ApplicationUserToManyCodeFileFilter;
  ApplicationUserToManyDataTableFilter: ApplicationUserToManyDataTableFilter;
  ApplicationUserToManyEulaVersionUserAcceptanceFilter: ApplicationUserToManyEulaVersionUserAcceptanceFilter;
  ApplicationUserToManyFileActivityFilter: ApplicationUserToManyFileActivityFilter;
  ApplicationUserToManyFileFilter: ApplicationUserToManyFileFilter;
  ApplicationUserToManyFileOutputGroupFilter: ApplicationUserToManyFileOutputGroupFilter;
  ApplicationUserToManyFileProcessingNotificationFilter: ApplicationUserToManyFileProcessingNotificationFilter;
  ApplicationUserToManyGdtAnalysisTableFilter: ApplicationUserToManyGdtAnalysisTableFilter;
  ApplicationUserToManyGdtAnalysisTableRowFilter: ApplicationUserToManyGdtAnalysisTableRowFilter;
  ApplicationUserToManyMetadataValueFilter: ApplicationUserToManyMetadataValueFilter;
  ApplicationUserToManyNotificationFilter: ApplicationUserToManyNotificationFilter;
  ApplicationUserToManyProjectClonedNotificationFilter: ApplicationUserToManyProjectClonedNotificationFilter;
  ApplicationUserToManyProjectFilter: ApplicationUserToManyProjectFilter;
  ApplicationUserToManyProjectFolderFilter: ApplicationUserToManyProjectFolderFilter;
  ApplicationUserToManyProjectSharedNotificationFilter: ApplicationUserToManyProjectSharedNotificationFilter;
  ApplicationUserToManyProjectTagFilter: ApplicationUserToManyProjectTagFilter;
  ApplicationUserToManyRoleChangeNotificationFilter: ApplicationUserToManyRoleChangeNotificationFilter;
  ApplicationUserToManyTaskFilter: ApplicationUserToManyTaskFilter;
  ApplicationUserToManyTenantUserMembershipNotificationFilter: ApplicationUserToManyTenantUserMembershipNotificationFilter;
  ApplicationUserToManyToolFilter: ApplicationUserToManyToolFilter;
  ApplicationUserToManyToolVersionFilter: ApplicationUserToManyToolVersionFilter;
  ApplicationUsersEdge: ApplicationUsersEdge;
  Avatar: Avatar;
  AvatarAvatarPkeyConnect: AvatarAvatarPkeyConnect;
  AvatarAvatarUserIdKeyConnect: AvatarAvatarUserIdKeyConnect;
  AvatarCondition: AvatarCondition;
  AvatarFilter: AvatarFilter;
  AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate: AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate;
  AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate: AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate;
  AvatarPatch: AvatarPatch;
  AvatarUserId771332F2FkApplicationUserIdInput: AvatarUserId771332F2FkApplicationUserIdInput;
  AvatarUserId771332F2FkApplicationUserIdInverseInput: AvatarUserId771332F2FkApplicationUserIdInverseInput;
  AvatarsConnection: AvatarsConnection;
  AvatarsEdge: AvatarsEdge;
  BigFloat: Scalars['BigFloat']['output'];
  BigFloatFilter: BigFloatFilter;
  BigInt: Scalars['BigInt']['output'];
  BigIntFilter: BigIntFilter;
  Boolean: Scalars['Boolean']['output'];
  BooleanFilter: BooleanFilter;
  ChangeUserSessionInput: ChangeUserSessionInput;
  ChangeUserSessionPayload: ChangeUserSessionPayload;
  CodeFile: CodeFile;
  CodeFileCodeFilePkeyConnect: CodeFileCodeFilePkeyConnect;
  CodeFileCondition: CodeFileCondition;
  CodeFileFilter: CodeFileFilter;
  CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate;
  CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate;
  CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate;
  CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput: CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput;
  CodeFileTenantIdC35D8B4EFkTenantIdInput: CodeFileTenantIdC35D8B4EFkTenantIdInput;
  CodeFileTenantIdC35D8B4EFkTenantIdInverseInput: CodeFileTenantIdC35D8B4EFkTenantIdInverseInput;
  CodeFileToManyCodeFileFilter: CodeFileToManyCodeFileFilter;
  CodeFileUserIdAb9E5143FkApplicationUserIdInput: CodeFileUserIdAb9E5143FkApplicationUserIdInput;
  CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput: CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput;
  CodeFilesConnection: CodeFilesConnection;
  CodeFilesEdge: CodeFilesEdge;
  CreateApplicationUserMetadatumInput: CreateApplicationUserMetadatumInput;
  CreateApplicationUserMetadatumPayload: CreateApplicationUserMetadatumPayload;
  CreateApplicationUserSessionInput: CreateApplicationUserSessionInput;
  CreateApplicationUserSessionPayload: CreateApplicationUserSessionPayload;
  CreateEulaVersionUserAcceptanceInput: CreateEulaVersionUserAcceptanceInput;
  CreateEulaVersionUserAcceptancePayload: CreateEulaVersionUserAcceptancePayload;
  CreateMetadataValueInput: CreateMetadataValueInput;
  CreateMetadataValuePayload: CreateMetadataValuePayload;
  CreateMetadatumInput: CreateMetadatumInput;
  CreateMetadatumPayload: CreateMetadatumPayload;
  CreateRoleInput: CreateRoleInput;
  CreateRolePayload: CreateRolePayload;
  CreateSessionInput: CreateSessionInput;
  CreateSessionPayload: CreateSessionPayload;
  CurrentApplicationUser: CurrentApplicationUser;
  CurrentApplicationUserCondition: CurrentApplicationUserCondition;
  CurrentApplicationUserFilter: CurrentApplicationUserFilter;
  CurrentApplicationUsersConnection: CurrentApplicationUsersConnection;
  CurrentApplicationUsersEdge: CurrentApplicationUsersEdge;
  CurrentUserMembership: CurrentUserMembership;
  CurrentUserMembershipCondition: CurrentUserMembershipCondition;
  CurrentUserMembershipFilter: CurrentUserMembershipFilter;
  CurrentUserMembershipsConnection: CurrentUserMembershipsConnection;
  CurrentUserMembershipsEdge: CurrentUserMembershipsEdge;
  Cursor: Scalars['Cursor']['output'];
  DataTable: DataTable;
  DataTableCondition: DataTableCondition;
  DataTableDataTablePkeyConnect: DataTableDataTablePkeyConnect;
  DataTableFilter: DataTableFilter;
  DataTableFolderId4Fe6C7FeFkProjectFolderIdInput: DataTableFolderId4Fe6C7FeFkProjectFolderIdInput;
  DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput: DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput;
  DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate;
  DataTableProjectId59F60EaeFkProjectIdInput: DataTableProjectId59F60EaeFkProjectIdInput;
  DataTableProjectId59F60EaeFkProjectIdInverseInput: DataTableProjectId59F60EaeFkProjectIdInverseInput;
  DataTableUserIdAb79B056FkApplicationUserIdInput: DataTableUserIdAb79B056FkApplicationUserIdInput;
  DataTableUserIdAb79B056FkApplicationUserIdInverseInput: DataTableUserIdAb79B056FkApplicationUserIdInverseInput;
  DataTablesConnection: DataTablesConnection;
  DataTablesEdge: DataTablesEdge;
  Datetime: Scalars['Datetime']['output'];
  DatetimeFilter: DatetimeFilter;
  DeleteSessionInput: DeleteSessionInput;
  DeleteSessionPayload: DeleteSessionPayload;
  EulaVersion: EulaVersion;
  EulaVersionCondition: EulaVersionCondition;
  EulaVersionEulaVersionPkeyConnect: EulaVersionEulaVersionPkeyConnect;
  EulaVersionEulaVersionVersionKeyConnect: EulaVersionEulaVersionVersionKeyConnect;
  EulaVersionFilter: EulaVersionFilter;
  EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate: EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate;
  EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate: EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate;
  EulaVersionToManyEulaVersionUserAcceptanceFilter: EulaVersionToManyEulaVersionUserAcceptanceFilter;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput;
  EulaVersionUserAcceptance: EulaVersionUserAcceptance;
  EulaVersionUserAcceptanceCondition: EulaVersionUserAcceptanceCondition;
  EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect: EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect;
  EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect: EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect;
  EulaVersionUserAcceptanceFilter: EulaVersionUserAcceptanceFilter;
  EulaVersionUserAcceptanceInput: EulaVersionUserAcceptanceInput;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate;
  EulaVersionUserAcceptancesConnection: EulaVersionUserAcceptancesConnection;
  EulaVersionUserAcceptancesEdge: EulaVersionUserAcceptancesEdge;
  EulaVersionsConnection: EulaVersionsConnection;
  EulaVersionsEdge: EulaVersionsEdge;
  File: File;
  FileActivitiesConnection: FileActivitiesConnection;
  FileActivitiesEdge: FileActivitiesEdge;
  FileActivity: FileActivity;
  FileActivityCondition: FileActivityCondition;
  FileActivityFileActivityPkeyConnect: FileActivityFileActivityPkeyConnect;
  FileActivityFileId015763A9FkFileIdInput: FileActivityFileId015763A9FkFileIdInput;
  FileActivityFileId015763A9FkFileIdInverseInput: FileActivityFileId015763A9FkFileIdInverseInput;
  FileActivityFilter: FileActivityFilter;
  FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate;
  FileActivityProjectId6F35B8CcFkProjectIdInput: FileActivityProjectId6F35B8CcFkProjectIdInput;
  FileActivityProjectId6F35B8CcFkProjectIdInverseInput: FileActivityProjectId6F35B8CcFkProjectIdInverseInput;
  FileActivityTenantIdC46A4F01FkTenantIdInput: FileActivityTenantIdC46A4F01FkTenantIdInput;
  FileActivityTenantIdC46A4F01FkTenantIdInverseInput: FileActivityTenantIdC46A4F01FkTenantIdInverseInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdInput: FileActivityUserId868Ad8A9FkApplicationUserIdInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput: FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput;
  FileCondition: FileCondition;
  FileFilePkeyConnect: FileFilePkeyConnect;
  FileFilter: FileFilter;
  FileMetadataConnection: FileMetadataConnection;
  FileMetadataEdge: FileMetadataEdge;
  FileMetadataFileId78256936FkFileIdInput: FileMetadataFileId78256936FkFileIdInput;
  FileMetadataFileId78256936FkFileIdInverseInput: FileMetadataFileId78256936FkFileIdInverseInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdInput: FileMetadataMetadataIdFefc0061FkMetadataIdInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput: FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput;
  FileMetadataProjectId3474994EFkProjectIdInput: FileMetadataProjectId3474994EFkProjectIdInput;
  FileMetadataProjectId3474994EFkProjectIdInverseInput: FileMetadataProjectId3474994EFkProjectIdInverseInput;
  FileMetadataTenantId79Fe438BFkTenantIdInput: FileMetadataTenantId79Fe438BFkTenantIdInput;
  FileMetadataTenantId79Fe438BFkTenantIdInverseInput: FileMetadataTenantId79Fe438BFkTenantIdInverseInput;
  FileMetadatum: FileMetadatum;
  FileMetadatumCondition: FileMetadatumCondition;
  FileMetadatumFileMetadataPkeyConnect: FileMetadatumFileMetadataPkeyConnect;
  FileMetadatumFilter: FileMetadatumFilter;
  FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate;
  FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate: FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate;
  FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate: FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate;
  FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate: FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate;
  FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate: FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate;
  FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate: FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate;
  FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate: FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate;
  FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate: FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate;
  FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate: FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate;
  FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate: FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate;
  FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate: FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate;
  FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOutputGroup: FileOutputGroup;
  FileOutputGroupCondition: FileOutputGroupCondition;
  FileOutputGroupFileOutputGroupPkeyConnect: FileOutputGroupFileOutputGroupPkeyConnect;
  FileOutputGroupFileOutputGroupTaskIdKeyConnect: FileOutputGroupFileOutputGroupTaskIdKeyConnect;
  FileOutputGroupFilter: FileOutputGroupFilter;
  FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput: FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput;
  FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput: FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput;
  FileOutputGroupMetadataConnection: FileOutputGroupMetadataConnection;
  FileOutputGroupMetadataEdge: FileOutputGroupMetadataEdge;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput;
  FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput: FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput;
  FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput: FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput;
  FileOutputGroupMetadatum: FileOutputGroupMetadatum;
  FileOutputGroupMetadatumCondition: FileOutputGroupMetadatumCondition;
  FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect: FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect;
  FileOutputGroupMetadatumFilter: FileOutputGroupMetadatumFilter;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupProjectId908Fb9FfFkProjectIdInput: FileOutputGroupProjectId908Fb9FfFkProjectIdInput;
  FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput: FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput;
  FileOutputGroupTaskId2B1Df6A1FkTaskIdInput: FileOutputGroupTaskId2B1Df6A1FkTaskIdInput;
  FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput: FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput;
  FileOutputGroupTenantId3Fa46D44FkTenantIdInput: FileOutputGroupTenantId3Fa46D44FkTenantIdInput;
  FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput: FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput;
  FileOutputGroupToManyFileOutputGroupMetadatumFilter: FileOutputGroupToManyFileOutputGroupMetadatumFilter;
  FileOutputGroupToManyOutputGroupFileFilter: FileOutputGroupToManyOutputGroupFileFilter;
  FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput: FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput;
  FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput: FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput;
  FileOutputGroupsConnection: FileOutputGroupsConnection;
  FileOutputGroupsEdge: FileOutputGroupsEdge;
  FileProcessingNotiUserId08265156FkApplicatiInput: FileProcessingNotiUserId08265156FkApplicatiInput;
  FileProcessingNotiUserId08265156FkApplicatiInverseInput: FileProcessingNotiUserId08265156FkApplicatiInverseInput;
  FileProcessingNotification: FileProcessingNotification;
  FileProcessingNotificationCondition: FileProcessingNotificationCondition;
  FileProcessingNotificationFileId717B514EFkFileIdInput: FileProcessingNotificationFileId717B514EFkFileIdInput;
  FileProcessingNotificationFileId717B514EFkFileIdInverseInput: FileProcessingNotificationFileId717B514EFkFileIdInverseInput;
  FileProcessingNotificationFileProcessingNotificationPkeyConnect: FileProcessingNotificationFileProcessingNotificationPkeyConnect;
  FileProcessingNotificationFilter: FileProcessingNotificationFilter;
  FileProcessingNotificationId630E6495FkNotificationIdInput: FileProcessingNotificationId630E6495FkNotificationIdInput;
  FileProcessingNotificationId630E6495FkNotificationIdInverseInput: FileProcessingNotificationId630E6495FkNotificationIdInverseInput;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationsConnection: FileProcessingNotificationsConnection;
  FileProcessingNotificationsEdge: FileProcessingNotificationsEdge;
  FileProjectId3Ecca975FkProjectIdInput: FileProjectId3Ecca975FkProjectIdInput;
  FileProjectId3Ecca975FkProjectIdInverseInput: FileProjectId3Ecca975FkProjectIdInverseInput;
  FileProjectReferenceIdUniqueConnect: FileProjectReferenceIdUniqueConnect;
  FileSeriesParentIdF7A07E20FkFileIdInput: FileSeriesParentIdF7A07E20FkFileIdInput;
  FileTaskIdE4Da87AeFkTaskIdInput: FileTaskIdE4Da87AeFkTaskIdInput;
  FileTaskIdE4Da87AeFkTaskIdInverseInput: FileTaskIdE4Da87AeFkTaskIdInverseInput;
  FileTenantId61625016FkTenantIdInput: FileTenantId61625016FkTenantIdInput;
  FileTenantId61625016FkTenantIdInverseInput: FileTenantId61625016FkTenantIdInverseInput;
  FileToManyFileActivityFilter: FileToManyFileActivityFilter;
  FileToManyFileFilter: FileToManyFileFilter;
  FileToManyFileMetadatumFilter: FileToManyFileMetadatumFilter;
  FileToManyFileProcessingNotificationFilter: FileToManyFileProcessingNotificationFilter;
  FileToManyOutputGroupFileFilter: FileToManyOutputGroupFileFilter;
  FileToManyTaskSourceFilter: FileToManyTaskSourceFilter;
  FileUserId01D90B53FkApplicationUserIdInput: FileUserId01D90B53FkApplicationUserIdInput;
  FileUserId01D90B53FkApplicationUserIdInverseInput: FileUserId01D90B53FkApplicationUserIdInverseInput;
  FilesConnection: FilesConnection;
  FilesEdge: FilesEdge;
  Float: Scalars['Float']['output'];
  FloatFilter: FloatFilter;
  GdtAnalysisTable: GdtAnalysisTable;
  GdtAnalysisTableCondition: GdtAnalysisTableCondition;
  GdtAnalysisTableFilter: GdtAnalysisTableFilter;
  GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput: GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput;
  GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput: GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput;
  GdtAnalysisTableGdtAnalysisTablePkeyConnect: GdtAnalysisTableGdtAnalysisTablePkeyConnect;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableProjectId544B76D9FkProjectIdInput: GdtAnalysisTableProjectId544B76D9FkProjectIdInput;
  GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput: GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput;
  GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput: GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput;
  GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput: GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput;
  GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput: GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput;
  GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput: GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput;
  GdtAnalysisTableRow: GdtAnalysisTableRow;
  GdtAnalysisTableRowCondition: GdtAnalysisTableRowCondition;
  GdtAnalysisTableRowFilter: GdtAnalysisTableRowFilter;
  GdtAnalysisTableRowGdtAnalysisTableRowOrderUniqueConnect: GdtAnalysisTableRowGdtAnalysisTableRowOrderUniqueConnect;
  GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect: GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect;
  GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect: GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowOrderUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowOrderUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowOrderUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowOrderUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowOrderUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowOrderUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowOrderUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowOrderUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowOrderUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowOrderUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput: GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput;
  GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput: GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput;
  GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput: GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput;
  GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput: GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput;
  GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput: GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput;
  GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput: GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput;
  GdtAnalysisTableRowsConnection: GdtAnalysisTableRowsConnection;
  GdtAnalysisTableRowsEdge: GdtAnalysisTableRowsEdge;
  GdtAnalysisTableToManyGdtAnalysisTableRowFilter: GdtAnalysisTableToManyGdtAnalysisTableRowFilter;
  GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput: GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput;
  GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput: GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput;
  GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput: GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput;
  GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput: GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput;
  GdtAnalysisTablesConnection: GdtAnalysisTablesConnection;
  GdtAnalysisTablesEdge: GdtAnalysisTablesEdge;
  Int: Scalars['Int']['output'];
  IntFilter: IntFilter;
  Interval: Interval;
  IntervalFilter: IntervalFilter;
  IntervalInput: IntervalInput;
  JSON: Scalars['JSON']['output'];
  JSONFilter: JsonFilter;
  MetadataConnection: MetadataConnection;
  MetadataEdge: MetadataEdge;
  MetadataProjectId3333C2AdFkProjectIdInput: MetadataProjectId3333C2AdFkProjectIdInput;
  MetadataProjectId3333C2AdFkProjectIdInverseInput: MetadataProjectId3333C2AdFkProjectIdInverseInput;
  MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput: MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput;
  MetadataTenantIdC1D8772DFkTenantIdInput: MetadataTenantIdC1D8772DFkTenantIdInput;
  MetadataTenantIdC1D8772DFkTenantIdInverseInput: MetadataTenantIdC1D8772DFkTenantIdInverseInput;
  MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput: MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput;
  MetadataValue: MetadataValue;
  MetadataValueCondition: MetadataValueCondition;
  MetadataValueFilter: MetadataValueFilter;
  MetadataValueInput: MetadataValueInput;
  MetadataValueMetadataId063A53B6FkMetadataIdInput: MetadataValueMetadataId063A53B6FkMetadataIdInput;
  MetadataValueMetadataId063A53B6FkMetadataIdInverseInput: MetadataValueMetadataId063A53B6FkMetadataIdInverseInput;
  MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput: MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput;
  MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput: MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput;
  MetadataValueMetadataValuePkeyConnect: MetadataValueMetadataValuePkeyConnect;
  MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate;
  MetadataValueProjectId87227D96FkProjectIdInput: MetadataValueProjectId87227D96FkProjectIdInput;
  MetadataValueProjectId87227D96FkProjectIdInverseInput: MetadataValueProjectId87227D96FkProjectIdInverseInput;
  MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput: MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput;
  MetadataValueTaskId3D37D135FkTaskIdInput: MetadataValueTaskId3D37D135FkTaskIdInput;
  MetadataValueTaskId3D37D135FkTaskIdInverseInput: MetadataValueTaskId3D37D135FkTaskIdInverseInput;
  MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput: MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdInput: MetadataValueTenantIdB4C2D5D6FkTenantIdInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput: MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput: MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput;
  MetadataValuesConnection: MetadataValuesConnection;
  MetadataValuesEdge: MetadataValuesEdge;
  Metadatum: Metadatum;
  MetadatumCondition: MetadatumCondition;
  MetadatumFilter: MetadatumFilter;
  MetadatumInput: MetadatumInput;
  MetadatumMetadataPkeyConnect: MetadatumMetadataPkeyConnect;
  MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate: MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate: MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate;
  MetadatumToManyFileMetadatumFilter: MetadatumToManyFileMetadatumFilter;
  MetadatumToManyFileOutputGroupMetadatumFilter: MetadatumToManyFileOutputGroupMetadatumFilter;
  MetadatumToManyMetadataValueFilter: MetadatumToManyMetadataValueFilter;
  Mutation: {};
  Notification: Notification;
  NotificationCondition: NotificationCondition;
  NotificationFilter: NotificationFilter;
  NotificationNotificationPkeyConnect: NotificationNotificationPkeyConnect;
  NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate: NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate;
  NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate: NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate;
  NotificationUserId1002Fc38FkApplicationUserIdInput: NotificationUserId1002Fc38FkApplicationUserIdInput;
  NotificationUserId1002Fc38FkApplicationUserIdInverseInput: NotificationUserId1002Fc38FkApplicationUserIdInverseInput;
  NotificationsConnection: NotificationsConnection;
  NotificationsEdge: NotificationsEdge;
  OutputGroupFile: OutputGroupFile;
  OutputGroupFileCondition: OutputGroupFileCondition;
  OutputGroupFileFilter: OutputGroupFileFilter;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOutputGroupFilesPkeyConnect: OutputGroupFileOutputGroupFilesPkeyConnect;
  OutputGroupFilesConnection: OutputGroupFilesConnection;
  OutputGroupFilesEdge: OutputGroupFilesEdge;
  OutputGroupFilesFileIdEdeabb23FkFileIdInput: OutputGroupFilesFileIdEdeabb23FkFileIdInput;
  OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput: OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput;
  OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput: OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput;
  OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput: OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput;
  OutputGroupFilesProjectId8709B561FkProjectIdInput: OutputGroupFilesProjectId8709B561FkProjectIdInput;
  OutputGroupFilesProjectId8709B561FkProjectIdInverseInput: OutputGroupFilesProjectId8709B561FkProjectIdInverseInput;
  PageInfo: PageInfo;
  Project: Project;
  ProjectCloneSourceId92Ccacf5FkProjectIdInput: ProjectCloneSourceId92Ccacf5FkProjectIdInput;
  ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput: ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput;
  ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput: ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput;
  ProjectClonedNotifUserId4Fd693D7FkApplicatiInput: ProjectClonedNotifUserId4Fd693D7FkApplicatiInput;
  ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput: ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput;
  ProjectClonedNotification: ProjectClonedNotification;
  ProjectClonedNotificationCondition: ProjectClonedNotificationCondition;
  ProjectClonedNotificationFilter: ProjectClonedNotificationFilter;
  ProjectClonedNotificationIdD235A018FkNotificationIdInput: ProjectClonedNotificationIdD235A018FkNotificationIdInput;
  ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput: ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationProjectClonedNotificationPkeyConnect: ProjectClonedNotificationProjectClonedNotificationPkeyConnect;
  ProjectClonedNotificationProjectIdF6267374FkProjectIdInput: ProjectClonedNotificationProjectIdF6267374FkProjectIdInput;
  ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput: ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput;
  ProjectClonedNotificationsConnection: ProjectClonedNotificationsConnection;
  ProjectClonedNotificationsEdge: ProjectClonedNotificationsEdge;
  ProjectCondition: ProjectCondition;
  ProjectFilter: ProjectFilter;
  ProjectFolder: ProjectFolder;
  ProjectFolderCondition: ProjectFolderCondition;
  ProjectFolderFilter: ProjectFolderFilter;
  ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate: ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate: ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate: ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate: ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate;
  ProjectFolderProjectFolderPkeyConnect: ProjectFolderProjectFolderPkeyConnect;
  ProjectFolderProjectIdEf44DadfFkProjectIdInput: ProjectFolderProjectIdEf44DadfFkProjectIdInput;
  ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput: ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput;
  ProjectFolderToManyDataTableFilter: ProjectFolderToManyDataTableFilter;
  ProjectFolderToManyGdtAnalysisTableFilter: ProjectFolderToManyGdtAnalysisTableFilter;
  ProjectFolderUserIdF2E16179FkApplicationUserIdInput: ProjectFolderUserIdF2E16179FkApplicationUserIdInput;
  ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput: ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput;
  ProjectFoldersConnection: ProjectFoldersConnection;
  ProjectFoldersEdge: ProjectFoldersEdge;
  ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate: ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate: ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate: ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate: ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate: ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate;
  ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate: ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate: ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate;
  ProjectProjectKeyTenantUniqueConnect: ProjectProjectKeyTenantUniqueConnect;
  ProjectProjectPkeyConnect: ProjectProjectPkeyConnect;
  ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput: ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput;
  ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput: ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput;
  ProjectSharedNotifUserId9A19122FFkApplicatiInput: ProjectSharedNotifUserId9A19122FFkApplicatiInput;
  ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput: ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput;
  ProjectSharedNotification: ProjectSharedNotification;
  ProjectSharedNotificationCondition: ProjectSharedNotificationCondition;
  ProjectSharedNotificationFilter: ProjectSharedNotificationFilter;
  ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput: ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput;
  ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput: ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput: ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput;
  ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput: ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput;
  ProjectSharedNotificationProjectSharedNotificationPkeyConnect: ProjectSharedNotificationProjectSharedNotificationPkeyConnect;
  ProjectSharedNotificationsConnection: ProjectSharedNotificationsConnection;
  ProjectSharedNotificationsEdge: ProjectSharedNotificationsEdge;
  ProjectTag: ProjectTag;
  ProjectTagCondition: ProjectTagCondition;
  ProjectTagFilter: ProjectTagFilter;
  ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate: ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate;
  ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate: ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate;
  ProjectTagProjectId5Ab280C9FkProjectIdInput: ProjectTagProjectId5Ab280C9FkProjectIdInput;
  ProjectTagProjectId5Ab280C9FkProjectIdInverseInput: ProjectTagProjectId5Ab280C9FkProjectIdInverseInput;
  ProjectTagProjectTagPkeyConnect: ProjectTagProjectTagPkeyConnect;
  ProjectTagUserId780C8348FkApplicationUserIdInput: ProjectTagUserId780C8348FkApplicationUserIdInput;
  ProjectTagUserId780C8348FkApplicationUserIdInverseInput: ProjectTagUserId780C8348FkApplicationUserIdInverseInput;
  ProjectTagsConnection: ProjectTagsConnection;
  ProjectTagsEdge: ProjectTagsEdge;
  ProjectTenantId03F0Ca53FkTenantIdInput: ProjectTenantId03F0Ca53FkTenantIdInput;
  ProjectTenantId03F0Ca53FkTenantIdInverseInput: ProjectTenantId03F0Ca53FkTenantIdInverseInput;
  ProjectToManyDataTableFilter: ProjectToManyDataTableFilter;
  ProjectToManyFileActivityFilter: ProjectToManyFileActivityFilter;
  ProjectToManyFileFilter: ProjectToManyFileFilter;
  ProjectToManyFileMetadatumFilter: ProjectToManyFileMetadatumFilter;
  ProjectToManyFileOutputGroupFilter: ProjectToManyFileOutputGroupFilter;
  ProjectToManyFileOutputGroupMetadatumFilter: ProjectToManyFileOutputGroupMetadatumFilter;
  ProjectToManyGdtAnalysisTableFilter: ProjectToManyGdtAnalysisTableFilter;
  ProjectToManyGdtAnalysisTableRowFilter: ProjectToManyGdtAnalysisTableRowFilter;
  ProjectToManyMetadataValueFilter: ProjectToManyMetadataValueFilter;
  ProjectToManyMetadatumFilter: ProjectToManyMetadatumFilter;
  ProjectToManyOutputGroupFileFilter: ProjectToManyOutputGroupFileFilter;
  ProjectToManyProjectClonedNotificationFilter: ProjectToManyProjectClonedNotificationFilter;
  ProjectToManyProjectFilter: ProjectToManyProjectFilter;
  ProjectToManyProjectFolderFilter: ProjectToManyProjectFolderFilter;
  ProjectToManyProjectSharedNotificationFilter: ProjectToManyProjectSharedNotificationFilter;
  ProjectToManyProjectTagFilter: ProjectToManyProjectTagFilter;
  ProjectToManyTaskFilter: ProjectToManyTaskFilter;
  ProjectUserIdB5Fbb914FkApplicationUserIdInput: ProjectUserIdB5Fbb914FkApplicationUserIdInput;
  ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput: ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput;
  ProjectsConnection: ProjectsConnection;
  ProjectsEdge: ProjectsEdge;
  Query: {};
  RoleChangeNotificaUserId879Bd49AFkApplicatiInput: RoleChangeNotificaUserId879Bd49AFkApplicatiInput;
  RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput: RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput;
  RoleChangeNotification: RoleChangeNotification;
  RoleChangeNotificationCondition: RoleChangeNotificationCondition;
  RoleChangeNotificationFilter: RoleChangeNotificationFilter;
  RoleChangeNotificationIdD576A528FkNotificationIdInput: RoleChangeNotificationIdD576A528FkNotificationIdInput;
  RoleChangeNotificationIdD576A528FkNotificationIdInverseInput: RoleChangeNotificationIdD576A528FkNotificationIdInverseInput;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationRoleChangeNotificationPkeyConnect: RoleChangeNotificationRoleChangeNotificationPkeyConnect;
  RoleChangeNotificationTenantId36852Ce9FkTenantIdInput: RoleChangeNotificationTenantId36852Ce9FkTenantIdInput;
  RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput: RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput;
  RoleChangeNotificationsConnection: RoleChangeNotificationsConnection;
  RoleChangeNotificationsEdge: RoleChangeNotificationsEdge;
  String: Scalars['String']['output'];
  StringFilter: StringFilter;
  Task: Task;
  TaskActivitiesConnection: TaskActivitiesConnection;
  TaskActivitiesEdge: TaskActivitiesEdge;
  TaskActivity: TaskActivity;
  TaskActivityCondition: TaskActivityCondition;
  TaskActivityFilter: TaskActivityFilter;
  TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate: TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate;
  TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate: TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate;
  TaskActivityTaskActivityPkeyConnect: TaskActivityTaskActivityPkeyConnect;
  TaskActivityTaskActivityTaskIdKeyConnect: TaskActivityTaskActivityTaskIdKeyConnect;
  TaskActivityTaskIdC451Ae92FkTaskIdInput: TaskActivityTaskIdC451Ae92FkTaskIdInput;
  TaskActivityTaskIdC451Ae92FkTaskIdInverseInput: TaskActivityTaskIdC451Ae92FkTaskIdInverseInput;
  TaskCondition: TaskCondition;
  TaskFilter: TaskFilter;
  TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate: TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate;
  TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate: TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate;
  TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate: TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate;
  TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate: TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate: TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate: TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate: TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate: TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate;
  TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate: TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate;
  TaskProjectId963D6354FkProjectIdInput: TaskProjectId963D6354FkProjectIdInput;
  TaskProjectId963D6354FkProjectIdInverseInput: TaskProjectId963D6354FkProjectIdInverseInput;
  TaskResource: TaskResource;
  TaskResourceCondition: TaskResourceCondition;
  TaskResourceFilter: TaskResourceFilter;
  TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate: TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate;
  TaskResourceTaskId73Fcabc0FkTaskIdInput: TaskResourceTaskId73Fcabc0FkTaskIdInput;
  TaskResourceTaskId73Fcabc0FkTaskIdInverseInput: TaskResourceTaskId73Fcabc0FkTaskIdInverseInput;
  TaskResourceTaskResourcePkeyConnect: TaskResourceTaskResourcePkeyConnect;
  TaskResourceUsage: TaskResourceUsage;
  TaskResourceUsageCondition: TaskResourceUsageCondition;
  TaskResourceUsageFilter: TaskResourceUsageFilter;
  TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate: TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate;
  TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate: TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate;
  TaskResourceUsageTaskIdA28F1580FkTaskIdInput: TaskResourceUsageTaskIdA28F1580FkTaskIdInput;
  TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput: TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput;
  TaskResourceUsageTaskResourceUsagePkeyConnect: TaskResourceUsageTaskResourceUsagePkeyConnect;
  TaskResourceUsageTaskResourceUsageTaskIdKeyConnect: TaskResourceUsageTaskResourceUsageTaskIdKeyConnect;
  TaskResourceUsagesConnection: TaskResourceUsagesConnection;
  TaskResourceUsagesEdge: TaskResourceUsagesEdge;
  TaskResourcesConnection: TaskResourcesConnection;
  TaskResourcesEdge: TaskResourcesEdge;
  TaskSource: TaskSource;
  TaskSourceCondition: TaskSourceCondition;
  TaskSourceFileId2F628862FkFileIdInput: TaskSourceFileId2F628862FkFileIdInput;
  TaskSourceFileId2F628862FkFileIdInverseInput: TaskSourceFileId2F628862FkFileIdInverseInput;
  TaskSourceFilter: TaskSourceFilter;
  TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate;
  TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate;
  TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate;
  TaskSourceTaskIdF241BaedFkTaskIdInput: TaskSourceTaskIdF241BaedFkTaskIdInput;
  TaskSourceTaskIdF241BaedFkTaskIdInverseInput: TaskSourceTaskIdF241BaedFkTaskIdInverseInput;
  TaskSourceTaskSourcePkeyConnect: TaskSourceTaskSourcePkeyConnect;
  TaskSourceToolSourceId14453EdbFkToolSourceIdInput: TaskSourceToolSourceId14453EdbFkToolSourceIdInput;
  TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput: TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput;
  TaskSourcesConnection: TaskSourcesConnection;
  TaskSourcesEdge: TaskSourcesEdge;
  TaskTaskExecutorIdKeyConnect: TaskTaskExecutorIdKeyConnect;
  TaskTaskPkeyConnect: TaskTaskPkeyConnect;
  TaskTenantId148E90DaFkTenantIdInput: TaskTenantId148E90DaFkTenantIdInput;
  TaskTenantId148E90DaFkTenantIdInverseInput: TaskTenantId148E90DaFkTenantIdInverseInput;
  TaskToManyFileFilter: TaskToManyFileFilter;
  TaskToManyGdtAnalysisTableRowFilter: TaskToManyGdtAnalysisTableRowFilter;
  TaskToManyMetadataValueFilter: TaskToManyMetadataValueFilter;
  TaskToManyTaskResourceFilter: TaskToManyTaskResourceFilter;
  TaskToManyTaskSourceFilter: TaskToManyTaskSourceFilter;
  TaskToolVersionId14506837FkToolVersionIdInput: TaskToolVersionId14506837FkToolVersionIdInput;
  TaskToolVersionId14506837FkToolVersionIdInverseInput: TaskToolVersionId14506837FkToolVersionIdInverseInput;
  TaskUserId270D0Bb2FkApplicationUserIdInput: TaskUserId270D0Bb2FkApplicationUserIdInput;
  TaskUserId270D0Bb2FkApplicationUserIdInverseInput: TaskUserId270D0Bb2FkApplicationUserIdInverseInput;
  TasksConnection: TasksConnection;
  TasksEdge: TasksEdge;
  Tenant: Tenant;
  TenantContract: TenantContract;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput;
  TenantContractAllowance: TenantContractAllowance;
  TenantContractAllowanceCondition: TenantContractAllowanceCondition;
  TenantContractAllowanceFilter: TenantContractAllowanceFilter;
  TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate: TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate;
  TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate: TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate;
  TenantContractAllowanceTenantContractAllowancePkeyConnect: TenantContractAllowanceTenantContractAllowancePkeyConnect;
  TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect: TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect;
  TenantContractAllowancesConnection: TenantContractAllowancesConnection;
  TenantContractAllowancesEdge: TenantContractAllowancesEdge;
  TenantContractCondition: TenantContractCondition;
  TenantContractFilter: TenantContractFilter;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate;
  TenantContractTenantContractNameKeyConnect: TenantContractTenantContractNameKeyConnect;
  TenantContractTenantContractPkeyConnect: TenantContractTenantContractPkeyConnect;
  TenantContractTenantContractSfidKeyConnect: TenantContractTenantContractSfidKeyConnect;
  TenantContractTenantIdBa8Ac167FkTenantIdInput: TenantContractTenantIdBa8Ac167FkTenantIdInput;
  TenantContractTenantIdBa8Ac167FkTenantIdInverseInput: TenantContractTenantIdBa8Ac167FkTenantIdInverseInput;
  TenantContractToManyTenantContractTransactionFilter: TenantContractToManyTenantContractTransactionFilter;
  TenantContractTranTenantContractId1E374993FkTenantCoInput: TenantContractTranTenantContractId1E374993FkTenantCoInput;
  TenantContractTranTenantContractId1E374993FkTenantCoInverseInput: TenantContractTranTenantContractId1E374993FkTenantCoInverseInput;
  TenantContractTransaction: TenantContractTransaction;
  TenantContractTransactionCondition: TenantContractTransactionCondition;
  TenantContractTransactionFilter: TenantContractTransactionFilter;
  TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate: TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate;
  TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate: TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate;
  TenantContractTransactionTenantContractTransactionPkeyConnect: TenantContractTransactionTenantContractTransactionPkeyConnect;
  TenantContractTransactionToManyTenantContractAllowanceFilter: TenantContractTransactionToManyTenantContractAllowanceFilter;
  TenantContractTransactionsConnection: TenantContractTransactionsConnection;
  TenantContractTransactionsEdge: TenantContractTransactionsEdge;
  TenantContractsConnection: TenantContractsConnection;
  TenantContractsEdge: TenantContractsEdge;
  TenantFilter: TenantFilter;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate;
  TenantTenantKeyKeyConnect: TenantTenantKeyKeyConnect;
  TenantTenantPkeyConnect: TenantTenantPkeyConnect;
  TenantTenantRepositoryNameKeyConnect: TenantTenantRepositoryNameKeyConnect;
  TenantTenantSfidKeyConnect: TenantTenantSfidKeyConnect;
  TenantToManyApplicationUserMembershipFilter: TenantToManyApplicationUserMembershipFilter;
  TenantToManyApplicationUserSessionFilter: TenantToManyApplicationUserSessionFilter;
  TenantToManyCodeFileFilter: TenantToManyCodeFileFilter;
  TenantToManyFileActivityFilter: TenantToManyFileActivityFilter;
  TenantToManyFileFilter: TenantToManyFileFilter;
  TenantToManyFileMetadatumFilter: TenantToManyFileMetadatumFilter;
  TenantToManyFileOutputGroupFilter: TenantToManyFileOutputGroupFilter;
  TenantToManyFileOutputGroupMetadatumFilter: TenantToManyFileOutputGroupMetadatumFilter;
  TenantToManyMetadataValueFilter: TenantToManyMetadataValueFilter;
  TenantToManyMetadatumFilter: TenantToManyMetadatumFilter;
  TenantToManyProjectFilter: TenantToManyProjectFilter;
  TenantToManyRoleChangeNotificationFilter: TenantToManyRoleChangeNotificationFilter;
  TenantToManyTaskFilter: TenantToManyTaskFilter;
  TenantToManyTenantContractFilter: TenantToManyTenantContractFilter;
  TenantToManyTenantUserMembershipNotificationFilter: TenantToManyTenantUserMembershipNotificationFilter;
  TenantToManyToolFilter: TenantToManyToolFilter;
  TenantToManyToolTenantFilter: TenantToManyToolTenantFilter;
  TenantToManyToolVersionFilter: TenantToManyToolVersionFilter;
  TenantUserMembershId10Affa8DFkNotificatInput: TenantUserMembershId10Affa8DFkNotificatInput;
  TenantUserMembershId10Affa8DFkNotificatInverseInput: TenantUserMembershId10Affa8DFkNotificatInverseInput;
  TenantUserMembershInviterId29476E5EFkApplicatiInput: TenantUserMembershInviterId29476E5EFkApplicatiInput;
  TenantUserMembershInviterId29476E5EFkApplicatiInverseInput: TenantUserMembershInviterId29476E5EFkApplicatiInverseInput;
  TenantUserMembershTenantIdC67818C5FkTenantIdInput: TenantUserMembershTenantIdC67818C5FkTenantIdInput;
  TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput: TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput;
  TenantUserMembershUserId2B78E8A0FkApplicatiInput: TenantUserMembershUserId2B78E8A0FkApplicatiInput;
  TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput: TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput;
  TenantUserMembershipNotification: TenantUserMembershipNotification;
  TenantUserMembershipNotificationCondition: TenantUserMembershipNotificationCondition;
  TenantUserMembershipNotificationFilter: TenantUserMembershipNotificationFilter;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect: TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect;
  TenantUserMembershipNotificationsConnection: TenantUserMembershipNotificationsConnection;
  TenantUserMembershipNotificationsEdge: TenantUserMembershipNotificationsEdge;
  Tool: Tool;
  ToolCondition: ToolCondition;
  ToolFilter: ToolFilter;
  ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate: ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate;
  ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate: ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate;
  ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate: ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate;
  ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate;
  ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate: ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate;
  ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate: ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate;
  ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate: ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate;
  ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate: ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate;
  ToolParameter: ToolParameter;
  ToolParameterCondition: ToolParameterCondition;
  ToolParameterFilter: ToolParameterFilter;
  ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate: ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate;
  ToolParameterToolParameterPkeyConnect: ToolParameterToolParameterPkeyConnect;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput;
  ToolParametersConnection: ToolParametersConnection;
  ToolParametersEdge: ToolParametersEdge;
  ToolProjectId20A84210FkProjectIdInput: ToolProjectId20A84210FkProjectIdInput;
  ToolProjectId20A84210FkProjectIdInverseInput: ToolProjectId20A84210FkProjectIdInverseInput;
  ToolResult: ToolResult;
  ToolResultCondition: ToolResultCondition;
  ToolResultFilter: ToolResultFilter;
  ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate: ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate;
  ToolResultToolResultPkeyConnect: ToolResultToolResultPkeyConnect;
  ToolResultToolVersionId41Fb163EFkToolVersionIdInput: ToolResultToolVersionId41Fb163EFkToolVersionIdInput;
  ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput: ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput;
  ToolResultsConnection: ToolResultsConnection;
  ToolResultsEdge: ToolResultsEdge;
  ToolSecret: ToolSecret;
  ToolSecretCondition: ToolSecretCondition;
  ToolSecretFilter: ToolSecretFilter;
  ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate: ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate;
  ToolSecretToolSecretPkeyConnect: ToolSecretToolSecretPkeyConnect;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput;
  ToolSecretsConnection: ToolSecretsConnection;
  ToolSecretsEdge: ToolSecretsEdge;
  ToolSource: ToolSource;
  ToolSourceCondition: ToolSourceCondition;
  ToolSourceFilter: ToolSourceFilter;
  ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate: ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate;
  ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate: ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate;
  ToolSourceToManyTaskSourceFilter: ToolSourceToManyTaskSourceFilter;
  ToolSourceToolSourcePkeyConnect: ToolSourceToolSourcePkeyConnect;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput;
  ToolSourcesConnection: ToolSourcesConnection;
  ToolSourcesEdge: ToolSourcesEdge;
  ToolTenant: ToolTenant;
  ToolTenantCondition: ToolTenantCondition;
  ToolTenantFilter: ToolTenantFilter;
  ToolTenantId1Baab08EFkTenantIdInput: ToolTenantId1Baab08EFkTenantIdInput;
  ToolTenantId1Baab08EFkTenantIdInverseInput: ToolTenantId1Baab08EFkTenantIdInverseInput;
  ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate: ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate;
  ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate: ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate;
  ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate: ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate;
  ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate: ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate;
  ToolTenantToolTenantsPkeyConnect: ToolTenantToolTenantsPkeyConnect;
  ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect: ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect;
  ToolTenantsConnection: ToolTenantsConnection;
  ToolTenantsEdge: ToolTenantsEdge;
  ToolTenantsTenantId9C4A54FeFkTenantIdInput: ToolTenantsTenantId9C4A54FeFkTenantIdInput;
  ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput: ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdInput: ToolTenantsToolIdF77Ef6F7FkToolIdInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput: ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput;
  ToolToManyToolTenantFilter: ToolToManyToolTenantFilter;
  ToolToManyToolVersionFilter: ToolToManyToolVersionFilter;
  ToolToolPkeyConnect: ToolToolPkeyConnect;
  ToolToolProjectIdKeyConnect: ToolToolProjectIdKeyConnect;
  ToolUserIdFd36Dfa4FkApplicationUserIdInput: ToolUserIdFd36Dfa4FkApplicationUserIdInput;
  ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput: ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput;
  ToolVersion: ToolVersion;
  ToolVersionCondition: ToolVersionCondition;
  ToolVersionFilter: ToolVersionFilter;
  ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate: ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate;
  ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate;
  ToolVersionTenantId03A60B0CFkTenantIdInput: ToolVersionTenantId03A60B0CFkTenantIdInput;
  ToolVersionTenantId03A60B0CFkTenantIdInverseInput: ToolVersionTenantId03A60B0CFkTenantIdInverseInput;
  ToolVersionToManyGdtAnalysisTableFilter: ToolVersionToManyGdtAnalysisTableFilter;
  ToolVersionToManyGdtAnalysisTableRowFilter: ToolVersionToManyGdtAnalysisTableRowFilter;
  ToolVersionToManyTaskFilter: ToolVersionToManyTaskFilter;
  ToolVersionToManyToolParameterFilter: ToolVersionToManyToolParameterFilter;
  ToolVersionToManyToolResultFilter: ToolVersionToManyToolResultFilter;
  ToolVersionToManyToolSecretFilter: ToolVersionToManyToolSecretFilter;
  ToolVersionToManyToolSourceFilter: ToolVersionToManyToolSourceFilter;
  ToolVersionToolId3B396B22FkToolIdInput: ToolVersionToolId3B396B22FkToolIdInput;
  ToolVersionToolId3B396B22FkToolIdInverseInput: ToolVersionToolId3B396B22FkToolIdInverseInput;
  ToolVersionToolVersionPkeyConnect: ToolVersionToolVersionPkeyConnect;
  ToolVersionUserId68A75E07FkApplicationUserIdInput: ToolVersionUserId68A75E07FkApplicationUserIdInput;
  ToolVersionUserId68A75E07FkApplicationUserIdInverseInput: ToolVersionUserId68A75E07FkApplicationUserIdInverseInput;
  ToolVersionsConnection: ToolVersionsConnection;
  ToolVersionsEdge: ToolVersionsEdge;
  ToolsConnection: ToolsConnection;
  ToolsEdge: ToolsEdge;
  UUID: Scalars['UUID']['output'];
  UUIDFilter: UuidFilter;
  UpdateApplicationUserByEmailInput: UpdateApplicationUserByEmailInput;
  UpdateApplicationUserByGlobalUserIdInput: UpdateApplicationUserByGlobalUserIdInput;
  UpdateApplicationUserByIdInput: UpdateApplicationUserByIdInput;
  UpdateApplicationUserByUsernameInput: UpdateApplicationUserByUsernameInput;
  UpdateApplicationUserMetadatumByIdInput: UpdateApplicationUserMetadatumByIdInput;
  UpdateApplicationUserMetadatumByUserIdAndKeyInput: UpdateApplicationUserMetadatumByUserIdAndKeyInput;
  UpdateApplicationUserMetadatumPayload: UpdateApplicationUserMetadatumPayload;
  UpdateApplicationUserPayload: UpdateApplicationUserPayload;
  UpdateAvatarByIdInput: UpdateAvatarByIdInput;
  UpdateAvatarByUserIdInput: UpdateAvatarByUserIdInput;
  UpdateAvatarPayload: UpdateAvatarPayload;
  UserAccessToProject: UserAccessToProject;
  UserAccessToProjectCondition: UserAccessToProjectCondition;
  UserAccessToProjectFilter: UserAccessToProjectFilter;
  UserAccessToProjectsConnection: UserAccessToProjectsConnection;
  UserAccessToProjectsEdge: UserAccessToProjectsEdge;
  updateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  updateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  updateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch: UpdateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  updateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  updateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  updateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  updateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  updateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  updateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  updateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  updateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  updateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  updateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  updateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  updateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  updateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  updateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  updateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  updateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  updateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  updateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  updateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  updateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  updateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  updateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  updateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  updateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  updateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  updateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  updateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  updateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  updateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  updateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch: UpdateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  updateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch: UpdateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch;
  updateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch: UpdateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  updateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch: UpdateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  updateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch: UpdateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
  updateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch: UpdateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  updateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch: UpdateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  updateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch: UpdateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  updateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  updateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  updateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch: UpdateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  updateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch: UpdateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  updateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch: UpdateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  updateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch: UpdateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  updateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch: UpdateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  updateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch: UpdateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  updateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch: UpdateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch;
  updateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch: UpdateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  updateFileOnFileForFileTenantId61625016FkTenantIdPatch: UpdateFileOnFileForFileTenantId61625016FkTenantIdPatch;
  updateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch: UpdateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  updateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch: UpdateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  updateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch: UpdateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  updateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch: UpdateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  updateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch: UpdateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  updateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch: UpdateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  updateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch: UpdateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  updateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch: UpdateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
  updateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch: UpdateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
  updateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch: UpdateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
  updateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch: UpdateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  updateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch: UpdateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  updateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch: UpdateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
  updateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch: UpdateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  updateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch: UpdateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
  updateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch: UpdateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
  updateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch: UpdateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
  updateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch: UpdateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  updateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch: UpdateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
  updateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch: UpdateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
  updateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch: UpdateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  updateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch: UpdateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  updateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch: UpdateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  updateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch: UpdateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  updateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch: UpdateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  updateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch: UpdateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  updateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch: UpdateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  updateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch: UpdateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  updateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch: UpdateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  updateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch: UpdateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  updateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch: UpdateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  updateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch: UpdateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  updateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch: UpdateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  updateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  updateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  updateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch: UpdateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  updateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch: UpdateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch;
  updateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch: UpdateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  updateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch: UpdateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  updateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch: UpdateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  updateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch: UpdateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  updateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch: UpdateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  updateProjectOnToolForToolProjectId20A84210FkProjectIdPatch: UpdateProjectOnToolForToolProjectId20A84210FkProjectIdPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  updateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch: UpdateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  updateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch: UpdateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  updateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch: UpdateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  updateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch: UpdateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  updateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch: UpdateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  updateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch: UpdateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  updateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch: UpdateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  updateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch: UpdateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  updateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch: UpdateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  updateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch: UpdateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  updateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch: UpdateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  updateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch: UpdateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  updateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch: UpdateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  updateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch: UpdateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  updateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch: UpdateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  updateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch: UpdateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  updateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch: UpdateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
  updateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch: UpdateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  updateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch: UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  updateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch: UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  updateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch: UpdateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  updateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch: UpdateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  updateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  updateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  updateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  updateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  updateTenantOnFileForFileTenantId61625016FkTenantIdPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
  updateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  updateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  updateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  updateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  updateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  updateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  updateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  updateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  updateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  updateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  updateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  updateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  updateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  updateToolOnToolForToolProjectId20A84210FkProjectIdPatch: UpdateToolOnToolForToolProjectId20A84210FkProjectIdPatch;
  updateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch: UpdateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  updateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch: UpdateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  updateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch: UpdateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  updateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch: UpdateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  updateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch: UpdateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
  updateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch: UpdateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
  updateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch: UpdateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
  updateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch: UpdateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
  updateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch: UpdateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
  updateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch: UpdateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  updateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch: UpdateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  updateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch: UpdateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
  updateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch: UpdateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  updateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch: UpdateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  updateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch: UpdateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
  updateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch: UpdateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
  updateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch: UpdateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
  updateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch: UpdateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
  updateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch: UpdateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  updateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch: UpdateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  updateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch: UpdateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
};

export type ApplicationUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUser'] = ResolversParentTypes['ApplicationUser']> = {
  applicationUserMembershipsByUserId?: Resolver<ResolversTypes['ApplicationUserMembershipsConnection'], ParentType, ContextType, RequireFields<ApplicationUserApplicationUserMembershipsByUserIdArgs, 'orderBy'>>;
  applicationUserMetadataByUserId?: Resolver<ResolversTypes['ApplicationUserMetadataConnection'], ParentType, ContextType, RequireFields<ApplicationUserApplicationUserMetadataByUserIdArgs, 'orderBy'>>;
  applicationUserSessionsByUserId?: Resolver<ResolversTypes['ApplicationUserSessionsConnection'], ParentType, ContextType, RequireFields<ApplicationUserApplicationUserSessionsByUserIdArgs, 'orderBy'>>;
  avatarByUserId?: Resolver<Maybe<ResolversTypes['Avatar']>, ParentType, ContextType>;
  avatarsByUserId?: Resolver<ResolversTypes['AvatarsConnection'], ParentType, ContextType, RequireFields<ApplicationUserAvatarsByUserIdArgs, 'orderBy'>>;
  codeFilesByUserId?: Resolver<ResolversTypes['CodeFilesConnection'], ParentType, ContextType, RequireFields<ApplicationUserCodeFilesByUserIdArgs, 'orderBy'>>;
  cognitoTenantKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dataTablesByUserId?: Resolver<ResolversTypes['DataTablesConnection'], ParentType, ContextType, RequireFields<ApplicationUserDataTablesByUserIdArgs, 'orderBy'>>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailMarketingConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eulaVersionUserAcceptancesByUserId?: Resolver<ResolversTypes['EulaVersionUserAcceptancesConnection'], ParentType, ContextType, RequireFields<ApplicationUserEulaVersionUserAcceptancesByUserIdArgs, 'orderBy'>>;
  fileActivitiesByUserId?: Resolver<ResolversTypes['FileActivitiesConnection'], ParentType, ContextType, RequireFields<ApplicationUserFileActivitiesByUserIdArgs, 'orderBy'>>;
  fileOutputGroupsByUserId?: Resolver<ResolversTypes['FileOutputGroupsConnection'], ParentType, ContextType, RequireFields<ApplicationUserFileOutputGroupsByUserIdArgs, 'orderBy'>>;
  fileProcessingNotificationsByUserId?: Resolver<ResolversTypes['FileProcessingNotificationsConnection'], ParentType, ContextType, RequireFields<ApplicationUserFileProcessingNotificationsByUserIdArgs, 'orderBy'>>;
  filesByUserId?: Resolver<ResolversTypes['FilesConnection'], ParentType, ContextType, RequireFields<ApplicationUserFilesByUserIdArgs, 'orderBy'>>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gdtAnalysisTableRowsByUserId?: Resolver<ResolversTypes['GdtAnalysisTableRowsConnection'], ParentType, ContextType, RequireFields<ApplicationUserGdtAnalysisTableRowsByUserIdArgs, 'orderBy'>>;
  gdtAnalysisTablesByUserId?: Resolver<ResolversTypes['GdtAnalysisTablesConnection'], ParentType, ContextType, RequireFields<ApplicationUserGdtAnalysisTablesByUserIdArgs, 'orderBy'>>;
  globalUserId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  homeRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  internal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStaff?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSuperuser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadataValuesByUserId?: Resolver<ResolversTypes['MetadataValuesConnection'], ParentType, ContextType, RequireFields<ApplicationUserMetadataValuesByUserIdArgs, 'orderBy'>>;
  notificationsByUserId?: Resolver<ResolversTypes['NotificationsConnection'], ParentType, ContextType, RequireFields<ApplicationUserNotificationsByUserIdArgs, 'orderBy'>>;
  personalRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectClonedNotificationsByUserId?: Resolver<ResolversTypes['ProjectClonedNotificationsConnection'], ParentType, ContextType, RequireFields<ApplicationUserProjectClonedNotificationsByUserIdArgs, 'orderBy'>>;
  projectFoldersByUserId?: Resolver<ResolversTypes['ProjectFoldersConnection'], ParentType, ContextType, RequireFields<ApplicationUserProjectFoldersByUserIdArgs, 'orderBy'>>;
  projectSharedNotificationsBySharerId?: Resolver<ResolversTypes['ProjectSharedNotificationsConnection'], ParentType, ContextType, RequireFields<ApplicationUserProjectSharedNotificationsBySharerIdArgs, 'orderBy'>>;
  projectSharedNotificationsByUserId?: Resolver<ResolversTypes['ProjectSharedNotificationsConnection'], ParentType, ContextType, RequireFields<ApplicationUserProjectSharedNotificationsByUserIdArgs, 'orderBy'>>;
  projectTagsByUserId?: Resolver<ResolversTypes['ProjectTagsConnection'], ParentType, ContextType, RequireFields<ApplicationUserProjectTagsByUserIdArgs, 'orderBy'>>;
  projectsByUserId?: Resolver<ResolversTypes['ProjectsConnection'], ParentType, ContextType, RequireFields<ApplicationUserProjectsByUserIdArgs, 'orderBy'>>;
  roleChangeNotificationsByUserId?: Resolver<ResolversTypes['RoleChangeNotificationsConnection'], ParentType, ContextType, RequireFields<ApplicationUserRoleChangeNotificationsByUserIdArgs, 'orderBy'>>;
  tasksByUserId?: Resolver<ResolversTypes['TasksConnection'], ParentType, ContextType, RequireFields<ApplicationUserTasksByUserIdArgs, 'orderBy'>>;
  tenantUserMembershipNotificationsByInviterId?: Resolver<ResolversTypes['TenantUserMembershipNotificationsConnection'], ParentType, ContextType, RequireFields<ApplicationUserTenantUserMembershipNotificationsByInviterIdArgs, 'orderBy'>>;
  tenantUserMembershipNotificationsByUserId?: Resolver<ResolversTypes['TenantUserMembershipNotificationsConnection'], ParentType, ContextType, RequireFields<ApplicationUserTenantUserMembershipNotificationsByUserIdArgs, 'orderBy'>>;
  toolVersionsByUserId?: Resolver<ResolversTypes['ToolVersionsConnection'], ParentType, ContextType, RequireFields<ApplicationUserToolVersionsByUserIdArgs, 'orderBy'>>;
  toolsByUserId?: Resolver<ResolversTypes['ToolsConnection'], ParentType, ContextType, RequireFields<ApplicationUserToolsByUserIdArgs, 'orderBy'>>;
  userOrigin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUserMembership'] = ResolversParentTypes['ApplicationUserMembership']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sfLeadCreated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMembershipsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUserMembershipsConnection'] = ResolversParentTypes['ApplicationUserMembershipsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ApplicationUserMembershipsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ApplicationUserMembership']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMembershipsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUserMembershipsEdge'] = ResolversParentTypes['ApplicationUserMembershipsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ApplicationUserMembership'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMetadataConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUserMetadataConnection'] = ResolversParentTypes['ApplicationUserMetadataConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ApplicationUserMetadataEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ApplicationUserMetadatum']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMetadataEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUserMetadataEdge'] = ResolversParentTypes['ApplicationUserMetadataEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ApplicationUserMetadatum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMetadatumResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUserMetadatum'] = ResolversParentTypes['ApplicationUserMetadatum']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUserSession'] = ResolversParentTypes['ApplicationUserSession']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  datetimeLastActive?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  lastPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserSessionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUserSessionsConnection'] = ResolversParentTypes['ApplicationUserSessionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ApplicationUserSessionsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ApplicationUserSession']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserSessionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUserSessionsEdge'] = ResolversParentTypes['ApplicationUserSessionsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ApplicationUserSession'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUsersEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationUsersEdge'] = ResolversParentTypes['ApplicationUsersEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ApplicationUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvatarResolvers<ContextType = any, ParentType extends ResolversParentTypes['Avatar'] = ResolversParentTypes['Avatar']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  imageBase64?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  initials?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  useImage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvatarsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvatarsConnection'] = ResolversParentTypes['AvatarsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AvatarsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Avatar']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvatarsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvatarsEdge'] = ResolversParentTypes['AvatarsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Avatar'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BigFloatScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigFloat'], any> {
  name: 'BigFloat';
}

export interface BigIntScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigInt'], any> {
  name: 'BigInt';
}

export type ChangeUserSessionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeUserSessionPayload'] = ResolversParentTypes['ChangeUserSessionPayload']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  applicationUserSession?: Resolver<Maybe<ResolversTypes['ApplicationUserSession']>, ParentType, ContextType>;
  applicationUserSessionEdge?: Resolver<Maybe<ResolversTypes['ApplicationUserSessionsEdge']>, ParentType, ContextType, RequireFields<ChangeUserSessionPayloadApplicationUserSessionEdgeArgs, 'orderBy'>>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodeFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodeFile'] = ResolversParentTypes['CodeFile']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  checksum?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  codeFileBySeriesParentId?: Resolver<Maybe<ResolversTypes['CodeFile']>, ParentType, ContextType>;
  codeFilesBySeriesParentId?: Resolver<ResolversTypes['CodeFilesConnection'], ParentType, ContextType, RequireFields<CodeFileCodeFilesBySeriesParentIdArgs, 'orderBy'>>;
  compressed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dateArchived?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dateDataDeleted?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  dateDeleted?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  executorId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fileFormat?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fileStructure?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fileType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  isSeries?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  multipartUploadId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  partSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesParentId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  signal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tags?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uploadStatus?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodeFilesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodeFilesConnection'] = ResolversParentTypes['CodeFilesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CodeFilesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CodeFile']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodeFilesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodeFilesEdge'] = ResolversParentTypes['CodeFilesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CodeFile'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateApplicationUserMetadatumPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateApplicationUserMetadatumPayload'] = ResolversParentTypes['CreateApplicationUserMetadatumPayload']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  applicationUserMetadatum?: Resolver<Maybe<ResolversTypes['ApplicationUserMetadatum']>, ParentType, ContextType>;
  applicationUserMetadatumEdge?: Resolver<Maybe<ResolversTypes['ApplicationUserMetadataEdge']>, ParentType, ContextType, RequireFields<CreateApplicationUserMetadatumPayloadApplicationUserMetadatumEdgeArgs, 'orderBy'>>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateApplicationUserSessionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateApplicationUserSessionPayload'] = ResolversParentTypes['CreateApplicationUserSessionPayload']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  applicationUserSession?: Resolver<Maybe<ResolversTypes['ApplicationUserSession']>, ParentType, ContextType>;
  applicationUserSessionEdge?: Resolver<Maybe<ResolversTypes['ApplicationUserSessionsEdge']>, ParentType, ContextType, RequireFields<CreateApplicationUserSessionPayloadApplicationUserSessionEdgeArgs, 'orderBy'>>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateEulaVersionUserAcceptancePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateEulaVersionUserAcceptancePayload'] = ResolversParentTypes['CreateEulaVersionUserAcceptancePayload']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eulaVersionByEulaVersionId?: Resolver<Maybe<ResolversTypes['EulaVersion']>, ParentType, ContextType>;
  eulaVersionUserAcceptance?: Resolver<Maybe<ResolversTypes['EulaVersionUserAcceptance']>, ParentType, ContextType>;
  eulaVersionUserAcceptanceEdge?: Resolver<Maybe<ResolversTypes['EulaVersionUserAcceptancesEdge']>, ParentType, ContextType, RequireFields<CreateEulaVersionUserAcceptancePayloadEulaVersionUserAcceptanceEdgeArgs, 'orderBy'>>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateMetadataValuePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMetadataValuePayload'] = ResolversParentTypes['CreateMetadataValuePayload']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadataValue?: Resolver<Maybe<ResolversTypes['MetadataValue']>, ParentType, ContextType>;
  metadataValueEdge?: Resolver<Maybe<ResolversTypes['MetadataValuesEdge']>, ParentType, ContextType, RequireFields<CreateMetadataValuePayloadMetadataValueEdgeArgs, 'orderBy'>>;
  metadatumByMetadataId?: Resolver<Maybe<ResolversTypes['Metadatum']>, ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  taskByTaskId?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateMetadatumPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMetadatumPayload'] = ResolversParentTypes['CreateMetadatumPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadatum?: Resolver<Maybe<ResolversTypes['Metadatum']>, ParentType, ContextType>;
  metadatumEdge?: Resolver<Maybe<ResolversTypes['MetadataEdge']>, ParentType, ContextType, RequireFields<CreateMetadatumPayloadMetadatumEdgeArgs, 'orderBy'>>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateRolePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateRolePayload'] = ResolversParentTypes['CreateRolePayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateSessionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSessionPayload'] = ResolversParentTypes['CreateSessionPayload']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  applicationUserSession?: Resolver<Maybe<ResolversTypes['ApplicationUserSession']>, ParentType, ContextType>;
  applicationUserSessionEdge?: Resolver<Maybe<ResolversTypes['ApplicationUserSessionsEdge']>, ParentType, ContextType, RequireFields<CreateSessionPayloadApplicationUserSessionEdgeArgs, 'orderBy'>>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentApplicationUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentApplicationUser'] = ResolversParentTypes['CurrentApplicationUser']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  globalUserId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentApplicationUsersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentApplicationUsersConnection'] = ResolversParentTypes['CurrentApplicationUsersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CurrentApplicationUsersEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CurrentApplicationUser']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentApplicationUsersEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentApplicationUsersEdge'] = ResolversParentTypes['CurrentApplicationUsersEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CurrentApplicationUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentUserMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentUserMembership'] = ResolversParentTypes['CurrentUserMembership']> = {
  role?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentUserMembershipsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentUserMembershipsConnection'] = ResolversParentTypes['CurrentUserMembershipsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CurrentUserMembershipsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CurrentUserMembership']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentUserMembershipsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentUserMembershipsEdge'] = ResolversParentTypes['CurrentUserMembershipsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CurrentUserMembership'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CursorScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Cursor'], any> {
  name: 'Cursor';
}

export type DataTableResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataTable'] = ResolversParentTypes['DataTable']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dateDeleted?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  folderId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  hidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectFolderByFolderId?: Resolver<Maybe<ResolversTypes['ProjectFolder']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTablesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataTablesConnection'] = ResolversParentTypes['DataTablesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DataTablesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['DataTable']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTablesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataTablesEdge'] = ResolversParentTypes['DataTablesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DataTable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DatetimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Datetime'], any> {
  name: 'Datetime';
}

export type DeleteSessionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteSessionPayload'] = ResolversParentTypes['DeleteSessionPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EulaVersion'] = ResolversParentTypes['EulaVersion']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dateVersion?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  eulaVersionUserAcceptancesByEulaVersionId?: Resolver<ResolversTypes['EulaVersionUserAcceptancesConnection'], ParentType, ContextType, RequireFields<EulaVersionEulaVersionUserAcceptancesByEulaVersionIdArgs, 'orderBy'>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionUserAcceptanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['EulaVersionUserAcceptance'] = ResolversParentTypes['EulaVersionUserAcceptance']> = {
  accepted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  dateReviewed?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  eulaVersionByEulaVersionId?: Resolver<Maybe<ResolversTypes['EulaVersion']>, ParentType, ContextType>;
  eulaVersionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionUserAcceptancesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EulaVersionUserAcceptancesConnection'] = ResolversParentTypes['EulaVersionUserAcceptancesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EulaVersionUserAcceptancesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EulaVersionUserAcceptance']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionUserAcceptancesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EulaVersionUserAcceptancesEdge'] = ResolversParentTypes['EulaVersionUserAcceptancesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EulaVersionUserAcceptance'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EulaVersionsConnection'] = ResolversParentTypes['EulaVersionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EulaVersionsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EulaVersion']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EulaVersionsEdge'] = ResolversParentTypes['EulaVersionsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EulaVersion'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileResolvers<ContextType = any, ParentType extends ResolversParentTypes['File'] = ResolversParentTypes['File']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  dateArchived?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dateDataDeleted?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  dateDeleted?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  fileActivitiesByFileId?: Resolver<ResolversTypes['FileActivitiesConnection'], ParentType, ContextType, RequireFields<FileFileActivitiesByFileIdArgs, 'orderBy'>>;
  fileBySeriesParentId?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  fileFormat?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fileMetadataByFileId?: Resolver<ResolversTypes['FileMetadataConnection'], ParentType, ContextType, RequireFields<FileFileMetadataByFileIdArgs, 'orderBy'>>;
  fileProcessingNotificationsByFileId?: Resolver<ResolversTypes['FileProcessingNotificationsConnection'], ParentType, ContextType, RequireFields<FileFileProcessingNotificationsByFileIdArgs, 'orderBy'>>;
  fileStructure?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fileType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  filesBySeriesParentId?: Resolver<ResolversTypes['FilesConnection'], ParentType, ContextType, RequireFields<FileFilesBySeriesParentIdArgs, 'orderBy'>>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  isSeries?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  multipartUploadId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outputGroupFilesByFileId?: Resolver<ResolversTypes['OutputGroupFilesConnection'], ParentType, ContextType, RequireFields<FileOutputGroupFilesByFileIdArgs, 'orderBy'>>;
  parentIds?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  partSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  preview?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  processingStatus?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  referenceId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  seriesOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesParentId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  signal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tags?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  taskByTaskId?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskSourcesByFileId?: Resolver<ResolversTypes['TaskSourcesConnection'], ParentType, ContextType, RequireFields<FileTaskSourcesByFileIdArgs, 'orderBy'>>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uploadStatus?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileActivitiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileActivitiesConnection'] = ResolversParentTypes['FileActivitiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FileActivitiesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['FileActivity']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileActivitiesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileActivitiesEdge'] = ResolversParentTypes['FileActivitiesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FileActivity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileActivity'] = ResolversParentTypes['FileActivity']> = {
  activityType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  bytes?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentTypeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  costId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fileByFileId?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileMetadataConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileMetadataConnection'] = ResolversParentTypes['FileMetadataConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FileMetadataEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['FileMetadatum']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileMetadataEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileMetadataEdge'] = ResolversParentTypes['FileMetadataEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FileMetadatum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileMetadatumResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileMetadatum'] = ResolversParentTypes['FileMetadatum']> = {
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fileByFileId?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  metadataId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  metadatumByMetadataId?: Resolver<Maybe<ResolversTypes['Metadatum']>, ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileOutputGroup'] = ResolversParentTypes['FileOutputGroup']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fileOutputGroupMetadataByFileOutputGroupId?: Resolver<ResolversTypes['FileOutputGroupMetadataConnection'], ParentType, ContextType, RequireFields<FileOutputGroupFileOutputGroupMetadataByFileOutputGroupIdArgs, 'orderBy'>>;
  groupType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputGroupFilesByFileOutputGroupId?: Resolver<ResolversTypes['OutputGroupFilesConnection'], ParentType, ContextType, RequireFields<FileOutputGroupOutputGroupFilesByFileOutputGroupIdArgs, 'orderBy'>>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  taskByTaskId?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupMetadataConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileOutputGroupMetadataConnection'] = ResolversParentTypes['FileOutputGroupMetadataConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FileOutputGroupMetadataEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['FileOutputGroupMetadatum']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupMetadataEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileOutputGroupMetadataEdge'] = ResolversParentTypes['FileOutputGroupMetadataEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FileOutputGroupMetadatum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupMetadatumResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileOutputGroupMetadatum'] = ResolversParentTypes['FileOutputGroupMetadatum']> = {
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fileOutputGroupByFileOutputGroupId?: Resolver<Maybe<ResolversTypes['FileOutputGroup']>, ParentType, ContextType>;
  fileOutputGroupId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  metadataId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  metadatumByMetadataId?: Resolver<Maybe<ResolversTypes['Metadatum']>, ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileOutputGroupsConnection'] = ResolversParentTypes['FileOutputGroupsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FileOutputGroupsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['FileOutputGroup']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileOutputGroupsEdge'] = ResolversParentTypes['FileOutputGroupsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FileOutputGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileProcessingNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileProcessingNotification'] = ResolversParentTypes['FileProcessingNotification']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  fileByFileId?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  fileId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  notificationById?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileProcessingNotificationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileProcessingNotificationsConnection'] = ResolversParentTypes['FileProcessingNotificationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FileProcessingNotificationsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['FileProcessingNotification']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileProcessingNotificationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileProcessingNotificationsEdge'] = ResolversParentTypes['FileProcessingNotificationsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FileProcessingNotification'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FilesConnection'] = ResolversParentTypes['FilesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['FilesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['File']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FilesEdge'] = ResolversParentTypes['FilesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['File'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableResolvers<ContextType = any, ParentType extends ResolversParentTypes['GdtAnalysisTable'] = ResolversParentTypes['GdtAnalysisTable']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dateDeleted?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  folderId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  gdtAnalysisTableRowsByTableId?: Resolver<ResolversTypes['GdtAnalysisTableRowsConnection'], ParentType, ContextType, RequireFields<GdtAnalysisTableGdtAnalysisTableRowsByTableIdArgs, 'orderBy'>>;
  hidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectFolderByFolderId?: Resolver<Maybe<ResolversTypes['ProjectFolder']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<Maybe<ResolversTypes['ToolVersion']>, ParentType, ContextType>;
  toolVersionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  workflowTableId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['GdtAnalysisTableRow'] = ResolversParentTypes['GdtAnalysisTableRow']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  cached?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dateDeleted?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  editable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  gdtAnalysisTableByTableId?: Resolver<Maybe<ResolversTypes['GdtAnalysisTable']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  index?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  joinable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  resourceTier?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tableId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  taskByTaskId?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<Maybe<ResolversTypes['ToolVersion']>, ParentType, ContextType>;
  toolVersionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableRowsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GdtAnalysisTableRowsConnection'] = ResolversParentTypes['GdtAnalysisTableRowsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['GdtAnalysisTableRowsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GdtAnalysisTableRow']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableRowsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GdtAnalysisTableRowsEdge'] = ResolversParentTypes['GdtAnalysisTableRowsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['GdtAnalysisTableRow'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTablesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GdtAnalysisTablesConnection'] = ResolversParentTypes['GdtAnalysisTablesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['GdtAnalysisTablesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GdtAnalysisTable']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTablesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GdtAnalysisTablesEdge'] = ResolversParentTypes['GdtAnalysisTablesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['GdtAnalysisTable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntervalResolvers<ContextType = any, ParentType extends ResolversParentTypes['Interval'] = ResolversParentTypes['Interval']> = {
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  months?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seconds?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  years?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type MetadataConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetadataConnection'] = ResolversParentTypes['MetadataConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MetadataEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Metadatum']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadataEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetadataEdge'] = ResolversParentTypes['MetadataEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Metadatum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadataValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetadataValue'] = ResolversParentTypes['MetadataValue']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  metadataId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  metadatumByMetadataId?: Resolver<Maybe<ResolversTypes['Metadatum']>, ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  taskByTaskId?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadataValuesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetadataValuesConnection'] = ResolversParentTypes['MetadataValuesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MetadataValuesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MetadataValue']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadataValuesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetadataValuesEdge'] = ResolversParentTypes['MetadataValuesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MetadataValue'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadatumResolvers<ContextType = any, ParentType extends ResolversParentTypes['Metadatum'] = ResolversParentTypes['Metadatum']> = {
  activeValue?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, Partial<MetadatumActiveValueArgs>>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileMetadataByMetadataId?: Resolver<ResolversTypes['FileMetadataConnection'], ParentType, ContextType, RequireFields<MetadatumFileMetadataByMetadataIdArgs, 'orderBy'>>;
  fileOutputGroupMetadataByMetadataId?: Resolver<ResolversTypes['FileOutputGroupMetadataConnection'], ParentType, ContextType, RequireFields<MetadatumFileOutputGroupMetadataByMetadataIdArgs, 'orderBy'>>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadataValuesByMetadataId?: Resolver<ResolversTypes['MetadataValuesConnection'], ParentType, ContextType, RequireFields<MetadatumMetadataValuesByMetadataIdArgs, 'orderBy'>>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  changeUserSession?: Resolver<Maybe<ResolversTypes['ChangeUserSessionPayload']>, ParentType, ContextType, RequireFields<MutationChangeUserSessionArgs, 'input'>>;
  createApplicationUserMetadatum?: Resolver<Maybe<ResolversTypes['CreateApplicationUserMetadatumPayload']>, ParentType, ContextType, RequireFields<MutationCreateApplicationUserMetadatumArgs, 'input'>>;
  createApplicationUserSession?: Resolver<Maybe<ResolversTypes['CreateApplicationUserSessionPayload']>, ParentType, ContextType, RequireFields<MutationCreateApplicationUserSessionArgs, 'input'>>;
  createEulaVersionUserAcceptance?: Resolver<Maybe<ResolversTypes['CreateEulaVersionUserAcceptancePayload']>, ParentType, ContextType, RequireFields<MutationCreateEulaVersionUserAcceptanceArgs, 'input'>>;
  createMetadataValue?: Resolver<Maybe<ResolversTypes['CreateMetadataValuePayload']>, ParentType, ContextType, RequireFields<MutationCreateMetadataValueArgs, 'input'>>;
  createMetadatum?: Resolver<Maybe<ResolversTypes['CreateMetadatumPayload']>, ParentType, ContextType, RequireFields<MutationCreateMetadatumArgs, 'input'>>;
  createRole?: Resolver<Maybe<ResolversTypes['CreateRolePayload']>, ParentType, ContextType, RequireFields<MutationCreateRoleArgs, 'input'>>;
  createSession?: Resolver<Maybe<ResolversTypes['CreateSessionPayload']>, ParentType, ContextType, RequireFields<MutationCreateSessionArgs, 'input'>>;
  deleteSession?: Resolver<Maybe<ResolversTypes['DeleteSessionPayload']>, ParentType, ContextType, RequireFields<MutationDeleteSessionArgs, 'input'>>;
  updateApplicationUserByEmail?: Resolver<Maybe<ResolversTypes['UpdateApplicationUserPayload']>, ParentType, ContextType, RequireFields<MutationUpdateApplicationUserByEmailArgs, 'input'>>;
  updateApplicationUserByGlobalUserId?: Resolver<Maybe<ResolversTypes['UpdateApplicationUserPayload']>, ParentType, ContextType, RequireFields<MutationUpdateApplicationUserByGlobalUserIdArgs, 'input'>>;
  updateApplicationUserById?: Resolver<Maybe<ResolversTypes['UpdateApplicationUserPayload']>, ParentType, ContextType, RequireFields<MutationUpdateApplicationUserByIdArgs, 'input'>>;
  updateApplicationUserByUsername?: Resolver<Maybe<ResolversTypes['UpdateApplicationUserPayload']>, ParentType, ContextType, RequireFields<MutationUpdateApplicationUserByUsernameArgs, 'input'>>;
  updateApplicationUserMetadatumById?: Resolver<Maybe<ResolversTypes['UpdateApplicationUserMetadatumPayload']>, ParentType, ContextType, RequireFields<MutationUpdateApplicationUserMetadatumByIdArgs, 'input'>>;
  updateApplicationUserMetadatumByUserIdAndKey?: Resolver<Maybe<ResolversTypes['UpdateApplicationUserMetadatumPayload']>, ParentType, ContextType, RequireFields<MutationUpdateApplicationUserMetadatumByUserIdAndKeyArgs, 'input'>>;
  updateAvatarById?: Resolver<Maybe<ResolversTypes['UpdateAvatarPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAvatarByIdArgs, 'input'>>;
  updateAvatarByUserId?: Resolver<Maybe<ResolversTypes['UpdateAvatarPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAvatarByUserIdArgs, 'input'>>;
};

export type NotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fileProcessingNotificationById?: Resolver<Maybe<ResolversTypes['FileProcessingNotification']>, ParentType, ContextType>;
  fileProcessingNotificationsById?: Resolver<ResolversTypes['FileProcessingNotificationsConnection'], ParentType, ContextType, RequireFields<NotificationFileProcessingNotificationsByIdArgs, 'orderBy'>>;
  hasSeen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  projectClonedNotificationById?: Resolver<Maybe<ResolversTypes['ProjectClonedNotification']>, ParentType, ContextType>;
  projectClonedNotificationsById?: Resolver<ResolversTypes['ProjectClonedNotificationsConnection'], ParentType, ContextType, RequireFields<NotificationProjectClonedNotificationsByIdArgs, 'orderBy'>>;
  projectSharedNotificationById?: Resolver<Maybe<ResolversTypes['ProjectSharedNotification']>, ParentType, ContextType>;
  projectSharedNotificationsById?: Resolver<ResolversTypes['ProjectSharedNotificationsConnection'], ParentType, ContextType, RequireFields<NotificationProjectSharedNotificationsByIdArgs, 'orderBy'>>;
  roleChangeNotificationById?: Resolver<Maybe<ResolversTypes['RoleChangeNotification']>, ParentType, ContextType>;
  roleChangeNotificationsById?: Resolver<ResolversTypes['RoleChangeNotificationsConnection'], ParentType, ContextType, RequireFields<NotificationRoleChangeNotificationsByIdArgs, 'orderBy'>>;
  tenantUserMembershipNotificationById?: Resolver<Maybe<ResolversTypes['TenantUserMembershipNotification']>, ParentType, ContextType>;
  tenantUserMembershipNotificationsById?: Resolver<ResolversTypes['TenantUserMembershipNotificationsConnection'], ParentType, ContextType, RequireFields<NotificationTenantUserMembershipNotificationsByIdArgs, 'orderBy'>>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationsConnection'] = ResolversParentTypes['NotificationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['NotificationsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Notification']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationsEdge'] = ResolversParentTypes['NotificationsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Notification'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutputGroupFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutputGroupFile'] = ResolversParentTypes['OutputGroupFile']> = {
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fileByFileId?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  fileId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  fileOutputGroupByFileOutputGroupId?: Resolver<Maybe<ResolversTypes['FileOutputGroup']>, ParentType, ContextType>;
  fileOutputGroupId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutputGroupFilesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutputGroupFilesConnection'] = ResolversParentTypes['OutputGroupFilesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OutputGroupFilesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['OutputGroupFile']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutputGroupFilesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutputGroupFilesEdge'] = ResolversParentTypes['OutputGroupFilesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['OutputGroupFile'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['Project'] = ResolversParentTypes['Project']> = {
  activeFiles?: Resolver<ResolversTypes['FilesConnection'], ParentType, ContextType, Partial<ProjectActiveFilesArgs>>;
  activeStorageSize?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  archivedStorageSize?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  cloneSourceId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  dataTablesByProjectId?: Resolver<ResolversTypes['DataTablesConnection'], ParentType, ContextType, RequireFields<ProjectDataTablesByProjectIdArgs, 'orderBy'>>;
  dateArchived?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  dateDataDeleted?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  dateDeleted?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  dateLastActive?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  defaultUserAccessLevel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileActivitiesByProjectId?: Resolver<ResolversTypes['FileActivitiesConnection'], ParentType, ContextType, RequireFields<ProjectFileActivitiesByProjectIdArgs, 'orderBy'>>;
  fileMetadataByProjectId?: Resolver<ResolversTypes['FileMetadataConnection'], ParentType, ContextType, RequireFields<ProjectFileMetadataByProjectIdArgs, 'orderBy'>>;
  fileOutputGroupMetadataByProjectId?: Resolver<ResolversTypes['FileOutputGroupMetadataConnection'], ParentType, ContextType, RequireFields<ProjectFileOutputGroupMetadataByProjectIdArgs, 'orderBy'>>;
  fileOutputGroupsByProjectId?: Resolver<ResolversTypes['FileOutputGroupsConnection'], ParentType, ContextType, RequireFields<ProjectFileOutputGroupsByProjectIdArgs, 'orderBy'>>;
  filesByProjectId?: Resolver<ResolversTypes['FilesConnection'], ParentType, ContextType, RequireFields<ProjectFilesByProjectIdArgs, 'orderBy'>>;
  gdtAnalysisTableRowsByProjectId?: Resolver<ResolversTypes['GdtAnalysisTableRowsConnection'], ParentType, ContextType, RequireFields<ProjectGdtAnalysisTableRowsByProjectIdArgs, 'orderBy'>>;
  gdtAnalysisTablesByProjectId?: Resolver<ResolversTypes['GdtAnalysisTablesConnection'], ParentType, ContextType, RequireFields<ProjectGdtAnalysisTablesByProjectIdArgs, 'orderBy'>>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iconColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  iconText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  isDemo?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isToolProject?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadataByProjectId?: Resolver<ResolversTypes['MetadataConnection'], ParentType, ContextType, RequireFields<ProjectMetadataByProjectIdArgs, 'orderBy'>>;
  metadataValuesByProjectId?: Resolver<ResolversTypes['MetadataValuesConnection'], ParentType, ContextType, RequireFields<ProjectMetadataValuesByProjectIdArgs, 'orderBy'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outputGroupFilesByProjectId?: Resolver<ResolversTypes['OutputGroupFilesConnection'], ParentType, ContextType, RequireFields<ProjectOutputGroupFilesByProjectIdArgs, 'orderBy'>>;
  pinned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectByCloneSourceId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectClonedNotificationsByProjectId?: Resolver<ResolversTypes['ProjectClonedNotificationsConnection'], ParentType, ContextType, RequireFields<ProjectProjectClonedNotificationsByProjectIdArgs, 'orderBy'>>;
  projectClonedNotificationsBySrcProjectId?: Resolver<ResolversTypes['ProjectClonedNotificationsConnection'], ParentType, ContextType, RequireFields<ProjectProjectClonedNotificationsBySrcProjectIdArgs, 'orderBy'>>;
  projectFoldersByProjectId?: Resolver<ResolversTypes['ProjectFoldersConnection'], ParentType, ContextType, RequireFields<ProjectProjectFoldersByProjectIdArgs, 'orderBy'>>;
  projectSharedNotificationsByProjectId?: Resolver<ResolversTypes['ProjectSharedNotificationsConnection'], ParentType, ContextType, RequireFields<ProjectProjectSharedNotificationsByProjectIdArgs, 'orderBy'>>;
  projectTagsByProjectId?: Resolver<ResolversTypes['ProjectTagsConnection'], ParentType, ContextType, RequireFields<ProjectProjectTagsByProjectIdArgs, 'orderBy'>>;
  projectsByCloneSourceId?: Resolver<ResolversTypes['ProjectsConnection'], ParentType, ContextType, RequireFields<ProjectProjectsByCloneSourceIdArgs, 'orderBy'>>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tasksByProjectId?: Resolver<ResolversTypes['TasksConnection'], ParentType, ContextType, RequireFields<ProjectTasksByProjectIdArgs, 'orderBy'>>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  toolByProjectId?: Resolver<Maybe<ResolversTypes['Tool']>, ParentType, ContextType>;
  toolsByProjectId?: Resolver<ResolversTypes['ToolsConnection'], ParentType, ContextType, RequireFields<ProjectToolsByProjectIdArgs, 'orderBy'>>;
  tourType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedCredits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectClonedNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectClonedNotification'] = ResolversParentTypes['ProjectClonedNotification']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  notificationById?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectBySrcProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  projectName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srcProjectId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  succeeded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectClonedNotificationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectClonedNotificationsConnection'] = ResolversParentTypes['ProjectClonedNotificationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProjectClonedNotificationsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ProjectClonedNotification']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectClonedNotificationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectClonedNotificationsEdge'] = ResolversParentTypes['ProjectClonedNotificationsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProjectClonedNotification'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectFolderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectFolder'] = ResolversParentTypes['ProjectFolder']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dataTablesByFolderId?: Resolver<ResolversTypes['DataTablesConnection'], ParentType, ContextType, RequireFields<ProjectFolderDataTablesByFolderIdArgs, 'orderBy'>>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  gdtAnalysisTablesByFolderId?: Resolver<ResolversTypes['GdtAnalysisTablesConnection'], ParentType, ContextType, RequireFields<ProjectFolderGdtAnalysisTablesByFolderIdArgs, 'orderBy'>>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectFoldersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectFoldersConnection'] = ResolversParentTypes['ProjectFoldersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProjectFoldersEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ProjectFolder']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectFoldersEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectFoldersEdge'] = ResolversParentTypes['ProjectFoldersEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProjectFolder'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectSharedNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectSharedNotification'] = ResolversParentTypes['ProjectSharedNotification']> = {
  accessLevel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  applicationUserBySharerId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  notificationById?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  sharerId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectSharedNotificationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectSharedNotificationsConnection'] = ResolversParentTypes['ProjectSharedNotificationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProjectSharedNotificationsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ProjectSharedNotification']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectSharedNotificationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectSharedNotificationsEdge'] = ResolversParentTypes['ProjectSharedNotificationsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProjectSharedNotification'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectTag'] = ResolversParentTypes['ProjectTag']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectTagsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectTagsConnection'] = ResolversParentTypes['ProjectTagsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProjectTagsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ProjectTag']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectTagsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectTagsEdge'] = ResolversParentTypes['ProjectTagsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProjectTag'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectsConnection'] = ResolversParentTypes['ProjectsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProjectsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Project']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectsEdge'] = ResolversParentTypes['ProjectsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Project'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  allApplicationUserMemberships?: Resolver<Maybe<ResolversTypes['ApplicationUserMembershipsConnection']>, ParentType, ContextType, RequireFields<QueryAllApplicationUserMembershipsArgs, 'orderBy'>>;
  allApplicationUserMetadata?: Resolver<Maybe<ResolversTypes['ApplicationUserMetadataConnection']>, ParentType, ContextType, RequireFields<QueryAllApplicationUserMetadataArgs, 'orderBy'>>;
  allApplicationUserSessions?: Resolver<Maybe<ResolversTypes['ApplicationUserSessionsConnection']>, ParentType, ContextType, RequireFields<QueryAllApplicationUserSessionsArgs, 'orderBy'>>;
  allAvatars?: Resolver<Maybe<ResolversTypes['AvatarsConnection']>, ParentType, ContextType, RequireFields<QueryAllAvatarsArgs, 'orderBy'>>;
  allCodeFiles?: Resolver<Maybe<ResolversTypes['CodeFilesConnection']>, ParentType, ContextType, RequireFields<QueryAllCodeFilesArgs, 'orderBy'>>;
  allCurrentApplicationUsers?: Resolver<Maybe<ResolversTypes['CurrentApplicationUsersConnection']>, ParentType, ContextType, RequireFields<QueryAllCurrentApplicationUsersArgs, 'orderBy'>>;
  allCurrentUserMemberships?: Resolver<Maybe<ResolversTypes['CurrentUserMembershipsConnection']>, ParentType, ContextType, RequireFields<QueryAllCurrentUserMembershipsArgs, 'orderBy'>>;
  allDataTables?: Resolver<Maybe<ResolversTypes['DataTablesConnection']>, ParentType, ContextType, RequireFields<QueryAllDataTablesArgs, 'orderBy'>>;
  allEulaVersionUserAcceptances?: Resolver<Maybe<ResolversTypes['EulaVersionUserAcceptancesConnection']>, ParentType, ContextType, RequireFields<QueryAllEulaVersionUserAcceptancesArgs, 'orderBy'>>;
  allEulaVersions?: Resolver<Maybe<ResolversTypes['EulaVersionsConnection']>, ParentType, ContextType, RequireFields<QueryAllEulaVersionsArgs, 'orderBy'>>;
  allFileActivities?: Resolver<Maybe<ResolversTypes['FileActivitiesConnection']>, ParentType, ContextType, RequireFields<QueryAllFileActivitiesArgs, 'orderBy'>>;
  allFileMetadata?: Resolver<Maybe<ResolversTypes['FileMetadataConnection']>, ParentType, ContextType, RequireFields<QueryAllFileMetadataArgs, 'orderBy'>>;
  allFileOutputGroupMetadata?: Resolver<Maybe<ResolversTypes['FileOutputGroupMetadataConnection']>, ParentType, ContextType, RequireFields<QueryAllFileOutputGroupMetadataArgs, 'orderBy'>>;
  allFileOutputGroups?: Resolver<Maybe<ResolversTypes['FileOutputGroupsConnection']>, ParentType, ContextType, RequireFields<QueryAllFileOutputGroupsArgs, 'orderBy'>>;
  allFileProcessingNotifications?: Resolver<Maybe<ResolversTypes['FileProcessingNotificationsConnection']>, ParentType, ContextType, RequireFields<QueryAllFileProcessingNotificationsArgs, 'orderBy'>>;
  allFiles?: Resolver<Maybe<ResolversTypes['FilesConnection']>, ParentType, ContextType, RequireFields<QueryAllFilesArgs, 'orderBy'>>;
  allGdtAnalysisTableRows?: Resolver<Maybe<ResolversTypes['GdtAnalysisTableRowsConnection']>, ParentType, ContextType, RequireFields<QueryAllGdtAnalysisTableRowsArgs, 'orderBy'>>;
  allGdtAnalysisTables?: Resolver<Maybe<ResolversTypes['GdtAnalysisTablesConnection']>, ParentType, ContextType, RequireFields<QueryAllGdtAnalysisTablesArgs, 'orderBy'>>;
  allNotifications?: Resolver<Maybe<ResolversTypes['NotificationsConnection']>, ParentType, ContextType, RequireFields<QueryAllNotificationsArgs, 'orderBy'>>;
  allOutputGroupFiles?: Resolver<Maybe<ResolversTypes['OutputGroupFilesConnection']>, ParentType, ContextType, RequireFields<QueryAllOutputGroupFilesArgs, 'orderBy'>>;
  allProjectClonedNotifications?: Resolver<Maybe<ResolversTypes['ProjectClonedNotificationsConnection']>, ParentType, ContextType, RequireFields<QueryAllProjectClonedNotificationsArgs, 'orderBy'>>;
  allProjectFolders?: Resolver<Maybe<ResolversTypes['ProjectFoldersConnection']>, ParentType, ContextType, RequireFields<QueryAllProjectFoldersArgs, 'orderBy'>>;
  allProjectSharedNotifications?: Resolver<Maybe<ResolversTypes['ProjectSharedNotificationsConnection']>, ParentType, ContextType, RequireFields<QueryAllProjectSharedNotificationsArgs, 'orderBy'>>;
  allProjectTags?: Resolver<Maybe<ResolversTypes['ProjectTagsConnection']>, ParentType, ContextType, RequireFields<QueryAllProjectTagsArgs, 'orderBy'>>;
  allProjects?: Resolver<Maybe<ResolversTypes['ProjectsConnection']>, ParentType, ContextType, RequireFields<QueryAllProjectsArgs, 'orderBy'>>;
  allRoleChangeNotifications?: Resolver<Maybe<ResolversTypes['RoleChangeNotificationsConnection']>, ParentType, ContextType, RequireFields<QueryAllRoleChangeNotificationsArgs, 'orderBy'>>;
  allTaskActivities?: Resolver<Maybe<ResolversTypes['TaskActivitiesConnection']>, ParentType, ContextType, RequireFields<QueryAllTaskActivitiesArgs, 'orderBy'>>;
  allTaskResourceUsages?: Resolver<Maybe<ResolversTypes['TaskResourceUsagesConnection']>, ParentType, ContextType, RequireFields<QueryAllTaskResourceUsagesArgs, 'orderBy'>>;
  allTaskResources?: Resolver<Maybe<ResolversTypes['TaskResourcesConnection']>, ParentType, ContextType, RequireFields<QueryAllTaskResourcesArgs, 'orderBy'>>;
  allTaskSources?: Resolver<Maybe<ResolversTypes['TaskSourcesConnection']>, ParentType, ContextType, RequireFields<QueryAllTaskSourcesArgs, 'orderBy'>>;
  allTasks?: Resolver<Maybe<ResolversTypes['TasksConnection']>, ParentType, ContextType, RequireFields<QueryAllTasksArgs, 'orderBy'>>;
  allTenantContractAllowances?: Resolver<Maybe<ResolversTypes['TenantContractAllowancesConnection']>, ParentType, ContextType, RequireFields<QueryAllTenantContractAllowancesArgs, 'orderBy'>>;
  allTenantContractTransactions?: Resolver<Maybe<ResolversTypes['TenantContractTransactionsConnection']>, ParentType, ContextType, RequireFields<QueryAllTenantContractTransactionsArgs, 'orderBy'>>;
  allTenantContracts?: Resolver<Maybe<ResolversTypes['TenantContractsConnection']>, ParentType, ContextType, RequireFields<QueryAllTenantContractsArgs, 'orderBy'>>;
  allTenantUserMembershipNotifications?: Resolver<Maybe<ResolversTypes['TenantUserMembershipNotificationsConnection']>, ParentType, ContextType, RequireFields<QueryAllTenantUserMembershipNotificationsArgs, 'orderBy'>>;
  allToolParameters?: Resolver<Maybe<ResolversTypes['ToolParametersConnection']>, ParentType, ContextType, RequireFields<QueryAllToolParametersArgs, 'orderBy'>>;
  allToolResults?: Resolver<Maybe<ResolversTypes['ToolResultsConnection']>, ParentType, ContextType, RequireFields<QueryAllToolResultsArgs, 'orderBy'>>;
  allToolSecrets?: Resolver<Maybe<ResolversTypes['ToolSecretsConnection']>, ParentType, ContextType, RequireFields<QueryAllToolSecretsArgs, 'orderBy'>>;
  allToolSources?: Resolver<Maybe<ResolversTypes['ToolSourcesConnection']>, ParentType, ContextType, RequireFields<QueryAllToolSourcesArgs, 'orderBy'>>;
  allToolTenants?: Resolver<Maybe<ResolversTypes['ToolTenantsConnection']>, ParentType, ContextType, RequireFields<QueryAllToolTenantsArgs, 'orderBy'>>;
  allToolVersions?: Resolver<Maybe<ResolversTypes['ToolVersionsConnection']>, ParentType, ContextType, RequireFields<QueryAllToolVersionsArgs, 'orderBy'>>;
  allTools?: Resolver<Maybe<ResolversTypes['ToolsConnection']>, ParentType, ContextType, RequireFields<QueryAllToolsArgs, 'orderBy'>>;
  allUserAccessToProjects?: Resolver<Maybe<ResolversTypes['UserAccessToProjectsConnection']>, ParentType, ContextType, RequireFields<QueryAllUserAccessToProjectsArgs, 'orderBy'>>;
  applicationUserByEmail?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType, RequireFields<QueryApplicationUserByEmailArgs, 'email'>>;
  applicationUserByGlobalUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType, RequireFields<QueryApplicationUserByGlobalUserIdArgs, 'globalUserId'>>;
  applicationUserById?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType, RequireFields<QueryApplicationUserByIdArgs, 'id'>>;
  applicationUserByUsername?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType, RequireFields<QueryApplicationUserByUsernameArgs, 'username'>>;
  applicationUserMembershipById?: Resolver<Maybe<ResolversTypes['ApplicationUserMembership']>, ParentType, ContextType, RequireFields<QueryApplicationUserMembershipByIdArgs, 'id'>>;
  applicationUserMembershipByUserIdAndTenantId?: Resolver<Maybe<ResolversTypes['ApplicationUserMembership']>, ParentType, ContextType, RequireFields<QueryApplicationUserMembershipByUserIdAndTenantIdArgs, 'tenantId' | 'userId'>>;
  applicationUserMetadatumById?: Resolver<Maybe<ResolversTypes['ApplicationUserMetadatum']>, ParentType, ContextType, RequireFields<QueryApplicationUserMetadatumByIdArgs, 'id'>>;
  applicationUserMetadatumByUserIdAndKey?: Resolver<Maybe<ResolversTypes['ApplicationUserMetadatum']>, ParentType, ContextType, RequireFields<QueryApplicationUserMetadatumByUserIdAndKeyArgs, 'key' | 'userId'>>;
  applicationUserSessionById?: Resolver<Maybe<ResolversTypes['ApplicationUserSession']>, ParentType, ContextType, RequireFields<QueryApplicationUserSessionByIdArgs, 'id'>>;
  assertUserAcceptedEula?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  assertUserCanSeeTenantInfo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<QueryAssertUserCanSeeTenantInfoArgs>>;
  assertUserCanSeeUserInfo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<QueryAssertUserCanSeeUserInfoArgs>>;
  assertUserHasProjectSharedByTenant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<QueryAssertUserHasProjectSharedByTenantArgs>>;
  assertUserHasTenantOfId?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<QueryAssertUserHasTenantOfIdArgs>>;
  assertUserIsAdminOfProjectTenant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<QueryAssertUserIsAdminOfProjectTenantArgs>>;
  assertUserIsAdminOfTenant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<QueryAssertUserIsAdminOfTenantArgs>>;
  assertUserIsInvitedToTenant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<QueryAssertUserIsInvitedToTenantArgs>>;
  avatarById?: Resolver<Maybe<ResolversTypes['Avatar']>, ParentType, ContextType, RequireFields<QueryAvatarByIdArgs, 'id'>>;
  avatarByUserId?: Resolver<Maybe<ResolversTypes['Avatar']>, ParentType, ContextType, RequireFields<QueryAvatarByUserIdArgs, 'userId'>>;
  codeFileById?: Resolver<Maybe<ResolversTypes['CodeFile']>, ParentType, ContextType, RequireFields<QueryCodeFileByIdArgs, 'id'>>;
  dataTableById?: Resolver<Maybe<ResolversTypes['DataTable']>, ParentType, ContextType, RequireFields<QueryDataTableByIdArgs, 'id'>>;
  eulaVersionById?: Resolver<Maybe<ResolversTypes['EulaVersion']>, ParentType, ContextType, RequireFields<QueryEulaVersionByIdArgs, 'id'>>;
  eulaVersionByVersion?: Resolver<Maybe<ResolversTypes['EulaVersion']>, ParentType, ContextType, RequireFields<QueryEulaVersionByVersionArgs, 'version'>>;
  eulaVersionUserAcceptanceById?: Resolver<Maybe<ResolversTypes['EulaVersionUserAcceptance']>, ParentType, ContextType, RequireFields<QueryEulaVersionUserAcceptanceByIdArgs, 'id'>>;
  eulaVersionUserAcceptanceByUserIdAndEulaVersionId?: Resolver<Maybe<ResolversTypes['EulaVersionUserAcceptance']>, ParentType, ContextType, RequireFields<QueryEulaVersionUserAcceptanceByUserIdAndEulaVersionIdArgs, 'eulaVersionId' | 'userId'>>;
  fileActivityById?: Resolver<Maybe<ResolversTypes['FileActivity']>, ParentType, ContextType, RequireFields<QueryFileActivityByIdArgs, 'id'>>;
  fileById?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType, RequireFields<QueryFileByIdArgs, 'id'>>;
  fileByProjectIdAndReferenceId?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType, RequireFields<QueryFileByProjectIdAndReferenceIdArgs, 'projectId' | 'referenceId'>>;
  fileMetadatumById?: Resolver<Maybe<ResolversTypes['FileMetadatum']>, ParentType, ContextType, RequireFields<QueryFileMetadatumByIdArgs, 'id'>>;
  fileOutputGroupById?: Resolver<Maybe<ResolversTypes['FileOutputGroup']>, ParentType, ContextType, RequireFields<QueryFileOutputGroupByIdArgs, 'id'>>;
  fileOutputGroupByTaskId?: Resolver<Maybe<ResolversTypes['FileOutputGroup']>, ParentType, ContextType, RequireFields<QueryFileOutputGroupByTaskIdArgs, 'taskId'>>;
  fileOutputGroupMetadatumById?: Resolver<Maybe<ResolversTypes['FileOutputGroupMetadatum']>, ParentType, ContextType, RequireFields<QueryFileOutputGroupMetadatumByIdArgs, 'id'>>;
  fileProcessingNotificationById?: Resolver<Maybe<ResolversTypes['FileProcessingNotification']>, ParentType, ContextType, RequireFields<QueryFileProcessingNotificationByIdArgs, 'id'>>;
  gdtAnalysisTableById?: Resolver<Maybe<ResolversTypes['GdtAnalysisTable']>, ParentType, ContextType, RequireFields<QueryGdtAnalysisTableByIdArgs, 'id'>>;
  gdtAnalysisTableRowById?: Resolver<Maybe<ResolversTypes['GdtAnalysisTableRow']>, ParentType, ContextType, RequireFields<QueryGdtAnalysisTableRowByIdArgs, 'id'>>;
  gdtAnalysisTableRowByTableIdAndIndex?: Resolver<Maybe<ResolversTypes['GdtAnalysisTableRow']>, ParentType, ContextType, RequireFields<QueryGdtAnalysisTableRowByTableIdAndIndexArgs, 'index' | 'tableId'>>;
  gdtAnalysisTableRowByTableIdAndOrder?: Resolver<Maybe<ResolversTypes['GdtAnalysisTableRow']>, ParentType, ContextType, RequireFields<QueryGdtAnalysisTableRowByTableIdAndOrderArgs, 'order' | 'tableId'>>;
  getCurrentUser?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  getCurrentUserId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  getUserActiveSession?: Resolver<Maybe<ResolversTypes['ApplicationUserSession']>, ParentType, ContextType, RequireFields<QueryGetUserActiveSessionArgs, 'userid'>>;
  jwtHasGlobalUserIdClaim?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  metadataValueById?: Resolver<Maybe<ResolversTypes['MetadataValue']>, ParentType, ContextType, RequireFields<QueryMetadataValueByIdArgs, 'id'>>;
  metadatumById?: Resolver<Maybe<ResolversTypes['Metadatum']>, ParentType, ContextType, RequireFields<QueryMetadatumByIdArgs, 'id'>>;
  notificationById?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType, RequireFields<QueryNotificationByIdArgs, 'id'>>;
  outputGroupFileById?: Resolver<Maybe<ResolversTypes['OutputGroupFile']>, ParentType, ContextType, RequireFields<QueryOutputGroupFileByIdArgs, 'id'>>;
  projectById?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<QueryProjectByIdArgs, 'id'>>;
  projectByKeyAndTenantId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<QueryProjectByKeyAndTenantIdArgs, 'key' | 'tenantId'>>;
  projectClonedNotificationById?: Resolver<Maybe<ResolversTypes['ProjectClonedNotification']>, ParentType, ContextType, RequireFields<QueryProjectClonedNotificationByIdArgs, 'id'>>;
  projectFolderById?: Resolver<Maybe<ResolversTypes['ProjectFolder']>, ParentType, ContextType, RequireFields<QueryProjectFolderByIdArgs, 'id'>>;
  projectSharedNotificationById?: Resolver<Maybe<ResolversTypes['ProjectSharedNotification']>, ParentType, ContextType, RequireFields<QueryProjectSharedNotificationByIdArgs, 'id'>>;
  projectTagById?: Resolver<Maybe<ResolversTypes['ProjectTag']>, ParentType, ContextType, RequireFields<QueryProjectTagByIdArgs, 'id'>>;
  query?: Resolver<ResolversTypes['Query'], ParentType, ContextType>;
  roleChangeNotificationById?: Resolver<Maybe<ResolversTypes['RoleChangeNotification']>, ParentType, ContextType, RequireFields<QueryRoleChangeNotificationByIdArgs, 'id'>>;
  sessionIsActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sessionIsActiveSession?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QuerySessionIsActiveSessionArgs, 'id'>>;
  taskActivityById?: Resolver<Maybe<ResolversTypes['TaskActivity']>, ParentType, ContextType, RequireFields<QueryTaskActivityByIdArgs, 'id'>>;
  taskActivityByTaskId?: Resolver<Maybe<ResolversTypes['TaskActivity']>, ParentType, ContextType, RequireFields<QueryTaskActivityByTaskIdArgs, 'taskId'>>;
  taskByExecutorId?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType, RequireFields<QueryTaskByExecutorIdArgs, 'executorId'>>;
  taskById?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType, RequireFields<QueryTaskByIdArgs, 'id'>>;
  taskResourceById?: Resolver<Maybe<ResolversTypes['TaskResource']>, ParentType, ContextType, RequireFields<QueryTaskResourceByIdArgs, 'id'>>;
  taskResourceUsageById?: Resolver<Maybe<ResolversTypes['TaskResourceUsage']>, ParentType, ContextType, RequireFields<QueryTaskResourceUsageByIdArgs, 'id'>>;
  taskResourceUsageByTaskId?: Resolver<Maybe<ResolversTypes['TaskResourceUsage']>, ParentType, ContextType, RequireFields<QueryTaskResourceUsageByTaskIdArgs, 'taskId'>>;
  taskSourceById?: Resolver<Maybe<ResolversTypes['TaskSource']>, ParentType, ContextType, RequireFields<QueryTaskSourceByIdArgs, 'id'>>;
  tenantById?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType, RequireFields<QueryTenantByIdArgs, 'id'>>;
  tenantByKey?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType, RequireFields<QueryTenantByKeyArgs, 'key'>>;
  tenantByRepositoryName?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType, RequireFields<QueryTenantByRepositoryNameArgs, 'repositoryName'>>;
  tenantBySfid?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType, RequireFields<QueryTenantBySfidArgs, 'sfid'>>;
  tenantContractAllowanceById?: Resolver<Maybe<ResolversTypes['TenantContractAllowance']>, ParentType, ContextType, RequireFields<QueryTenantContractAllowanceByIdArgs, 'id'>>;
  tenantContractAllowanceByTenantContractTransactionIdAndQuotaType?: Resolver<Maybe<ResolversTypes['TenantContractAllowance']>, ParentType, ContextType, RequireFields<QueryTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeArgs, 'quotaType' | 'tenantContractTransactionId'>>;
  tenantContractById?: Resolver<Maybe<ResolversTypes['TenantContract']>, ParentType, ContextType, RequireFields<QueryTenantContractByIdArgs, 'id'>>;
  tenantContractByName?: Resolver<Maybe<ResolversTypes['TenantContract']>, ParentType, ContextType, RequireFields<QueryTenantContractByNameArgs, 'name'>>;
  tenantContractBySfid?: Resolver<Maybe<ResolversTypes['TenantContract']>, ParentType, ContextType, RequireFields<QueryTenantContractBySfidArgs, 'sfid'>>;
  tenantContractTransactionById?: Resolver<Maybe<ResolversTypes['TenantContractTransaction']>, ParentType, ContextType, RequireFields<QueryTenantContractTransactionByIdArgs, 'id'>>;
  tenantUserMembershipNotificationById?: Resolver<Maybe<ResolversTypes['TenantUserMembershipNotification']>, ParentType, ContextType, RequireFields<QueryTenantUserMembershipNotificationByIdArgs, 'id'>>;
  toolById?: Resolver<Maybe<ResolversTypes['Tool']>, ParentType, ContextType, RequireFields<QueryToolByIdArgs, 'id'>>;
  toolByProjectId?: Resolver<Maybe<ResolversTypes['Tool']>, ParentType, ContextType, RequireFields<QueryToolByProjectIdArgs, 'projectId'>>;
  toolParameterById?: Resolver<Maybe<ResolversTypes['ToolParameter']>, ParentType, ContextType, RequireFields<QueryToolParameterByIdArgs, 'id'>>;
  toolResultById?: Resolver<Maybe<ResolversTypes['ToolResult']>, ParentType, ContextType, RequireFields<QueryToolResultByIdArgs, 'id'>>;
  toolSecretById?: Resolver<Maybe<ResolversTypes['ToolSecret']>, ParentType, ContextType, RequireFields<QueryToolSecretByIdArgs, 'id'>>;
  toolSourceById?: Resolver<Maybe<ResolversTypes['ToolSource']>, ParentType, ContextType, RequireFields<QueryToolSourceByIdArgs, 'id'>>;
  toolTenantById?: Resolver<Maybe<ResolversTypes['ToolTenant']>, ParentType, ContextType, RequireFields<QueryToolTenantByIdArgs, 'id'>>;
  toolTenantByToolIdAndTenantId?: Resolver<Maybe<ResolversTypes['ToolTenant']>, ParentType, ContextType, RequireFields<QueryToolTenantByToolIdAndTenantIdArgs, 'tenantId' | 'toolId'>>;
  toolVersionById?: Resolver<Maybe<ResolversTypes['ToolVersion']>, ParentType, ContextType, RequireFields<QueryToolVersionByIdArgs, 'id'>>;
  userHasActiveSession?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryUserHasActiveSessionArgs, 'userid'>>;
  userIdIsSettingsGlobalUserId?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<QueryUserIdIsSettingsGlobalUserIdArgs>>;
};

export type RoleChangeNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleChangeNotification'] = ResolversParentTypes['RoleChangeNotification']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  notificationById?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleChangeNotificationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleChangeNotificationsConnection'] = ResolversParentTypes['RoleChangeNotificationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RoleChangeNotificationsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['RoleChangeNotification']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleChangeNotificationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleChangeNotificationsEdge'] = ResolversParentTypes['RoleChangeNotificationsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RoleChangeNotification'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['Task'] = ResolversParentTypes['Task']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  cloned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  containerImageId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  errorDescription?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  executorId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fileOutputGroupByTaskId?: Resolver<Maybe<ResolversTypes['FileOutputGroup']>, ParentType, ContextType>;
  fileOutputGroupsByTaskId?: Resolver<ResolversTypes['FileOutputGroupsConnection'], ParentType, ContextType, RequireFields<TaskFileOutputGroupsByTaskIdArgs, 'orderBy'>>;
  filesByTaskId?: Resolver<ResolversTypes['FilesConnection'], ParentType, ContextType, RequireFields<TaskFilesByTaskIdArgs, 'orderBy'>>;
  gdtAnalysisTableRowsByTaskId?: Resolver<ResolversTypes['GdtAnalysisTableRowsConnection'], ParentType, ContextType, RequireFields<TaskGdtAnalysisTableRowsByTaskIdArgs, 'orderBy'>>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  inputsHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadataValuesByTaskId?: Resolver<ResolversTypes['MetadataValuesConnection'], ParentType, ContextType, RequireFields<TaskMetadataValuesByTaskIdArgs, 'orderBy'>>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  resourceTier?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taskActivitiesByTaskId?: Resolver<ResolversTypes['TaskActivitiesConnection'], ParentType, ContextType, RequireFields<TaskTaskActivitiesByTaskIdArgs, 'orderBy'>>;
  taskActivityByTaskId?: Resolver<Maybe<ResolversTypes['TaskActivity']>, ParentType, ContextType>;
  taskParameters?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  taskResourceUsageByTaskId?: Resolver<Maybe<ResolversTypes['TaskResourceUsage']>, ParentType, ContextType>;
  taskResourceUsagesByTaskId?: Resolver<ResolversTypes['TaskResourceUsagesConnection'], ParentType, ContextType, RequireFields<TaskTaskResourceUsagesByTaskIdArgs, 'orderBy'>>;
  taskResourcesByTaskId?: Resolver<ResolversTypes['TaskResourcesConnection'], ParentType, ContextType, RequireFields<TaskTaskResourcesByTaskIdArgs, 'orderBy'>>;
  taskSourcesByTaskId?: Resolver<ResolversTypes['TaskSourcesConnection'], ParentType, ContextType, RequireFields<TaskTaskSourcesByTaskIdArgs, 'orderBy'>>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  toolExitcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toolExitcodeDescription?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<Maybe<ResolversTypes['ToolVersion']>, ParentType, ContextType>;
  toolVersionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivitiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivitiesConnection'] = ResolversParentTypes['TaskActivitiesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TaskActivitiesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TaskActivity']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivitiesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivitiesEdge'] = ResolversParentTypes['TaskActivitiesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TaskActivity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivity'] = ResolversParentTypes['TaskActivity']> = {
  cloned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  costId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Interval'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  instanceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskByTaskId?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskResource'] = ResolversParentTypes['TaskResource']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taskByTaskId?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourceUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskResourceUsage'] = ResolversParentTypes['TaskResourceUsage']> = {
  cpuMax?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cpuMean?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cpuMedian?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cpuMin?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cpuStd?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  memoryMax?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  memoryMean?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  memoryMedian?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  memoryMin?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  memoryStd?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  storageMax?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  storageMean?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  storageMedian?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  storageMin?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  storageStd?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  taskByTaskId?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourceUsagesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskResourceUsagesConnection'] = ResolversParentTypes['TaskResourceUsagesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TaskResourceUsagesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TaskResourceUsage']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourceUsagesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskResourceUsagesEdge'] = ResolversParentTypes['TaskResourceUsagesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TaskResourceUsage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourcesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskResourcesConnection'] = ResolversParentTypes['TaskResourcesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TaskResourcesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TaskResource']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourcesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskResourcesEdge'] = ResolversParentTypes['TaskResourcesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TaskResource'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskSource'] = ResolversParentTypes['TaskSource']> = {
  fileByFileId?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taskByTaskId?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  toolSourceByToolSourceId?: Resolver<Maybe<ResolversTypes['ToolSource']>, ParentType, ContextType>;
  toolSourceId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskSourcesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskSourcesConnection'] = ResolversParentTypes['TaskSourcesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TaskSourcesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TaskSource']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskSourcesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskSourcesEdge'] = ResolversParentTypes['TaskSourcesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TaskSource'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TasksConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TasksConnection'] = ResolversParentTypes['TasksConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TasksEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Task']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TasksEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TasksEdge'] = ResolversParentTypes['TasksEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Task'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantResolvers<ContextType = any, ParentType extends ResolversParentTypes['Tenant'] = ResolversParentTypes['Tenant']> = {
  activeStorageSize?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  applicationUserMembershipsByTenantId?: Resolver<ResolversTypes['ApplicationUserMembershipsConnection'], ParentType, ContextType, RequireFields<TenantApplicationUserMembershipsByTenantIdArgs, 'orderBy'>>;
  applicationUserSessionsByTenantId?: Resolver<ResolversTypes['ApplicationUserSessionsConnection'], ParentType, ContextType, RequireFields<TenantApplicationUserSessionsByTenantIdArgs, 'orderBy'>>;
  archivedStorageSize?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  codeFilesByTenantId?: Resolver<ResolversTypes['CodeFilesConnection'], ParentType, ContextType, RequireFields<TenantCodeFilesByTenantIdArgs, 'orderBy'>>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  fileActivitiesByTenantId?: Resolver<ResolversTypes['FileActivitiesConnection'], ParentType, ContextType, RequireFields<TenantFileActivitiesByTenantIdArgs, 'orderBy'>>;
  fileMetadataByTenantId?: Resolver<ResolversTypes['FileMetadataConnection'], ParentType, ContextType, RequireFields<TenantFileMetadataByTenantIdArgs, 'orderBy'>>;
  fileOutputGroupMetadataByTenantId?: Resolver<ResolversTypes['FileOutputGroupMetadataConnection'], ParentType, ContextType, RequireFields<TenantFileOutputGroupMetadataByTenantIdArgs, 'orderBy'>>;
  fileOutputGroupsByTenantId?: Resolver<ResolversTypes['FileOutputGroupsConnection'], ParentType, ContextType, RequireFields<TenantFileOutputGroupsByTenantIdArgs, 'orderBy'>>;
  filesByTenantId?: Resolver<ResolversTypes['FilesConnection'], ParentType, ContextType, RequireFields<TenantFilesByTenantIdArgs, 'orderBy'>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  internal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadataByTenantId?: Resolver<ResolversTypes['MetadataConnection'], ParentType, ContextType, RequireFields<TenantMetadataByTenantIdArgs, 'orderBy'>>;
  metadataValuesByTenantId?: Resolver<ResolversTypes['MetadataValuesConnection'], ParentType, ContextType, RequireFields<TenantMetadataValuesByTenantIdArgs, 'orderBy'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectsByTenantId?: Resolver<ResolversTypes['ProjectsConnection'], ParentType, ContextType, RequireFields<TenantProjectsByTenantIdArgs, 'orderBy'>>;
  repositoryName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roleChangeNotificationsByTenantId?: Resolver<ResolversTypes['RoleChangeNotificationsConnection'], ParentType, ContextType, RequireFields<TenantRoleChangeNotificationsByTenantIdArgs, 'orderBy'>>;
  sfid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tasksByTenantId?: Resolver<ResolversTypes['TasksConnection'], ParentType, ContextType, RequireFields<TenantTasksByTenantIdArgs, 'orderBy'>>;
  tenantContractsByTenantId?: Resolver<ResolversTypes['TenantContractsConnection'], ParentType, ContextType, RequireFields<TenantTenantContractsByTenantIdArgs, 'orderBy'>>;
  tenantType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tenantUserMembershipNotificationsByTenantId?: Resolver<ResolversTypes['TenantUserMembershipNotificationsConnection'], ParentType, ContextType, RequireFields<TenantTenantUserMembershipNotificationsByTenantIdArgs, 'orderBy'>>;
  toolTenantsByTenantId?: Resolver<ResolversTypes['ToolTenantsConnection'], ParentType, ContextType, RequireFields<TenantToolTenantsByTenantIdArgs, 'orderBy'>>;
  toolVersionsByTenantId?: Resolver<ResolversTypes['ToolVersionsConnection'], ParentType, ContextType, RequireFields<TenantToolVersionsByTenantIdArgs, 'orderBy'>>;
  toolsByTenantId?: Resolver<ResolversTypes['ToolsConnection'], ParentType, ContextType, RequireFields<TenantToolsByTenantIdArgs, 'orderBy'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantContract'] = ResolversParentTypes['TenantContract']> = {
  contractType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  salesOrder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sfid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantContractTransactionsByTenantContractId?: Resolver<ResolversTypes['TenantContractTransactionsConnection'], ParentType, ContextType, RequireFields<TenantContractTenantContractTransactionsByTenantContractIdArgs, 'orderBy'>>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractAllowanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantContractAllowance'] = ResolversParentTypes['TenantContractAllowance']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quotaType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tenantContractTransactionByTenantContractTransactionId?: Resolver<Maybe<ResolversTypes['TenantContractTransaction']>, ParentType, ContextType>;
  tenantContractTransactionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractAllowancesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantContractAllowancesConnection'] = ResolversParentTypes['TenantContractAllowancesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TenantContractAllowancesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TenantContractAllowance']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractAllowancesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantContractAllowancesEdge'] = ResolversParentTypes['TenantContractAllowancesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TenantContractAllowance'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantContractTransaction'] = ResolversParentTypes['TenantContractTransaction']> = {
  currency?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['BigFloat'], ParentType, ContextType>;
  tenantContractAllowancesByTenantContractTransactionId?: Resolver<ResolversTypes['TenantContractAllowancesConnection'], ParentType, ContextType, RequireFields<TenantContractTransactionTenantContractAllowancesByTenantContractTransactionIdArgs, 'orderBy'>>;
  tenantContractByTenantContractId?: Resolver<Maybe<ResolversTypes['TenantContract']>, ParentType, ContextType>;
  tenantContractId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractTransactionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantContractTransactionsConnection'] = ResolversParentTypes['TenantContractTransactionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TenantContractTransactionsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TenantContractTransaction']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractTransactionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantContractTransactionsEdge'] = ResolversParentTypes['TenantContractTransactionsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TenantContractTransaction'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantContractsConnection'] = ResolversParentTypes['TenantContractsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TenantContractsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TenantContract']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantContractsEdge'] = ResolversParentTypes['TenantContractsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TenantContract'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantUserMembershipNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantUserMembershipNotification'] = ResolversParentTypes['TenantUserMembershipNotification']> = {
  applicationUserByInviterId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  inviterId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  notificationById?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantUserMembershipNotificationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantUserMembershipNotificationsConnection'] = ResolversParentTypes['TenantUserMembershipNotificationsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TenantUserMembershipNotificationsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TenantUserMembershipNotification']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantUserMembershipNotificationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantUserMembershipNotificationsEdge'] = ResolversParentTypes['TenantUserMembershipNotificationsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TenantUserMembershipNotification'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResolvers<ContextType = any, ParentType extends ResolversParentTypes['Tool'] = ResolversParentTypes['Tool']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  codeLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  docsLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helpText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maturity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectByProjectId?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  searchTerms?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tags?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  toolTenantsByToolId?: Resolver<ResolversTypes['ToolTenantsConnection'], ParentType, ContextType, RequireFields<ToolToolTenantsByToolIdArgs, 'orderBy'>>;
  toolVersionsByToolId?: Resolver<ResolversTypes['ToolVersionsConnection'], ParentType, ContextType, RequireFields<ToolToolVersionsByToolIdArgs, 'orderBy'>>;
  toolboxId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolParameterResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolParameter'] = ResolversParentTypes['ToolParameter']> = {
  default?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  helpText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<Maybe<ResolversTypes['ToolVersion']>, ParentType, ContextType>;
  toolVersionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolParametersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolParametersConnection'] = ResolversParentTypes['ToolParametersConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ToolParametersEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ToolParameter']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolParametersEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolParametersEdge'] = ResolversParentTypes['ToolParametersEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ToolParameter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolResult'] = ResolversParentTypes['ToolResult']> = {
  fileFormats?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  helpText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<Maybe<ResolversTypes['ToolVersion']>, ParentType, ContextType>;
  toolVersionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResultsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolResultsConnection'] = ResolversParentTypes['ToolResultsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ToolResultsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ToolResult']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResultsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolResultsEdge'] = ResolversParentTypes['ToolResultsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ToolResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSecretResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolSecret'] = ResolversParentTypes['ToolSecret']> = {
  helpText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<Maybe<ResolversTypes['ToolVersion']>, ParentType, ContextType>;
  toolVersionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSecretsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolSecretsConnection'] = ResolversParentTypes['ToolSecretsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ToolSecretsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ToolSecret']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSecretsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolSecretsEdge'] = ResolversParentTypes['ToolSecretsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ToolSecret'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolSource'] = ResolversParentTypes['ToolSource']> = {
  fileFormats?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  helpText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  multiple?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  taskSourcesByToolSourceId?: Resolver<ResolversTypes['TaskSourcesConnection'], ParentType, ContextType, RequireFields<ToolSourceTaskSourcesByToolSourceIdArgs, 'orderBy'>>;
  toolVersionByToolVersionId?: Resolver<Maybe<ResolversTypes['ToolVersion']>, ParentType, ContextType>;
  toolVersionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSourcesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolSourcesConnection'] = ResolversParentTypes['ToolSourcesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ToolSourcesEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ToolSource']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSourcesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolSourcesEdge'] = ResolversParentTypes['ToolSourcesEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ToolSource'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTenantResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolTenant'] = ResolversParentTypes['ToolTenant']> = {
  id?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  toolByToolId?: Resolver<Maybe<ResolversTypes['Tool']>, ParentType, ContextType>;
  toolId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTenantsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolTenantsConnection'] = ResolversParentTypes['ToolTenantsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ToolTenantsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ToolTenant']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTenantsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolTenantsEdge'] = ResolversParentTypes['ToolTenantsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ToolTenant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolVersionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolVersion'] = ResolversParentTypes['ToolVersion']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  changelog?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  command?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  compatibleVersions?: Resolver<ResolversTypes['ToolVersionsConnection'], ParentType, ContextType, Partial<ToolVersionCompatibleVersionsArgs>>;
  containerImageId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  draftToolSpec?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  gdtAnalysisTableRowsByToolVersionId?: Resolver<ResolversTypes['GdtAnalysisTableRowsConnection'], ParentType, ContextType, RequireFields<ToolVersionGdtAnalysisTableRowsByToolVersionIdArgs, 'orderBy'>>;
  gdtAnalysisTablesByToolVersionId?: Resolver<ResolversTypes['GdtAnalysisTablesConnection'], ParentType, ContextType, RequireFields<ToolVersionGdtAnalysisTablesByToolVersionIdArgs, 'orderBy'>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isToolSpecForwardsCompatible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isUpgradableToNextVersion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maturity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tasksByToolVersionId?: Resolver<ResolversTypes['TasksConnection'], ParentType, ContextType, RequireFields<ToolVersionTasksByToolVersionIdArgs, 'orderBy'>>;
  tenantByTenantId?: Resolver<Maybe<ResolversTypes['Tenant']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  toolByToolId?: Resolver<Maybe<ResolversTypes['Tool']>, ParentType, ContextType>;
  toolId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  toolParametersByToolVersionId?: Resolver<ResolversTypes['ToolParametersConnection'], ParentType, ContextType, RequireFields<ToolVersionToolParametersByToolVersionIdArgs, 'orderBy'>>;
  toolResultsByToolVersionId?: Resolver<ResolversTypes['ToolResultsConnection'], ParentType, ContextType, RequireFields<ToolVersionToolResultsByToolVersionIdArgs, 'orderBy'>>;
  toolSecretsByToolVersionId?: Resolver<ResolversTypes['ToolSecretsConnection'], ParentType, ContextType, RequireFields<ToolVersionToolSecretsByToolVersionIdArgs, 'orderBy'>>;
  toolSourcesByToolVersionId?: Resolver<ResolversTypes['ToolSourcesConnection'], ParentType, ContextType, RequireFields<ToolVersionToolSourcesByToolVersionIdArgs, 'orderBy'>>;
  toolSpec?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  toolSpecVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolVersionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolVersionsConnection'] = ResolversParentTypes['ToolVersionsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ToolVersionsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ToolVersion']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolVersionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolVersionsEdge'] = ResolversParentTypes['ToolVersionsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ToolVersion'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolsConnection'] = ResolversParentTypes['ToolsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ToolsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Tool']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolsEdge'] = ResolversParentTypes['ToolsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Tool'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export type UpdateApplicationUserMetadatumPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateApplicationUserMetadatumPayload'] = ResolversParentTypes['UpdateApplicationUserMetadatumPayload']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  applicationUserMetadatum?: Resolver<Maybe<ResolversTypes['ApplicationUserMetadatum']>, ParentType, ContextType>;
  applicationUserMetadatumEdge?: Resolver<Maybe<ResolversTypes['ApplicationUserMetadataEdge']>, ParentType, ContextType, RequireFields<UpdateApplicationUserMetadatumPayloadApplicationUserMetadatumEdgeArgs, 'orderBy'>>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateApplicationUserPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateApplicationUserPayload'] = ResolversParentTypes['UpdateApplicationUserPayload']> = {
  applicationUser?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  applicationUserEdge?: Resolver<Maybe<ResolversTypes['ApplicationUsersEdge']>, ParentType, ContextType, RequireFields<UpdateApplicationUserPayloadApplicationUserEdgeArgs, 'orderBy'>>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAvatarPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAvatarPayload'] = ResolversParentTypes['UpdateAvatarPayload']> = {
  applicationUserByUserId?: Resolver<Maybe<ResolversTypes['ApplicationUser']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['Avatar']>, ParentType, ContextType>;
  avatarEdge?: Resolver<Maybe<ResolversTypes['AvatarsEdge']>, ParentType, ContextType, RequireFields<UpdateAvatarPayloadAvatarEdgeArgs, 'orderBy'>>;
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAccessToProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAccessToProject'] = ResolversParentTypes['UserAccessToProject']> = {
  edit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  grantAccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  view?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAccessToProjectsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAccessToProjectsConnection'] = ResolversParentTypes['UserAccessToProjectsConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UserAccessToProjectsEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['UserAccessToProject']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAccessToProjectsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAccessToProjectsEdge'] = ResolversParentTypes['UserAccessToProjectsEdge']> = {
  cursor?: Resolver<Maybe<ResolversTypes['Cursor']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UserAccessToProject'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ApplicationUser?: ApplicationUserResolvers<ContextType>;
  ApplicationUserMembership?: ApplicationUserMembershipResolvers<ContextType>;
  ApplicationUserMembershipsConnection?: ApplicationUserMembershipsConnectionResolvers<ContextType>;
  ApplicationUserMembershipsEdge?: ApplicationUserMembershipsEdgeResolvers<ContextType>;
  ApplicationUserMetadataConnection?: ApplicationUserMetadataConnectionResolvers<ContextType>;
  ApplicationUserMetadataEdge?: ApplicationUserMetadataEdgeResolvers<ContextType>;
  ApplicationUserMetadatum?: ApplicationUserMetadatumResolvers<ContextType>;
  ApplicationUserSession?: ApplicationUserSessionResolvers<ContextType>;
  ApplicationUserSessionsConnection?: ApplicationUserSessionsConnectionResolvers<ContextType>;
  ApplicationUserSessionsEdge?: ApplicationUserSessionsEdgeResolvers<ContextType>;
  ApplicationUsersEdge?: ApplicationUsersEdgeResolvers<ContextType>;
  Avatar?: AvatarResolvers<ContextType>;
  AvatarsConnection?: AvatarsConnectionResolvers<ContextType>;
  AvatarsEdge?: AvatarsEdgeResolvers<ContextType>;
  BigFloat?: GraphQLScalarType;
  BigInt?: GraphQLScalarType;
  ChangeUserSessionPayload?: ChangeUserSessionPayloadResolvers<ContextType>;
  CodeFile?: CodeFileResolvers<ContextType>;
  CodeFilesConnection?: CodeFilesConnectionResolvers<ContextType>;
  CodeFilesEdge?: CodeFilesEdgeResolvers<ContextType>;
  CreateApplicationUserMetadatumPayload?: CreateApplicationUserMetadatumPayloadResolvers<ContextType>;
  CreateApplicationUserSessionPayload?: CreateApplicationUserSessionPayloadResolvers<ContextType>;
  CreateEulaVersionUserAcceptancePayload?: CreateEulaVersionUserAcceptancePayloadResolvers<ContextType>;
  CreateMetadataValuePayload?: CreateMetadataValuePayloadResolvers<ContextType>;
  CreateMetadatumPayload?: CreateMetadatumPayloadResolvers<ContextType>;
  CreateRolePayload?: CreateRolePayloadResolvers<ContextType>;
  CreateSessionPayload?: CreateSessionPayloadResolvers<ContextType>;
  CurrentApplicationUser?: CurrentApplicationUserResolvers<ContextType>;
  CurrentApplicationUsersConnection?: CurrentApplicationUsersConnectionResolvers<ContextType>;
  CurrentApplicationUsersEdge?: CurrentApplicationUsersEdgeResolvers<ContextType>;
  CurrentUserMembership?: CurrentUserMembershipResolvers<ContextType>;
  CurrentUserMembershipsConnection?: CurrentUserMembershipsConnectionResolvers<ContextType>;
  CurrentUserMembershipsEdge?: CurrentUserMembershipsEdgeResolvers<ContextType>;
  Cursor?: GraphQLScalarType;
  DataTable?: DataTableResolvers<ContextType>;
  DataTablesConnection?: DataTablesConnectionResolvers<ContextType>;
  DataTablesEdge?: DataTablesEdgeResolvers<ContextType>;
  Datetime?: GraphQLScalarType;
  DeleteSessionPayload?: DeleteSessionPayloadResolvers<ContextType>;
  EulaVersion?: EulaVersionResolvers<ContextType>;
  EulaVersionUserAcceptance?: EulaVersionUserAcceptanceResolvers<ContextType>;
  EulaVersionUserAcceptancesConnection?: EulaVersionUserAcceptancesConnectionResolvers<ContextType>;
  EulaVersionUserAcceptancesEdge?: EulaVersionUserAcceptancesEdgeResolvers<ContextType>;
  EulaVersionsConnection?: EulaVersionsConnectionResolvers<ContextType>;
  EulaVersionsEdge?: EulaVersionsEdgeResolvers<ContextType>;
  File?: FileResolvers<ContextType>;
  FileActivitiesConnection?: FileActivitiesConnectionResolvers<ContextType>;
  FileActivitiesEdge?: FileActivitiesEdgeResolvers<ContextType>;
  FileActivity?: FileActivityResolvers<ContextType>;
  FileMetadataConnection?: FileMetadataConnectionResolvers<ContextType>;
  FileMetadataEdge?: FileMetadataEdgeResolvers<ContextType>;
  FileMetadatum?: FileMetadatumResolvers<ContextType>;
  FileOutputGroup?: FileOutputGroupResolvers<ContextType>;
  FileOutputGroupMetadataConnection?: FileOutputGroupMetadataConnectionResolvers<ContextType>;
  FileOutputGroupMetadataEdge?: FileOutputGroupMetadataEdgeResolvers<ContextType>;
  FileOutputGroupMetadatum?: FileOutputGroupMetadatumResolvers<ContextType>;
  FileOutputGroupsConnection?: FileOutputGroupsConnectionResolvers<ContextType>;
  FileOutputGroupsEdge?: FileOutputGroupsEdgeResolvers<ContextType>;
  FileProcessingNotification?: FileProcessingNotificationResolvers<ContextType>;
  FileProcessingNotificationsConnection?: FileProcessingNotificationsConnectionResolvers<ContextType>;
  FileProcessingNotificationsEdge?: FileProcessingNotificationsEdgeResolvers<ContextType>;
  FilesConnection?: FilesConnectionResolvers<ContextType>;
  FilesEdge?: FilesEdgeResolvers<ContextType>;
  GdtAnalysisTable?: GdtAnalysisTableResolvers<ContextType>;
  GdtAnalysisTableRow?: GdtAnalysisTableRowResolvers<ContextType>;
  GdtAnalysisTableRowsConnection?: GdtAnalysisTableRowsConnectionResolvers<ContextType>;
  GdtAnalysisTableRowsEdge?: GdtAnalysisTableRowsEdgeResolvers<ContextType>;
  GdtAnalysisTablesConnection?: GdtAnalysisTablesConnectionResolvers<ContextType>;
  GdtAnalysisTablesEdge?: GdtAnalysisTablesEdgeResolvers<ContextType>;
  Interval?: IntervalResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  MetadataConnection?: MetadataConnectionResolvers<ContextType>;
  MetadataEdge?: MetadataEdgeResolvers<ContextType>;
  MetadataValue?: MetadataValueResolvers<ContextType>;
  MetadataValuesConnection?: MetadataValuesConnectionResolvers<ContextType>;
  MetadataValuesEdge?: MetadataValuesEdgeResolvers<ContextType>;
  Metadatum?: MetadatumResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  NotificationsConnection?: NotificationsConnectionResolvers<ContextType>;
  NotificationsEdge?: NotificationsEdgeResolvers<ContextType>;
  OutputGroupFile?: OutputGroupFileResolvers<ContextType>;
  OutputGroupFilesConnection?: OutputGroupFilesConnectionResolvers<ContextType>;
  OutputGroupFilesEdge?: OutputGroupFilesEdgeResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Project?: ProjectResolvers<ContextType>;
  ProjectClonedNotification?: ProjectClonedNotificationResolvers<ContextType>;
  ProjectClonedNotificationsConnection?: ProjectClonedNotificationsConnectionResolvers<ContextType>;
  ProjectClonedNotificationsEdge?: ProjectClonedNotificationsEdgeResolvers<ContextType>;
  ProjectFolder?: ProjectFolderResolvers<ContextType>;
  ProjectFoldersConnection?: ProjectFoldersConnectionResolvers<ContextType>;
  ProjectFoldersEdge?: ProjectFoldersEdgeResolvers<ContextType>;
  ProjectSharedNotification?: ProjectSharedNotificationResolvers<ContextType>;
  ProjectSharedNotificationsConnection?: ProjectSharedNotificationsConnectionResolvers<ContextType>;
  ProjectSharedNotificationsEdge?: ProjectSharedNotificationsEdgeResolvers<ContextType>;
  ProjectTag?: ProjectTagResolvers<ContextType>;
  ProjectTagsConnection?: ProjectTagsConnectionResolvers<ContextType>;
  ProjectTagsEdge?: ProjectTagsEdgeResolvers<ContextType>;
  ProjectsConnection?: ProjectsConnectionResolvers<ContextType>;
  ProjectsEdge?: ProjectsEdgeResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RoleChangeNotification?: RoleChangeNotificationResolvers<ContextType>;
  RoleChangeNotificationsConnection?: RoleChangeNotificationsConnectionResolvers<ContextType>;
  RoleChangeNotificationsEdge?: RoleChangeNotificationsEdgeResolvers<ContextType>;
  Task?: TaskResolvers<ContextType>;
  TaskActivitiesConnection?: TaskActivitiesConnectionResolvers<ContextType>;
  TaskActivitiesEdge?: TaskActivitiesEdgeResolvers<ContextType>;
  TaskActivity?: TaskActivityResolvers<ContextType>;
  TaskResource?: TaskResourceResolvers<ContextType>;
  TaskResourceUsage?: TaskResourceUsageResolvers<ContextType>;
  TaskResourceUsagesConnection?: TaskResourceUsagesConnectionResolvers<ContextType>;
  TaskResourceUsagesEdge?: TaskResourceUsagesEdgeResolvers<ContextType>;
  TaskResourcesConnection?: TaskResourcesConnectionResolvers<ContextType>;
  TaskResourcesEdge?: TaskResourcesEdgeResolvers<ContextType>;
  TaskSource?: TaskSourceResolvers<ContextType>;
  TaskSourcesConnection?: TaskSourcesConnectionResolvers<ContextType>;
  TaskSourcesEdge?: TaskSourcesEdgeResolvers<ContextType>;
  TasksConnection?: TasksConnectionResolvers<ContextType>;
  TasksEdge?: TasksEdgeResolvers<ContextType>;
  Tenant?: TenantResolvers<ContextType>;
  TenantContract?: TenantContractResolvers<ContextType>;
  TenantContractAllowance?: TenantContractAllowanceResolvers<ContextType>;
  TenantContractAllowancesConnection?: TenantContractAllowancesConnectionResolvers<ContextType>;
  TenantContractAllowancesEdge?: TenantContractAllowancesEdgeResolvers<ContextType>;
  TenantContractTransaction?: TenantContractTransactionResolvers<ContextType>;
  TenantContractTransactionsConnection?: TenantContractTransactionsConnectionResolvers<ContextType>;
  TenantContractTransactionsEdge?: TenantContractTransactionsEdgeResolvers<ContextType>;
  TenantContractsConnection?: TenantContractsConnectionResolvers<ContextType>;
  TenantContractsEdge?: TenantContractsEdgeResolvers<ContextType>;
  TenantUserMembershipNotification?: TenantUserMembershipNotificationResolvers<ContextType>;
  TenantUserMembershipNotificationsConnection?: TenantUserMembershipNotificationsConnectionResolvers<ContextType>;
  TenantUserMembershipNotificationsEdge?: TenantUserMembershipNotificationsEdgeResolvers<ContextType>;
  Tool?: ToolResolvers<ContextType>;
  ToolParameter?: ToolParameterResolvers<ContextType>;
  ToolParametersConnection?: ToolParametersConnectionResolvers<ContextType>;
  ToolParametersEdge?: ToolParametersEdgeResolvers<ContextType>;
  ToolResult?: ToolResultResolvers<ContextType>;
  ToolResultsConnection?: ToolResultsConnectionResolvers<ContextType>;
  ToolResultsEdge?: ToolResultsEdgeResolvers<ContextType>;
  ToolSecret?: ToolSecretResolvers<ContextType>;
  ToolSecretsConnection?: ToolSecretsConnectionResolvers<ContextType>;
  ToolSecretsEdge?: ToolSecretsEdgeResolvers<ContextType>;
  ToolSource?: ToolSourceResolvers<ContextType>;
  ToolSourcesConnection?: ToolSourcesConnectionResolvers<ContextType>;
  ToolSourcesEdge?: ToolSourcesEdgeResolvers<ContextType>;
  ToolTenant?: ToolTenantResolvers<ContextType>;
  ToolTenantsConnection?: ToolTenantsConnectionResolvers<ContextType>;
  ToolTenantsEdge?: ToolTenantsEdgeResolvers<ContextType>;
  ToolVersion?: ToolVersionResolvers<ContextType>;
  ToolVersionsConnection?: ToolVersionsConnectionResolvers<ContextType>;
  ToolVersionsEdge?: ToolVersionsEdgeResolvers<ContextType>;
  ToolsConnection?: ToolsConnectionResolvers<ContextType>;
  ToolsEdge?: ToolsEdgeResolvers<ContextType>;
  UUID?: GraphQLScalarType;
  UpdateApplicationUserMetadatumPayload?: UpdateApplicationUserMetadatumPayloadResolvers<ContextType>;
  UpdateApplicationUserPayload?: UpdateApplicationUserPayloadResolvers<ContextType>;
  UpdateAvatarPayload?: UpdateAvatarPayloadResolvers<ContextType>;
  UserAccessToProject?: UserAccessToProjectResolvers<ContextType>;
  UserAccessToProjectsConnection?: UserAccessToProjectsConnectionResolvers<ContextType>;
  UserAccessToProjectsEdge?: UserAccessToProjectsEdgeResolvers<ContextType>;
};

